var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogohorizontal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1136.77 215.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clip-path);}.cls-2{clip-path:url(#clip-path-2);}.cls-3{clip-path:url(#clip-path-3);}.cls-4{clip-path:url(#clip-path-4);}.cls-5{clip-path:url(#clip-path-5);}.cls-6{clip-path:url(#clip-path-6);}.cls-7{clip-path:url(#clip-path-7);}.cls-8{clip-path:url(#clip-path-8);}.cls-9{clip-path:url(#clip-path-9);}.cls-10{clip-path:url(#clip-path-10);}.cls-11{clip-path:url(#clip-path-11);}.cls-12{clip-path:url(#clip-path-12);}.cls-13{clip-path:url(#clip-path-13);}.cls-14{clip-path:url(#clip-path-15);}.cls-15{clip-path:url(#clip-path-16);}.cls-16{clip-path:url(#clip-path-17);}.cls-17{clip-path:url(#clip-path-18);}.cls-18{clip-path:url(#clip-path-22);}.cls-19{clip-path:url(#clip-path-25);}.cls-20{clip-path:url(#clip-path-26);}.cls-21{clip-path:url(#clip-path-27);}.cls-22{fill:none;stroke-miterlimit:10;stroke-width:2.98px;stroke:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.32,
    y: 28.62,
    width: 0.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.32,
    y: 28.62,
    width: 0.4,
    height: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.51,
    y: 29.02,
    width: 0.4,
    height: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.12,
    y: 29.02,
    width: 0.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.12,
    y: 29.02,
    width: 0.4,
    height: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.52,
    y: 29.02,
    width: 0.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.32,
    y: 29.02,
    width: 0.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.92,
    y: 29.02,
    width: 0.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.13,
    y: 79.78,
    width: 0.8,
    height: 1.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.13,
    y: 80.98,
    width: 0.4,
    height: 1.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.13,
    y: 80.98,
    width: 0.4,
    height: 1.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.13,
    y: 82.18,
    width: 0.4,
    height: 1.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.13,
    y: 80.58,
    width: 0.8,
    height: 1.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.13,
    y: 81.78,
    width: 0.8,
    height: 1.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.13,
    y: 83.38,
    width: 0.8,
    height: 1.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.13,
    y: 84.98,
    width: 0.4,
    height: 1.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.92,
    y: 150.13,
    width: 0.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.72,
    y: 149.73,
    width: 1.2,
    height: 0.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.12,
    y: 149.73,
    width: 0.8,
    height: 0.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.13,
    y: 86.18,
    width: 0.8,
    height: 1.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.13,
    y: 87.77,
    width: 0.8,
    height: 1.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2939.79,
    y1: 2369.39,
    x2: -2761.99,
    y2: 2369.39,
    gradientTransform: "translate(-2038.3 -2742.9) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d3f83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#6f4487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#a44b8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b94e8f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.22,159.77h7c6.34,0,10.72,4.35,10.72,10v.06c0,5.67-4.38,10.08-10.72,10.08h-7Zm2.28,2.11v16h4.72c5.1,0,8.36-3.46,8.36-7.93v0c0-4.47-3.26-8-8.36-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.8,172.54v-.06c0-4.29,3-7.75,7.15-7.75,4.41,0,6.94,3.51,6.94,7.86a5.47,5.47,0,0,1,0,.72H397.05a5.21,5.21,0,0,0,5.24,5.05,6.16,6.16,0,0,0,4.7-2.11l1.38,1.24a7.69,7.69,0,0,1-6.13,2.8A7.41,7.41,0,0,1,394.8,172.54Zm11.84-.87c-.23-2.71-1.78-5.07-4.75-5.07-2.59,0-4.55,2.16-4.84,5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.89,178l1.12-1.59a8.74,8.74,0,0,0,5.16,1.91c1.79,0,3.08-.93,3.08-2.37v-.05c0-1.5-1.75-2.08-3.71-2.63-2.34-.66-4.93-1.47-4.93-4.2v-.06c0-2.56,2.13-4.26,5.07-4.26a10.17,10.17,0,0,1,5.36,1.64l-1,1.67a8.45,8.45,0,0,0-4.41-1.44c-1.75,0-2.88.92-2.88,2.16v.06c0,1.41,1.85,2,3.83,2.56,2.31.69,4.79,1.59,4.79,4.27v0c0,2.83-2.34,4.47-5.3,4.47A10.26,10.26,0,0,1,421.89,178Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.88,159.34h2.54v2.45h-2.54Zm.14,5.71h2.22v14.89H448Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.57,182.53l1-1.73a9.51,9.51,0,0,0,5.73,1.91c3.29,0,5.42-1.82,5.42-5.3v-1.76a7.06,7.06,0,0,1-5.85,3.14,6.89,6.89,0,0,1-7-7v-.06a7,7,0,0,1,12.82-4v-2.68h2.22v12.3a7.18,7.18,0,0,1-1.9,5.27,7.88,7.88,0,0,1-5.68,2A11.63,11.63,0,0,1,465.57,182.53Zm12.22-10.74v-.06a5.22,5.22,0,0,0-5.48-5,4.92,4.92,0,0,0-5.15,5v.06a5,5,0,0,0,5.15,5.07A5.26,5.26,0,0,0,477.79,171.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.22,165.05h2.22v2.59a5.65,5.65,0,0,1,5.1-2.91c3.6,0,5.7,2.42,5.7,6v9.25H506v-8.7c0-2.77-1.5-4.49-4.12-4.49a4.38,4.38,0,0,0-4.47,4.66v8.53h-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.05,176.91h2.65v3h-2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.53,159.63h2.14l9.19,20.31h-2.45L593,174.61h-11l-2.39,5.33h-2.34Zm5.62,12.91-4.58-10.26L583,172.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.81,165.05H614v3.89a6.38,6.38,0,0,1,6.08-4.15v2.39h-.17c-3.26,0-5.91,2.33-5.91,6.83v5.93h-2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.27,172.57v-.06a7.75,7.75,0,0,1,13.59-5.13l-1.47,1.56a6,6,0,0,0-4.52-2.25,5.5,5.5,0,0,0-5.33,5.76v.06A5.57,5.57,0,0,0,640,178.3a6.14,6.14,0,0,0,4.56-2.22l1.41,1.33a7.7,7.7,0,0,1-13.71-4.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660,158.91h2.21v8.73a5.65,5.65,0,0,1,5.1-2.91c3.61,0,5.71,2.42,5.71,6v9.25h-2.22v-8.7c0-2.77-1.5-4.49-4.12-4.49a4.38,4.38,0,0,0-4.47,4.66v8.53H660Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.14,159.34h2.53v2.45h-2.53Zm.14,5.71h2.22v14.89h-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.78,176v-9h-2.07v-1.95h2.07v-4.5H709v4.5h4.72V167H709v8.71a2.2,2.2,0,0,0,2.5,2.47,4.64,4.64,0,0,0,2.17-.52v1.91a5.64,5.64,0,0,1-2.68.63C708.6,180.2,706.78,179,706.78,176Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.63,172.54v-.06c0-4.29,3-7.75,7.15-7.75,4.41,0,6.94,3.51,6.94,7.86a5.47,5.47,0,0,1,0,.72H728.88a5.21,5.21,0,0,0,5.24,5.05,6.16,6.16,0,0,0,4.7-2.11l1.38,1.24a7.67,7.67,0,0,1-6.13,2.8A7.41,7.41,0,0,1,726.63,172.54Zm11.85-.87c-.23-2.71-1.79-5.07-4.76-5.07-2.59,0-4.55,2.16-4.84,5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754,172.57v-.06a7.75,7.75,0,0,1,13.59-5.13l-1.46,1.56a6,6,0,0,0-4.53-2.25,5.5,5.5,0,0,0-5.33,5.76v.06a5.57,5.57,0,0,0,5.48,5.79,6.14,6.14,0,0,0,4.55-2.22l1.41,1.33A7.7,7.7,0,0,1,754,172.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.53,176v-9h-2.07v-1.95h2.07v-4.5h2.22v4.5h4.73V167h-4.73v8.71a2.2,2.2,0,0,0,2.51,2.47,4.6,4.6,0,0,0,2.16-.52v1.91a5.61,5.61,0,0,1-2.68.63C784.35,180.2,782.53,179,782.53,176Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.51,174.29v-9.24h2.22v8.7c0,2.76,1.5,4.49,4.12,4.49a4.4,4.4,0,0,0,4.47-4.67v-8.52h2.18v14.89h-2.18v-2.59a5.69,5.69,0,0,1-5.1,2.91C805.62,180.26,803.51,177.84,803.51,174.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.84,165.05h2.22v3.89a6.36,6.36,0,0,1,6.07-4.15v2.39H840c-3.25,0-5.9,2.33-5.9,6.83v5.93h-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.3,172.54v-.06c0-4.29,3-7.75,7.14-7.75,4.41,0,6.94,3.51,6.94,7.86,0,.29,0,.47,0,.72H854.54a5.21,5.21,0,0,0,5.25,5.05,6.16,6.16,0,0,0,4.69-2.11l1.39,1.24a7.71,7.71,0,0,1-6.14,2.8A7.4,7.4,0,0,1,852.3,172.54Zm11.84-.87c-.23-2.71-1.79-5.07-4.76-5.07-2.59,0-4.55,2.16-4.84,5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.35,176.91H902v3h-2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.58,159.77h2.27v20.17h-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.73,165.05H957v2.59a5.65,5.65,0,0,1,5.1-2.91c3.6,0,5.7,2.42,5.7,6v9.25h-2.21v-8.7c0-2.77-1.5-4.49-4.12-4.49a4.38,4.38,0,0,0-4.47,4.66v8.53h-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.6,176v-9h-2.07v-1.95h2.07v-4.5h2.22v4.5h4.73V167h-4.73v8.71a2.2,2.2,0,0,0,2.51,2.47,4.6,4.6,0,0,0,2.16-.52v1.91a5.61,5.61,0,0,1-2.68.63C985.42,180.2,983.6,179,983.6,176Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.46,172.54v-.06c0-4.29,3-7.75,7.14-7.75,4.41,0,6.95,3.51,6.95,7.86a5.47,5.47,0,0,1,0,.72h-11.81a5.2,5.2,0,0,0,5.24,5.05,6.18,6.18,0,0,0,4.7-2.11l1.38,1.24a7.71,7.71,0,0,1-6.14,2.8A7.4,7.4,0,0,1,1003.46,172.54Zm11.84-.87c-.23-2.71-1.79-5.07-4.75-5.07-2.6,0-4.56,2.16-4.84,5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.78,165.05H1034v3.89a6.38,6.38,0,0,1,6.08-4.15v2.39h-.17c-3.26,0-5.91,2.33-5.91,6.83v5.93h-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.86,159.34h2.53v2.45h-2.53Zm.14,5.71h2.22v14.89H1054Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.8,172.57v-.06a7.77,7.77,0,0,1,15.53-.06v.06a7.74,7.74,0,0,1-7.81,7.78A7.63,7.63,0,0,1,1070.8,172.57Zm13.25,0v-.06a5.63,5.63,0,0,0-5.53-5.82,5.49,5.49,0,0,0-5.44,5.76v.06a5.58,5.58,0,0,0,5.5,5.79A5.49,5.49,0,0,0,1084.05,172.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.68,165.05h2.22v3.89a6.36,6.36,0,0,1,6.08-4.15v2.39h-.18c-3.25,0-5.9,2.33-5.9,6.83v5.93h-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.46,178l1.12-1.59a8.71,8.71,0,0,0,5.16,1.91c1.78,0,3.08-.93,3.08-2.37v-.05c0-1.5-1.76-2.08-3.72-2.63-2.33-.66-4.92-1.47-4.92-4.2v-.06c0-2.56,2.13-4.26,5.07-4.26a10.13,10.13,0,0,1,5.35,1.64l-1,1.67a8.48,8.48,0,0,0-4.41-1.44c-1.76,0-2.88.92-2.88,2.16v.06c0,1.41,1.84,2,3.83,2.56,2.3.69,4.78,1.59,4.78,4.27v0c0,2.83-2.33,4.47-5.3,4.47A10.26,10.26,0,0,1,1121.46,178Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.73,113A29.64,29.64,0,0,1,374,109.3a26.86,26.86,0,0,1-10.25-10A28.24,28.24,0,0,1,360,84.73a27.9,27.9,0,0,1,3.75-14.53,27.12,27.12,0,0,1,10.2-9.94,29.54,29.54,0,0,1,14.79-3.65,29.92,29.92,0,0,1,14.73,3.6,26.2,26.2,0,0,1,10.2,9.94,28.43,28.43,0,0,1,3.7,14.58,28.43,28.43,0,0,1-3.7,14.58,26.61,26.61,0,0,1-10.2,10A29.63,29.63,0,0,1,388.73,113Zm0-8.75a19,19,0,0,0,9.52-2.39A16.92,16.92,0,0,0,404.87,95a21.3,21.3,0,0,0,2.39-10.26,20.91,20.91,0,0,0-2.39-10.26,17,17,0,0,0-6.62-6.71,18.89,18.89,0,0,0-9.52-2.4,18.66,18.66,0,0,0-9.48,2.4,17.81,17.81,0,0,0-6.66,6.71,20.1,20.1,0,0,0-2.5,10.26A20.47,20.47,0,0,0,372.59,95a17.69,17.69,0,0,0,6.66,6.82A18.75,18.75,0,0,0,388.73,104.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.43,56.61a25.5,25.5,0,0,1,11.77,2.61,18.42,18.42,0,0,1,8,7.91Q525,72.44,525,80.56v31.76H515V81.71q0-8-3.75-12.08t-10.51-4.06A17.8,17.8,0,0,0,492,67.65a14,14,0,0,0-5.78,6.15,22.48,22.48,0,0,0-2,10.1v28.42h-10V81.71q0-8-3.69-12.08T460,65.57a17.53,17.53,0,0,0-8.64,2.08,14.31,14.31,0,0,0-5.84,6.15,22.07,22.07,0,0,0-2.08,10.1v28.42h-10V57.14H443V71.82l-1.57-3.75a18.89,18.89,0,0,1,8-8.44,25.48,25.48,0,0,1,12.6-3,23.64,23.64,0,0,1,13.64,3.91q5.73,3.9,7.5,11.82l-4.06-1.67a20.74,20.74,0,0,1,8.74-10.2A27.22,27.22,0,0,1,502.43,56.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.11,56.61A26,26,0,0,1,587,59.22a18.68,18.68,0,0,1,8.08,7.91Q598,72.44,598,80.56v31.76H588V81.71q0-8-3.9-12.08t-11-4.06a19.67,19.67,0,0,0-9.26,2.08,14.32,14.32,0,0,0-6.1,6.15,21.55,21.55,0,0,0-2.13,10.1v28.42h-10V57.14h9.58V72l-1.56-4A19.23,19.23,0,0,1,562,59.63,27.35,27.35,0,0,1,575.11,56.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.74,46.51a6.65,6.65,0,0,1-4.84-1.87A6.13,6.13,0,0,1,617,40.06a6.25,6.25,0,0,1,1.93-4.69,6.65,6.65,0,0,1,4.84-1.87,6.78,6.78,0,0,1,4.84,1.82,6,6,0,0,1,1.93,4.53,6.5,6.5,0,0,1-6.77,6.66Zm-5,65.81V57.14h10v55.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650,132.52V57.14h9.58V72l-.63,12.8L660,97.64v34.88ZM679.24,113a25.23,25.23,0,0,1-12.55-3.18,23.08,23.08,0,0,1-9.06-9.42q-3.39-6.25-3.38-15.62t3.28-15.62a22.11,22.11,0,0,1,9-9.37,26,26,0,0,1,12.76-3.13,28.77,28.77,0,0,1,14.37,3.54A26.27,26.27,0,0,1,703.5,70a28.89,28.89,0,0,1,3.64,14.73,29.22,29.22,0,0,1-3.64,14.79,26.09,26.09,0,0,1-9.89,9.89A28.67,28.67,0,0,1,679.24,113Zm-.84-8.75a19,19,0,0,0,9.53-2.39A17.3,17.3,0,0,0,694.6,95,20.87,20.87,0,0,0,697,84.73a20.5,20.5,0,0,0-2.44-10.26,17.41,17.41,0,0,0-6.67-6.71,18.9,18.9,0,0,0-9.53-2.4,18.7,18.7,0,0,0-9.42,2.4,17.39,17.39,0,0,0-6.66,6.71,20.5,20.5,0,0,0-2.45,10.26A20.87,20.87,0,0,0,662.32,95a17.28,17.28,0,0,0,6.66,6.82A18.79,18.79,0,0,0,678.4,104.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.53,59.63a16.94,16.94,0,0,0-6.77,6.76V57.13h-9.58v55.19h3.14v-13a8.84,8.84,0,0,1,2.23-6.09,7.62,7.62,0,0,1,4.63-2.27V84.83q0-9.06,4.68-13.85t12.7-4.79h1.1a7.33,7.33,0,0,1,1.2.11V56.61A27.06,27.06,0,0,0,739.53,59.63Zm-9.08,39.52v13.17h2.73V95.11a3.46,3.46,0,0,0-1.62.9A4.84,4.84,0,0,0,730.45,99.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.38,113a32.15,32.15,0,0,1-15.57-3.65,26.29,26.29,0,0,1-10.41-10,28.52,28.52,0,0,1-3.69-14.58,29.08,29.08,0,0,1,3.59-14.58,25.88,25.88,0,0,1,9.89-9.94,30,30,0,0,1,28.37-.06,25.16,25.16,0,0,1,9.64,9.95A30.82,30.82,0,0,1,816.68,85c0,.42,0,.9,0,1.46s-.09,1.08-.15,1.56h-47V80.88h41.76l-4.06,2.5A18.55,18.55,0,0,0,805,73.9a16.72,16.72,0,0,0-6.3-6.51,19.63,19.63,0,0,0-18.59,0A16.57,16.57,0,0,0,773.78,74a20,20,0,0,0-2.29,9.63v1.67A19,19,0,0,0,774,95.09a17.54,17.54,0,0,0,7.14,6.72,22.43,22.43,0,0,0,10.51,2.39,23,23,0,0,0,8.91-1.66,19.6,19.6,0,0,0,7-5l5.52,6.45a24.13,24.13,0,0,1-9.32,6.67A32.55,32.55,0,0,1,791.38,113Zm-9.89-63.83,14.16-13.54h12.7L790.86,49.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.55,113a44.9,44.9,0,0,1-13.07-1.88,30.61,30.61,0,0,1-9.74-4.58l4.17-7.91a33.9,33.9,0,0,0,8.75,4.06,34.66,34.66,0,0,0,10.62,1.67q7,0,10-2a6.23,6.23,0,0,0,3.08-5.52,4.85,4.85,0,0,0-1.88-4.06,12.9,12.9,0,0,0-4.94-2.19c-2.05-.48-4.32-.92-6.82-1.3s-5-.87-7.5-1.46a29.59,29.59,0,0,1-6.87-2.5,12.88,12.88,0,0,1-5-4.48,13.77,13.77,0,0,1-1.88-7.65,14.16,14.16,0,0,1,2.82-8.75,17.83,17.83,0,0,1,8-5.77,33.24,33.24,0,0,1,12.24-2,48,48,0,0,1,11,1.31,27.5,27.5,0,0,1,9.11,3.69l-4.27,7.92a23.56,23.56,0,0,0-7.8-3.44,36.36,36.36,0,0,0-8.13-.94c-4.37,0-7.63.72-9.78,2.14a6.33,6.33,0,0,0-3.23,5.46,5.19,5.19,0,0,0,1.92,4.33,14.17,14.17,0,0,0,5,2.34,60.49,60.49,0,0,0,6.82,1.4c2.5.39,5,.87,7.5,1.46a30.49,30.49,0,0,1,6.82,2.45,13.28,13.28,0,0,1,5,4.37,13.11,13.11,0,0,1,1.92,7.5,13.43,13.43,0,0,1-2.91,8.64,19,19,0,0,1-8.23,5.68A35.65,35.65,0,0,1,848.55,113Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.65,113a32.15,32.15,0,0,1-15.57-3.65,26.23,26.23,0,0,1-10.41-10A28.43,28.43,0,0,1,882,84.73a29.18,29.18,0,0,1,3.59-14.58,25.9,25.9,0,0,1,9.9-9.94,30,30,0,0,1,28.37-.06,25.13,25.13,0,0,1,9.63,9.95A30.71,30.71,0,0,1,937,85c0,.42,0,.9-.05,1.46s-.09,1.08-.16,1.56h-47V80.88h41.76l-4.07,2.5a18.65,18.65,0,0,0-2.18-9.48,16.72,16.72,0,0,0-6.3-6.51,19.63,19.63,0,0,0-18.59,0A16.5,16.5,0,0,0,894.05,74a19.84,19.84,0,0,0-2.29,9.63v1.67a19,19,0,0,0,2.55,9.84,17.57,17.57,0,0,0,7.13,6.72A22.47,22.47,0,0,0,912,104.2a23,23,0,0,0,8.9-1.66,19.64,19.64,0,0,0,7-5l5.52,6.45a24.21,24.21,0,0,1-9.32,6.67A32.55,32.55,0,0,1,911.65,113Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.45,56.61a26.07,26.07,0,0,1,11.93,2.61,18.71,18.71,0,0,1,8.07,7.91q2.91,5.31,2.91,13.43v31.76h-10V81.71q0-8-3.91-12.08t-11-4.06a19.71,19.71,0,0,0-9.27,2.08,14.24,14.24,0,0,0-6.09,6.15A21.42,21.42,0,0,0,963,83.9v28.42H953V57.14h9.58V72l-1.57-4a19.28,19.28,0,0,1,8.33-8.44A27.38,27.38,0,0,1,982.45,56.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.14,113a30.65,30.65,0,0,1-15.05-3.65,26.83,26.83,0,0,1-10.36-10A28.16,28.16,0,0,1,1021,84.73a28.16,28.16,0,0,1,3.75-14.58,26.42,26.42,0,0,1,10.36-9.94,31,31,0,0,1,15.05-3.6,29.33,29.33,0,0,1,13.38,3,21,21,0,0,1,9.11,8.8l-7.6,4.9a17,17,0,0,0-6.61-6,18.66,18.66,0,0,0-8.39-1.93,19.41,19.41,0,0,0-9.68,2.4,17.66,17.66,0,0,0-6.77,6.71,20.1,20.1,0,0,0-2.5,10.26,20.4,20.4,0,0,0,2.5,10.31,17.68,17.68,0,0,0,6.77,6.77,19.51,19.51,0,0,0,9.68,2.39,18.78,18.78,0,0,0,8.39-1.92,17.12,17.12,0,0,0,6.61-6l7.6,4.79a21.84,21.84,0,0,1-9.11,8.8A28.62,28.62,0,0,1,1050.14,113Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.47,113a32.15,32.15,0,0,1-15.57-3.65,26.23,26.23,0,0,1-10.41-10,28.43,28.43,0,0,1-3.7-14.58,29.18,29.18,0,0,1,3.59-14.58,26,26,0,0,1,9.9-9.94,30,30,0,0,1,28.37-.06,25.06,25.06,0,0,1,9.63,9.95A30.71,30.71,0,0,1,1136.77,85c0,.42,0,.9,0,1.46s-.09,1.08-.16,1.56h-47V80.88h41.76l-4.06,2.5a18.65,18.65,0,0,0-2.19-9.48,16.72,16.72,0,0,0-6.3-6.51,19.63,19.63,0,0,0-18.59,0,16.57,16.57,0,0,0-6.35,6.56,19.84,19.84,0,0,0-2.29,9.63v1.67a19,19,0,0,0,2.55,9.84,17.57,17.57,0,0,0,7.13,6.72,22.47,22.47,0,0,0,10.52,2.39,23,23,0,0,0,8.9-1.66,19.55,19.55,0,0,0,7-5l5.52,6.45a24.21,24.21,0,0,1-9.32,6.67A32.55,32.55,0,0,1,1111.47,113Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.31,44.37l-.46.45.38-.28.46-.44-.38.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.84,35.27l-.56.28.42-.16.55-.28-.41.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.05,35.68l-.56.3.41-.17c.18-.11.37-.2.55-.3l-.4.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.88,48.58l-.42.49.33-.31.42-.49-.33.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.45,60.2l-.29.59c.09-.13.17-.26.26-.38l.29-.59c-.08.13-.17.25-.26.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.84,49.7l-.41.51.32-.32.42-.5c-.12.1-.22.21-.33.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.72,35.73l-.56.3.4-.17.55-.3-.39.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.71,61.54c-.1.2-.19.4-.28.6l.24-.38c.1-.2.19-.4.28-.6l-.24.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.28,35l-.56.27.39-.16.57-.27-.4.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.39,40.89l-.51.39.38-.24.51-.39-.38.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,56c-.12.18-.23.37-.35.56l.28-.36c.12-.18.23-.37.35-.56L39,56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.83,50.85l-.4.52.31-.33.41-.51-.32.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.84,39.12c.13.07.26.14.38.22-.17-.13-.35-.25-.53-.37l-.38-.21.53.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.63,43.9c-.16.15-.33.29-.48.44l.35-.27.48-.44-.35.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1,47.23c-.16.16-.3.32-.45.48l.33-.3.45-.48-.33.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.81,47.38l.33.3-.45-.49-.33-.29.45.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.18,41.78l-.5.41.36-.25c.16-.14.33-.27.5-.4l-.36.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.32,64.29l-.26.62c.07-.14.15-.27.23-.4s.16-.41.25-.61l-.22.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.89,32.23l-.57.19.38-.11.57-.19-.38.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,35.57l-.56.29.38-.17.57-.29-.39.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.36,38.14l.37.2-.54-.34-.38-.21.55.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.1,39.94l.37.23-.53-.38-.37-.22.53.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.32,58.58l-.32.58.26-.37.32-.58-.26.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.75,31.61l-.56.17.36-.09.57-.16-.37.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.91,53.23l-.38.54.29-.34c.12-.18.25-.36.38-.53l-.29.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,42.71l-.49.42.35-.26.5-.42-.36.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.32,38.8l-.53.36.36-.22.54-.35-.37.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,49.44l-.43.5.31-.31.42-.51-.3.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.61,40.67l-.52.4c.12-.09.24-.16.36-.24l.52-.39-.36.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.54,59.9l-.31.59.25-.38.3-.58-.24.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.08,67.11c-.08.21-.16.42-.23.63.06-.14.13-.27.19-.41s.15-.41.23-.62c-.07.13-.13.27-.19.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.66,36.22l-.56.31.38-.18L61,36l-.38.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.63,38.92l.36.21-.54-.36-.36-.21.54.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.22,74.92c.05.14.1.28.14.43,0-.22-.09-.44-.14-.65s-.09-.29-.14-.43c0,.21.1.43.14.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.3,36.32l.37.19c-.18-.11-.37-.21-.56-.31l-.37-.18.56.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.23,35.4l-.57.29.38-.17.56-.29-.37.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.76,67.29l.2.41-.24-.63c-.05-.13-.12-.26-.19-.4.08.21.16.42.23.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.89,54.63l.28.34c-.13-.18-.25-.37-.37-.55l-.28-.34c.13.18.25.36.37.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.83,43.66l-.49.44.34-.27.49-.43-.34.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.79,61.25c-.09.2-.19.39-.29.59.07-.13.15-.26.23-.38s.19-.4.29-.59c-.07.13-.15.25-.23.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.81,34.63l-.57.27.37-.16.57-.26-.37.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.84,37.83l-.55.34.37-.2.54-.34-.36.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.51,68.55l-.21.63c.06-.14.11-.27.18-.41s.14-.42.21-.63l-.18.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,50.58l-.42.52.3-.32.42-.52-.3.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.6,76.42l.12.43c0-.22-.08-.44-.13-.65l-.12-.43c0,.21.09.43.13.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.28,47l-.46.47.32-.29.46-.48-.32.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.16,34.72l.37.16-.57-.27-.37-.15.57.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.11,55.71l-.36.56.27-.35.36-.56-.27.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.58,34l.36.15-.57-.25-.37-.14.58.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.12,37.94l.37.21-.55-.34-.37-.21.55.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.08,39.61l-.53.38.36-.23.53-.37-.36.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.92,50.74c.09.11.2.21.29.32l-.41-.51-.3-.32.42.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.48,32l-.57.18.35-.1.57-.18-.35.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.64,47.12l.32.3-.45-.48-.32-.29.45.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.87,39.73l.36.23-.53-.37-.36-.23.53.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.78,55.88c.08.12.17.24.26.35l-.36-.56-.27-.35.37.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.38,36.91l-.56.33.37-.2.55-.32-.36.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,70c-.07.21-.13.42-.2.64l.17-.42c.07-.21.13-.42.2-.63-.06.14-.12.27-.17.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.08,62.61l-.28.6c.07-.13.14-.26.22-.38s.18-.41.28-.61l-.22.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.93,77.93c0,.14.08.29.11.43,0-.22-.07-.44-.11-.65s-.07-.29-.11-.44c0,.22.07.44.11.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,51.76l-.41.52L41.9,52l.4-.52-.28.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.69,44.65l-.48.45.33-.27.48-.45-.33.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.59,37l.36.19-.56-.32L119,36.7l.56.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.27,57c-.12.19-.24.38-.35.57l.25-.36c.11-.19.23-.38.35-.57a3.9,3.9,0,0,0-.25.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.89,32.53l-.57.2.35-.11.58-.21-.36.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.22,48.06l-.45.49.31-.3.45-.49-.31.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.94,36.05c-.19.09-.38.2-.56.3l.36-.18.56-.3-.36.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.78,62.78c.08.13.15.26.22.39l-.29-.6c-.06-.13-.14-.26-.21-.39.1.2.19.41.28.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.58,38.6,56,39c.12-.07.24-.14.35-.22l.55-.35-.36.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.24,44.79l.33.28-.48-.45-.33-.27c.16.15.33.29.48.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.89,51.92l.29.33c-.14-.18-.27-.36-.41-.53l-.28-.33.4.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.23,42.48l-.51.42.34-.26.5-.42-.33.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.49,71.46l-.18.64q.07-.19.15-.42c.06-.21.12-.42.19-.63-.06.14-.11.27-.16.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,36.15l.36.18-.57-.31-.36-.17.57.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.41,64c-.1.2-.18.41-.28.61l.21-.39.27-.61c-.07.13-.14.26-.2.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.23,79.44l.09.44c0-.22-.06-.44-.1-.66s-.06-.29-.1-.43c0,.22.07.44.11.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.62,57.16l.25.36-.34-.57-.25-.36.34.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.86,40.46l-.53.39.35-.24.53-.38-.35.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.52,35.23l-.57.29.36-.17.57-.28-.36.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.71,48.21l.3.31c-.15-.17-.29-.33-.45-.49l-.3-.3.45.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.38,38.72l.36.21-.55-.35-.35-.22.54.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.11,34.47l-.57.27.35-.16.58-.26-.36.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.72,42.61l.34.26-.51-.42-.33-.26.5.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.46,35.33a4,4,0,0,1,.36.17l-.57-.29-.35-.16c.19.09.38.18.56.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.07,53l-.39.54.27-.34.4-.53-.28.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.29,33.85l.35.15-.57-.25-.36-.14.58.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.45,58.29c-.11.19-.23.38-.34.58l.24-.37c.11-.19.22-.39.34-.58-.09.12-.16.24-.24.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.88,34.56l.36.16-.58-.27a3.68,3.68,0,0,1-.35-.15l.57.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.35,71.64l.15.42c-.06-.21-.12-.42-.19-.64l-.15-.41c.07.21.12.42.19.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.46,64.17c.07.13.14.26.2.39-.09-.2-.17-.41-.27-.61s-.13-.26-.2-.39l.27.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.58,45.67c-.16.16-.32.31-.47.47l.31-.29.48-.46-.32.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.11,37.64l-.55.34.35-.2.56-.34-.36.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.68,31.29l-.55.16.32-.08.55-.16-.32.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.19,49.17l-.44.51c.09-.11.2-.21.29-.32l.44-.49-.29.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,72.94c-.06.21-.12.43-.17.65,0-.15.09-.29.14-.43s.11-.43.17-.64c-.05.14-.09.28-.14.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.48,81c0,.15.06.3.08.44,0-.22-.06-.44-.08-.66l-.09-.44.09.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.84,53.12l.27.34-.4-.54a4,4,0,0,0-.27-.34l.4.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.77,65.39c-.09.21-.18.41-.26.62.06-.13.12-.27.19-.4s.17-.41.26-.61c-.07.13-.13.26-.19.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.68,30.29l-.51.11.27,0,.52-.11-.28.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.44,58.46l.24.37c-.11-.2-.22-.39-.34-.58s-.15-.25-.24-.37c.12.19.23.38.34.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.86,37.75l.35.2-.55-.33-.35-.2.55.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.36,45.82l.31.28-.47-.46-.32-.28.48.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.22,32.4l-.58.2.34-.11.57-.2-.33.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.74,49.33l.29.31-.43-.5-.3-.31c.15.16.3.33.44.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.07,43.43l-.5.44.33-.27.49-.43-.32.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.35,39.41l-.54.37.34-.23.54-.36-.34.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.8,73.12c0,.14.09.28.14.42l-.18-.64c0-.14-.09-.28-.14-.42l.18.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.67,36.73l-.56.32.35-.19.56-.32-.35.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.16,54.18l-.39.55.27-.35.38-.54c-.09.11-.18.22-.26.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.67,59.61l-.33.58.23-.37.33-.58c-.08.12-.16.24-.23.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.66,41.34l-.52.4.34-.24.52-.4c-.11.08-.23.15-.34.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.1,65.57c.06.13.12.27.19.4l-.26-.62c-.06-.13-.12-.26-.19-.39.09.2.18.41.26.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.63,74.43c-.06.22-.11.43-.16.65l.12-.43c.06-.21.11-.43.16-.65l-.12.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.69,82.5c0,.15.05.3.07.45,0-.22,0-.44-.07-.67s0-.29-.07-.44c0,.22,0,.44.07.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.89,43.57l.32.26-.5-.43-.32-.26.5.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.32,36.84l.35.19-.57-.32-.35-.19.57.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.88,30.7l-.54.14.29-.07.54-.13-.29.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.16,66.81l-.24.62.18-.4c.07-.21.16-.41.24-.62l-.18.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.13,31.76q-.28.07-.57.18l.33-.1.56-.18-.32.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.19,50.32l-.43.51.28-.32c.14-.18.28-.34.43-.51-.1.1-.19.21-.28.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.24,35.87l-.57.31L61,36l.57-.3-.35.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.75,54.34c.09.12.18.23.26.35l-.38-.55-.26-.34.38.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.22,59.78c.08.12.15.25.23.38l-.33-.59c-.07-.13-.15-.25-.22-.37.11.19.22.38.32.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,30.21l-.52.11.27-.05.51-.1-.26,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.83,35.07l-.57.28.34-.16.58-.28-.35.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.75,36l.35.18-.57-.3-.35-.17.57.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.42,34.32l-.57.26.35-.15.57-.26-.35.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.21,74.61c0,.14.09.29.12.43-.05-.22-.1-.44-.16-.65l-.12-.43c.06.22.11.44.16.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.45,46.87l.3.3-.47-.48-.3-.29.47.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.13,29.05h0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.87,38.4l-.55.36.34-.21.55-.36-.34.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,33.71l.34.14-.58-.25-.34-.13.58.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.74,50.47c.1.11.2.21.29.32l-.43-.51-.28-.32.42.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.7,67l.18.4c-.08-.21-.16-.41-.25-.62s-.11-.27-.17-.4l.24.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.92,61l-.31.59.21-.38.32-.59-.22.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.87,84c0,.15,0,.3,0,.45,0-.22,0-.45,0-.67l-.06-.44.06.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.17,35.17l.34.16-.57-.28-.34-.16.57.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.26,75.93c-.06.22-.1.43-.15.65,0-.14.07-.28.11-.43l.15-.65c0,.14-.08.29-.11.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.28,55.43c-.13.18-.25.37-.37.56l.25-.36c.12-.18.24-.37.37-.55-.09.11-.17.23-.25.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.57,34.41l.35.15-.58-.26-.34-.15.57.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.24,29h0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.94,44.41l-.5.45.32-.27.49-.45-.31.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.78,29h0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.11,38.52l.34.21-.55-.35a3.87,3.87,0,0,0-.34-.21c.19.11.37.23.55.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6,68.24c-.08.21-.16.42-.23.63.05-.13.1-.27.16-.4l.23-.63-.16.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.14,40.25l-.54.38.33-.23.54-.38-.33.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.49,42.25l-.52.42.33-.25c.16-.15.34-.28.51-.42l-.32.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.23,30.61l-.53.13.28-.06.53-.13-.28.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,61.12l.21.38-.31-.59-.21-.38.31.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,44.55l.31.28-.49-.45-.31-.27.49.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.63,55.59l.25.36-.37-.56-.25-.35.37.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.21,51.48l-.42.53.28-.33.41-.52-.27.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.38,30.14l-.5.1.25,0,.5-.1-.25.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.44,47.8c-.15.17-.31.33-.46.49l.3-.3c.15-.16.3-.33.46-.49l-.3.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.58,76.11a3.39,3.39,0,0,1,.11.43c0-.22-.09-.44-.14-.65s-.08-.29-.11-.43c.05.22.1.43.14.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.41,37.45l-.55.34a3.79,3.79,0,0,1,.34-.2l.55-.34a3.79,3.79,0,0,1-.34.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.84,40.37l.33.24c-.18-.14-.35-.27-.54-.39a2.75,2.75,0,0,0-.33-.23l.54.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.84,85.87c0,.15,0,.3,0,.45,0-.22,0-.44,0-.67s0-.29,0-.44c0,.22,0,.44,0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.92,77.44c0,.22-.09.44-.13.65,0-.14.06-.28.1-.43S30,77.22,30,77c0,.15-.07.29-.1.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.27,68.42c.06.14.11.28.16.41l-.23-.63-.16-.4c.08.2.15.41.23.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.21,62.31l-.3.6.2-.38.3-.6c-.07.12-.13.25-.2.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.37,31.09l-.55.15.3-.08.55-.15-.3.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.57,37.56l.34.2-.56-.33-.33-.2.55.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.43,56.7l-.36.57.24-.36c.12-.19.23-.38.36-.57-.09.12-.16.24-.24.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.72,51.64,137,52l-.42-.52-.27-.33.42.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.5,48l.3.31-.46-.49-.29-.3c.15.16.31.32.45.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.07,69.69c-.08.21-.15.43-.22.64l.15-.42.22-.63c0,.14-.11.27-.15.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,36.55l-.56.32.33-.19.57-.31-.34.18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.32,
    y: 28.62,
    width: 0.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.88,28.93h0"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 89.32,
    y: 28.62,
    width: 0.4,
    height: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.51,28.93h0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.83,45.43l-.48.46c.09-.1.19-.19.3-.29l.48-.45-.3.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.92,77.62l.09.43c0-.21-.08-.43-.13-.65l-.09-.44c0,.22.09.44.13.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.68,62.49c.07.12.14.25.2.38l-.3-.6c-.07-.13-.14-.25-.2-.38l.3.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.65,39.2l-.55.37.33-.22L56,39l-.32.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.1,87.13c0,.15,0,.3,0,.45,0-.22,0-.45,0-.67s0-.3,0-.45l0,.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,36.66l.33.18-.57-.31c-.1-.07-.22-.12-.33-.19l.57.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.48,56.87l.24.36c-.12-.19-.24-.38-.37-.57s-.15-.23-.23-.35l.36.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.59,30.53l-.53.12.27-.06.53-.12-.27.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.57,35.7,61,36l.34-.17.57-.3-.33.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.62,79c0,.22-.07.44-.11.66,0-.15,0-.3.08-.44l.12-.66-.09.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.27,52.68l-.41.54.26-.34.41-.54-.26.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.76,34.17l-.57.26.33-.15.57-.26-.33.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.8,69.87l.15.42c-.08-.21-.15-.43-.22-.64l-.15-.41.22.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.16,34.91l-.57.28.33-.17.57-.27-.33.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.41,48.91c-.15.17-.3.33-.44.5.09-.1.18-.21.28-.31s.29-.33.45-.5l-.29.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.34,39.32l.33.23-.55-.37a3.62,3.62,0,0,0-.32-.22l.54.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.34,43.2l-.51.43.31-.27.51-.43-.31.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.13,45.57l.3.29-.49-.47-.3-.28.49.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,41.12l-.53.4.32-.24c.17-.14.35-.27.53-.4l-.32.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9,32.15l-.56.2.31-.11.57-.19-.32.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.44,35.8l.33.18-.57-.3-.33-.17.57.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.25,34.26l.33.15-.58-.26-.33-.15.58.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.58,71.16c-.07.21-.14.42-.2.64,0-.14.09-.28.13-.42l.21-.64c0,.14-.1.28-.14.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.85,35l.33.17-.58-.28-.33-.16.58.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.62,58c-.12.19-.24.38-.35.57l.22-.36.35-.58c-.07.12-.15.24-.22.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.66,52.84c.09.11.18.22.26.34l-.41-.54-.26-.33.41.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.73,31l-.54.15.28-.08.55-.14-.29.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.63,43.33l.32.27-.51-.43-.31-.26.5.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,41.25l.32.24-.53-.4-.31-.24.52.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.21,79.14c0,.14.06.29.08.44,0-.22-.07-.44-.11-.66s-.06-.29-.08-.44c0,.22.08.44.11.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.53,49.06l.28.32c-.14-.17-.3-.34-.45-.5a4.12,4.12,0,0,0-.28-.31c.16.16.31.33.45.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.18,38.21l-.55.35.32-.21.56-.35-.33.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.36,63.87l.18.39c-.09-.2-.19-.41-.29-.61s-.12-.26-.18-.39c.1.2.19.4.29.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.29,71.34c0,.14.09.28.13.42l-.2-.65c-.05-.13-.09-.27-.14-.41l.21.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.3,58.17c.07.12.14.24.22.36l-.35-.57c-.07-.13-.15-.24-.22-.37l.35.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,30.44l-.52.13.25-.07.52-.12a2.27,2.27,0,0,1-.25.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.32,32.72l-.57.22.31-.13.57-.21-.31.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.82,38.32l.32.21-.56-.35-.32-.21.56.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.36,53.9c-.13.18-.27.36-.4.55l.25-.35.4-.54c-.09.11-.17.22-.25.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.13,72.63c-.07.22-.13.43-.19.65l.12-.43.19-.64-.12.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.42,50.05l-.44.51c.08-.11.18-.21.27-.32l.44-.51-.27.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.47,80.66c0,.15,0,.3.07.44,0-.22-.07-.44-.11-.66l-.06-.44c0,.22.07.44.1.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.74,37.26c-.19.11-.38.22-.56.34a3.62,3.62,0,0,1,.33-.2l.56-.33-.33.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.44,40l-.54.38.32-.23.54-.38-.32.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.84,59.31l-.34.59.21-.37.34-.59-.21.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.21,46.62l.29.29-.48-.47-.29-.29.48.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.21,44.17l-.5.45.3-.27.5-.45-.3.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.57,54.06l.25.35c-.14-.18-.27-.37-.4-.55l-.24-.34.39.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.78,42l-.52.41.31-.25c.17-.14.34-.28.52-.41l-.31.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,65.27c.05.13.11.26.17.4-.09-.21-.18-.42-.28-.62s-.11-.26-.17-.4c.1.21.18.41.28.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.26,37.37l.33.2-.57-.33a3.37,3.37,0,0,0-.32-.19l.56.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.11,30.9l-.54.14.27-.08.54-.14-.27.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.55,40.16l.32.23-.54-.38-.32-.23.54.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.74,72.81l.12.43c-.06-.22-.13-.43-.19-.65l-.12-.42c.07.21.13.43.19.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.53,50.2l.27.32-.44-.51c-.09-.1-.17-.21-.27-.31.15.17.3.33.44.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.08,59.49l.21.37-.34-.59-.21-.37.34.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.76,44.32l.3.27-.5-.45-.3-.27c.17.15.34.29.5.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.21,31.43l-.56.17.29-.1.55-.16-.28.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.08,29.09l-.32,0h0l.31,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.72,74.12l-.18.65c0-.14.07-.29.11-.43s.11-.43.17-.65c0,.15-.07.29-.1.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,29.1h0l-.3,0h0l.31,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.21,42.16l.3.25L127,42l-.31-.25.53.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.91,35.53l-.57.3.32-.17.58-.3-.33.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.35,30.36l-.52.12.24-.06.51-.12-.23.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.69,36.48l.32.18-.57-.31-.32-.18.57.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.68,82.2l.06.44-.09-.66c0-.15,0-.3-.05-.45,0,.23.06.45.08.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.48,55.14c-.12.19-.26.37-.38.56.07-.12.16-.23.23-.35l.39-.55-.24.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.9,34.11l.32.14-.58-.25-.31-.15.57.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7,47.55l-.47.48.28-.3.47-.48-.28.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.47,29.06l-.3,0h0l.3,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.1,35.63l.32.18-.57-.3-.32-.17.57.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.57,29.08h0l-.3,0h0l.29,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.51,34.84l.31.16-.57-.27-.32-.16.58.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,39l-.56.37.32-.22c.18-.13.37-.25.56-.37L56,39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.09,60.65l-.32.6c.07-.13.13-.26.2-.38s.21-.4.32-.6c-.06.13-.13.26-.2.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.45,51.21l-.43.53.26-.33.42-.52-.25.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.6,66.68c.05.14.11.27.16.41l-.27-.62-.15-.41c.09.21.17.42.26.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.15,74.3c0,.14.07.29.11.43l-.18-.65c0-.14-.07-.29-.11-.43.07.22.12.44.18.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.86,29l-.28,0h0l.28,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7,32.59l-.58.21a1.88,1.88,0,0,0,.3-.12l.58-.21-.3.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.18,29.05h0l-.28,0h0l.28,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.45,55.31l.24.35-.39-.55-.24-.35c.14.18.26.37.39.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,39.12l.31.22L122.8,39l-.32-.21.56.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.27,47.7l.27.3-.47-.49-.27-.3c.15.17.31.32.47.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.07,93.33l0,.45c0-.22,0-.44,0-.66l0-.45,0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.91,94.48c0,.15,0,.31,0,.46,0-.23,0-.45,0-.67s0-.3,0-.45l0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.34,75.62c-.06.22-.11.44-.16.66,0-.15.06-.29.1-.44s.1-.43.16-.65c0,.14-.07.29-.1.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.11,45.18l-.49.46a3.83,3.83,0,0,1,.29-.28l.49-.46-.29.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5,30.8,74,31l.25-.08.53-.14-.25.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.82,60.83c.06.12.14.25.2.38l-.33-.6-.19-.37c.11.19.21.39.32.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.73,67.94l-.25.63.15-.41c.08-.21.16-.42.25-.63l-.15.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.78,29h0l-.27,0h0l.27,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.86,83.74c0,.14,0,.29,0,.44,0-.22-.05-.44-.08-.66l0-.45c0,.22.05.44.07.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.26,40.9l-.54.4.31-.24.54-.4-.31.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.5,51.37l.26.33-.43-.52-.26-.33c.15.17.29.35.43.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.74,30.28l-.51.12.22-.06.51-.12-.22.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.64,43l-.52.43.3-.27c.17-.14.34-.29.52-.42a3.73,3.73,0,0,0-.3.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.67,29l-.26,0h0l.25,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.52,38l-.56.34c.1-.07.21-.13.31-.21l.56-.34-.31.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.38,29h0l-.25,0h0l.25,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.64,56.41l-.38.57.23-.36c.12-.19.24-.38.37-.56l-.22.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6,31.32l-.55.17.27-.09.55-.16-.27.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.87,45.33l.28.28-.49-.46-.29-.28c.17.15.34.3.5.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.74,41l.3.24-.53-.4-.31-.23.54.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.07,29l-.24,0h.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1,33.2l-.58.24.31-.14.57-.23-.3.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.39,62c-.11.2-.22.4-.32.6.06-.13.12-.26.19-.38s.2-.4.31-.6c-.06.12-.13.25-.18.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,29h-.06l-.23,0H92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.53,75.8l.09.43c-.05-.22-.11-.43-.17-.65s-.06-.29-.09-.43l.17.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.49,38.13l.31.21-.56-.35-.31-.21.56.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.16,68.12c.06.13.1.27.15.41-.08-.21-.16-.42-.25-.63l-.15-.41c.09.21.18.42.25.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.35,43.1l.3.26-.52-.43c-.1-.08-.19-.17-.3-.25l.52.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.48,29l-.23,0h.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.57,29H91.5l-.22,0h.07l.22,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.68,48.65l-.46.5c.08-.11.18-.21.26-.31l.47-.5-.27.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.51,52.4l-.42.54.24-.34.42-.53-.24.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.89,29l-.22,0h-.08l.21,0h.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,77.13c-.06.22-.1.44-.15.66,0-.15.05-.29.08-.44s.09-.44.15-.65c0,.14-.06.29-.08.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.09,37.08l-.56.33.31-.2.57-.32-.32.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.17,29H91l.21,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,86.29l0,.45-.06-.67c0-.15,0-.3,0-.45,0,.22,0,.45.05.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.3,56.58l.22.36c-.13-.19-.25-.38-.38-.56s-.14-.24-.22-.36l.38.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.29,29l-.19,0H88l.2,0h.09"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.51,
    y: 29.02,
    width: 0.4,
    height: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.76,29h-.1l-.2,0h.1l.2,0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.2,69.38c-.08.22-.15.43-.23.64,0-.14.09-.28.13-.41l.24-.64c-.05.14-.1.28-.14.41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.12,
    y: 29.02,
    width: 0.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.7,28.94l-.18,0h.18"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 90.12,
    y: 29.02,
    width: 0.4,
    height: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.35,29h-.12l-.18,0h.3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.53,62.19l.19.38c-.11-.2-.22-.4-.32-.6l-.18-.38.31.6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.52,
    y: 29.02,
    width: 0.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.12,28.94,89,29l-.13,0h.3"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 89.32,
    y: 29.02,
    width: 0.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.94,28.94l-.14,0-.16,0h.3"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 88.92,
    y: 29.02,
    width: 0.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.53,28.94h0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.93,37.19l.31.19-.57-.33-.31-.19.57.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.29,48.8l.27.31-.47-.49a3.88,3.88,0,0,0-.26-.31l.46.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.78,39.83c-.19.12-.37.25-.55.38l.3-.23.55-.38-.3.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.14,30.2l-.5.12.21-.06.5-.11-.21.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9,30.71l-.53.14.24-.07.53-.14-.24.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.45,52.56l.24.34c-.14-.18-.28-.36-.43-.53A2.62,2.62,0,0,0,137,52c.15.18.28.36.43.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,46.22l-.49.47.28-.29.49-.47-.28.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.86,77.31c0,.15,0,.29.08.44l-.15-.66c0-.15,0-.29-.08-.43l.15.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.34,36.3l.31.18-.57-.31-.31-.18.57.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.83,57.71c-.12.19-.24.38-.37.57l.21-.37c.12-.19.24-.38.37-.57-.07.12-.15.24-.21.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.71,63.39l-.3.61.17-.39.3-.61-.17.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.14,34.68l.31.16-.58-.27-.3-.16.57.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.23,40a3.55,3.55,0,0,1,.31.23L124,39.8l-.3-.23.54.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.69,69.57c.05.13.09.27.13.41-.07-.21-.15-.42-.23-.64s-.09-.27-.13-.41c.08.21.16.42.23.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.75,35.46l.3.18-.57-.29-.31-.17.58.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.09,86.83c0,.15,0,.3,0,.45,0-.23,0-.45,0-.67s0-.3,0-.45c0,.22,0,.45.05.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.71,78.65c0,.22-.09.44-.13.66l.06-.44c.05-.22.09-.44.14-.66,0,.15-.05.29-.07.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1,41.8l-.53.42.3-.26.53-.41-.3.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.52,43.94l-.51.44.29-.27c.17-.15.33-.3.51-.44l-.29.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,31.22l-.54.16.25-.09.55-.16-.26.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.06,31.8,70.5,32l.27-.1.56-.19-.27.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.94,46.37l.28.29-.49-.47-.28-.29c.17.15.33.31.49.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.71,70.85c-.07.21-.15.42-.22.64l.12-.42c.08-.21.15-.43.22-.64l-.12.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.69,49.78l-.46.51.26-.31.45-.51c-.09.1-.17.21-.25.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6,53.62l-.41.55.24-.35.41-.54-.24.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.11,57.88l.21.36-.37-.57-.2-.37.36.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.9,41.93l.29.26-.53-.42-.29-.24.53.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.21,63.57l.17.39c-.1-.2-.2-.41-.31-.61s-.11-.26-.17-.39c.11.2.21.4.31.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.62,98c0,.15,0,.3-.07.45,0-.21,0-.43.07-.65s0-.3.08-.46c0,.22,0,.44-.08.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.48,44.08l.28.27-.51-.44-.29-.27.52.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.56,30.13l-.49.11.19-.06.49-.1-.19.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5,33.07l-.58.23.29-.14.57-.22-.28.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.15,78.83c0,.15,0,.29.07.44,0-.22-.09-.44-.14-.66l-.06-.44c0,.22.09.44.13.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.32,30.62l-.53.14.23-.07.52-.14-.22.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.7,38.92l.3.22c-.18-.13-.37-.25-.56-.37l-.3-.21.56.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.29,49.94l.25.32-.45-.51-.25-.32.45.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.18,71l.12.42c-.07-.22-.15-.43-.22-.64l-.12-.42c.08.21.15.43.22.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.35,53.78c.08.12.16.23.23.35l-.41-.55-.23-.34.41.54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.13,
    y: 79.78,
    width: 0.8,
    height: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.46,80.18l-.12.66c0-.15,0-.3.05-.44s.07-.44.12-.66c0,.14,0,.29-.05.44"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.07,64.79c-.09.2-.19.41-.29.61.06-.13.11-.26.16-.39s.19-.42.29-.62c0,.13-.11.26-.16.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.05,59l-.35.58.2-.37.35-.58-.2.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.26,72.32c-.07.22-.14.43-.2.65,0-.14.07-.28.1-.42l.21-.65c0,.14-.07.28-.11.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,47.29c-.17.16-.32.33-.48.49a3.73,3.73,0,0,1,.26-.3l.48-.49-.26.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9,33.72l-.58.25.29-.14.58-.25-.29.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.39,99.5l-.09.45.09-.65.09-.45-.09.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.14,37.93l.3.21-.57-.34-.29-.21.56.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.85,65l.15.4c-.09-.2-.19-.41-.29-.61l-.15-.4c.09.21.19.41.29.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.42,31.12l-.54.16a2.34,2.34,0,0,1,.24-.09l.54-.16-.24.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.89,59.19c.06.13.13.25.19.38-.11-.2-.24-.39-.35-.59s-.13-.25-.19-.37l.35.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.41,80.36c0,.14,0,.29.05.44l-.12-.66c0-.15,0-.3-.05-.44.05.21.08.44.12.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.73,54.86l-.4.56.22-.35.4-.56-.22.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.15,89.93c0,.15,0,.3,0,.45,0-.22,0-.44,0-.66s0-.31,0-.46c0,.22,0,.45,0,.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.47,36.9l-.57.32.3-.19.57-.32-.3.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.43,44.94l-.51.46c.09-.1.19-.19.28-.28l.5-.46-.27.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,47.44l.27.3-.49-.48-.26-.3.48.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.41,40.81a3.47,3.47,0,0,1,.29.25l-.54-.4-.29-.24.54.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.72,50.94l-.44.52.24-.32.44-.52-.24.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.29,34.44l-.58.27a2.69,2.69,0,0,1,.29-.16l.58-.27a2.69,2.69,0,0,0-.29.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.62,29.15l-.33.05,0,0a1.75,1.75,0,0,1,.32,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.48,31.69l-.56.18.26-.1.55-.18-.25.1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.13,
    y: 80.98,
    width: 0.4,
    height: 1.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.24,81.71c0,.22-.07.44-.1.67,0-.15,0-.3,0-.45s.07-.44.11-.66c0,.15,0,.29,0,.44"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147.63,72.5c0,.15.08.29.11.43l-.21-.65c0-.14-.07-.28-.11-.42.07.22.15.43.21.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.68,35.2l-.58.29.29-.17L63,35l-.29.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.47,66.2c-.09.21-.18.42-.28.62l.15-.4c.09-.21.18-.41.28-.62l-.15.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.56,37l.3.2-.57-.33-.3-.19.57.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.74,30.54l-.52.13.22-.07.51-.13-.21.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.12,101c0,.15-.07.3-.1.45,0-.22.06-.43.1-.65s.07-.3.11-.45c0,.22-.07.43-.11.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.31,60.36c-.12.19-.23.39-.34.59l.18-.38.34-.59c-.06.12-.13.25-.18.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.25,29.12l-.32.05v0l.32,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.57,45.08l.27.28-.5-.45-.27-.28.5.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,42.87l.28.26-.53-.42a3.45,3.45,0,0,0-.28-.26l.53.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.23,55l.22.35-.41-.56c-.06-.11-.14-.23-.21-.34.13.18.27.36.4.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.85,73.81c-.06.22-.13.43-.19.65l.09-.43.19-.64-.09.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,36.12l.3.19-.58-.31-.29-.18.57.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,29.14v0l-.31-.05v0l.31,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.37,35.3l.29.17-.58-.29-.29-.16.58.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.25,51.1c.09.11.16.22.24.33-.14-.18-.29-.35-.44-.52l-.24-.33c.15.17.3.34.44.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.62,81.89c0,.15,0,.3,0,.44,0-.22-.07-.44-.11-.66l0-.44c0,.22.07.44.1.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.49,29.1l-.3,0,0,0,.3,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.91,32.93l-.57.23.27-.13.57-.22-.27.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.58,29.11l0,0-.3,0,0,0,.3,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.45,66.38c.05.13.1.27.14.4-.09-.21-.18-.41-.28-.62s-.09-.27-.14-.4c.1.2.19.41.28.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,48.39c-.16.16-.32.33-.47.5a3.76,3.76,0,0,1,.25-.31c.15-.17.31-.33.47-.49a3.61,3.61,0,0,0-.25.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.63,60.53a3.26,3.26,0,0,1,.18.38c-.11-.2-.22-.4-.34-.59l-.18-.38.34.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.89,39.74l.29.23-.56-.38-.29-.22.56.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.81,102.56l-.12.44.12-.64.12-.45-.12.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,74c0,.15.07.29.09.43-.06-.22-.13-.43-.19-.65l-.09-.43c.07.22.13.44.19.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.93,29.08l-.28,0,0,0,.29,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.89,56.13l-.39.56c.07-.12.13-.24.21-.36s.25-.37.39-.56a3.35,3.35,0,0,0-.21.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.14,29.09a.05.05,0,0,1,0,0l-.28,0h0l.28,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.85,31l-.53.16.22-.09.54-.15-.23.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.91,67.63c-.09.21-.18.42-.26.63,0-.14.08-.27.13-.41s.17-.41.26-.62l-.13.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.79,52.13c-.15.17-.29.35-.44.53l.23-.33c.15-.18.29-.36.44-.53l-.23.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.48,75.31c-.06.22-.13.44-.18.66,0-.15.05-.29.08-.44s.11-.43.17-.65c0,.14-.05.29-.07.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.38,29.06l-.27,0,0,0,.27,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.18,30.45l-.51.13.19-.07.51-.12-.19.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.69,29.07l0,0-.27,0h.06a1.15,1.15,0,0,1,.26,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,48.54l.25.31-.47-.49c-.08-.11-.17-.21-.25-.31l.47.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7,38.6l-.57.36a3.15,3.15,0,0,0,.29-.22l.56-.35-.28.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.36,46l-.49.47.26-.29.5-.46-.27.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6,61.71l-.33.6c.06-.12.12-.25.17-.38l.33-.6c-.06.13-.12.25-.17.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.91,31.58l-.56.18.24-.1.56-.17-.24.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.31,33.58l-.58.25.28-.15.58-.24-.28.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.8,83.43c0,.15,0,.3,0,.45l-.09-.67c0-.15,0-.3,0-.44,0,.22.07.44.09.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.82,29l-.25,0-.07,0,.26,0,.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.25,29.05l-.07,0-.25,0L92,29l.25,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.07,56.29l.21.36-.4-.56a3.24,3.24,0,0,0-.2-.36l.39.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.56,41.71l.28.25c-.17-.14-.36-.27-.54-.41L126,41.3l.54.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.46,104.07c0,.15-.08.3-.13.45,0-.22.08-.43.13-.65s.09-.29.13-.44c0,.21-.08.43-.13.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.34,38.72l.29.21-.57-.36-.28-.21.56.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.19,52.29l.23.33c-.15-.17-.29-.35-.44-.53l-.22-.33.43.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.27,29l-.24,0L87,29l.24,0,.08,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8,29l-.08,0-.24,0,.08,0,.24,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,67.81c.05.14.09.27.13.41-.09-.21-.17-.42-.27-.63s-.08-.27-.12-.41l.26.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.64,46.12l.26.29-.5-.47-.26-.29.5.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.28,37.63l-.57.34.28-.2.57-.34-.28.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.73,29l-.23,0-.1,0,.22,0,.11,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.42,75.49c0,.15.05.29.07.44-.05-.22-.12-.44-.18-.66s-.05-.29-.07-.43l.18.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.35,29l-.1,0L91,29l.1,0,.22,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.15,43.84l.27.27-.52-.44-.27-.27.52.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.34,61.89c.06.13.11.26.17.38l-.33-.6c-.06-.12-.11-.25-.17-.38l.33.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.18,29,88,29l-.12,0,.21,0,.12,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9,29l-.12,0-.21,0,.12,0a1.52,1.52,0,0,1,.21,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.63,29l-.19,0-.14,0,.2,0,.13,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.45,29a.7.7,0,0,0-.14,0l-.19,0,.13,0,.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.38,69.08l-.25.63.12-.41c.08-.21.16-.42.25-.63l-.12.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.14,76.82c-.05.22-.11.44-.16.66,0-.15,0-.29.06-.44s.11-.43.17-.65c0,.14-.05.29-.07.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.08,29l-.18,0-.14,0,.18,0,.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,29l-.15,0-.17,0,.14,0L90,29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.08,57.42,37.7,58c.07-.12.13-.24.19-.37l.38-.57c-.06.12-.13.24-.19.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.54,29l-.17,0-.16,0,.17,0,.16,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.87,36.72,59.3,37l.28-.19.57-.32-.28.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.77,37.74l.28.21-.57-.34-.28-.2.57.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.35,34.37l.28.16-.58-.27-.27-.15.57.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.93,85c0,.15,0,.3,0,.44,0-.22-.05-.44-.08-.66v-.45c0,.22,0,.45.07.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.29,30.92l-.53.16L74,31l.54-.14-.22.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.07,105.58c0,.15-.09.29-.15.44.06-.21.1-.42.15-.63l.15-.45-.15.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.63,30.37l-.51.13.18-.07.5-.12-.17.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.93,63.09l-.32.61c0-.13.1-.26.16-.39s.21-.41.31-.61l-.15.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.89,53.34c-.15.18-.29.36-.43.55l.22-.35L41.1,53l-.21.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.18,36.82l.28.2-.58-.33-.28-.19.58.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,35.13a2.61,2.61,0,0,0,.28.17l-.59-.28-.27-.17.58.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.58,36l.28.18-.58-.3-.28-.18.58.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,49.67l.24.32-.46-.51-.24-.31.46.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.54,69.26c0,.14.08.27.11.41-.08-.21-.16-.42-.25-.63s-.08-.28-.11-.41l.25.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.88,57.59c.07.12.13.24.19.36l-.38-.57c-.06-.13-.12-.24-.19-.36l.38.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.06,40.6l.27.24-.55-.4-.28-.23.56.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.75,77c0,.15,0,.29.06.44-.05-.22-.11-.44-.16-.66l-.06-.43c.06.21.11.43.16.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.35,31.47l-.55.18.23-.1.55-.17-.23.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.09,53.5l.22.35-.43-.55-.21-.33c.14.17.29.35.42.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.85,78.34,29.7,79c0-.15,0-.29.05-.44s.09-.44.15-.66c0,.15,0,.3,0,.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,63.27l.15.39-.32-.61-.15-.39.32.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,86.53c0,.15,0,.3,0,.45l-.06-.67c0-.15,0-.3,0-.45l.06.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.89,70.54c-.08.21-.16.43-.23.64,0-.14.06-.28.1-.42l.24-.64c0,.14-.07.28-.11.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.78,44.7l-.51.45c.08-.09.17-.18.25-.28l.52-.45-.26.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.53,39.41l-.56.38.28-.23.55-.37-.27.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.75,33.44l-.58.24.26-.14L67,33.3l-.26.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.68,47.19a3.61,3.61,0,0,1,.25.3c-.16-.16-.32-.33-.49-.48l-.25-.3.49.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.69,42.64l.27.26-.54-.42-.26-.26.53.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.75,30.83l-.52.15.19-.08.52-.15-.19.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.29,64.49l-.3.61c0-.13.09-.26.14-.4l.3-.61c0,.13-.09.26-.14.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.24,44.84l.26.28-.52-.45c-.08-.1-.17-.19-.25-.28l.51.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.61,97.68l-.09.45c0-.22,0-.44,0-.66s.07-.3.1-.45l-.06.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.51,39.53l.28.23-.56-.37-.28-.23.56.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.05,78.52c0,.15,0,.29,0,.44,0-.22-.1-.44-.15-.66s0-.29,0-.44l.15.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.18,108.56,147,109c.06-.21.12-.41.17-.63l.18-.44c-.06.21-.12.42-.17.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,70.72c0,.14.07.28.1.42l-.24-.64c0-.14-.06-.28-.1-.42l.24.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,54.58l-.42.55.21-.35.41-.55-.2.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.08,88.08c0,.15,0,.3,0,.45,0-.22,0-.45-.05-.67s0-.3,0-.45c0,.22,0,.45.05.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.59,79.87c0,.22-.09.44-.13.66,0-.15,0-.29,0-.44s.09-.44.14-.66c0,.15,0,.29,0,.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1,38.4l-.57.36.28-.22.56-.35-.27.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.66,58.9l.18.37c-.13-.19-.25-.39-.37-.58l-.18-.37c.13.19.25.39.37.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.14,34.13l-.58.27.26-.16L65.4,34l-.26.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.44,72l-.22.64.09-.42c.07-.22.15-.43.22-.65l-.09.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,50.83l.23.33c-.15-.18-.3-.35-.46-.52l-.22-.32.45.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.79,32.67l-.57.22.25-.12.57-.22-.25.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.65,64.66c0,.13.09.27.14.4-.1-.2-.2-.41-.31-.62s-.08-.26-.13-.39l.3.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.84,41.36l-.54.41.26-.25.55-.4-.27.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.16,29.26l-.34.06v0l.34-.05v0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.81,31.37l-.54.17.21-.1.54-.16-.21.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.93,29.28a.08.08,0,0,1,0,0c-.11,0-.22,0-.33-.06v0l.34.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,38.52l.27.22-.57-.36a2.78,2.78,0,0,0-.27-.21l.57.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,54.74l.2.36-.42-.56-.2-.34.42.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.38,99.22c0,.15-.07.3-.11.45,0-.22.06-.44.07-.66s.08-.3.11-.45c0,.22,0,.44-.07.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.67,110l-.19.43c.06-.2.13-.41.18-.62s.13-.29.2-.44c-.06.21-.13.42-.19.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.69,37.45l-.57.33.27-.2.57-.33-.27.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.82,32l-.56.2.23-.11.55-.2-.22.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3,36.54c-.2.1-.39.21-.58.32l.27-.19.58-.32a1.85,1.85,0,0,0-.27.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.3,80.05c0,.15,0,.29,0,.44-.05-.22-.1-.44-.14-.66s0-.3,0-.44c.05.22.1.44.14.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.2,41.49l.26.25-.55-.41-.26-.24.55.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.69,65.9c-.09.21-.19.41-.29.62,0-.14.09-.27.13-.4s.19-.42.29-.62c0,.13-.09.26-.13.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.64,29.23l-.33.06,0,0,.33-.05,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.54,35l.27.17-.59-.28a2.26,2.26,0,0,0-.26-.16l.58.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.09,89.63c0,.15,0,.3,0,.45,0-.22,0-.44,0-.66s0-.31,0-.46c0,.23,0,.45,0,.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.37,37.55l.27.21-.58-.34-.27-.2.58.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.45,29.25s0,0,0,0l-.32-.06,0,0,.32.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.48,72.2c0,.14.06.28.08.42-.07-.22-.14-.43-.22-.64s-.05-.29-.08-.43c.07.22.14.43.22.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.22,30.74l-.52.15.18-.08.52-.14-.18.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72,45.73l-.51.47c.09-.1.16-.2.25-.29l.51-.47-.25.29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.13,
    y: 80.98,
    width: 0.4,
    height: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.38,81.41l-.12.66c0-.15,0-.3,0-.44L29.4,81c0,.15,0,.3,0,.45"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M133.7,48.28l.23.31-.48-.49-.24-.31.49.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.16,35.78l.26.18-.58-.3-.26-.18.58.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.77,36.64l.26.19-.57-.32-.27-.18.58.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.12,111.5c-.06.14-.13.29-.2.43.06-.2.13-.41.2-.61s.14-.29.2-.44c-.06.21-.13.41-.2.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1,51.86l-.44.53.21-.34.45-.52c-.07.11-.15.21-.22.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.11,100.75l-.12.45c0-.21.06-.43.08-.65s.08-.3.13-.45l-.09.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.12,29.2l-.32.06,0,0,.31,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,73.5l-.21.65c0-.14.05-.28.08-.42s.13-.44.21-.65c0,.14-.05.28-.08.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.18,55.84l-.4.57.19-.36c.13-.19.26-.38.4-.56l-.19.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.8,43.61l.25.26-.53-.43-.25-.27.53.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.4,60.24c.06.12.11.25.16.37l-.35-.59c-.06-.12-.11-.25-.17-.37l.36.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.3,45.87l.25.29L131,45.7l-.24-.29.5.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.38,40.26l-.55.39.26-.24.56-.38-.27.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.25,66.08c0,.13.09.26.13.4l-.3-.62c0-.14-.07-.27-.12-.4.1.2.2.41.29.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6,29.18l-.3.05,0,0,.3-.05,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.49,29.19l0,0-.3-.06.06,0,.29.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.52,81.59c0,.14,0,.29,0,.44,0-.22-.08-.44-.12-.66s0-.3,0-.45c0,.22.09.44.13.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.07,91.19c0,.15,0,.3,0,.45,0-.22,0-.45,0-.67s0-.3.05-.45c0,.22,0,.44,0,.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.9,52l.21.33-.45-.53-.21-.33.45.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.67,40.39l.26.23-.56-.39-.26-.23.56.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.81,56c.06.12.12.24.19.36-.14-.19-.27-.38-.41-.56l-.19-.36.41.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.28,31.27l-.54.17.2-.1.54-.17-.2.1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.13,
    y: 82.18,
    width: 0.4,
    height: 1.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2,83c0,.22-.07.44-.1.66,0-.14,0-.29,0-.44s.07-.45.11-.67c0,.15,0,.3,0,.45"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M145.54,113c-.07.14-.14.29-.22.43l.21-.61.22-.43-.21.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.89,73.68c0,.15.05.29.07.43-.06-.22-.14-.43-.21-.65s-.05-.28-.07-.42l.21.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.13,67.33l-.28.63c0-.14.07-.28.12-.41l.27-.63c0,.14-.07.27-.11.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.09,29.15l-.29.06-.06,0,.28-.05.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.8,102.28c0,.15-.09.3-.14.45,0-.22.07-.43.1-.65s.1-.3.14-.45c0,.22-.06.43-.1.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,29.17l-.07,0-.28-.05.07,0,.28.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.26,32.55l-.57.21.23-.12.57-.21a1,1,0,0,0-.23.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.41,49.28l-.48.5.23-.32c.15-.17.31-.33.47-.5l-.22.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7,30.66l-.51.14.16-.08.51-.14-.16.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6,34l-.58.25.25-.15.57-.25L65.6,34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.29,31.87l-.56.19L71,32l.55-.19-.21.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.58,29.13l-.27.06-.08,0,.27,0,.08,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,39.21l-.57.37a2.75,2.75,0,0,1,.26-.22l.57-.37-.26.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.66,75c-.07.22-.13.44-.2.66l.06-.44c.07-.21.13-.43.2-.65l-.06.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.52,29.14l-.08,0-.27-.05.08,0,.27,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.73,42.28l-.54.42.25-.25c.18-.15.36-.28.54-.42l-.25.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.07,29.12l-.26.05-.1,0,.26-.05.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,29.13l-.1,0-.25-.05.1,0,.25.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,92.74c0,.15,0,.3-.07.45v-.66c0-.15,0-.3.07-.45v.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.92,114.38c-.08.14-.15.28-.24.42.08-.19.16-.4.23-.6l.24-.42c-.07.2-.15.4-.23.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.82,67.51c0,.13.07.27.11.41-.1-.21-.19-.43-.28-.63l-.12-.41.29.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.11,61.59l.15.39-.35-.6-.15-.39.35.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.69,83.13c0,.14,0,.29,0,.44,0-.22-.07-.44-.1-.66s0-.3,0-.45c0,.22.08.44.11.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.38,57.13l-.4.57.18-.36.39-.57c-.06.12-.12.24-.17.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.11,39.33l.26.23-.56-.38a2.75,2.75,0,0,1-.26-.22l.56.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.69,46.79l-.5.48a3.15,3.15,0,0,1,.24-.3l.49-.48-.23.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.68,49.41l.22.32-.47-.51c-.07-.11-.15-.21-.22-.31.16.16.31.33.47.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.56,29.1l-.24,0-.11,0,.24,0,.11,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.21,53.07c-.15.17-.29.36-.44.54l.2-.35c.15-.18.29-.36.44-.53a3.79,3.79,0,0,0-.2.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.45,103.8l-.15.45c0-.22.07-.43.11-.65s.11-.3.15-.45c0,.22-.07.43-.11.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.54,29.11l-.12,0-.24,0,.12,0,.24,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.32,42.42l.25.26-.54-.43-.26-.25.55.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,34.72,63.4,35l.25-.16.58-.28-.25.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.53,38.21l-.57.35.26-.21.57-.35-.26.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.06,29.09l-.23.05-.13,0,.23,0,.13,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,29.1l-.13,0-.23-.05.14,0,.22,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.26,75.18l.06.44c-.06-.22-.13-.44-.2-.66s0-.28-.05-.43c.06.22.13.44.19.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.56,29.09l-.22,0-.14,0,.21,0,.15,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.55,29.09l-.15,0-.21,0,.15,0,.21,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.05,29.08l-.19.05-.16,0,.19,0,.16,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.61,68.77c-.1.21-.18.43-.27.64,0-.14.06-.28.1-.42l.27-.63c0,.14-.07.28-.1.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.05,29.09l-.17,0-.19-.05.17,0,.19,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.55,29.08l-.18.05-.18-.05.18,0,.18,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.1,34.82l.25.16-.59-.28-.24-.16.58.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.34,46.94a2.37,2.37,0,0,1,.23.3c-.17-.17-.33-.33-.5-.48l-.23-.3.5.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.13,37.26l-.57.34.26-.21.57-.33-.26.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.88,44.6l.24.28-.52-.45c-.08-.09-.17-.18-.25-.28l.53.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.19,62.79l-.33.61L35,63l.33-.61-.14.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.54,38.32l.25.22-.57-.35L121,38c.2.12.38.24.58.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.61,57.3l.18.36-.4-.57-.17-.36c.13.19.27.37.39.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.75,36.36l-.59.32.26-.19.58-.31-.25.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.8,53.23c.06.11.13.22.19.34l-.43-.54-.2-.34.44.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.33,76.51c-.07.22-.13.44-.19.66,0-.14,0-.29.05-.44l.18-.65c0,.14,0,.29,0,.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.77,31.17l-.53.17.18-.1.53-.16-.18.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.19,30.57l-.5.14.14-.08.51-.13-.15.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.06,105.31l-.16.45.12-.64c.06-.15.12-.3.17-.45,0,.21-.08.43-.13.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.72,35.61l.25.18-.59-.3-.25-.17.59.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.26,41.14l-.56.41L53,41.3l.55-.4-.25.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.94,37.37l.25.2-.57-.34-.26-.19.58.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.33,36.46l.25.2c-.19-.11-.38-.22-.58-.32l-.25-.19.58.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.34,69c0,.14.07.28.1.42l-.27-.64c0-.14-.06-.27-.1-.41l.27.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.38,50.41l-.46.51.21-.32c.15-.17.31-.34.46-.52l-.21.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.78,63c.05.13.09.26.13.39-.1-.21-.22-.41-.33-.61s-.09-.26-.14-.39c.12.2.23.4.34.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.78,31.76l-.55.19.19-.11.55-.19-.19.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.74,32.43l-.57.21.22-.13L70,32.3l-.21.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.8,41.27l.25.25-.55-.4-.25-.25.55.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.6,76.69c0,.15,0,.29,0,.44l-.18-.66c0-.14,0-.29,0-.43l.18.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.61,58.44l-.39.58c.06-.12.11-.25.17-.37l.38-.58c-.06.12-.11.24-.16.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.74,95.84c0,.16-.06.31-.1.46,0-.22,0-.44,0-.66s.07-.3.1-.46l0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.12,70.23c-.09.22-.17.43-.25.64,0-.14.05-.27.08-.41s.17-.43.25-.64c0,.14-.06.27-.08.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.34,54.3l-.42.55.19-.35.42-.55-.19.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.64,43.24l-.54.43.25-.27c.17-.14.36-.28.53-.43l-.24.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,78c-.05.22-.11.43-.17.65,0-.14,0-.29,0-.43s.1-.44.16-.66L30,78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.64,50.56l.21.33-.47-.52-.21-.32.47.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.69,47.88l-.49.49c.07-.1.14-.21.22-.31l.49-.49a3.46,3.46,0,0,0-.22.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.92,86.22c0,.15,0,.3,0,.45l-.09-.66,0-.45c0,.22.06.44.08.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.56,64.18c-.11.21-.21.42-.32.62l.12-.4.32-.61-.12.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.81,40.05l-.56.39.25-.24.56-.38-.25.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.11,45.48,47.6,46c.08-.1.15-.2.23-.29l.51-.46-.23.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.69,30.49l-.49.14a.57.57,0,0,1,.13-.08l.49-.13-.13.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.39,58.61c.05.12.1.25.16.37-.13-.19-.25-.39-.39-.58s-.1-.25-.16-.37l.39.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.27,31.07l-.53.17.17-.1.52-.16-.16.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.41,43.37c.08.09.17.18.24.27l-.54-.43c-.08-.09-.15-.18-.24-.27l.54.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.66,54.46l.19.35c-.14-.18-.29-.36-.43-.55l-.18-.35.42.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.83,70.42c0,.13.06.27.08.41-.08-.21-.17-.42-.25-.64l-.09-.41c.09.21.17.42.26.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.25,40.18a2.73,2.73,0,0,1,.25.23l-.56-.38c-.08-.09-.17-.16-.25-.24l.56.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.34,48a3.46,3.46,0,0,1,.22.31l-.49-.5-.22-.3c.17.16.33.32.49.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.55,97.39c0,.15-.07.3-.11.46,0-.22,0-.44,0-.66a3.84,3.84,0,0,0,.11-.46c0,.22,0,.44,0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.89,78.21l0,.44c0-.22-.11-.44-.17-.66s0-.29,0-.43c.06.22.12.44.17.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.93,45.63a3.25,3.25,0,0,1,.23.29l-.52-.47-.23-.28.52.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.41,64.36c0,.13.08.27.13.4l-.33-.62c0-.13-.07-.26-.12-.39l.32.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.46,34.57l-.58.28.23-.17.59-.27-.24.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.39,39l-.57.37.25-.23.57-.36-.25.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.78,79.56c-.05.22-.11.44-.16.67,0-.15,0-.3,0-.45l.15-.66c0,.15,0,.3,0,.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.67,71.71l-.24.64c0-.14.05-.28.07-.42l.24-.64c0,.14,0,.28-.07.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,87.78c0,.15,0,.3,0,.45l-.06-.67c0-.15,0-.3,0-.45,0,.22,0,.44.07.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.87,59.77c-.13.19-.25.39-.37.59l.15-.38.37-.59-.15.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.46,51.59l-.46.52.2-.33c.15-.18.3-.35.46-.52l-.2.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.28,31.65l-.55.19.18-.11.55-.18-.18.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.66,109.78l-.21.44c.05-.21.11-.42.17-.62l.21-.44c-.06.21-.12.41-.17.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.23,29.37l-.34.08,0-.05.34-.07s0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.68,39.13l.25.22-.57-.37-.25-.22.57.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.16,42.06l-.55.42c.07-.09.16-.17.24-.26s.36-.28.55-.41a2.83,2.83,0,0,0-.24.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,38l-.58.35.25-.21.57-.35L58,38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.24,32.3l-.56.21.2-.12.56-.21-.2.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.51,55.56c-.14.18-.28.37-.41.56,0-.12.11-.24.17-.36s.27-.37.41-.56c0,.12-.11.24-.17.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,65.6l-.3.62c0-.14.07-.27.11-.41l.3-.62L34,65.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.32,98.94c0,.15-.08.3-.12.45,0-.22,0-.44.05-.66s.09-.3.13-.45l-.06.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2,30.41l-.48.14.11-.08.49-.13-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.22,36.19l-.58.31.24-.19.58-.31c-.09.06-.16.13-.24.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6,37.08l-.58.33.24-.2.58-.33-.24.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.25,35.45l.24.18-.59-.3-.23-.17.58.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.56,51.74l.2.34-.46-.53c-.06-.11-.13-.22-.2-.33.16.17.31.35.46.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.13,59.94l.14.38-.37-.59-.15-.38.38.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.28,71.89c0,.14.05.28.07.42-.08-.21-.16-.43-.25-.64s0-.28-.06-.42l.24.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.15,79.74c0,.15,0,.3,0,.45l-.15-.67c0-.15,0-.29,0-.44.06.22.11.44.16.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.09,38.13l.24.21-.57-.35-.24-.21.57.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.75,29.34l-.33.07,0-.05.33-.06,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.91,42.19a2.85,2.85,0,0,1,.23.26l-.55-.42-.23-.25.55.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.78,31l-.52.16.15-.09.52-.16-.15.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.37,29.36l-.05.05L94,29.34l.06-.05.32.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.87,36.29l.24.19-.58-.31-.24-.19.58.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.49,37.18l.24.21-.58-.34-.24-.19c.19.1.38.22.58.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.11,111.25l-.22.43.18-.62c.08-.14.15-.29.22-.43,0,.21-.12.41-.18.62"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.13,
    y: 80.58,
    width: 0.8,
    height: 1.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.56,81.1c0,.22-.09.44-.14.66,0-.14,0-.29,0-.44s.08-.44.13-.66v.44"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.5,55.73c.06.11.11.23.17.35l-.42-.56a3.78,3.78,0,0,0-.17-.35l.42.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,65.77c0,.14.08.27.11.41-.1-.21-.2-.42-.31-.62l-.11-.41c.11.21.21.42.31.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.26,73.2c-.08.21-.15.43-.22.65,0-.15,0-.29.05-.43s.15-.43.23-.65l-.06.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.09,46.54l-.51.48.22-.3.51-.47a3.15,3.15,0,0,0-.22.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.27,29.31l-.31.08-.07-.05.32-.07.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.05,100.47c0,.15-.09.31-.14.45,0-.21.05-.43.07-.65s.1-.3.14-.45c0,.22,0,.44-.07.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.85,29.33l-.07.05-.31-.07.07,0,.31.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.32,49.15c.08.1.14.21.21.31L134,49l-.2-.31.48.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.17,61.12l-.36.6.13-.39.36-.59c0,.12-.09.25-.13.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7,40.93l-.56.4.24-.25.56-.39-.24.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.48,44.36l.23.28-.54-.45-.22-.27.53.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8,29.29l-.3.07-.08-.05.3-.07.08.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.53,112.7l-.24.43c.06-.2.13-.41.2-.61l.23-.43c-.07.2-.13.4-.19.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.32,29.31l-.08.05-.3-.07.08-.05.3.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4,67c-.1.21-.2.42-.29.63l.09-.41.3-.62c0,.13-.07.27-.1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,46.69l.21.29c-.17-.15-.33-.32-.51-.47l-.21-.3.51.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.57,52.79l-.45.54.19-.34.44-.54-.18.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.36,81.28v.44c-.05-.22-.09-.44-.14-.66v-.45c.05.23.1.45.14.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.79,31.55c-.18.05-.36.12-.54.18l.17-.11.54-.18-.17.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,90.89c0,.15-.05.3-.07.45,0-.22,0-.44,0-.66s.05-.31.07-.46c0,.22,0,.45,0,.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.37,41.06l.24.24-.56-.4-.24-.24c.19.13.38.26.56.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.71,56.84l-.4.57c0-.12.1-.24.16-.36l.4-.57-.16.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.33,29.27l-.28.07-.1-.05.29-.07.09.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.79,29.28a.53.53,0,0,0-.1.06l-.28-.07.1-.05.28.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.67,32.9l-.57.23.21-.13.56-.23-.2.13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.13,
    y: 82.18,
    width: 0.4,
    height: 1.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.39,82.64c-.05.22-.09.45-.13.67,0-.15,0-.3,0-.45s.08-.44.13-.66c0,.14,0,.29,0,.44"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.74,102l-.15.45c0-.21.06-.43.08-.64s.1-.31.15-.46c0,.22,0,.44-.08.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.83,61.29c0,.13.09.26.13.39l-.36-.6c0-.13-.09-.25-.13-.38l.36.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,34.42l-.58.27.22-.16.58-.27-.22.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3,30.89l-.51.16.13-.09.52-.16-.14.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.75,32.19l-.55.2.18-.12.56-.2-.19.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.87,29.25l-.27.07-.12-.06.27-.05.12,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.89,74.7c-.07.21-.15.43-.21.65a3,3,0,0,1,0-.43l.21-.65c0,.14,0,.28,0,.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.26,29.26l-.12,0-.27-.06L92,29.2l.27.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.9,114.14c-.08.14-.16.28-.25.42q.12-.3.21-.6c.09-.14.17-.28.25-.43-.06.2-.14.4-.21.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.46,53l.18.34-.45-.54-.18-.33c.14.18.3.35.45.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.27,39.85l-.57.38.24-.24.57-.37-.24.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.57,67.2c0,.14.07.27.1.41l-.3-.63-.09-.4c.1.2.2.41.29.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,29.24l-.25.06L87,29.25l.25-.06.13,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.72,29.25l-.13.05-.26-.06.14,0,.25.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.08,43l-.55.43.23-.27.54-.43-.22.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.3,57c.06.12.11.24.16.36l-.41-.57c-.05-.12-.1-.24-.16-.36l.41.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.77,50.14l-.48.52c.07-.11.14-.22.2-.33l.47-.51-.19.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.94,29.23l-.24.06-.14-.05.24-.06.14.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.18,29.23l-.14.06-.24-.06.14-.05.24.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.54,82.82c0,.15,0,.3,0,.45,0-.22-.08-.45-.13-.67s0-.3,0-.44c0,.22.08.44.13.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.39,103.53c0,.15-.11.3-.17.45,0-.22.07-.43.1-.65s.11-.3.17-.45c0,.22-.06.43-.1.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.48,29.22l-.22.06-.17-.05.23-.06.16,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.64,29.22l-.16.06-.22-.06.16,0,.22,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.34,35.19l-.58.29a1.84,1.84,0,0,1,.22-.17l.58-.29-.22.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5,62.49c-.11.21-.23.41-.35.61l.12-.39c.12-.2.24-.4.35-.61l-.12.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,29.22l-.21.05-.18-.05.21,0,.18,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1,29.22l-.18.05-.21-.05.19,0,.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.56,29.22l-.19.05-.2-.05.2-.06.19.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.88,68.47c-.1.21-.19.42-.28.63,0-.14,0-.27.08-.41l.28-.63c0,.13-.05.27-.08.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.24,115.56c-.08.14-.17.28-.26.42.08-.2.15-.4.23-.59l.26-.43c-.07.2-.15.4-.23.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.87,38.81l-.58.37.23-.23.58-.36-.23.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.06,74.88c0,.14,0,.28,0,.43-.06-.22-.14-.44-.21-.66s0-.28,0-.43l.21.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,43.14l.23.27-.55-.43-.22-.26.54.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.54,45.24,48,45.7l.22-.28.52-.46-.21.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1,47.62l-.5.49c.06-.1.13-.2.2-.3l.5-.49-.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.77,35.29l.22.17-.59-.29a1.84,1.84,0,0,0-.22-.17l.59.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.72,36l-.59.31.23-.19.58-.3-.22.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.27,50.3l.19.32-.47-.51c-.07-.11-.13-.22-.2-.32.17.16.32.34.48.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.47,37.83l-.58.35.23-.21.58-.35-.23.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.09,36.9l-.58.33.23-.2.58-.33-.23.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.23,38.93l.23.22-.58-.36-.23-.22.58.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.32,31.44l-.53.19.15-.11.53-.18-.15.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.56,76.21c-.07.22-.14.44-.2.65l0-.43c.06-.22.13-.44.19-.66,0,.15,0,.29,0,.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.71,54c-.14.19-.29.36-.44.55l.17-.35c.15-.18.3-.36.44-.55-.05.12-.12.23-.17.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,58.15c-.14.19-.27.38-.4.58l.15-.37.39-.58c-.05.12-.1.24-.14.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5,62.67l.12.39-.36-.61c0-.13-.07-.26-.11-.38.12.19.23.39.35.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,105l-.18.45c0-.21.08-.43.11-.64l.18-.45c0,.21-.07.43-.11.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.84,30.81l-.51.15.12-.09.5-.15-.11.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.39,36.12l.22.19L117,36l-.22-.19.58.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.52,45.38l.22.29-.53-.46-.21-.28.52.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.78,94c0,.15-.06.31-.1.46v-.67c0-.15.07-.3.1-.45,0,.22,0,.44,0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.1,68.65c0,.14.05.27.08.41l-.29-.63c0-.14,0-.28-.08-.41l.29.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,47.77l.2.31-.51-.49c-.06-.1-.13-.2-.2-.3l.51.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62,37.94l.23.21-.58-.35-.23-.2.58.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,37l.23.2c-.2-.1-.39-.22-.59-.33l-.22-.19L119,37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.67,84.37l0,.45c0-.22-.07-.45-.11-.67l0-.45c0,.22.07.45.11.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.61,41.84c-.18.13-.37.27-.55.42l.22-.26.56-.41-.23.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.72,128.88c-.12.13-.25.24-.37.36l.36-.49.37-.37-.36.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.28,32.07l-.55.21a.66.66,0,0,1,.17-.12l.55-.2-.17.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2,32.78l-.57.22.19-.13.56-.22-.18.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.32,54.18c.05.12.12.24.17.35-.15-.18-.3-.36-.44-.55l-.17-.34.44.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.07,58.32c.05.12.1.25.14.37-.12-.2-.26-.39-.39-.58l-.15-.37c.14.19.27.39.4.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.39,76.39c0,.14,0,.29,0,.43-.07-.22-.13-.44-.2-.65s0-.29,0-.44c.06.22.13.44.19.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.39,69.93l-.27.64c0-.14.05-.28.07-.42l.27-.64c0,.14,0,.28-.07.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.87,63.88l-.34.62c0-.14.08-.27.11-.4s.22-.41.34-.61c0,.13-.08.26-.11.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.47,42l.22.25-.56-.41a2.62,2.62,0,0,0-.22-.25l.56.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.68,130.06l-.38.36c.13-.16.25-.33.37-.49l.39-.36c-.12.17-.25.33-.38.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.64,95.56l-.12.45c0-.22,0-.44,0-.66s.08-.31.11-.46v.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.86,51.32l-.47.52.18-.33L43,51a1.74,1.74,0,0,0-.18.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.48,34.27l-.58.27a1.56,1.56,0,0,1,.2-.16l.58-.27c-.06.06-.14.1-.2.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.26,77.73l-.18.66c0-.15,0-.3,0-.44s.12-.44.19-.66c0,.15,0,.29,0,.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,44l-.54.45.21-.28.54-.44c-.07.09-.15.18-.21.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.76,85.92c0,.15,0,.3,0,.45,0-.22-.06-.44-.1-.67s0-.3,0-.45l.09.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.62,131.22l-.4.34c.13-.16.26-.31.38-.47l.4-.35-.38.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.18,40.72l-.57.4c.07-.09.15-.17.22-.25l.57-.39-.22.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.38,30.72c-.16.06-.33.1-.49.15l.1-.09.49-.14a.39.39,0,0,1-.1.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.58,70.11c0,.14,0,.28.07.42l-.27-.64c0-.14,0-.28-.07-.42.1.21.18.43.27.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.87,31.35l-.53.17.13-.1.53-.18-.13.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.13,64.06l.1.4-.33-.62c0-.13-.07-.26-.11-.39.12.2.23.41.34.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.21,59.48c-.13.19-.26.39-.38.59,0-.13.09-.26.13-.38s.25-.4.39-.59c-.05.12-.09.25-.14.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.19,51.47l.18.34c-.16-.18-.31-.36-.47-.53l-.18-.33.47.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.13,48.74l-.49.5.19-.32.49-.5-.19.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.88,55.28l-.43.56.16-.36.43-.56c-.06.12-.11.24-.16.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.53,46.29l-.52.48.2-.3.52-.47-.2.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.52,132.34c-.13.12-.27.23-.41.34.14-.15.27-.31.4-.46l.4-.34c-.12.16-.26.31-.39.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.05,44.13l.21.27c-.18-.15-.35-.3-.54-.44l-.21-.27.54.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.69,77.91c0,.14,0,.29,0,.44-.06-.22-.12-.44-.19-.66s0-.3,0-.44c.07.22.13.44.19.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.92,40.84c.07.08.14.17.22.25l-.57-.4-.22-.24.57.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.44,97.11c0,.15-.08.3-.12.45,0-.22,0-.44,0-.66s.09-.3.13-.45c0,.22,0,.44,0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.86,35l-.58.29.2-.17.59-.29-.21.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.82,29.56l-.36.09,0-.06.36-.09,0,.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,71.4c-.09.22-.18.43-.26.65,0-.14,0-.29,0-.43s.17-.43.26-.64c0,.14,0,.28-.05.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.32,29.58l0,.07a2.25,2.25,0,0,0-.35-.09l0-.07.35.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.76,39.64l-.57.38.22-.23.57-.38-.22.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,79.26c-.06.22-.12.44-.17.66v-.44c.05-.22.11-.45.17-.66,0,.14,0,.29,0,.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.28,65.29l-.33.62c0-.13.06-.26.1-.4s.21-.41.32-.62c0,.14-.06.27-.09.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.93,48.89c.06.1.12.21.19.31-.17-.16-.33-.33-.5-.5s-.12-.21-.19-.31l.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.8,59.65c0,.12.09.25.14.38l-.39-.59c0-.13-.08-.25-.13-.38.13.2.26.39.38.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.6,109.53l-.23.43.15-.62c.08-.15.16-.29.23-.44l-.15.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.4,133.44l-.42.33.4-.45.42-.33-.4.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.54,46.44c.07.1.14.19.2.29l-.52-.47A3,3,0,0,0,131,46c.18.15.35.31.52.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.15,55.44c0,.12.11.24.15.36l-.43-.56a3.68,3.68,0,0,0-.15-.35c.15.18.29.37.43.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.82,87.48l-.06.45c0-.22,0-.45-.08-.67l.06-.45c0,.22,0,.44.08.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.83,32l-.55.2.15-.12.55-.19-.15.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.24,35.85l-.59.31.21-.19.58-.3-.2.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.38,29.53l-.34.08L84,29.55l.34-.08s0,0,.07.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.74,32.66l-.56.22.17-.14.56-.21a.7.7,0,0,0-.17.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.76,29.55l-.06.06-.34-.09.06-.06a3.37,3.37,0,0,1,.34.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.37,38.62l-.58.36.21-.22.58-.36-.21.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.24,134.51c-.14.11-.28.22-.43.32l.42-.43.42-.33c-.13.15-.27.29-.41.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.22,98.65l-.15.46c0-.22,0-.44,0-.66s.1-.3.14-.46l0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.55,42.78l-.55.43a2.65,2.65,0,0,1,.21-.26l.55-.43-.21.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.61,36.72l-.59.33.21-.2.59-.32-.21.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,37.64,58.4,38l.21-.21.59-.34a2.09,2.09,0,0,0-.22.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.88,36l.21.19c-.19-.11-.39-.21-.59-.31l-.2-.18.58.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,52.52c-.15.18-.31.35-.46.54l.17-.35.46-.53a3.59,3.59,0,0,0-.17.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.73,65.47c0,.13.06.27.09.4l-.33-.61-.09-.41.33.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.05,111l-.24.44c.06-.2.12-.41.17-.62l.24-.44c-.05.21-.11.42-.17.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.94,79.44v.44c-.06-.22-.12-.44-.17-.66v-.44c.06.21.12.44.17.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,29.5l-.33.08-.08-.06.32-.08.09.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.74,38.73,122,39l-.59-.36-.21-.22.58.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.42,31.25l-.52.18.12-.11.52-.17-.12.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2,29.51l-.09.07-.32-.09.08-.06.33.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.52,60.83c-.13.19-.26.39-.38.59l.12-.38.37-.6c0,.13-.08.26-.11.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.51,36.82l.21.2-.59-.32-.21-.2.59.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.13,37.75l.21.21-.58-.34-.21-.21.58.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.54,72.89c-.09.22-.17.43-.24.65,0-.14,0-.29,0-.43s.16-.43.25-.65c0,.14,0,.29,0,.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.54,42.91l.21.27-.55-.43-.21-.26.55.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.83,89c0,.15-.05.3-.07.45,0-.22,0-.45-.07-.67s.05-.3.07-.45c0,.22.05.44.07.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8,80.79c-.06.23-.11.45-.16.67,0-.15,0-.3,0-.45s.1-.44.16-.66c0,.15,0,.3,0,.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.09,56.56l-.42.57c0-.13.09-.25.14-.37l.42-.56a3.84,3.84,0,0,0-.14.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,34.13l-.58.26.19-.16.58-.26-.19.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.52,29.47l-.32.09-.1-.07.32-.08.1.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.08,52.68a3.54,3.54,0,0,1,.16.34l-.46-.54c-.05-.11-.11-.22-.16-.34l.46.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.63,29.49l-.1.06-.31-.08a.53.53,0,0,1,.1-.06l.31.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.94,100.19l-.15.46c0-.22,0-.44.05-.66s.1-.3.16-.45l-.06.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,45l-.54.46.21-.28c.17-.16.35-.31.53-.46L49,45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.46,112.45c-.08.15-.16.29-.25.43.07-.2.12-.4.18-.61l.26-.43c-.06.2-.12.41-.19.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.72,66.72c-.11.21-.21.42-.31.63,0-.14.05-.28.08-.41s.2-.42.31-.63c0,.14-.06.28-.08.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2,49.88l-.49.51c0-.11.12-.21.18-.32l.48-.51-.17.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.51,61c0,.13.07.25.11.38l-.37-.59-.12-.38.38.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.09,29.45l-.3.08a.41.41,0,0,1-.11-.07l.3-.07.11.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.55,47.37l-.52.49c.06-.11.13-.2.19-.31l.51-.48c-.06.1-.13.2-.18.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.06,29.46l-.12.07-.3-.08.12-.06.3.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1,41.62l-.56.41.21-.25.56-.41-.21.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,56.72c.05.12.1.25.14.37l-.42-.57c0-.12-.1-.24-.14-.36l.42.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.16,81c0,.15,0,.3,0,.45-.06-.22-.11-.44-.16-.67s0-.29,0-.44c.05.22.1.44.16.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.39,31.86l-.54.19.13-.12.55-.19-.14.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09,45.14l.19.29-.53-.46-.2-.28.54.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.67,29.43l-.29.08-.13-.07.29-.07.13.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.48,29.44l-.13.07-.28-.08.13-.07.28.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.87,50c.06.11.12.22.17.33-.16-.17-.32-.35-.49-.52l-.17-.32.49.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.84,113.89l-.26.43c.06-.2.13-.4.19-.6l.27-.43c-.07.2-.13.4-.2.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.8,90.59c0,.15-.05.31-.08.46l-.06-.67.09-.45c0,.22,0,.44.05.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.17,33.29l-.57.25a.8.8,0,0,1,.17-.15l.57-.24-.17.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.63,101.73c0,.15-.11.3-.17.45,0-.22,0-.43.07-.65s.12-.3.17-.45c0,.22,0,.43-.07.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.28,66.9c0,.14.06.27.08.41l-.31-.63c0-.14-.05-.27-.08-.41.11.21.21.42.31.63"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.13,
    y: 81.78,
    width: 0.8,
    height: 1.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.62,82.34c-.05.22-.09.44-.14.66l0-.44c0-.22.09-.45.14-.67l0,.45"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126,41.75l.2.25-.56-.41-.2-.25.56.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.53,47.52a3.21,3.21,0,0,1,.19.31l-.52-.49L132,47l.51.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.25,29.41l-.28.08-.14-.06.27-.08.15.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4,34.88l-.58.28L64,35l.58-.28-.19.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9,29.42l-.14.07-.27-.08.15-.06.26.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.17,74.39c-.08.22-.16.43-.23.65,0-.14,0-.29,0-.43s.15-.44.23-.65c0,.14,0,.29,0,.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3,32.54l-.56.21.16-.13.55-.21-.15.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,31.16l-.51.17.1-.1.51-.17-.1.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.85,62.2l-.36.6c0-.13.07-.26.1-.39s.24-.4.37-.6c0,.13-.08.26-.11.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.83,29.4l-.26.08-.16-.07.26-.07.16.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.32,29.41l-.16.07-.25-.08.16-.06.25.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.12,53.74l-.45.55.15-.35.45-.54-.15.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.41,29.39l-.24.08L88,29.4l.24-.07.18.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.74,29.4l-.18.07-.24-.08.18-.06.24.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.68,40.51l-.57.39.2-.24c.2-.13.38-.27.57-.39l-.2.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.18,115.32l-.28.42a5.89,5.89,0,0,0,.21-.59c.1-.14.19-.29.28-.43-.07.2-.13.4-.21.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,29.39l-.22.07-.2-.07.23-.07.19.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.16,29.39l-.2.07-.22-.07.2-.07.22.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.58,29.39l-.22.07-.2-.07.21-.07.21.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2,68.17c-.11.2-.2.42-.3.63l.06-.42.3-.63c0,.14,0,.28-.06.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.33,57.86c-.14.19-.28.38-.41.58,0-.13.09-.25.13-.37l.41-.58c-.05.12-.09.25-.13.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.28,103.25l-.18.46c0-.22.06-.44.08-.65l.19-.45-.09.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.33,82.52l0,.44c-.05-.22-.09-.44-.15-.66s0-.3,0-.45c.05.22.1.44.14.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.74,92.15c0,.15-.07.31-.11.46,0-.22,0-.45,0-.67s.08-.3.11-.45c0,.22,0,.44,0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.51,43.76,50,44.2l.2-.28.55-.43-.2.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.78,35.69l-.59.3.2-.18c.19-.11.39-.21.58-.3l-.19.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.81,74.57c0,.14,0,.29,0,.43-.07-.22-.15-.43-.23-.65s0-.29,0-.43c.08.21.16.43.23.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.94,53.91c0,.11.1.23.15.35l-.45-.55c-.06-.12-.1-.23-.16-.35.16.18.3.37.46.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.17,62.37c0,.13.07.26.1.39l-.36-.6c0-.13-.07-.26-.1-.39l.36.6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.13,
    y: 83.38,
    width: 0.8,
    height: 1.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.49,83.89c0,.22-.09.44-.13.67,0-.15,0-.3-.05-.45s.09-.45.13-.67c0,.15,0,.3,0,.45"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.49,116.73l-.3.42c.08-.2.16-.39.23-.59l.29-.42c-.07.2-.15.39-.22.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.28,39.44l-.58.38a2.29,2.29,0,0,1,.21-.23l.57-.38c-.07.08-.14.15-.2.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.29,51.05l-.48.52.16-.33.48-.52-.16.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.15,36.55l-.59.32c.06-.07.13-.13.2-.2l.58-.32-.19.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.59,43.89c.07.09.13.19.19.28l-.54-.44-.2-.27.55.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.84,75.9c-.08.22-.15.44-.22.66,0-.15,0-.29,0-.44s.14-.44.22-.66c0,.15,0,.3,0,.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.71,58c0,.12.09.25.13.37l-.41-.58c0-.12-.09-.24-.13-.37l.41.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.59,131l-.4.35.37-.48.41-.35-.38.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.89,38.43l-.58.36.2-.23c.2-.11.39-.23.58-.35l-.2.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,31.75l-.53.2a.34.34,0,0,1,.12-.12l.53-.19-.12.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.52,37.46l-.59.34.2-.21.58-.34-.19.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.9,104.77l-.21.45c0-.21.07-.43.1-.64l.2-.45-.09.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,46.05l-.53.47c.06-.1.12-.2.19-.3l.52-.47-.18.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.84,39.56c.07.07.13.15.2.23l-.58-.37a2.2,2.2,0,0,0-.2-.23l.58.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.59,48.48l-.51.5a3.14,3.14,0,0,1,.18-.31l.5-.5-.17.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.57,31.07l-.51.17.09-.1.51-.17-.09.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,36.65l.2.2-.59-.32-.19-.2.58.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.63,93.71l-.12.46c0-.22,0-.45,0-.67a3.74,3.74,0,0,0,.12-.45c0,.22,0,.44,0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5,132.17l-.42.34.38-.46.42-.35c-.13.16-.25.32-.38.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.22,63.59l-.35.61c0-.13.07-.27.09-.4l.35-.61-.09.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.23,38.54a2.09,2.09,0,0,1,.2.22l-.58-.36-.2-.22.58.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.78,51.21a3.36,3.36,0,0,1,.16.33l-.48-.53a3.18,3.18,0,0,0-.16-.32l.48.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.47,84.07c0,.15,0,.29-.05.44,0-.22-.08-.44-.13-.66s0-.3.05-.45c0,.22.08.44.13.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.61,37.57l.2.21-.59-.34-.19-.21.58.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.71,69.63l-.28.63c0-.14,0-.28,0-.42l.28-.63c0,.14,0,.27,0,.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.09,46.19c.07.1.12.2.19.3l-.53-.47c-.06-.1-.12-.2-.19-.3l.53.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.37,133.28l-.43.33.39-.45.43-.34-.39.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.74,33.16l-.57.24a1.07,1.07,0,0,1,.16-.14l.56-.24-.15.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.87,32.42l-.55.22.14-.14.55-.21-.14.13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.13,
    y: 84.98,
    width: 0.4,
    height: 1.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.39,85.44c0,.23-.08.45-.11.67l-.06-.45c0-.22.07-.45.11-.67l.06.45"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.15,76.08v.44c-.07-.22-.14-.44-.22-.66v-.44c.07.22.14.44.22.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.05,42.56c-.19.14-.37.29-.56.42.07-.08.13-.17.2-.26l.55-.42-.19.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3,55l-.44.55c0-.11.09-.23.14-.35s.29-.37.44-.56c0,.12-.1.24-.14.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.46,106.28c-.06.15-.14.3-.21.45,0-.21.07-.42.11-.64l.21-.44c0,.21-.07.42-.11.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.49,48.63l.18.32-.51-.5a3.07,3.07,0,0,0-.17-.31c.17.16.34.32.5.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6,59.19l-.4.58.12-.37.39-.59c0,.13-.08.25-.11.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.22,134.35l-.44.32.4-.44.44-.32-.4.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.8,63.76l.09.4-.35-.61-.09-.4.35.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.54,77.42c-.07.22-.13.44-.2.66v-.44c.06-.22.12-.44.2-.66v.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.48,95.27c0,.15-.09.3-.13.45,0-.22,0-.44,0-.66s.09-.3.13-.46c0,.22,0,.45,0,.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,34.73l-.59.28.18-.17.58-.28-.17.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.06,42.69c.06.09.13.17.19.27-.18-.15-.37-.29-.56-.43a2.48,2.48,0,0,0-.19-.26l.56.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,135.4l-.45.31c.14-.14.28-.28.41-.43s.3-.21.45-.31l-.41.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.76,55.16l.14.36c-.15-.19-.3-.37-.44-.56s-.09-.24-.14-.35l.44.55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.92,
    y: 150.13,
    width: 0.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.1,150.25l.31.06-.31-.06-.3-.07.3.07"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147,107.78c-.07.15-.15.3-.23.44l.12-.63c.08-.14.16-.29.23-.44l-.12.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.82,136.41l-.45.31.42-.42.46-.31c-.14.15-.28.28-.43.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.56,85.62l-.06.45-.12-.67c0-.15,0-.3.06-.45,0,.22.09.45.12.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.41,29.79l-.37.1L83,29.81l.36-.1.07.08"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.92,
    y: 150.13,
    width: 0.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.12,150.25l.29.06-.3-.06-.29-.07.3.07"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 88.92,
    y: 150.13,
    width: 0.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.13,150.25l.28.06-.29-.06-.27-.07.28.07"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.75,29.81l-.06.08-.37-.11.07-.07.36.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.44,59.36l.12.38-.4-.59-.12-.38.4.59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.92,
    y: 150.13,
    width: 0.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.15,150.25l.26.06-.27-.06-.26-.08.27.08"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.55,31.65l-.53.19.11-.12.52-.18-.1.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.59,137.39l-.47.3.43-.4.47-.3-.43.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.62,41.4l-.57.42.19-.26.57-.41c-.06.09-.13.17-.19.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.41,52.25c-.16.17-.31.35-.47.53l.15-.34c.16-.18.32-.35.47-.53l-.15.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.49,44.77l-.54.45.18-.28c.18-.15.36-.31.55-.45a2.75,2.75,0,0,0-.19.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.63,65l-.33.62c0-.13,0-.27.07-.4l.34-.62c0,.14-.05.27-.08.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.44,77.6c0,.15,0,.29,0,.44-.06-.22-.14-.44-.2-.66s0-.29,0-.44l.21.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.27,71.1c-.09.21-.19.43-.27.64l0-.42c.1-.22.18-.43.27-.64l0,.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.29,96.82l-.15.46c0-.22,0-.44,0-.66s.1-.31.14-.46v.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,29.75l-.35.1-.08-.07.35-.1.08.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.34,35.53c-.19.09-.39.19-.58.3a1.54,1.54,0,0,1,.17-.19l.59-.29a1.53,1.53,0,0,0-.18.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.49,109.27l-.24.44c0-.21.09-.42.13-.63s.17-.29.25-.44c0,.21-.09.42-.14.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.15,29.77l-.08.08-.35-.1a.6.6,0,0,0,.08-.08l.35.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.29,79c-.06.22-.13.44-.19.67,0-.15,0-.3,0-.45s.13-.44.19-.66c0,.15,0,.29,0,.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.15,33.84l-.57.26.16-.16.57-.25-.16.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.66,49.62l-.5.51.16-.32.5-.51c-.06.11-.11.21-.16.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,47.12l-.52.49a3.07,3.07,0,0,1,.17-.31l.53-.48-.18.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.61,44.91c.07.09.12.19.18.28l-.54-.45-.18-.29.54.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.66,52.4l.15.35-.47-.54-.15-.34c.16.18.31.36.47.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.21,40.3l-.58.39.2-.24.57-.39-.19.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.61,87.18c0,.15-.05.3-.07.45,0-.22-.07-.45-.11-.67s.06-.3.08-.45c0,.22.07.44.1.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.46,32.31l-.54.21a.71.71,0,0,1,.12-.13l.54-.21-.12.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.51,56.27l-.43.57.12-.36.43-.57-.12.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.91,60.53l-.39.6c0-.13.07-.26.1-.39l.39-.59c0,.13-.07.26-.1.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.39,65.17c0,.14.05.27.08.4l-.34-.62c0-.13,0-.26-.08-.4l.34.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.62,29.72l-.34.1-.1-.08.34-.09.1.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.55,29.74l-.1.08-.34-.11.1-.07.34.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.71,36.38l-.59.32.18-.2.59-.31-.18.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.94,110.74l-.25.44.15-.62c.09-.14.17-.29.26-.44,0,.21-.1.42-.16.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.06,98.37l-.16.46c0-.22,0-.44,0-.66s.1-.31.16-.46c0,.22,0,.44,0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.07,47.27c.06.1.12.2.17.3l-.52-.48c-.05-.1-.11-.2-.17-.3l.52.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.43,49.77c.06.11.11.22.16.32-.17-.16-.34-.34-.5-.51s-.11-.21-.16-.32l.5.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.91,40.42l.19.24-.58-.39c0-.08-.12-.16-.18-.24l.57.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.82,39.24l-.58.38a2.11,2.11,0,0,1,.19-.23L57,39l-.19.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.08,37.28l-.59.34.18-.21.59-.33a1.71,1.71,0,0,0-.18.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.69,79.13c0,.15,0,.3,0,.44-.06-.22-.13-.44-.19-.66s0-.29,0-.44c.07.22.13.44.19.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.45,38.24l-.59.35.19-.22.58-.35-.18.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.43,36.48l.18.19-.59-.31c0-.07-.11-.13-.17-.2l.58.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.23,29.69l-.32.1-.12-.08.33-.09.11.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.94,29.71l-.12.08-.32-.1.11-.08.33.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.55,56.44c0,.12.09.24.13.36-.14-.19-.29-.37-.44-.56l-.12-.36c.15.18.29.37.43.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.86,72.58c-.09.22-.17.44-.26.65,0-.14,0-.28,0-.43s.17-.43.26-.64c0,.14,0,.28,0,.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,43.53l-.55.44.18-.28.55-.43-.18.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.14,60.71c0,.12.07.25.1.38l-.39-.6c0-.12-.07-.25-.1-.38l.39.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.15,31.56l-.52.18.09-.11.52-.19-.09.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.08,66.42l-.33.63.06-.41.33-.63-.06.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.36,112.2l-.27.44.17-.62c.08-.14.18-.28.27-.43-.06.21-.12.41-.17.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.31,39.36l.19.23-.59-.37c0-.08-.12-.15-.18-.23l.58.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.08,80.49l-.18.66,0-.44c.06-.22.11-.44.17-.67,0,.15,0,.3,0,.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.07,37.39l.18.21-.59-.34-.18-.21.59.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.63,88.74c0,.15-.07.3-.1.45,0-.22-.05-.44-.08-.67l.09-.45.09.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.69,38.35l.18.22-.58-.36-.18-.21.58.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.85,29.67l-.32.09-.12-.08.31-.09.13.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.32,29.68l-.13.08-.31-.1.13-.07.31.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.79,99.91c-.06.15-.11.31-.17.46l0-.66c.06-.15.12-.3.17-.45,0,.22,0,.44,0,.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.55,34.58l-.58.28a1.29,1.29,0,0,1,.16-.17l.58-.28-.16.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.57,53.47,41.1,54c0-.12.1-.24.14-.35s.31-.36.46-.55c0,.12-.09.24-.13.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.09,43.66a2.2,2.2,0,0,1,.18.28l-.55-.44-.18-.27.55.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.47,29.65l-.3.09L86,29.66l.3-.09.15.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.71,29.66l-.15.08-.3-.1.15-.07.3.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.74,113.65l-.28.43c.06-.2.12-.4.17-.61l.29-.43-.18.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,66.6,145,67l-.33-.63-.06-.41.33.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5,45.8l-.53.47c.05-.1.11-.19.17-.29l.53-.47c-.06.1-.11.2-.17.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.25,61.9l-.38.61.09-.4.37-.6c0,.13-.06.26-.08.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.09,29.63l-.29.09-.16-.08.29-.09a.8.8,0,0,0,.16.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.91,80.67c0,.15,0,.3,0,.44l-.18-.66c0-.15,0-.3,0-.45.06.23.11.45.18.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.09,29.64l-.17.08-.28-.09.16-.08.29.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.75,57.57l-.42.58c0-.12.08-.25.11-.37l.42-.57c0,.12-.07.24-.11.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.54,130.86l-.42.35c.12-.15.23-.32.35-.47l.42-.36-.35.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.51,53.63l.14.35-.47-.55-.13-.34.46.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.07,32.2l-.54.21a.64.64,0,0,1,.1-.13l.54-.21-.1.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.76,50.79c-.17.17-.33.34-.49.52l.15-.33c.16-.18.32-.35.49-.52a1.66,1.66,0,0,0-.15.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.58,42.34l-.56.42c.06-.09.11-.17.18-.26s.37-.28.56-.42l-.18.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.71,29.62l-.27.09-.18-.08.28-.09.17.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.46,29.63l-.18.08L91,29.62l.17-.08c.09,0,.18.06.27.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.6,90.3c0,.15-.07.3-.11.45,0-.22,0-.44-.07-.66s.07-.31.11-.46c0,.22,0,.44.07.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.49,74.08c-.08.22-.17.44-.24.66,0-.15,0-.29,0-.44s.17-.43.25-.65c0,.15,0,.29,0,.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.08,115.08l-.3.43.2-.6.29-.43c-.06.2-.12.4-.19.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9,82c0,.22-.11.44-.16.66,0-.15,0-.3,0-.45s.1-.44.16-.66c0,.15,0,.3,0,.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.08,48.23l-.52.49c0-.1.1-.21.16-.31l.52-.49a3,3,0,0,0-.16.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.75,33.71l-.57.25.14-.15.57-.25-.14.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.34,29.61l-.26.09a1.11,1.11,0,0,1-.19-.09l.25-.08.2.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.44,132l-.43.34c.12-.15.24-.31.37-.46l.43-.35-.37.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.84,29.61l-.2.09a2.5,2.5,0,0,0-.25-.09l.2-.08.25.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,29.6l-.24.09-.21-.08.24-.09.21.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.21,29.61l-.21.08-.24-.09.21-.08.24.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.59,29.6l-.23.09-.22-.09.22-.08.23.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.61,46c.06.09.11.19.17.29l-.54-.47c-.05-.1-.11-.19-.17-.29l.54.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.93,35.37l-.59.3c0-.07.11-.13.16-.19l.59-.29-.16.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.93,32.92l-.56.23.12-.15.56-.23-.12.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.56,67.86c-.11.21-.21.42-.31.63,0-.13,0-.27,0-.41l.32-.63c0,.14,0,.28,0,.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.31,133.11l-.44.33.38-.45.44-.34c-.12.16-.25.31-.38.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.77,31.46l-.52.19.07-.12.52-.18-.07.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.8,62.07c0,.13.06.27.08.4-.12-.2-.24-.41-.37-.61l-.09-.39.38.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.55,42.47c0,.09.12.17.17.26l-.56-.42-.18-.26.57.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.31,57.74c0,.12.08.25.11.37l-.42-.57c0-.13-.07-.25-.11-.37l.42.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.33,50.94c.06.11.1.22.15.33l-.49-.52-.15-.33c.17.17.33.35.49.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.16,134.19l-.45.32.39-.44.45-.32-.39.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.38,116.5c-.09.14-.2.28-.31.42.08-.2.14-.4.21-.59s.21-.28.31-.43l-.21.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,48.38l.15.31-.51-.5c0-.1-.11-.2-.16-.31l.52.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,135.24l-.46.32c.13-.15.27-.29.4-.43l.46-.32c-.13.15-.27.29-.4.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.35,74.26c0,.15,0,.29,0,.44l-.25-.66v-.43l.24.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.17,41.19l-.58.41.18-.25.57-.41-.17.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.77,136.26l-.47.31.41-.42.47-.31-.41.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.08,82.21c0,.15,0,.3-.05.45-.06-.22-.11-.44-.17-.67l.06-.44c.05.22.11.44.16.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.53,91.86l-.12.46-.06-.67a3.9,3.9,0,0,0,.12-.46c0,.22,0,.45.06.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.53,137.25l-.47.3c.13-.14.28-.27.42-.4l.47-.3c-.13.13-.27.27-.42.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.65,117.89l-.32.42c.08-.2.15-.39.22-.58l.32-.42c-.07.19-.14.39-.22.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3,36.21l-.59.32.16-.2.59-.31c-.06.06-.11.13-.16.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.77,83.59l-.15.66-.06-.45.15-.66.06.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75,54.72l-.45.56c0-.12.08-.24.12-.36l.45-.55-.12.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.16,75.59l-.23.66c0-.14,0-.29,0-.44s.16-.43.23-.65c0,.15,0,.29,0,.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,44.53l-.55.46c.06-.1.11-.2.17-.29l.55-.45-.17.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.62,63.29l-.36.61c0-.13.05-.26.07-.4l.37-.61c0,.14-.06.27-.08.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.77,40.1l-.58.39.17-.25.59-.38c-.07.08-.12.16-.18.24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.72,
    y: 149.73,
    width: 1.2,
    height: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.22,150.05l.3.08-.34-.08-.3-.08.34.08"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.66,37.1l-.59.34.17-.21.59-.33-.17.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,58.9l-.41.58c0-.12.06-.25.1-.38l.41-.58c0,.13-.07.25-.1.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.15,34.43l-.58.28a1.22,1.22,0,0,1,.15-.17l.58-.27-.15.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.69,32.09l-.54.21.09-.13.54-.2a.94.94,0,0,0-.09.12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.72,
    y: 149.73,
    width: 1.2,
    height: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.27,150l.29.08-.33-.07L88,150l.32.08"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.39,39.05l-.58.37c0-.08.11-.15.17-.23l.58-.37c-.05.08-.11.15-.17.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.08,69.32c-.1.21-.21.42-.3.64l0-.42.3-.64,0,.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,38.05l-.59.36c.05-.08.11-.15.16-.22l.59-.35-.16.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.42,93.42l-.13.46c0-.22,0-.44,0-.67s.1-.3.14-.45c0,.22,0,.44,0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.33,54.88l.12.36-.46-.56c0-.11-.07-.23-.11-.35l.45.55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.72,
    y: 149.73,
    width: 1.2,
    height: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.32,150l.28.08-.32-.08L88,150l.31.08"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.1,44.67l.17.28-.55-.45c-.06-.09-.11-.19-.16-.28l.54.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.39,31.37l-.51.19.06-.12.51-.18-.06.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.37,40.22l.17.24-.58-.39-.17-.24.58.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.21,83.76l-.06.45-.15-.66c0-.15.05-.3.06-.45l.15.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.5,37.21l.16.21-.59-.34-.16-.2.59.33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.12,
    y: 149.73,
    width: 0.8,
    height: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.37,150l.26.09-.29-.08-.26-.09.29.08"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.89,52l-.48.53.13-.34.48-.53c0,.11-.09.22-.13.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.43,63.46c0,.14,0,.27.07.4-.12-.2-.24-.41-.37-.61s0-.26-.07-.39c.12.2.24.4.37.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.85,75.77c0,.15,0,.29,0,.44l-.24-.66c0-.14,0-.28,0-.43l.24.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.54,46.88c-.18.15-.36.31-.53.48a3,3,0,0,1,.15-.31l.54-.48a3,3,0,0,0-.16.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.31,106c-.07.15-.15.3-.23.45l.09-.64c.08-.15.16-.3.23-.45,0,.21-.06.43-.09.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.76,39.16l.16.24-.58-.38-.17-.22.59.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.13,38.16l.17.22-.59-.35-.17-.22.59.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.68,85.14c-.05.23-.09.45-.13.67,0-.15-.06-.3-.08-.45s.08-.45.13-.67c0,.15,0,.3.08.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.37,33.58l-.58.25s.08-.11.13-.16l.57-.24a.88.88,0,0,0-.12.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,59.07l.09.38c-.13-.2-.27-.4-.41-.59s-.06-.25-.1-.38c.15.2.28.39.42.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.16,49.36l-.51.51a1.87,1.87,0,0,1,.15-.32l.5-.51c0,.11-.09.22-.14.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,30.05l-.38.13-.08-.1.38-.11.08.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.18,30.08l-.08.09-.38-.12L95.8,30l.38.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.87,77.12c-.07.22-.15.44-.22.66,0-.15,0-.3,0-.44s.15-.44.22-.66c0,.14,0,.29,0,.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.57,43.3l-.56.44c.05-.09.1-.18.16-.27l.56-.44c-.06.09-.11.18-.16.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.2,52.14c.05.11.09.22.14.34l-.49-.54c0-.11-.08-.22-.13-.33.16.17.33.35.48.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.58,47l.15.3-.53-.48-.15-.3.53.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.27,95c-.05.15-.09.31-.15.46,0-.22,0-.45,0-.67l.15-.45c0,.22,0,.44,0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.84,107.52l-.24.45c0-.21.07-.42.11-.64l.24-.44c0,.21-.07.42-.11.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.54,35.22l-.59.29c0-.06.1-.12.15-.18l.58-.29a1.24,1.24,0,0,0-.14.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,64.7l-.36.61.06-.4c.12-.2.24-.41.35-.62,0,.14,0,.27-.05.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,49.51l.14.32c-.17-.17-.33-.34-.51-.5a3.09,3.09,0,0,0-.14-.32l.51.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.31,85.32c0,.15-.06.3-.08.45,0-.22-.09-.44-.14-.67s.06-.3.08-.45c.05.22.1.45.14.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.65,30l-.37.11-.1-.09.37-.11.1.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,56l-.45.57c0-.12.07-.25.11-.36l.45-.57c0,.12-.08.24-.11.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.57,43.44l.16.27-.56-.44L127,43l.56.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.54,30l-.1.09L95.08,30l.1-.09.36.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.64,70.79c-.1.22-.2.43-.29.65,0-.15,0-.29,0-.43s.19-.42.28-.64c0,.14,0,.28,0,.42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.13,
    y: 86.18,
    width: 0.8,
    height: 1.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.62,86.7c0,.23-.07.45-.11.67,0-.15-.07-.3-.1-.45l.12-.67.09.45"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.14,77.3l0,.44-.22-.66,0-.44c.07.22.14.44.22.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.34,60.24l-.4.6c0-.13.06-.26.08-.39l.4-.59c0,.13-.05.25-.08.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.32,32l-.53.2s0-.08.07-.13l.53-.19-.07.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.34,109c-.09.15-.17.3-.26.44l.12-.62c.09-.15.17-.3.26-.44l-.12.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.08,96.54c-.05.15-.1.3-.16.45,0-.22,0-.44,0-.66s.11-.3.16-.46c0,.23,0,.45,0,.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,64.87c0,.14,0,.27,0,.41-.12-.21-.23-.42-.35-.62s0-.27-.06-.41l.36.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.14,42.12l-.57.42.17-.26.57-.42-.17.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3,30l-.36.12L83.83,30l.36-.12.11.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.89,30l-.11.09L94.42,30l.12-.09.35.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.12,56.16c0,.12.07.24.1.36-.14-.19-.29-.38-.44-.56s-.07-.24-.11-.37l.45.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.62,78.65l-.21.66,0-.44c.06-.22.13-.44.2-.66,0,.14,0,.29,0,.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,45.57,48.5,46l.15-.29.54-.46-.15.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.91,36.05c-.2.1-.4.2-.59.31,0-.07.1-.13.15-.2l.58-.3a1.33,1.33,0,0,0-.14.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.79,110.49c-.09.15-.17.3-.27.44,0-.21.09-.41.13-.62l.28-.44c0,.21-.09.41-.14.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.78,34.3c-.2.09-.39.17-.58.27l.12-.17.58-.27-.12.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.05,53.2l-.47.54.12-.35c.16-.17.31-.36.47-.54l-.12.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.73,60.41c0,.13.06.26.08.39l-.4-.59c0-.13,0-.26-.08-.39l.4.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.36,86.88l-.09.45c0-.22-.09-.44-.12-.67l.09-.45c0,.22.08.45.12.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,30l-.34.12-.13-.1.34-.11L85,30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.24,30l-.13.09L93.77,30l.13-.09.34.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.18,32.68l-.54.23a.64.64,0,0,1,.08-.14l.55-.23-.09.14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.13,
    y: 87.77,
    width: 0.8,
    height: 1.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.61,88.27c0,.22-.06.44-.1.67,0-.16-.07-.31-.11-.46s.06-.45.1-.67c0,.15.08.3.11.46"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130.09,45.71l.15.29-.55-.46c0-.1-.09-.2-.14-.3l.54.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.86,98.09l-.18.46v-.66l.18-.46q0,.33,0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.74,41l-.58.41.17-.26.57-.4a2.13,2.13,0,0,1-.16.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.49,66.12l-.35.63c0-.14,0-.28,0-.41s.22-.42.34-.63c0,.14,0,.27,0,.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6,48l-.52.49a2.92,2.92,0,0,1,.14-.31l.52-.49c-.05.1-.09.2-.14.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.27,36.93l-.59.33.15-.2.59-.33c-.06.07-.1.13-.15.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.27,50.52l-.5.52c0-.11.08-.22.13-.33s.33-.35.5-.51a3.05,3.05,0,0,0-.13.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.32,72.28l-.27.65V72.5l.27-.65v.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.21,112l-.29.43c.06-.2.11-.41.15-.61s.2-.29.29-.44l-.15.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.39,78.83c0,.14,0,.29,0,.44l-.21-.66c0-.15,0-.3,0-.45.08.22.14.44.21.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.61,29.93l-.33.11L85.14,30l.32-.11.15.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.59,29.94l-.15.1-.33-.12.15-.09.33.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.05,53.36l.12.35-.48-.55c0-.11-.07-.23-.12-.34l.48.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.45,137.11l-.49.3.41-.41.49-.3-.41.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.89,135.09l-.47.31.38-.43.48-.32-.39.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.68,136.11l-.48.31.4-.42.48-.31-.4.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.36,39.9l-.58.38.15-.24.59-.38-.16.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.41,41.11c0,.08.1.17.16.25L124,41a2.13,2.13,0,0,0-.16-.25l.58.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.63,37.87l-.59.35a1.7,1.7,0,0,1,.15-.22l.59-.35-.15.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.41,80.19c-.07.22-.13.44-.19.66l-.06-.44c.07-.22.13-.45.19-.67l.06.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,38.86l-.59.37.16-.23c.19-.13.39-.25.59-.37l-.16.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.22,57.29l-.44.57c0-.12.07-.24.1-.37l.43-.57c0,.12-.07.25-.09.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.27,29.91A1.92,1.92,0,0,0,86,30l-.17-.1.32-.11.16.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,31.89l-.52.2a1.12,1.12,0,0,1,0-.13l.52-.19,0,.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.52,48.12c0,.11.1.21.14.32l-.53-.5c0-.1-.09-.2-.13-.31l.52.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.93,29.92l-.17.09-.31-.11.17-.09.31.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.69,61.61c-.14.2-.26.4-.39.6,0-.13,0-.26.07-.39s.25-.4.39-.6c0,.13,0,.26-.07.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.59,113.41l-.3.43c.06-.2.11-.41.16-.61s.2-.29.3-.43c-.05.2-.11.4-.16.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.37,88.44c0,.15-.07.3-.11.46,0-.23-.06-.45-.1-.67s.08-.31.11-.46c0,.22.07.45.1.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.85,50.68,135,51c-.16-.18-.33-.35-.5-.52s-.08-.22-.13-.33l.51.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.57,66.3c0,.13,0,.27,0,.41-.11-.21-.22-.42-.34-.63s0-.27,0-.4l.34.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.8,40l.15.25-.58-.39-.16-.24.59.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.58,44.3l-.56.45.15-.28.56-.45-.15.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.54,38l.15.21-.59-.35-.15-.21.59.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.93,29.89l-.3.11-.18-.1.31-.1a1.4,1.4,0,0,1,.17.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.27,29.9l-.18.09-.3-.11.18-.09.3.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.17,39l.16.23-.59-.37-.15-.22.58.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.16,35.07l-.58.28.13-.18.58-.28a1.4,1.4,0,0,0-.13.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.93,114.84c-.1.15-.2.29-.31.43l.18-.6.31-.43-.18.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6,29.87l-.29.11-.19-.1.28-.1.2.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6,29.88l-.19.1-.29-.11.2-.09.28.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.87,57.46c0,.12.07.24.09.37-.14-.2-.29-.39-.43-.58s-.06-.24-.1-.37l.44.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.6,80.36c0,.15,0,.3,0,.45-.06-.22-.13-.44-.19-.66s0-.3,0-.45c.07.22.13.44.19.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.27,29.86,88,30l-.2-.1.27-.1.21.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.94,29.87l-.21.1-.27-.11.21-.09.27.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.39,61.78l.06.39q-.18-.3-.39-.6c0-.13,0-.26-.07-.39l.4.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.56,44.44a1.51,1.51,0,0,1,.15.28l-.55-.45L128,44l.55.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.93,29.86l-.25.1-.23-.1.26-.1.22.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.27,29.86,90,30l-.25-.1.22-.1.26.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.87,73.78c-.1.22-.19.43-.27.65,0-.14,0-.29,0-.43s.17-.44.26-.65c0,.14,0,.29,0,.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6,29.86l-.24.1-.24-.1.24-.1.24.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.26,149.81l.3.09-.36-.08-.3-.1.36.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,67.56l-.33.63,0-.41.33-.63,0,.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.24,116.26l-.33.42c.07-.19.13-.39.19-.59l.33-.42c-.07.2-.13.39-.19.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.34,90c0,.16-.08.31-.12.46,0-.22-.05-.45-.09-.67s.09-.3.13-.46c0,.23.06.45.08.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.23,81.73c-.05.23-.12.45-.17.67,0-.15,0-.3-.07-.45l.18-.67.06.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.25,54.44c-.16.19-.32.37-.47.56,0-.12.07-.24.11-.36s.3-.37.46-.55c0,.12-.07.24-.1.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.84,32.57l-.55.23a1.09,1.09,0,0,1,.08-.15l.54-.22s0,.1-.07.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.35,149.8l.28.1-.35-.09-.28-.1.35.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.09,46.63l-.54.48c0-.1.1-.2.14-.3l.54-.48c0,.1-.1.2-.14.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.42,34.16l-.58.27c0-.06.07-.12.11-.17l.58-.27a1.63,1.63,0,0,0-.11.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.43,149.8l.28.09-.34-.09-.27-.1.33.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.15,43.08c-.2.14-.38.29-.57.43l.15-.27.56-.43c0,.09-.1.18-.14.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.51,117.66l-.34.42c.07-.19.13-.39.2-.58l.34-.42c-.07.19-.13.39-.2.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.54,35.89c-.2.1-.4.2-.59.31l.13-.2.59-.3a1.27,1.27,0,0,0-.13.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.63,31.8l-.52.2a.5.5,0,0,1,0-.13l.52-.19a.56.56,0,0,0,0,.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.53,149.79l.25.1-.32-.1-.26-.1.33.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.17,74c0,.14,0,.29,0,.43l-.27-.65c0-.14,0-.29,0-.43.09.21.18.43.26.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.41,51.71c-.17.18-.33.36-.5.53L43,51.9c.16-.18.33-.35.5-.52-.05.11-.08.22-.12.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.09,67.74c0,.14,0,.27,0,.41q-.15-.32-.33-.63a2.83,2.83,0,0,0,0-.41c.12.21.23.42.34.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.86,54.61a3.57,3.57,0,0,1,.1.35l-.46-.55c0-.12-.07-.24-.11-.35.16.18.32.36.47.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.07,63l-.38.61.05-.39.38-.61c0,.13,0,.26,0,.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7,49.11c-.18.16-.35.33-.52.5,0-.11.08-.21.13-.32l.51-.5-.12.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5,58.61l-.42.59c0-.13.05-.26.08-.38l.42-.58c0,.12,0,.25-.08.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.74,119l-.35.42c.07-.19.15-.38.22-.58s.23-.27.35-.41l-.22.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.05,46.77a2.92,2.92,0,0,0,.14.31l-.54-.48-.14-.3.54.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.78,81.91c0,.15-.05.3-.07.45l-.18-.67c0-.14.05-.3.07-.45l.18.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,43.21c0,.09.1.18.14.27l-.56-.43-.15-.27.57.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.28,91.57c-.05.15-.09.3-.14.46,0-.23,0-.45-.08-.67s.1-.31.14-.46c0,.22.05.44.08.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.54,75.29c-.09.22-.17.44-.25.66l0-.44c.09-.22.16-.44.25-.65l0,.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1,83.29c-.06.22-.11.44-.16.66,0-.15-.06-.3-.08-.45s.11-.44.16-.67c0,.15.06.31.08.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.74,41.91c-.2.13-.39.27-.58.41l.15-.26.57-.41a2.15,2.15,0,0,0-.14.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.54,104.24l-.23.45.06-.64.23-.46-.06.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.71,51.87l.12.34c-.17-.18-.33-.36-.5-.53s-.08-.23-.11-.34l.49.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.43,49.26c0,.1.09.21.13.32l-.52-.51-.12-.32.51.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9,36.76l-.59.33.13-.21.59-.32-.13.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.49,69c-.1.21-.21.42-.32.64,0-.14,0-.28,0-.42s.21-.42.32-.64c0,.14,0,.28,0,.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,63.17c0,.13,0,.26.05.4l-.38-.61c0-.14,0-.27-.05-.4l.38.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.59,58.78c0,.12,0,.25.08.38l-.43-.59c0-.12-.05-.25-.08-.37.15.19.29.39.43.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.35,40.78l-.58.4a2,2,0,0,1,.14-.25l.58-.4a2,2,0,0,0-.14.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.17,93.13l-.15.46-.06-.67.15-.46c0,.23,0,.45.06.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.61,45.33l-.55.47c0-.1.09-.2.14-.3l.55-.46-.14.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.61,30.39a.94.94,0,0,0-.1.1l-.39-.13.09-.1.4.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.26,37.69l-.59.35c0-.08.09-.15.13-.22l.59-.34-.13.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5,32.47l-.54.21.06-.14.54-.21-.06.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.81,34.92l-.58.29.11-.19.58-.28-.11.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.11,105.75c-.08.15-.16.31-.25.45,0-.21,0-.42.08-.63s.17-.31.25-.46c0,.22-.05.43-.08.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.5,75.47l0,.44c-.08-.22-.16-.44-.25-.66l0-.43c.08.21.17.43.25.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.91,83.46c0,.15-.06.3-.08.45-.06-.22-.11-.44-.17-.66l.09-.46c.05.23.1.45.16.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.47,55.71l-.46.57c0-.12.06-.24.1-.37l.45-.56c0,.12-.07.24-.09.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,39.7l-.59.38c0-.08.09-.16.14-.24l.59-.38c0,.08-.1.16-.14.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3,31.71l-.51.19a.53.53,0,0,1,0-.12l.5-.19s0,.08,0,.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.62,38.67,58,39l.14-.22.59-.37-.13.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.57,69.2c0,.14,0,.28,0,.42-.1-.22-.21-.43-.32-.64s0-.28,0-.42c.11.21.21.42.32.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,84.84c-.06.23-.1.45-.15.67,0-.15-.07-.3-.09-.45s.09-.45.14-.67c0,.15.06.3.1.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.82,40.9l.14.25-.58-.4-.14-.25.58.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.92,37.8l.14.21-.59-.34a1.59,1.59,0,0,1-.13-.22l.58.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.48,64.4l-.36.62c0-.14,0-.27,0-.41s.24-.41.37-.61c0,.13,0,.27-.05.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.54,45.47c0,.1.09.19.13.29l-.55-.46c0-.1-.09-.19-.14-.29l.56.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.25,76.81l-.24.66c0-.14,0-.29,0-.44l.24-.66c0,.15,0,.3,0,.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.64,107.26c-.08.15-.17.3-.26.45q.06-.31.09-.63c.09-.15.18-.3.26-.45,0,.21,0,.42-.09.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.2,39.81c0,.09.09.16.14.25l-.59-.39a1.76,1.76,0,0,0-.14-.23l.59.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.57,38.78l.13.23-.59-.36-.13-.23.59.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.93,30.35l-.12.1-.38-.13.11-.1.39.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.82,60l-.42.6c0-.13.05-.26.07-.39l.42-.59c0,.13,0,.26-.07.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.64,55.88l.09.36-.46-.56c0-.12-.05-.24-.09-.36.16.18.31.37.46.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,94.69c-.05.16-.11.31-.17.46,0-.22,0-.44,0-.66s.11-.31.17-.46c0,.22,0,.44,0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.16,47.73l-.53.49c0-.11.09-.21.13-.31s.35-.33.53-.49c0,.1-.09.2-.13.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.58,52.93l-.49.54c0-.12.07-.23.11-.35l.48-.54c0,.12-.06.24-.1.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.05,70.49l-.3.65v-.43l.3-.64v.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,85l-.09.45c-.06-.22-.1-.44-.16-.67s.07-.3.1-.45c.05.22.11.45.15.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.82,50.26l-.52.52c0-.11.07-.22.12-.33s.34-.35.51-.51a3,3,0,0,0-.11.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.59,64.57c0,.14,0,.27,0,.41l-.37-.62c0-.13,0-.27,0-.4.13.2.25.41.37.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,30.29l-.37.13-.13-.11.37-.13.13.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.14,108.76l-.27.44c0-.21.07-.42.1-.63l.27-.44c0,.21-.06.42-.1.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.17,44.07l-.56.45c0-.1.09-.19.13-.28l.56-.45c0,.1-.09.19-.13.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.24,30.31l-.13.1-.37-.13.13-.1.37.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.19,35.73,63.6,36l.12-.2.58-.3-.11.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.79,77c0,.15,0,.3,0,.44l-.24-.66c0-.14,0-.29,0-.44l.24.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.28,60.12l.06.39-.42-.59c0-.13,0-.26-.06-.39l.42.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,47.87l.12.32-.53-.49a2.88,2.88,0,0,0-.13-.31l.54.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.55,53.09l.1.34-.49-.54c0-.11-.07-.23-.1-.34l.49.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.83,96.25c-.06.15-.11.31-.18.46,0-.22,0-.44,0-.66s.13-.31.18-.46c0,.22,0,.44,0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,31.63l-.5.19c0-.05,0-.09,0-.13l.5-.19a.62.62,0,0,1,0,.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.18,32.36l-.53.22a.57.57,0,0,1,0-.14l.53-.21,0,.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.6,110.24l-.29.44.12-.62.28-.44c0,.2-.07.41-.11.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.67,30.25l-.35.14-.15-.11.36-.13.14.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.32,50.41a3.38,3.38,0,0,1,.11.34l-.51-.52c0-.11-.07-.22-.11-.33l.51.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,44.21a2.39,2.39,0,0,1,.13.28l-.56-.45c0-.09-.09-.18-.13-.28l.56.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,78.35c-.08.22-.15.44-.22.66,0-.15,0-.3-.06-.45s.14-.44.22-.66l.06.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.55,30.27l-.15.11L94,30.25l.15-.1.36.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.94,65.82l-.36.63,0-.41c.11-.21.23-.42.35-.62,0,.13,0,.27,0,.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.73,57c-.16.19-.3.38-.45.57,0-.12,0-.24.08-.37l.44-.57c0,.12,0,.25-.07.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.05,86.58c0,.15-.07.3-.11.46,0-.23-.09-.45-.13-.67s.07-.31.11-.46c.05.22.09.45.13.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.37,30.23l-.34.13-.16-.11.34-.13.16.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.75,42.86l-.57.43.13-.27.57-.43c0,.09-.08.18-.13.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,111.71c-.09.15-.19.29-.3.44,0-.21.09-.41.14-.62l.3-.44c-.05.21-.09.42-.14.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.55,36.6l-.59.32.12-.2.59-.32-.12.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.85,30.24l-.16.11-.34-.13.16-.1.34.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.94,88l-.12.67-.12-.46.12-.67.12.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.65,72l-.29.65c0-.15,0-.29,0-.43s.19-.43.3-.65c0,.14,0,.29,0,.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.48,34.78l-.58.28a1.62,1.62,0,0,1,.1-.18l.58-.28a1.62,1.62,0,0,0-.1.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.17,61.32l-.4.6c0-.13,0-.26,0-.39l.4-.6c0,.13,0,.26,0,.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.35,149.53l.29.11-.38-.1-.29-.12.38.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.67,46.39l-.54.48.12-.3.55-.48c0,.1-.09.2-.13.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,78.52c0,.15,0,.3-.06.45-.07-.22-.14-.44-.22-.66l.06-.45c.08.22.15.44.22.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,33.09l-.55.24.06-.16.55-.23-.06.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.07,30.2l-.33.13-.17-.11.33-.12a1.51,1.51,0,0,0,.17.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.15,30.22l-.18.11-.33-.13.18-.1.33.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.4,113.16l-.32.44.15-.61.31-.44c0,.21-.1.41-.14.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.39,57.17c0,.13.05.25.07.37-.14-.19-.3-.38-.45-.57s0-.24-.07-.37l.45.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.14,66c0,.13,0,.27,0,.41l-.36-.63c0-.13,0-.27,0-.4.12.2.24.41.35.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.47,149.52l.28.11-.37-.1-.27-.12.36.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.36,41.69l-.58.42a2.1,2.1,0,0,1,.13-.26c.19-.14.38-.28.58-.41-.05.08-.09.17-.13.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.78,79.89c-.06.22-.14.44-.2.66,0-.15,0-.3-.07-.45l.21-.66.06.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.78,30.19l-.32.12-.19-.11.32-.12.19.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.91,37.52l-.59.34.12-.22L61,37.3l-.12.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.45,30.2l-.2.11-.31-.13.19-.1.32.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.78,54.17l-.48.55.09-.35.48-.55-.09.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.48,46.53a2.85,2.85,0,0,1,.12.31l-.54-.48-.12-.3.54.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.74,114.6l-.33.43c.06-.2.11-.4.16-.6l.33-.43c-.05.2-.11.4-.16.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.93,61.49c0,.13,0,.26,0,.39l-.41-.6c0-.13,0-.26,0-.39l.41.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.07,88.15c0,.15-.08.3-.13.45l-.12-.67c0-.15.09-.3.13-.46l.12.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6,149.51l.26.11-.35-.1-.26-.12.35.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.49,30.17l-.3.12a1,1,0,0,1-.21-.11l.3-.12.21.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.27,48.85l-.53.51c0-.11.07-.22.11-.32l.53-.51c0,.11-.08.22-.11.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.74,30.18l-.21.11-.3-.12.21-.11.3.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,89.54c0,.22-.07.44-.11.67-.05-.16-.09-.31-.13-.46s.06-.45.1-.67c.05.15.09.3.14.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,40.58,55.4,41l.12-.25.59-.39-.13.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.27,38.49l-.6.36.12-.23.6-.36a1.27,1.27,0,0,0-.12.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.87,32.27l-.52.21a.59.59,0,0,1,0-.14l.53-.21,0,.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,51.45c-.17.17-.33.35-.5.53,0-.12.07-.23.1-.34s.34-.35.5-.53l-.1.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.19,30.16l-.28.12-.23-.11.29-.12.22.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.82,41.82l.13.26-.58-.41-.13-.26.58.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,30.17l-.22.11-.29-.12.23-.11.28.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.62,39.51l-.59.38a1.36,1.36,0,0,1,.13-.24l.58-.38-.12.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.73,149.5l.24.11-.34-.11-.24-.11.34.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.05,116l-.34.42.17-.59c.12-.14.23-.28.34-.43-.06.2-.12.4-.17.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9,30.16c-.09,0-.18.07-.27.12l-.24-.12.27-.11.24.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.32,30.16c-.08,0-.16.07-.24.12a1.59,1.59,0,0,0-.27-.12l.24-.11.27.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.61,30.16l-.25.11-.26-.11.26-.12.25.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.43,67.26c-.12.21-.24.42-.35.63,0-.14,0-.27,0-.41l.35-.63c0,.14,0,.28,0,.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.35,54.33l.09.36-.48-.56-.09-.35.48.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.29,73.48c-.1.21-.19.43-.28.65,0-.15,0-.29,0-.43s.18-.44.28-.65c0,.14,0,.28,0,.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.93,38.59l.12.23-.59-.36-.12-.22.59.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.2,40.69c0,.09.09.17.13.26l-.59-.4-.12-.25.58.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.88,49c0,.11.08.21.11.32l-.53-.5c0-.11-.07-.21-.1-.32l.52.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.87,35.58l-.59.3a1.74,1.74,0,0,1,.1-.19l.58-.3a1.63,1.63,0,0,0-.09.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.32,117.43c-.12.14-.24.28-.35.43l.18-.59.35-.42-.18.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.57,39.62c0,.08.09.16.12.24l-.59-.38-.12-.23.59.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,100.9c-.08.15-.15.31-.23.46,0-.22,0-.43,0-.65s.15-.31.22-.46c0,.22,0,.44,0,.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.22,45.1l-.56.46.12-.3.56-.45a2.52,2.52,0,0,0-.12.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,58.33l-.44.58.06-.38.44-.58c0,.13,0,.25-.06.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.18,51.6c0,.12.07.23.1.34l-.51-.53c0-.11-.06-.22-.1-.33l.51.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.61,81.43c-.07.22-.13.45-.19.67,0-.15-.06-.3-.08-.45s.12-.45.19-.67c0,.15.06.3.08.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,89.71l-.14.46-.11-.67c.05-.15.1-.31.14-.46,0,.22.08.45.11.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.55,118.82l-.36.42c.07-.19.14-.38.2-.58l.36-.42c-.06.2-.13.39-.2.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.56,62.7c-.13.21-.27.41-.4.61,0-.13,0-.26,0-.4l.39-.6,0,.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.69,33l-.55.24c0-.06,0-.11,0-.16l.54-.23c0,.05,0,.1,0,.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.78,73.66l0,.43c-.09-.22-.19-.43-.28-.65s0-.29,0-.43c.09.21.19.43.28.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.68,102.44l-.24.46,0-.65.24-.46,0,.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.1,58.49c0,.13,0,.26.06.38l-.44-.58-.06-.38.44.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.55,62.87l0,.4-.39-.61c0-.13,0-.26,0-.39.13.2.26.4.4.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.58,32.17l-.52.21a.66.66,0,0,1,0-.14l.52-.21a.71.71,0,0,0,0,.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.23,36.44l-.59.32.1-.21.59-.31a1.24,1.24,0,0,0-.1.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,55.44c-.16.18-.31.37-.47.56,0-.12.05-.24.08-.36s.31-.38.47-.56c0,.12-.06.24-.08.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,91.28l-.15.45-.09-.66.15-.46.09.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.76,47.48l-.54.49c0-.1.07-.21.11-.31l.54-.49c0,.11-.08.21-.11.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.79,43.85l-.57.44.12-.28.57-.44-.12.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,75l-.27.65c0-.14,0-.29,0-.43s.18-.44.26-.66c0,.15,0,.3.05.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,68.72l-.33.64v-.42L34,68.3v.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.29,104c-.08.15-.16.3-.25.45,0-.21,0-.43,0-.64s.17-.31.25-.46c0,.22,0,.44,0,.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.21,30.71l-.41.16-.11-.12.41-.15.11.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.48,83l-.18.66c0-.15-.06-.3-.1-.45s.12-.44.18-.67c0,.15.07.3.1.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.24,126.71l-.43.38c.1-.17.19-.35.28-.52l.43-.38-.28.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.24,127.94l-.44.37c.1-.16.2-.33.29-.5l.44-.38-.29.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.21,129.15l-.45.37c.1-.17.21-.33.3-.5a5.54,5.54,0,0,0,.45-.37c-.09.17-.2.34-.3.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,30.74l-.11.12-.4-.15.11-.12.4.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.14,52.66l-.49.54c0-.12.05-.23.08-.35l.5-.53-.09.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4,50l-.52.51.09-.33.53-.51c0,.11-.07.22-.1.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.12,55.6c0,.12,0,.24.07.36-.15-.19-.31-.37-.47-.56a2.29,2.29,0,0,0-.07-.36c.16.19.32.37.47.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.86,105.49c-.08.15-.17.3-.26.45l.06-.64c.09-.15.18-.3.26-.45,0,.21,0,.43-.06.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.11,75.17c0,.14,0,.29-.05.43l-.27-.65c0-.15,0-.29.05-.44l.27.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.59,37.35l-.6.34.11-.22c.19-.12.39-.23.59-.34a1.47,1.47,0,0,0-.1.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.34,59.67c-.15.19-.29.39-.43.59,0-.13,0-.26.05-.39l.43-.58c0,.12,0,.25,0,.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,64.11c-.13.2-.26.4-.38.61,0-.13,0-.27,0-.4s.25-.41.38-.62c0,.14,0,.27,0,.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.39,42.64l-.58.43.12-.27.58-.42-.12.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.87,92.84c-.06.16-.12.31-.17.46,0-.22,0-.44-.08-.66l.17-.47c0,.23.05.45.08.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.93,30.67l-.39.15-.13-.12.39-.15.13.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.56,83.16c0,.15-.07.3-.1.46-.06-.23-.12-.45-.19-.67s.07-.3.11-.46l.18.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,52.82l.09.35-.5-.54c0-.12-.06-.23-.08-.35l.49.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4,32.87l-.54.24,0-.16.54-.23,0,.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.39,84.55c-.06.22-.12.44-.17.67,0-.16-.07-.31-.11-.46s.11-.45.17-.67c0,.15.07.3.11.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.56,35.43l-.59.3.09-.19.58-.29a1.42,1.42,0,0,0-.08.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.4,107c-.09.15-.18.3-.28.45,0-.21,0-.42.07-.63s.19-.31.28-.45c0,.21-.05.42-.07.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.67,76.51c-.09.22-.17.44-.25.66l-.06-.44.25-.66.06.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.94,38.31l-.59.35.1-.22.59-.36c0,.08-.07.15-.1.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,41.49l-.58.41a2,2,0,0,1,.11-.26l.58-.41c0,.09-.07.17-.11.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3,32.08l-.51.21a.71.71,0,0,1,0-.14l.51-.21a.61.61,0,0,0,0,.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.78,59.84c0,.12,0,.25.05.38l-.43-.59c0-.13,0-.26-.05-.38.15.19.29.39.43.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.13,64.28c0,.13,0,.27,0,.4l-.39-.61a2.61,2.61,0,0,0,0-.4l.39.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.29,46.15l-.55.48.1-.31.56-.47-.11.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.66,30.63l-.38.15-.14-.12.38-.14.14.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.52,70.19c-.12.21-.22.43-.33.64,0-.14,0-.28,0-.42l.32-.64c0,.14,0,.28,0,.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.29,39.32l-.59.37.1-.24.6-.37a2.56,2.56,0,0,0-.11.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.65,40.38l-.59.39a2.72,2.72,0,0,1,.11-.25l.59-.39a1.89,1.89,0,0,0-.11.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.9,108.5l-.29.45c0-.21.06-.42.08-.63s.2-.3.29-.45c0,.21,0,.42-.08.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.18,41.61l.12.26-.59-.41c0-.09-.07-.17-.11-.26l.58.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.44,149.21l.27.12-.39-.11-.27-.13.39.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.28,56.73l-.46.57a2.38,2.38,0,0,1,.06-.37l.46-.57c0,.13,0,.25-.06.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.92,39.43l.1.24-.59-.38a1.63,1.63,0,0,0-.11-.23l.6.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.65,84.72c0,.15-.07.3-.11.46-.06-.23-.11-.45-.17-.67s.08-.31.11-.46c.06.22.12.45.17.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.56,40.49c0,.09.07.17.11.26l-.6-.4c0-.08-.07-.16-.1-.25l.59.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.39,76.69a3.32,3.32,0,0,1-.06.44c-.08-.22-.16-.44-.25-.66l.06-.44c.09.22.17.44.25.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4,30.6l-.37.14-.16-.12.37-.14.16.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.34,86.11c-.05.22-.11.45-.15.67-.05-.15-.09-.31-.13-.46l.15-.67c0,.16.08.31.13.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.35,110l-.3.44c0-.21.07-.41.1-.62l.31-.45c0,.21-.07.42-.11.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6,149.19a2.1,2.1,0,0,0,.26.13l-.38-.12-.26-.13.38.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.43,65.53l-.37.62c0-.14,0-.27,0-.41l.37-.62c0,.14,0,.27,0,.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.88,48.6l-.54.5.09-.32.54-.49-.09.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.42,78l-.24.67c0-.15-.05-.3-.07-.45l.24-.66c0,.15,0,.3.07.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.93,36.28l-.59.32a1.89,1.89,0,0,1,.09-.21l.58-.31-.08.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.14,30.57l-.36.14-.18-.12.36-.14.18.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7,61c-.15.2-.28.4-.42.6l0-.39.42-.6c0,.13,0,.26,0,.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.86,56.89l.06.38c-.15-.2-.31-.39-.46-.58l-.06-.36c.16.18.31.38.46.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.11,30.59l-.18.12-.35-.14a1.13,1.13,0,0,1,.18-.12l.35.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.35,53.9l-.48.55c0-.12,0-.24.07-.35s.32-.37.49-.55c0,.12,0,.23-.08.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.77,111.46l-.31.44c0-.2.08-.41.11-.61s.21-.3.32-.44l-.12.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.76,149.18l.25.13-.37-.12-.24-.13.36.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.86,44.87l-.57.46c0-.1.07-.2.11-.3l.56-.45a1.42,1.42,0,0,0-.1.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.56,51.19l-.52.53.09-.34.51-.53c0,.12-.06.23-.08.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.13,32.77l-.54.23s0-.1,0-.16l.54-.22a.76.76,0,0,0,0,.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.12,71.68c-.11.21-.21.43-.31.65,0-.15,0-.29,0-.43l.3-.65c0,.14,0,.29,0,.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.88,30.55l-.34.14c-.07-.05-.14-.08-.2-.13l.35-.13.19.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.7,86.28c0,.16-.08.31-.13.46,0-.22-.1-.45-.15-.67s.09-.3.13-.46l.15.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.37,30.56l-.2.12-.34-.14.2-.12.34.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.16,112.92l-.33.44c0-.2.09-.41.13-.61l.33-.44c0,.21-.09.41-.13.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.93,149.17l.23.13-.35-.12-.23-.14.35.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.67,65.7c0,.14,0,.27,0,.41l-.37-.62c0-.14,0-.27,0-.41.13.2.25.41.37.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.32,87.68c-.05.22-.09.44-.13.67L30,87.89c.05-.23.1-.45.14-.67.05.15.09.31.14.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.3,97.53c-.06.15-.14.3-.21.46l0-.66.21-.46,0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.43,61.2l0,.39L141,61l0-.39.42.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.8,54.06c0,.12,0,.24.07.35l-.49-.54c0-.12,0-.24-.07-.36l.49.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.64,78.22c0,.15,0,.3-.07.45l-.24-.67c0-.14,0-.29.07-.44l.24.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.62,30.53l-.32.14-.21-.13.33-.13.2.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.62,30.54l-.21.12-.32-.14.21-.12.32.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.61,51.34c0,.11,0,.23.08.34-.18-.17-.34-.35-.52-.52a3.38,3.38,0,0,0-.08-.34l.52.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5,114.37c-.11.14-.22.29-.34.43l.15-.6.34-.44-.15.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.29,37.18c-.2.11-.4.22-.59.34a1.43,1.43,0,0,1,.08-.22l.59-.33-.08.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.37,30.51l-.31.14a1.71,1.71,0,0,1-.23-.13l.32-.13.22.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.88,30.52l-.23.13-.31-.14.22-.12.32.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.45,43.63l-.58.44c0-.1.07-.19.1-.28l.58-.44a2.31,2.31,0,0,0-.1.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.21,79.59c-.07.22-.15.44-.22.66l-.09-.45.23-.66c0,.15.05.3.08.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.81,115.8l-.35.42c0-.19.11-.39.16-.59l.35-.43c-.05.2-.11.4-.16.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.89,33.54l-.56.25,0-.17.56-.25a1,1,0,0,0,0,.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.12,30.5l-.3.14-.24-.13.3-.13.24.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.13,30.51l-.24.12-.3-.13.24-.12.3.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.57,58.05l-.45.58c0-.13,0-.26.05-.38l.45-.58c0,.13,0,.25,0,.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.87,30.5l-.28.13-.26-.13.29-.13.25.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.38,30.5l-.26.13-.28-.13.25-.13.29.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,99.08l-.23.46c0-.22,0-.44,0-.66l.23-.46c0,.22,0,.44,0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.63,30.49l-.28.14-.27-.14.28-.12.27.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.93,67c-.12.21-.25.41-.36.63,0-.14,0-.28,0-.42l.36-.63c0,.14,0,.28,0,.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.72,87.85l-.15.46c0-.23-.09-.45-.14-.67l.15-.46c0,.22.09.45.14.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.08,117.21c-.11.14-.24.28-.36.42l.17-.59.37-.42c-.06.2-.11.39-.18.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6,34.37l-.57.28c0-.06,0-.12,0-.18l.57-.27c0,.06,0,.11,0,.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.39,47.24l-.55.49a2.81,2.81,0,0,1,.1-.31l.54-.49-.09.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.32,118.6,141,119l.18-.58.38-.42c-.06.19-.12.39-.19.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.64,38.13q-.3.16-.6.36l.09-.23.6-.35a1.45,1.45,0,0,0-.09.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.09,62.41l-.41.61c0-.13,0-.27,0-.4l.41-.6c0,.13,0,.26,0,.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.75,73.18c-.1.21-.2.43-.29.65,0-.15,0-.29-.05-.44l.3-.64c0,.14,0,.28,0,.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.06,42.43l-.58.43a1.69,1.69,0,0,1,.1-.27l.58-.43c0,.09-.07.18-.1.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.52,120l-.38.42c.06-.19.13-.38.19-.57s.26-.28.39-.42c-.06.19-.13.38-.2.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,130.16l-.47.35.3-.48.47-.36-.3.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.87,32.67l-.53.23s0-.1,0-.16l.53-.22a.76.76,0,0,0,0,.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.57,58.21c0,.13,0,.25,0,.38l-.45-.58c0-.13,0-.25,0-.38l.45.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.69,121.33c-.13.13-.26.27-.4.4.08-.18.14-.37.21-.56s.27-.27.4-.41l-.21.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.73,100.63l-.24.46v-.66l.23-.46c0,.22,0,.44,0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,129l-.45.37.28-.5.46-.37a5,5,0,0,1-.29.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,39.13l-.6.37.09-.23.6-.37a1.57,1.57,0,0,0-.09.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.82,122.66l-.4.4.22-.55.41-.4c-.08.18-.15.37-.23.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.69,41.28l-.59.41c0-.09.07-.17.1-.26.19-.14.39-.27.59-.4l-.1.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,127.76l-.45.37.28-.51.45-.37c-.09.17-.18.34-.28.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.59,55.17l-.48.56.06-.37.48-.55-.06.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.92,124l-.42.39q.13-.27.24-.54c.14-.13.29-.26.42-.4a5.38,5.38,0,0,1-.24.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,126.52l-.44.38c.09-.17.17-.35.26-.52l.44-.38c-.08.17-.17.34-.26.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.34,40.18l-.6.39c0-.08.07-.16.1-.25l.59-.38a2.34,2.34,0,0,0-.09.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,125.26l-.43.38c.09-.17.17-.35.25-.53l.43-.39c-.08.18-.16.36-.25.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.14,42.56c0,.09.07.18.1.27l-.58-.43a2,2,0,0,0-.1-.26c.2.13.39.28.58.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,49.76c-.18.16-.36.33-.53.51,0-.11,0-.22.08-.33l.53-.51c0,.11-.05.22-.08.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,81.13l-.21.67c0-.15-.07-.3-.1-.45l.21-.67c0,.15.06.3.1.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.69,89.42c-.05.15-.11.3-.16.46l-.12-.67.15-.46c0,.22.09.44.13.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,62.58l0,.4c-.14-.2-.28-.4-.41-.61s0-.26,0-.39l.41.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.42,90.82c0,.22-.08.44-.11.67L30.14,91c0-.22.07-.44.11-.66.05.15.11.3.17.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.75,52.4l-.51.54c0-.12,0-.24.07-.35l.51-.53a3.4,3.4,0,0,0-.07.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.34,73.35c0,.15,0,.29-.05.44l-.3-.65c0-.15,0-.29,0-.43l.3.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.24,39.24a2.25,2.25,0,0,1,.08.24l-.59-.37-.09-.24.6.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.52,41.4a1.61,1.61,0,0,1,.09.26l-.58-.4a2,2,0,0,0-.1-.26l.59.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.88,40.3a1.84,1.84,0,0,1,.09.25l-.59-.39-.09-.25.59.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.38,102.17l-.25.46c0-.22,0-.44,0-.65l.25-.46c0,.22,0,.43,0,.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.81,31.1a4.08,4.08,0,0,1-.42.17l-.12-.13.42-.17.12.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.56,55.33l.06.36-.48-.56-.06-.36.48.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.16,49.9c0,.11.05.22.08.33l-.53-.51c0-.11-.06-.22-.08-.33l.53.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,45.92l-.57.47.09-.3.56-.47c0,.1-.06.2-.08.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.46,68.42l-.35.64c0-.14,0-.28,0-.42l.35-.64c0,.15,0,.28,0,.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,81.31c0,.15-.07.3-.11.45l-.21-.67c0-.15.07-.3.1-.45.08.22.15.45.22.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.63,33.42l-.54.25a1,1,0,0,1,0-.17l.54-.24c0,.05,0,.11,0,.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.42,52.55c0,.12.05.23.07.35l-.51-.54c0-.11,0-.23-.07-.34l.51.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.43,74.69c-.1.22-.19.44-.28.65,0-.14,0-.29-.06-.43s.18-.44.28-.66a3.11,3.11,0,0,0,.06.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9,59.38c-.14.2-.29.4-.44.59l0-.38c.15-.2.3-.39.44-.59l0,.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,103.71l-.27.45c0-.22,0-.43,0-.65s.18-.3.27-.45c0,.21,0,.43,0,.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.52,92.39l-.09.66c-.06-.15-.13-.3-.18-.46l.09-.66.18.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.91,82.69c-.07.22-.13.44-.2.67,0-.16-.07-.31-.11-.46s.13-.44.19-.66l.12.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.52,63.82c-.14.2-.27.4-.4.61V64l.4-.61v.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.58,31.06l-.41.16L82,31.09l.4-.16.15.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.34,34.25l-.57.27,0-.18.57-.27,0,.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.68,31.08l-.14.14-.41-.17.15-.13.4.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.53,148.85l.26.14-.4-.13-.26-.15.4.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.57,105.23c-.09.15-.18.3-.28.45,0-.21,0-.42,0-.64s.19-.3.28-.45c0,.21,0,.43,0,.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.66,74.87l-.06.43c-.09-.21-.19-.43-.28-.65l.06-.44.28.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.24,59.55l0,.39-.44-.59,0-.39c.15.2.3.39.44.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.53,44.64,51,45.1a2.45,2.45,0,0,1,.08-.29l.57-.46c0,.1-.06.2-.08.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.52,48.36l-.54.5c0-.11,0-.22.07-.33L47.6,48c0,.11-.06.21-.08.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.62,64v.4c-.13-.2-.26-.41-.4-.61v-.41l.4.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.73,148.83,85,149l-.39-.13-.24-.15.39.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.35,31l-.4.16-.16-.13.4-.16.16.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.87,56.46l-.48.56c0-.12,0-.24,0-.37s.31-.37.47-.56c0,.12,0,.24,0,.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.91,31l-.16.13L95.36,31l.16-.13.39.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.11,106.74c-.1.16-.2.3-.29.45,0-.21,0-.42.05-.63l.29-.45c0,.21,0,.42,0,.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.14,76.21l-.27.66c0-.15-.05-.29-.07-.44s.17-.44.27-.66c0,.15,0,.29.07.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.68,44.77c0,.1.06.2.08.3l-.57-.46c0-.09,0-.19-.08-.29l.57.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.82,84.25c-.07.22-.13.45-.18.67-.05-.15-.1-.3-.14-.46s.13-.44.19-.66c0,.14.08.3.13.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,69.89l-.33.65c0-.15,0-.29,0-.43s.22-.43.34-.64l0,.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.36,38l-.59.35a2,2,0,0,1,.07-.23l.6-.34c0,.07,0,.14-.08.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.19,50.93l-.52.53.06-.34.52-.52-.06.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.93,148.81l.23.14-.38-.13-.23-.14.38.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,53.64l-.5.54c0-.12,0-.23.05-.35l.5-.55c0,.12,0,.24-.05.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.61,108.25l-.31.45c0-.21,0-.42.07-.63l.3-.45-.06.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.12,31l-.38.16L83.57,31l.38-.16a1.09,1.09,0,0,0,.17.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.39,33.32l-.54.24a1,1,0,0,1,0-.17l.54-.24c0,.06,0,.11,0,.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.3,56.62c0,.12,0,.24,0,.37l-.48-.57c0-.12,0-.25,0-.37l.48.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.14,31l-.18.14L94.58,31l.18-.13.38.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.37,94.12c-.07.16-.13.31-.2.46l-.09-.66c.08-.16.14-.31.21-.46,0,.22.05.44.08.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.27,60.75c-.15.19-.3.39-.43.59,0-.13,0-.26,0-.39l.43-.59c0,.12,0,.25,0,.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.71,39l-.6.37a2.25,2.25,0,0,1,.08-.24c.19-.12.39-.25.59-.36,0,.07-.05.15-.07.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.13,148.8l.22.14-.37-.13-.21-.15.36.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,65.23c-.14.21-.26.42-.39.63,0-.14,0-.28,0-.41l.39-.62c0,.13,0,.27,0,.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,76.39c0,.15,0,.29-.08.44l-.27-.66c0-.14.06-.29.08-.44l.27.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.07,109.74c-.11.15-.21.3-.32.44,0-.2.05-.41.08-.62l.32-.45c0,.21-.06.42-.08.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.08,43.54c0,.09.06.19.08.28l-.58-.44c0-.09,0-.18-.08-.28l.58.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,51.08l.06.34-.53-.52c0-.11,0-.23-.06-.34l.53.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.21,53.79c0,.12,0,.24,0,.36l-.5-.55c0-.12,0-.24,0-.35l.5.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9,31l-.37.16L84.34,31l.37-.15.19.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.37,31l-.2.14L93.8,31l.2-.13.37.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4,41.08l-.59.41c0-.09,0-.18.08-.26.19-.14.39-.27.59-.4,0,.08,0,.17-.08.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.77,85.82c-.06.22-.12.44-.17.67-.06-.16-.1-.31-.15-.46s.11-.45.17-.67c0,.15.09.3.15.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.06,47l-.56.49c0-.11,0-.21.08-.32l.55-.48c0,.11-.05.21-.07.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.49,111.22l-.33.44.09-.62.34-.44c0,.21-.06.41-.1.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.76,35l-.58.28a1.29,1.29,0,0,1,0-.19l.57-.28,0,.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9,77.74c-.09.22-.18.45-.26.67L31.55,78l.25-.66c0,.15.06.3.1.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.46,42.34c0,.1.06.19.08.28-.19-.14-.39-.29-.59-.42,0-.09,0-.18-.07-.27l.58.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.18,95.69l-.21.46c0-.22-.05-.44-.07-.66s.15-.31.21-.47c0,.22,0,.44.07.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.88,60.91c0,.13,0,.26,0,.39l-.43-.59c0-.13,0-.26,0-.39.15.19.29.39.43.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.69,30.93l-.36.15L85.12,31l.36-.16.21.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.58,30.94l-.21.14L93,30.92l.21-.13.35.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.18,40.1c0,.09,0,.17.07.25l-.59-.38-.07-.25.59.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.16,65.41c0,.13,0,.27,0,.41l-.39-.62c0-.14,0-.28,0-.41l.39.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.83,41.2a2.5,2.5,0,0,1,.07.26l-.59-.4-.07-.26.59.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.87,112.68l-.34.44c0-.2.08-.41.11-.61l.35-.44-.12.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.63,131.15l-.49.35c.11-.16.2-.32.3-.47l.49-.36-.3.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.63,71.38,33.3,72c0-.15,0-.29,0-.43s.21-.44.33-.65c0,.14,0,.29.05.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.47,30.91l-.34.15-.22-.14.34-.15.22.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8,30.92l-.23.14-.34-.16.23-.13.34.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.22,114.13c-.11.15-.24.29-.35.43l.12-.6.36-.43c0,.2-.08.4-.13.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.71,130l-.48.36.29-.48.48-.37c-.09.17-.19.33-.29.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.17,57.77c-.15.19-.31.38-.46.58l0-.38c.15-.19.3-.39.46-.58l0,.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.3,86c-.05.15-.09.3-.14.46,0-.23-.12-.45-.18-.67s.11-.31.15-.46c.06.22.12.44.17.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.2,77.92l-.09.45c-.09-.22-.18-.44-.26-.66l.09-.45.26.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.26,30.89l-.33.15-.24-.14.33-.15.24.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.53,115.56l-.36.43c0-.19.09-.39.14-.59l.36-.43c0,.2-.09.4-.14.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.76,128.79l-.47.37.28-.5.47-.37c-.09.17-.18.34-.28.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,97.25c-.08.15-.16.31-.23.46l-.06-.66c.08-.16.16-.31.23-.46l.06.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,30.9l-.24.14-.33-.15.24-.14.33.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.75,87.38l-.15.68c-.06-.16-.11-.31-.16-.46l.15-.67c.06.15.11.3.16.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.68,49.5l-.54.51c0-.11,0-.22.06-.33l.54-.5c0,.11-.05.22-.06.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.17,33.21l-.54.24a.88.88,0,0,1,0-.16l.53-.24a.9.9,0,0,0,0,.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.81,117l-.38.42.15-.58.38-.43-.15.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.79,127.57l-.46.38c.08-.17.17-.34.26-.51l.46-.38c-.09.17-.18.34-.26.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.05,30.88l-.31.15-.26-.14.32-.15.25.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.22,30.89,91,31l-.32-.15.26-.14.31.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.84,30.87l-.3.15-.27-.14.31-.15.26.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.43,30.88l-.27.14-.3-.15.27-.14.3.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.47,66.67c-.13.21-.25.42-.37.63,0-.14,0-.28,0-.41s.24-.42.37-.63c0,.14,0,.28,0,.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.05,118.38l-.39.42c.06-.2.11-.39.17-.58l.39-.42c-.06.19-.11.38-.17.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.78,126.33l-.45.38c.08-.17.16-.35.25-.52l.45-.39c-.09.18-.17.35-.25.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.64,30.87l-.29.15-.28-.15a2.44,2.44,0,0,0,.28-.14l.29.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.69,79.29c-.08.22-.17.44-.24.66,0-.15-.07-.3-.11-.45l.24-.66c0,.15.07.3.11.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.22,54.9l-.5.55c0-.12,0-.24.05-.36s.32-.37.49-.55c0,.12,0,.24,0,.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,57.93c0,.13,0,.25,0,.38l-.46-.58,0-.37.47.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.25,119.76l-.4.41c.07-.19.13-.38.19-.57l.4-.42c-.06.19-.12.38-.19.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.74,125.06l-.44.39c.08-.18.16-.35.23-.53l.44-.39-.23.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.66,62.13l-.42.6v-.4l.43-.6c0,.13,0,.26,0,.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.43,121.11l-.42.41c.07-.18.14-.37.2-.56l.41-.41c-.06.19-.13.38-.19.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.67,123.77l-.44.39c.08-.18.16-.36.23-.54l.43-.4-.22.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.39,52.14l-.52.53c0-.11,0-.23.05-.34l.52-.54c0,.12,0,.23,0,.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.56,122.45l-.42.4.21-.55.42-.4-.21.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.69,98.81l-.24.46c0-.22,0-.44,0-.66l.24-.46c0,.22,0,.44,0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.32,87.56c-.06.15-.11.3-.16.46-.06-.23-.11-.45-.16-.67s.11-.31.16-.46c.06.22.1.44.16.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.58,45.83a1.46,1.46,0,0,1,.07.3c-.18-.16-.38-.31-.57-.47l-.06-.3.56.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.27,72.88c-.11.22-.21.43-.31.65,0-.14-.05-.29-.07-.44l.31-.64c0,.14,0,.29.07.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.78,89c-.05.22-.09.44-.14.67-.06-.16-.12-.31-.17-.47s.09-.44.14-.67c.05.16.11.31.17.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.87,34l-.55.27a1.15,1.15,0,0,0,0-.19l.56-.25V34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,55.05c0,.13,0,.25,0,.37l-.49-.56c0-.12,0-.24,0-.36.17.18.33.37.49.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.66,66.85c0,.14,0,.27,0,.41-.13-.21-.25-.42-.38-.62l0-.42c.13.21.25.42.37.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.8,52.29c0,.12,0,.23,0,.35l-.52-.54c0-.11,0-.22-.05-.34.18.17.35.35.52.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.53,62.19v.5l-.42-.6v-.4l.42.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.38,100.36c-.08.15-.16.31-.25.46l0-.66c.09-.15.18-.3.26-.46,0,.22,0,.44,0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.53,34.89l-.57.28c0-.06,0-.13,0-.19l.57-.28a1.28,1.28,0,0,1,0,.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.43,31.53l-.44.19-.14-.15.43-.18.15.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.62,148.44l.25.16-.42-.14-.24-.17.41.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.79,135.37l-.53.32c.11-.14.23-.28.33-.42l.53-.33-.33.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.52,80.84c-.08.22-.16.44-.23.66-.05-.15-.08-.3-.12-.45s.15-.44.23-.67c0,.15.07.31.12.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.85,73.06l-.06.43-.32-.65c0-.14.05-.29.07-.43.1.21.21.43.31.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.46,38.77l-.6.37c0-.08,0-.16,0-.24l.6-.36c0,.08,0,.16,0,.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,44.55l.06.29-.58-.45a1.5,1.5,0,0,0-.06-.29l.58.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2,48.12l-.55.49c0-.11,0-.21.06-.32l.55-.49-.06.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,33.12l-.53.23,0-.16.53-.24c0,.06,0,.11,0,.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.51,59.1l-.46.59c0-.13,0-.26,0-.38l.45-.59c0,.13,0,.26,0,.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,101.9l-.27.46c0-.22,0-.43,0-.65s.19-.3.27-.46c0,.22,0,.44,0,.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,68.13l-.37.63,0-.42c.12-.21.23-.42.36-.63,0,.14,0,.28,0,.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8,39.81l-.6.38.06-.25.6-.38a1,1,0,0,0-.06.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.85,148.42l.24.16-.4-.14-.24-.17.4.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,134.32l-.52.33c.11-.15.22-.29.32-.44l.52-.33-.32.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1,63.53c-.14.2-.28.4-.41.61,0-.14,0-.27,0-.41l.41-.61c0,.14,0,.27,0,.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,74.39q-.16.33-.3.66c0-.15-.06-.3-.08-.44s.19-.44.3-.66c0,.15.05.3.08.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.23,31.49l-.42.18-.16-.15.42-.18.16.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.38,43.32c0,.1.05.19.07.28l-.59-.43-.06-.28.58.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.58,81l-.12.45c-.08-.22-.16-.44-.23-.66l.12-.45c.08.22.16.44.23.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.05,31.51l-.16.15-.42-.18.17-.14.41.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.66,59.27c0,.13,0,.26,0,.38l-.45-.58c0-.13,0-.26,0-.39l.45.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.65,103.44l-.28.46c0-.22,0-.43,0-.65s.19-.3.28-.46c0,.22,0,.43,0,.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.45,39.92l.06.25-.6-.39c0-.08,0-.16,0-.24l.59.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5,56.18l-.49.57,0-.37.48-.57c0,.13,0,.25,0,.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.86,50.68l-.54.52c0-.11,0-.23,0-.34l.54-.52c0,.12,0,.23,0,.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.75,42.14a2.61,2.61,0,0,1,.06.27l-.59-.42-.06-.27.59.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.22,90.7c-.06.15-.12.31-.19.46,0-.22-.08-.45-.13-.67s.13-.31.19-.46c0,.22.09.44.13.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.13,68.3c0,.14,0,.28,0,.42l-.36-.63c0-.14,0-.28,0-.42l.36.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.13,133.23l-.51.34.31-.45.51-.34-.31.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.11,41l.06.26-.6-.4-.06-.25.6.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,92.1c0,.22-.08.45-.11.67-.07-.15-.13-.31-.2-.46s.07-.45.11-.67c.07.15.13.31.2.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.39,82.39c-.08.22-.15.45-.22.67,0-.15-.09-.3-.13-.45l.21-.67c.05.15.09.3.14.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.09,148.4l.22.16-.39-.15-.22-.16.39.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.62,53.37l-.51.55c0-.12,0-.24,0-.36s.33-.36.51-.54c0,.12,0,.23,0,.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.66,33.9l-.54.26,0-.18.55-.26c0,.06,0,.12,0,.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.06,63.7c0,.13,0,.27,0,.4l-.42-.61c0-.14,0-.27,0-.41.14.21.28.41.41.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.23,105c-.1.15-.19.3-.3.45,0-.21,0-.42,0-.64s.2-.3.29-.46c0,.22,0,.44,0,.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.17,74.57c0,.14,0,.29-.08.44-.09-.22-.2-.44-.3-.66s.06-.29.08-.44q.16.33.3.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.25,31.47l-.18.15-.41-.18.18-.15.41.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.35,50.83c0,.11,0,.22.05.34l-.54-.52c0-.12,0-.23-.05-.34l.54.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.26,132.12l-.51.35c.11-.16.21-.31.3-.47l.51-.35-.3.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,56.34c0,.13,0,.25,0,.37l-.48-.56,0-.37.49.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.34,148.38a1.56,1.56,0,0,0,.2.16l-.38-.14-.2-.17.38.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.58,53.53l0,.35-.51-.54,0-.36.51.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.77,106.49l-.31.45c0-.21,0-.42,0-.64l.31-.45c0,.21,0,.42,0,.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.58,69.6l-.35.64-.06-.43.35-.64.06.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.11,92.27c-.06.15-.13.31-.2.46,0-.22-.07-.44-.11-.67s.14-.31.2-.46c0,.22.08.45.11.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1,93.67c0,.22-.07.45-.1.67-.07-.15-.14-.31-.22-.46s.07-.45.1-.67c.07.15.14.31.22.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.46,46.91a2.84,2.84,0,0,1,.06.31l-.57-.48a2.87,2.87,0,0,0,0-.31c.19.16.38.31.56.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.66,75.92c-.09.21-.19.43-.28.65,0-.14-.07-.29-.1-.44l.29-.66.09.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.36,131c-.16.12-.32.24-.49.35.1-.15.19-.31.28-.47l.5-.36c-.09.16-.19.32-.29.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.85,31.41l-.39.17-.19-.15.39-.17.19.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.88,60.46l-.45.6v-.4l.45-.59c0,.13,0,.26,0,.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.44,31.43l-.2.15-.39-.18.19-.14.4.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3,84l-.21.67c-.05-.16-.09-.31-.14-.46s.13-.45.2-.67c.05.15.09.3.15.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.58,148.36l.19.16-.37-.14-.19-.17.37.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.27,108l-.32.46c0-.21,0-.43.05-.64s.22-.3.32-.45c0,.21,0,.43,0,.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.56,65l-.4.62c0-.14,0-.28,0-.42s.26-.41.4-.61c0,.13,0,.27,0,.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.44,129.81l-.49.36.27-.49.49-.36-.27.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.67,31.38l-.38.17-.21-.15.39-.17.2.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.73,109.49l-.33.45c0-.21,0-.42.07-.63l.33-.45c0,.21,0,.42-.07.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.62,31.39l-.21.16L94,31.37l.21-.14.38.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,93.84l-.22.46c0-.22-.07-.44-.1-.67s.15-.3.22-.46c0,.22.07.45.1.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.37,49.26c-.19.17-.37.33-.55.51a3.26,3.26,0,0,1,0-.33l.54-.51c0,.11,0,.22,0,.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.49,128.61,133,129a4.74,4.74,0,0,0,.26-.5l.49-.37-.26.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.3,60.63c0,.13,0,.26,0,.39-.14-.2-.29-.4-.44-.59V60l.45.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.46,76.09c0,.15-.06.29-.1.44-.09-.22-.19-.43-.28-.65l.09-.45.29.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.31,136.25l-.53.32.33-.42.54-.31c-.11.14-.22.28-.34.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.16,111l-.35.45c0-.21.05-.41.08-.62l.35-.45c0,.21-.05.42-.08.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.23,38.6l-.6.36c0-.08,0-.15,0-.24l.6-.35a.85.85,0,0,0,0,.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.89,45.6c0,.1,0,.2,0,.3l-.58-.47a2.5,2.5,0,0,0,0-.29l.58.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.81,57.49l-.47.58c0-.13,0-.25,0-.38l.47-.57c0,.12,0,.25,0,.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.5,127.39l-.47.37.25-.51.47-.38c-.08.17-.16.35-.25.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5,31.35l-.37.17-.23-.15.37-.17.23.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.6,65.12l0,.41-.4-.62,0-.41.4.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.47,33.79l-.54.26a1.16,1.16,0,0,1,0-.18l.54-.25c0,.06,0,.12,0,.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8,31.37l-.23.15-.37-.17.23-.15.37.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.55,112.44l-.36.44.09-.61.36-.44-.09.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.24,85.52l-.18.67c-.06-.15-.11-.3-.16-.46s.11-.44.18-.67c.05.16.11.31.16.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.42,77.45l-.28.66c0-.15-.07-.3-.1-.45s.17-.44.27-.66c0,.15.07.3.11.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.49,126.14l-.46.38c.08-.17.15-.35.23-.52l.47-.39-.24.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.07,51.88c-.18.18-.35.36-.53.53,0-.11,0-.23,0-.34l.52-.53,0,.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.18,71.09l-.34.64-.06-.43c.11-.22.22-.43.34-.64l.06.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.9,113.9l-.37.43c0-.2.07-.4.11-.6l.37-.44c0,.2-.08.4-.11.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.78,95.41c-.07.15-.15.3-.23.46,0-.22-.05-.44-.08-.66l.23-.47c0,.22.06.45.08.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.32,31.33,86,31.5c-.09-.05-.16-.11-.24-.16l.35-.16.24.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.88,54.63c-.17.18-.34.37-.5.56,0-.13,0-.25,0-.37.16-.19.33-.37.5-.55,0,.12,0,.24,0,.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,31.34l-.24.15-.35-.16.24-.16.35.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.45,124.86l-.46.4c.08-.18.15-.36.22-.54l.46-.39c-.07.18-.15.36-.22.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.57,39.62,59,40a2.34,2.34,0,0,1,0-.26l.6-.37a2,2,0,0,0,0,.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.21,115.33l-.38.43c0-.19.09-.39.12-.59l.39-.43c-.05.2-.09.39-.13.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.52,135.23l-.54.32.32-.43.54-.33c-.11.15-.22.29-.32.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.37,123.57l-.44.39c.07-.18.14-.36.2-.54l.45-.4-.21.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.38,57.65c0,.13,0,.26,0,.38l-.48-.57c0-.13,0-.25,0-.38l.48.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.49,116.75l-.39.43c.05-.2.09-.39.14-.59l.39-.43c0,.2-.09.4-.14.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.15,31.31l-.34.17-.25-.16.34-.16.25.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.28,44.33c0,.1,0,.2,0,.29l-.58-.45c0-.09,0-.19,0-.28l.58.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.26,122.25l-.43.4.19-.55.44-.41-.2.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.15,31.32l-.26.16-.34-.17.25-.15.35.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.74,118.16l-.41.42c.06-.19.11-.39.15-.58s.28-.28.41-.43l-.15.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.13,34.64l-.57.28v-.19l.56-.28a1.23,1.23,0,0,0,0,.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.12,120.9l-.42.41c.05-.18.12-.37.17-.56l.43-.41-.18.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,119.54l-.42.42c.06-.19.11-.38.17-.57s.27-.29.41-.42c-.05.19-.11.38-.16.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.14,52c0,.12,0,.23,0,.35-.18-.18-.36-.35-.53-.53l0-.35.52.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.28,61.84l-.43.6c0-.13,0-.26,0-.4.15-.19.29-.39.44-.59,0,.13,0,.26,0,.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,31.3l-.32.16-.28-.15.33-.16.27.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.32,31.31l-.28.15-.32-.16.27-.15.33.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.85,85.7c0,.15-.1.3-.16.46-.06-.23-.13-.45-.19-.68l.17-.45.18.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.71,77.62c0,.15-.08.3-.11.45-.1-.22-.18-.44-.28-.66s.08-.3.11-.45l.28.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.07,66.38q-.21.32-.39.63a3,3,0,0,1,0-.42c.12-.21.25-.41.38-.62,0,.14,0,.27,0,.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.33,54.79c0,.12,0,.24,0,.36l-.51-.55c0-.12,0-.25,0-.37l.51.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.82,31.29l-.32.17-.28-.16.31-.16.29.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.48,31.3l-.28.16-.32-.17.29-.15.31.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.65,31.29l-.3.16-.3-.16.3-.15.3.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.56,97l-.25.47c0-.22,0-.45-.07-.67s.17-.31.25-.46c0,.22,0,.44.07.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.91,47.88l-.56.49c0-.11,0-.21,0-.32.18-.17.37-.33.56-.49,0,.11,0,.21-.05.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.66,43.11c0,.09,0,.19,0,.28l-.59-.43c0-.09,0-.19,0-.28l.59.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.71,148l.24.17-.43-.15-.23-.18.42.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.23,87.1c-.06.22-.11.44-.17.66l-.18-.46c.06-.22.12-.44.17-.67l.18.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.36,40.81a2.34,2.34,0,0,1,0,.26l-.6-.4a2.17,2.17,0,0,0,0-.25l.6.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.69,134.17l-.53.33.31-.44.53-.34-.31.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,41.94c0,.09,0,.18,0,.27l-.6-.42a2,2,0,0,0,0-.26l.59.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.21,79c-.09.22-.17.44-.26.67l-.12-.46c.08-.22.17-.44.26-.66,0,.15.08.3.12.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.57,138.09l-.56.29.35-.39c.18-.1.37-.19.55-.3-.11.14-.23.27-.34.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.9,62c0,.13,0,.26,0,.4l-.44-.61c0-.13,0-.26,0-.39.15.2.3.39.44.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.1,66.55c0,.14,0,.28,0,.42-.12-.21-.26-.42-.39-.63,0-.13,0-.27.05-.41l.39.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.29,33.69l-.54.26c0-.06,0-.13,0-.19l.54-.24a1.54,1.54,0,0,0,.05.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.29,98.53c-.08.15-.16.31-.26.46,0-.22,0-.44-.05-.66l.26-.46c0,.22,0,.44,0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.83,72.58l-.33.66c0-.15,0-.3-.08-.44l.33-.65c0,.15,0,.29.08.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,148l.21.18-.41-.16-.22-.18L83,148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.84,133.08l-.52.34.3-.46.52-.34-.3.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.87,87.26l-.18.47-.18-.67c.06-.16.13-.31.18-.47l.18.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.16,58.83l-.47.58V59l.46-.59c0,.13,0,.26,0,.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.26,88.67c-.06.22-.11.44-.16.67-.06-.16-.13-.31-.19-.46l.15-.67c.07.15.13.31.2.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.56,50.43,46,51l0-.34.54-.52,0,.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,100.09l-.27.46c0-.22,0-.44,0-.66l.27-.46c0,.22,0,.44,0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.75,139.81l-.57.28.35-.36.57-.29-.35.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.81,137.12l-.55.3.33-.4.55-.31-.33.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.26,148l.2.18-.4-.16-.2-.18.4.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,132l-.52.35c.1-.16.2-.31.29-.47l.51-.35L130,132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.17,55.91l-.5.57c0-.12,0-.25,0-.37.16-.19.33-.38.5-.56,0,.12,0,.24,0,.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6,67.84l-.37.63c0-.14,0-.28-.06-.42s.25-.42.38-.63c0,.14,0,.28.05.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,80.54c-.08.22-.17.45-.24.67-.05-.15-.1-.3-.14-.46l.24-.66c.05.15.09.3.14.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,59c0,.13,0,.26,0,.38l-.46-.58v-.38c.16.19.32.38.47.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.31,53.11l-.52.54c0-.11,0-.23,0-.35l.52-.54c0,.12,0,.24,0,.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,34.52l-.56.28c0-.06,0-.13,0-.19l.56-.28a1.06,1.06,0,0,0,0,.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,38.43l-.6.36,0-.24L62,38.2a1.79,1.79,0,0,1,0,.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.72,63.24c-.14.2-.29.41-.42.61a2.69,2.69,0,0,1,0-.4c.13-.21.28-.41.42-.61l0,.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.75,46.67c0,.11,0,.21,0,.32l-.57-.48c0-.11,0-.21,0-.31l.57.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.84,88.84l-.19.46c-.05-.22-.11-.45-.16-.67l.19-.46c.06.22.11.44.16.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.65,101.64l-.29.46c0-.22,0-.44,0-.66s.19-.3.28-.46c0,.22,0,.44,0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.32,90.24c0,.23-.09.45-.14.67-.07-.15-.14-.31-.2-.46s.09-.45.14-.67c.06.15.13.31.2.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.55,35.43l-.57.3c0-.07,0-.14,0-.21l.58-.29a1.34,1.34,0,0,0,0,.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.06,130.81l-.5.36.27-.48.51-.36c-.09.16-.18.32-.28.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.54,147.93l.19.17-.39-.16a1.07,1.07,0,0,1-.19-.18l.39.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.51,74.1c-.11.21-.21.43-.32.65l-.09-.44c.1-.22.21-.44.31-.65,0,.14.06.29.1.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,56.07v.37l-.49-.56v-.37l.49.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.91,53.26c0,.12,0,.24,0,.36l-.52-.54c0-.12,0-.24,0-.36l.52.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.13,33.6l-.53.25c0-.06,0-.13-.08-.19l.53-.24a1.42,1.42,0,0,0,.08.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.56,68a3,3,0,0,1-.06.42c-.12-.21-.25-.42-.38-.63s0-.28.06-.42c.13.21.26.42.38.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,136.11l-.54.32c.1-.14.21-.28.32-.41l.54-.32c-.1.14-.21.28-.32.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,63.41l0,.4c-.14-.2-.28-.41-.43-.61,0-.13,0-.27,0-.4l.42.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.26,103.18l-.29.46c0-.22,0-.44,0-.65l.29-.46c0,.21,0,.43,0,.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.36,39.45l-.6.37,0-.25.59-.37c0,.08,0,.16,0,.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.13,129.63l-.5.37.26-.49c.17-.12.34-.24.5-.37-.08.17-.17.33-.26.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.73,31.91l-.42.2-.19-.17.42-.19.19.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,138.9l-.57.29c.12-.12.23-.25.34-.37l.57-.3-.34.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.58,31.94l-.2.16L96,31.91l.19-.16.42.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.16,45.37l0,.3-.58-.46c0-.1,0-.2,0-.3l.59.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.83,147.91l.17.18-.38-.17a1.45,1.45,0,0,1-.17-.18l.38.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.77,90.41c-.06.16-.13.31-.2.46l-.15-.67.21-.46c.05.22.1.45.14.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1,49l-.56.5c0-.11,0-.22,0-.33l.55-.5c0,.11,0,.22,0,.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.91,82.1c-.08.22-.15.45-.23.67l-.15-.46c.08-.22.15-.44.23-.67l.15.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.84,104.71c-.1.15-.2.31-.31.46,0-.22,0-.43,0-.65s.21-.3.31-.46c0,.22,0,.43,0,.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.64,74.27c0,.15-.07.29-.1.44-.1-.22-.21-.43-.32-.65,0-.15.07-.3.1-.44.11.21.21.43.32.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.53,60.18l-.45.6c0-.13,0-.27,0-.39l.45-.6c0,.13,0,.26,0,.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.17,128.43l-.49.38c.09-.17.17-.34.25-.51l.49-.37c-.08.17-.16.33-.25.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.16,140.57l-.57.28.35-.35.57-.28c-.11.12-.23.24-.35.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.22,135.08l-.55.33L126,135l.54-.33-.3.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.18,69.31c-.12.21-.25.42-.37.64,0-.15-.05-.29-.07-.43s.24-.43.37-.64c0,.14,0,.28.07.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.59,31.87l-.41.19L83,31.9l.41-.19.21.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.53,44.12a2.54,2.54,0,0,1,0,.29L125,44l0-.29.58.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.73,31.9l-.21.16-.41-.19.21-.16.41.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.39,106.23l-.33.46c0-.22,0-.43,0-.64s.22-.3.32-.46c0,.22,0,.43,0,.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.12,147.89a1.29,1.29,0,0,0,.16.17l-.37-.16-.16-.18.37.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.58,40.62l0,.26-.6-.39,0-.26.6.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.18,127.2c-.15.13-.32.25-.48.38.08-.17.16-.34.23-.51l.49-.38-.24.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.19,64.66c-.14.2-.27.41-.41.62a3,3,0,0,1,0-.42l.41-.61c0,.14,0,.27,0,.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.79,34.41l-.55.27-.06-.19.55-.27.06.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.23,75.62c-.11.22-.2.44-.3.66,0-.15-.08-.3-.11-.45l.3-.65c0,.14.07.29.11.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.9,42.9l0,.28-.6-.42,0-.28.6.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.24,41.74a1.24,1.24,0,0,1,0,.27l-.6-.41a2.45,2.45,0,0,0,0-.27l.59.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.67,92c-.08.16-.15.31-.22.47,0-.22-.09-.45-.14-.67s.16-.31.23-.47c.05.23.08.45.13.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.67,60.35l0,.39-.45-.59c0-.13,0-.26,0-.39l.46.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.79,51.63l-.54.53c0-.12,0-.23,0-.35l.53-.52c0,.11,0,.22,0,.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.89,107.74a5.3,5.3,0,0,1-.34.45c0-.2,0-.42,0-.63l.33-.45,0,.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.27,138l-.56.3.32-.39.57-.3-.33.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.49,57.22c-.16.19-.32.39-.49.58v-.38l.48-.57c0,.12,0,.25,0,.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.17,126l-.48.39c.07-.18.15-.35.22-.53l.48-.39c-.08.18-.15.35-.22.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.44,31.84l-.39.19-.22-.17.39-.18.22.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.82,83.67c-.07.22-.15.44-.22.66-.06-.15-.11-.3-.16-.46l.21-.66c.06.15.11.3.17.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.87,31.86l-.22.16-.4-.18.23-.16.39.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,69.48c0,.14-.05.28-.07.43-.12-.22-.25-.43-.37-.64s0-.29.07-.43c.13.21.25.43.37.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.58,54.37l-.51.55v-.36l.51-.55v.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.35,109.24l-.34.45c0-.21,0-.41,0-.62l.35-.45c0,.21,0,.41-.05.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.38,134l-.53.33c.1-.15.19-.3.29-.44l.54-.34c-.1.15-.19.3-.3.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.12,124.67l-.47.39c.07-.17.14-.35.2-.53s.32-.26.47-.4l-.2.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.39,35.31l-.57.29,0-.2.57-.3a1.52,1.52,0,0,0,0,.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,64.83c0,.13,0,.27,0,.41l-.42-.62c0-.14,0-.27.05-.41.14.21.28.41.41.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.78,110.73l-.36.45c0-.21.05-.42.06-.62l.37-.45c0,.21,0,.41-.07.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.92,75.79c0,.15-.07.3-.11.45-.1-.22-.2-.44-.31-.66l.12-.44.3.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.31,31.81l-.39.19-.23-.17.38-.18.24.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,123.37l-.45.4c.06-.18.13-.36.19-.55l.46-.4c-.07.18-.13.36-.2.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.57,141.32l-.58.26.34-.34.58-.26-.34.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,31.83l-.24.16-.38-.18.24-.16.38.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.52,93.56c-.08.15-.15.31-.23.46l-.12-.66.24-.47c0,.22.08.44.11.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.72,57.38c0,.13,0,.25,0,.38l-.48-.57c0-.13,0-.26,0-.38l.48.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.81,147.51l.22.19-.44-.17-.22-.19.44.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.44,139.69l-.57.29c.11-.12.23-.24.34-.37l.57-.28-.34.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.17,112.2l-.37.45c0-.21,0-.41.08-.62l.37-.44c0,.2-.05.41-.08.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.92,122c-.14.14-.3.27-.45.41l.18-.56.45-.41-.18.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.65,54.52v.37l-.52-.56a2.16,2.16,0,0,0,0-.36c.17.19.35.37.52.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.59,47.78c0,.11,0,.21,0,.32l-.57-.49c0-.1,0-.21,0-.32l.57.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.53,113.66c-.13.15-.26.29-.38.44l.09-.61.38-.43-.09.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.77,120.69l-.43.42c0-.19.11-.38.16-.57l.44-.41-.17.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.17,31.79,85.8,32l-.25-.16.37-.18.25.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.85,115.1l-.4.44c0-.2.07-.4.11-.6l.39-.44c0,.2-.07.4-.1.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.14,31.8l-.25.17-.37-.18.26-.17.36.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.59,119.32l-.42.42c.05-.19.1-.38.14-.57l.43-.42c-.05.19-.09.38-.15.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.79,70.79l-.36.65c0-.15,0-.29-.08-.44l.35-.64.09.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.53,132.92l-.53.34c.09-.15.18-.3.28-.45l.53-.35c-.09.16-.19.31-.28.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.38,117.94l-.42.42c0-.19.1-.39.14-.58l.42-.43c-.05.2-.09.39-.14.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.5,137l-.56.31.32-.4.55-.31-.31.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,77.15c-.1.22-.2.44-.29.66l-.13-.44c.1-.22.19-.45.29-.66,0,.15.08.3.13.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.77,85.23c-.07.23-.14.45-.2.67-.07-.15-.12-.31-.18-.46s.13-.44.2-.67c.05.16.12.31.18.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.94,61.56l-.44.6c0-.13,0-.27,0-.4l.45-.6,0,.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,31.77l-.35.18-.27-.17.36-.17.26.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.28,31.78,92,32l-.36-.18.27-.16.36.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.34,95.13l-.25.46c0-.22-.07-.44-.1-.66l.25-.47c0,.22.07.45.1.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.12,147.49a1.8,1.8,0,0,1,.2.19l-.42-.17-.21-.2.43.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,31.76l-.35.18-.28-.17.34-.18.29.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7,66.1l-.4.62c0-.14,0-.28-.06-.42l.4-.62.06.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.41,31.77l-.29.17-.34-.18.28-.17.35.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.64,34.31c-.18.08-.36.18-.54.27a1.59,1.59,0,0,1-.07-.2l.54-.26c0,.06.05.12.07.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.18,39.28l-.6.37a2.09,2.09,0,0,1,0-.25l.6-.37a2,2,0,0,0,0,.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.79,31.75l-.33.18-.3-.17.33-.17.3.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3,50.18l-.55.52c0-.11,0-.23,0-.34l.55-.51c0,.11,0,.22,0,.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.54,31.76l-.31.17-.32-.18.3-.17.33.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.66,31.75l-.31.18L89,31.75l.32-.17.31.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.38,71c0,.14,0,.28-.08.43l-.36-.65.09-.43.35.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.64,131.8l-.52.35.27-.47.52-.35-.27.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.17,77.33c0,.15-.09.3-.13.45-.1-.22-.19-.45-.29-.66s.09-.3.13-.45l.29.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.26,61.72c0,.14,0,.27,0,.4-.15-.2-.29-.4-.45-.6,0-.13,0-.26,0-.39l.45.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,46.44c0,.11,0,.21,0,.32l-.57-.48a3,3,0,0,1,0-.31l.57.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.35,85.4c0,.16-.12.31-.18.47-.06-.23-.13-.45-.2-.68l.18-.46c.08.23.14.45.2.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.33,37.17l-.59.33c0-.07,0-.15,0-.23l.59-.33c0,.08,0,.15,0,.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.7,138.78l-.57.29.33-.37.57-.3-.33.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.11,96.7l-.26.46c0-.22-.06-.44-.09-.66L147,96c0,.22.06.45.08.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.7,136l-.55.31.3-.41.56-.32-.31.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.85,140.47l-.58.27c.11-.12.22-.24.34-.35l.57-.28-.33.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.84,58.55c-.16.2-.32.39-.47.59l0-.39.48-.58c0,.13,0,.26,0,.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.76,86.81c-.07.22-.13.44-.19.67-.07-.16-.14-.31-.2-.47s.13-.44.19-.67l.2.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.43,147.46c.06.06.12.13.19.19l-.41-.17-.19-.2c.13.07.27.12.41.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.49,66.26l-.06.42c-.14-.21-.27-.42-.41-.62,0-.14,0-.28.06-.42.14.21.28.41.41.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.24,35.19l-.56.29a1.6,1.6,0,0,1-.05-.21l.56-.29c0,.07,0,.14,0,.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.78,78.7c-.09.22-.18.44-.28.66,0-.15-.09-.3-.14-.45s.19-.44.28-.66c0,.15.09.3.14.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,52.86l-.53.54c0-.12,0-.24,0-.36L45,52.5c0,.12,0,.24,0,.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.73,130.64l-.52.36.26-.48.52-.36c-.08.16-.17.32-.26.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8,36.14l-.58.31,0-.21.58-.31,0,.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.44,72.29c-.12.22-.24.43-.35.65,0-.14-.07-.29-.1-.44l.34-.64c0,.14.07.29.11.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.39,45.15a3,3,0,0,1,0,.31l-.59-.46c0-.1,0-.2,0-.3l.58.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.85,98.26l-.27.46c0-.22-.06-.44-.08-.66s.19-.3.28-.46c0,.22.05.44.07.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.38,58.71l0,.39-.48-.58,0-.39.48.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.75,147.44l.17.19-.4-.18-.18-.19c.14.06.28.11.41.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.37,87c-.07.15-.13.3-.2.46-.06-.23-.13-.45-.19-.67s.13-.31.2-.46c.06.22.13.44.19.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.76,43.9c0,.1,0,.2,0,.3l-.59-.45c0-.09,0-.19,0-.29l.59.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.79,129.46l-.51.37c.09-.16.17-.33.25-.49l.5-.37c-.07.16-.15.33-.24.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.45,41.54a2.53,2.53,0,0,1,0,.28l-.6-.41c0-.09,0-.18,0-.27l.6.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.39,63l-.44.61c0-.14,0-.27-.05-.41l.44-.61c0,.14,0,.27,0,.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.86,48.78l-.56.5c0-.11,0-.22,0-.33l.56-.5c0,.11,0,.22,0,.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.89,134.94c-.19.1-.37.22-.55.32l.29-.42.55-.34c-.1.15-.2.29-.29.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.78,88.38c-.06.22-.12.45-.17.67-.08-.15-.14-.31-.21-.46s.11-.45.18-.67c.06.15.13.31.2.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.11,42.7c0,.09,0,.19,0,.28l-.6-.42c0-.1,0-.19,0-.28l.6.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.35,55.8c0,.13,0,.25,0,.38l-.51-.57c0-.12,0-.24,0-.37.17.19.33.38.5.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.24,67.55l-.39.63c0-.14-.05-.28-.07-.42l.39-.63c0,.14,0,.28.07.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.94,137.83l-.57.3.32-.39.56-.3-.31.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.51,34.21l-.54.26-.09-.19.54-.26.09.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.54,32.47l-.44.21-.19-.18.44-.21.19.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.24,141.22l-.58.26.33-.34.58-.27c-.1.12-.22.23-.33.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.74,72.46c0,.15-.07.3-.11.44l-.34-.65c0-.14.07-.29.1-.43l.35.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.55,99.82l-.29.46-.06-.65c.1-.16.2-.31.29-.47l.06.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.61,80.25c-.09.22-.17.44-.26.67-.05-.16-.11-.31-.15-.46s.17-.44.26-.67l.15.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.83,128.26l-.51.37c.09-.17.16-.33.23-.5l.51-.38-.23.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.07,147.41c.06.06.11.13.16.19l-.39-.17-.16-.2.39.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.11,139.58l-.57.28.32-.36.58-.29-.33.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.4,48.92c0,.11,0,.22,0,.33l-.56-.5c0-.11,0-.22,0-.33l.56.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.82,63.12c0,.14,0,.27,0,.41l-.44-.61c0-.14,0-.27,0-.4l.44.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.21,101.37l-.3.46c0-.21,0-.43,0-.65s.2-.31.31-.46c0,.21,0,.43,0,.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.34,88.55l-.21.46-.18-.67.21-.46.18.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,67.72c0,.14,0,.28-.08.42l-.39-.63c0-.14.05-.28.07-.42.14.21.27.42.4.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.58,147a2.09,2.09,0,0,0,.22.2,4.37,4.37,0,0,1-.46-.18,2.09,2.09,0,0,1-.22-.2l.46.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.12,73.81l-.33.65c0-.15-.08-.3-.11-.45l.32-.65.12.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.85,90c-.06.22-.11.44-.16.67-.08-.16-.15-.31-.22-.47s.1-.44.16-.67c.07.16.14.31.22.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.43,32.42l-.43.21-.21-.18.43-.2.21.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,133.87l-.54.33.28-.44.54-.34c-.09.15-.18.3-.28.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.83,127l-.49.38.21-.51.5-.39c-.07.18-.15.35-.22.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.23,59.91c-.16.19-.31.39-.47.59,0-.13,0-.26,0-.39l.47-.59c0,.13,0,.26,0,.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.54,51.38l-.54.53c0-.12,0-.23,0-.35l.55-.52v.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.11,35.07l-.55.29a1.72,1.72,0,0,1-.07-.21l.55-.28c0,.07,0,.13.07.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.83,102.92l-.32.46c0-.22,0-.44,0-.65s.22-.31.32-.47l0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.18,37l-.58.33a1.66,1.66,0,0,1,0-.22c.19-.12.39-.22.58-.33l0,.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.16,136.85l-.56.31.3-.4.56-.32-.3.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.8,125.76l-.48.39c.07-.17.13-.35.2-.52l.49-.4-.21.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.67,36l-.58.31c0-.07,0-.15,0-.22l.58-.3a1.6,1.6,0,0,0,0,.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.05,74c0,.14-.07.29-.11.44l-.33-.66c0-.14.07-.29.11-.44.12.22.22.44.33.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.32,32.38c-.14.07-.28.13-.42.21l-.22-.18.42-.2.22.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.41,104.45l-.33.46c0-.21,0-.43,0-.64l.33-.46c0,.21,0,.43,0,.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.48,81.81l-.24.67c-.06-.16-.12-.31-.17-.46l.24-.67c.06.15.12.31.17.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.28,90.12c-.08.16-.15.32-.23.47-.05-.22-.11-.44-.16-.67s.15-.31.22-.46c.06.22.11.44.17.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.32,54.11c-.18.18-.35.37-.52.55,0-.12,0-.24,0-.37l.52-.54c0,.12,0,.24,0,.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.83,47.55c0,.11,0,.21,0,.32l-.57-.49c0-.1,0-.21,0-.31.2.15.39.31.58.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,91.54c0,.22-.1.44-.14.67l-.24-.47.15-.67c.07.16.15.31.23.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.39,34.11l-.53.27-.11-.2.53-.26.11.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,60.07l0,.39c-.16-.19-.32-.39-.47-.59l0-.39c.16.2.32.39.47.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.82,69c-.13.21-.26.42-.38.64l-.09-.43.38-.64.09.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.91,147l.21.2-.45-.18-.21-.21.45.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.18,132.77l-.54.34c.09-.15.18-.3.26-.45l.54-.35-.26.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.51,140.36l-.58.27c.11-.11.22-.23.32-.35l.58-.28-.32.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.75,124.48l-.48.39c.06-.17.12-.35.19-.53l.48-.4c-.07.18-.13.36-.19.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.87,64.37l-.43.62-.06-.41L37.8,64c0,.13.05.27.07.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.36,138.66l-.57.29.31-.37.57-.3-.31.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,106l-.33.45v-.63c.11-.16.22-.31.34-.46,0,.21,0,.43,0,.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.66,123.17l-.47.4c.06-.18.12-.36.17-.54l.47-.41c-.05.18-.11.37-.17.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.22,32.34l-.41.21-.24-.18.41-.2.24.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.84,75.33l-.32.65-.12-.44c.1-.22.2-.44.31-.66,0,.15.09.3.13.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.93,54.26c0,.12,0,.24,0,.37-.18-.19-.36-.37-.53-.56,0-.12,0-.24,0-.36l.52.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,57.11l0,.38-.5-.57,0-.38.5.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.12,32.36c-.08.07-.16.12-.24.18l-.41-.2.24-.17.41.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.46,107.49c-.11.16-.23.31-.35.46,0-.21,0-.42,0-.63s.23-.31.35-.46c0,.21,0,.42,0,.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.37,69.19c0,.14-.06.28-.09.43L142.9,69l.09-.43.38.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.54,121.84l-.46.41c.06-.19.11-.37.16-.56l.46-.41c0,.19-.1.37-.16.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.35,135.84l-.56.32.29-.42.56-.32-.29.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.17,91.7c-.08.16-.15.31-.24.47,0-.22-.1-.45-.15-.67L147,91l.15.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.34,64.54l-.06.41c-.15-.2-.29-.41-.43-.61,0-.14.05-.28.07-.41l.42.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.22,46.22c0,.1,0,.21,0,.31l-.59-.47v-.31l.58.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.93,109l-.36.45,0-.63.36-.45c0,.21,0,.42,0,.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.28,131.64l-.53.35c.09-.15.17-.31.26-.47l.53-.36-.26.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.25,147l.2.2L81,147l-.19-.21.43.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.39,120.48l-.45.42c.05-.19.1-.38.14-.56l.45-.42c0,.19-.09.38-.14.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.08,49.94l-.56.52v-.34c.18-.18.37-.34.56-.51v.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.12,32.31l-.39.21c-.09-.07-.18-.12-.26-.19l.4-.19.25.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4,83.38c-.09.22-.16.44-.24.66-.06-.15-.13-.3-.18-.46s.15-.44.23-.66l.19.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.89,141.11l-.58.27.32-.34.59-.27-.33.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.36,110.49l-.37.45c0-.21,0-.42,0-.62l.38-.45c0,.2,0,.41,0,.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.22,32.33l-.26.18-.39-.2.25-.17.4.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.54,38l-.59.35,0-.24.59-.35,0,.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.2,119.11l-.44.42c.05-.19.09-.38.13-.57s.3-.28.44-.43c0,.2-.08.39-.13.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.76,112l-.39.44.06-.61.39-.45-.06.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.33,75.5c0,.15-.08.3-.13.45-.1-.22-.21-.44-.32-.66.05-.15.1-.3.14-.44.1.21.2.43.31.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,35l-.55.29L71.36,35l.55-.28L72,35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.12,113.43l-.4.44c0-.2.05-.4.07-.61s.27-.29.4-.44c0,.2-.05.41-.07.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.73,116.31l-.42.43c0-.2.07-.4.1-.59l.42-.44c0,.2-.06.4-.1.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.44,114.88l-.41.43.09-.6c.14-.14.27-.29.41-.44l-.09.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.6,44.94v.3c-.2-.15-.4-.3-.59-.46v-.29l.59.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.65,61.28l-.46.6c0-.13,0-.26,0-.4l.46-.6c0,.14,0,.27,0,.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62,41.35v.28c-.21-.14-.4-.28-.61-.41a2.44,2.44,0,0,0,0-.27l.6.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,32.29l-.39.2-.26-.18.38-.2.27.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.31,32.31l-.27.18-.38-.2.27-.18.38.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.19,50.08c0,.12,0,.23,0,.34l-.56-.51c0-.11,0-.22,0-.33l.56.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,93.28l-.26.46c0-.22-.08-.44-.13-.66l.25-.47c.05.22.09.45.14.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.59,137.71l-.57.3.29-.39.58-.31-.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.44,70.5l-.37.65c0-.15-.07-.29-.1-.44l.36-.64c0,.15.07.29.11.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,43.7V44l-.6-.44a2.81,2.81,0,0,0,0-.29l.59.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.29,42.5v.29l-.6-.43v-.28l.6.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.36,130.48l-.52.36.24-.48.52-.37a4.44,4.44,0,0,1-.24.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.76,139.47l-.58.28.31-.36.58-.29-.31.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.61,146.93l.17.21-.43-.19-.17-.21.43.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.94,32.27l-.37.2-.29-.18.37-.2.29.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.41,32.28l-.29.19-.37-.2.29-.18.37.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.53,134.79l-.56.33c.09-.14.19-.28.28-.43l.55-.33-.27.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.06,36.88l-.58.33a1.55,1.55,0,0,1,0-.23l.58-.32c0,.07,0,.15,0,.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6,76.86c-.1.22-.21.44-.3.66l-.15-.45c.1-.22.2-.44.31-.66,0,.16.09.3.14.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.38,65.81l-.42.62c0-.14-.05-.28-.07-.41l.41-.63c0,.14.05.28.08.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.55,35.89c-.19.09-.38.2-.57.3,0-.07,0-.14-.07-.22l.57-.3.07.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.81,52.6q-.29.27-.54.54c0-.12,0-.24,0-.36l.54-.53c0,.12,0,.24,0,.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.85,32.26l-.36.19-.3-.18.36-.19.3.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5,32.27l-.3.18-.36-.19.3-.18.36.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.58,61.45c0,.13,0,.26-.05.39-.16-.19-.31-.39-.47-.59l.06-.4.46.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.34,85c-.07.22-.14.44-.22.67-.07-.16-.13-.31-.19-.47s.14-.44.22-.67c.06.16.12.31.19.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.57,58.28c-.16.2-.32.39-.49.58,0-.12,0-.25,0-.38.16-.2.33-.39.49-.58,0,.13,0,.25,0,.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.76,32.25l-.34.2-.32-.19.35-.19.31.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.59,32.26l-.32.19-.34-.2.31-.18.35.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.67,32.25l-.33.19a3.37,3.37,0,0,1-.32-.19l.32-.18.33.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.84,94.85c-.08.16-.17.31-.26.47l-.12-.67c.09-.15.18-.31.26-.47l.12.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.63,55.39l-.52.56c0-.13,0-.25,0-.38L43.6,55l0,.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.76,70.67c0,.15-.07.29-.11.44-.12-.22-.24-.43-.37-.64,0-.15.08-.29.11-.44.13.21.25.43.37.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.42,129.29l-.52.37c.08-.16.15-.33.22-.49l.52-.37-.22.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,146.9l.16.21-.42-.19-.16-.21.42.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.83,66c0,.14-.05.28-.08.41-.13-.2-.27-.41-.42-.62l.09-.41c.14.2.28.41.41.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.58,77l-.15.45c-.1-.22-.2-.44-.31-.66.06-.14.1-.29.15-.44.1.22.21.43.31.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.67,58.44c0,.13,0,.26,0,.39-.16-.2-.33-.39-.49-.58,0-.13,0-.26,0-.39.16.2.33.39.49.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.63,48.68c0,.11,0,.22,0,.33l-.58-.5c0-.11,0-.21,0-.32l.58.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.81,85.11l-.2.47c-.07-.23-.15-.45-.22-.67s.13-.31.2-.46c.08.22.15.44.22.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.15,140.25l-.58.28.3-.35.59-.28c-.11.11-.21.23-.31.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.63,55.54l0,.37c-.18-.18-.35-.37-.52-.56l0-.37.52.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.67,133.72l-.55.34c.09-.15.18-.3.26-.45l.56-.34-.27.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.79,136.72l-.57.32c.1-.14.2-.27.29-.41l.57-.32c-.1.14-.19.28-.29.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.62,96.42l-.28.47c0-.22-.06-.44-.1-.66l.28-.47c0,.22.07.44.1.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9,34.86l-.54.28-.11-.21.55-.28a2,2,0,0,0,.1.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.44,128.08l-.51.38a5.49,5.49,0,0,0,.21-.51c.18-.12.34-.25.51-.38-.06.17-.14.34-.21.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.33,86.52l-.21.67-.21-.46.21-.67.21.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.09,72l-.36.65-.12-.44.36-.64.12.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4,78.41c-.1.22-.2.44-.29.66-.06-.15-.11-.3-.16-.45s.19-.44.29-.66c0,.15.1.3.16.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,138.54l-.57.3c.1-.13.2-.25.29-.38l.58-.3c-.09.13-.2.26-.3.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.32,146.88l.15.2-.41-.19c0-.07-.1-.14-.14-.21l.4.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1,62.68l-.45.61c0-.14,0-.28-.07-.41l.45-.61c0,.14,0,.27.07.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2,33l-.45.23-.21-.19.46-.22.2.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.36,98l-.29.46-.09-.66.29-.46.09.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.43,37.81l-.59.35a2,2,0,0,1,0-.24l.59-.34c0,.07,0,.15.05.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.33,51.14l-.55.52c0-.12,0-.23,0-.35l.55-.52c0,.12,0,.23,0,.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.53,141l-.59.27c.11-.11.21-.22.31-.34l.59-.27-.31.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.44,126.84l-.51.38c.07-.17.14-.34.2-.51l.51-.39c-.07.17-.13.35-.2.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.93,67.26l-.41.63-.09-.42.41-.63.09.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,47.32c0,.11,0,.21,0,.32l-.58-.48c0-.11,0-.21,0-.32l.58.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.82,86.69l-.21.46-.21-.67a4.69,4.69,0,0,0,.21-.46c.08.22.14.44.21.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.11,72.17c0,.15-.07.3-.12.44-.11-.22-.24-.43-.36-.65l.12-.43.36.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.79,132.61l-.54.35c.08-.15.17-.3.25-.46l.55-.35c-.08.16-.17.31-.26.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.45,35.77l-.56.3-.09-.22.57-.3a2,2,0,0,0,.08.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.13,62.84c0,.14,0,.27-.07.41-.14-.2-.3-.41-.45-.61,0-.13,0-.27.07-.4l.45.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.36,88.1c-.07.22-.14.44-.2.67-.07-.16-.15-.31-.22-.47s.12-.45.19-.67l.23.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.06,99.55l-.3.47c0-.22,0-.44-.08-.66s.21-.31.3-.47c0,.22.06.44.08.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,36.75l-.58.33c0-.08,0-.16-.07-.23l.58-.32a1.87,1.87,0,0,0,.07.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.4,125.57l-.49.4.18-.53.5-.39c-.06.17-.12.35-.19.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,146.43l.19.22-.46-.2c-.07-.07-.13-.15-.19-.22l.46.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,135.7l-.56.33.27-.42.57-.33-.28.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,59.64l-.48.59-.06-.4.48-.59.06.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.29,67.43c0,.14-.07.28-.1.42-.13-.21-.26-.42-.4-.62l.09-.43.41.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.13,33l-.45.22L81.46,33l.45-.22.22.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.23,80c-.09.22-.19.44-.28.67-.06-.16-.12-.31-.17-.46l.28-.67c0,.16.11.31.17.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1,53.85l-.54.55,0-.36.54-.55c0,.12,0,.24,0,.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.41,46c0,.1,0,.21,0,.31l-.59-.46c0-.11,0-.21,0-.31.2.15.4.3.59.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.38,139.36l-.58.28.3-.36.58-.29-.3.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,56.69l-.51.57c0-.13,0-.25,0-.38l.51-.57c0,.13,0,.25,0,.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.72,101.11l-.32.46c0-.22,0-.43-.06-.65s.22-.31.32-.47l.06.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.78,73.51c-.12.22-.24.44-.35.66,0-.15-.09-.3-.13-.45l.34-.65c0,.15.09.3.14.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.34,124.28l-.49.4c.06-.17.12-.35.17-.53l.49-.41c0,.19-.11.37-.17.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.82,34.76l-.54.28a1.13,1.13,0,0,1-.12-.21l.53-.27.13.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.79,88.26c-.07.16-.15.32-.22.47l-.2-.67c.08-.16.16-.31.23-.47.07.23.13.45.19.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.2,137.58l-.57.31.29-.39.57-.31-.29.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.89,131.48l-.54.35.24-.47.54-.35-.24.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.45,42.31l0,.28-.6-.42a2.46,2.46,0,0,0,0-.28l.61.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.77,44.73c0,.1,0,.2,0,.3-.19-.16-.39-.3-.59-.45,0-.1,0-.2,0-.3l.59.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.28,59.79c0,.14,0,.27-.06.4l-.48-.59.06-.39.48.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.42,89.68l-.18.67c-.08-.16-.15-.32-.23-.47s.11-.45.17-.67l.24.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.11,43.49c0,.1,0,.2,0,.3-.2-.15-.39-.3-.6-.44a2.64,2.64,0,0,0,0-.29l.6.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.17,54a2.22,2.22,0,0,1,0,.37c-.17-.19-.35-.37-.53-.55l0-.36.53.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.34,102.66l-.33.46c0-.22,0-.44,0-.65l.33-.46c0,.21,0,.43,0,.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.89,49.71l-.56.51c0-.12,0-.23,0-.34l.56-.51c0,.11,0,.22,0,.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.06,32.92l-.43.23-.24-.2.43-.21.24.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.24,123l-.47.41.15-.55.48-.41a5,5,0,0,1-.16.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4,146.39a1.84,1.84,0,0,0,.17.22l-.45-.19c-.06-.08-.12-.15-.17-.23l.45.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.29,56.84c0,.13,0,.26,0,.38-.17-.19-.33-.38-.51-.56,0-.13,0-.26.05-.38l.51.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.59,64.09c-.15.21-.3.41-.44.62,0-.14-.06-.28-.08-.41.14-.21.29-.41.44-.62,0,.14.05.28.08.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.51,68.73l-.39.64c0-.15-.07-.29-.11-.43l.4-.64c0,.15.07.29.1.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.13,134.65l-.56.34c.09-.15.18-.29.26-.44l.56-.33-.26.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.93,104.19l-.34.47,0-.65.34-.46,0,.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.12,121.64l-.47.41c0-.19.1-.37.14-.56l.47-.41c0,.18-.1.37-.14.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.11,81.52c-.09.22-.19.44-.27.67l-.19-.46.27-.67c.06.16.13.31.19.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.76,140.15l-.58.28.29-.36.59-.28-.3.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.4,49.85l0,.33-.56-.51c0-.11,0-.22,0-.33l.57.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.73,89.84l-.24.47-.18-.67.24-.47.18.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.53,91.26c-.06.22-.12.44-.17.67-.08-.16-.16-.32-.25-.47s.11-.45.16-.67l.26.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,32.89l-.42.22-.26-.2.42-.21.26.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,130.32l-.53.36c.08-.16.15-.32.22-.48l.54-.37c-.08.16-.15.32-.23.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.48,105.72l-.36.46c0-.21,0-.42,0-.63l.35-.47c0,.22,0,.43,0,.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,120.28l-.46.42c.05-.19.08-.38.13-.57l.46-.42c0,.19-.08.38-.13.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.65,64.26c0,.14-.06.27-.08.41l-.45-.61.09-.41c.15.2.3.4.44.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.33,37.67l-.59.34-.06-.24.59-.34.06.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,107.25l-.37.45v-.63c.12-.15.24-.31.37-.46v.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.71,68.9c0,.14-.07.29-.11.43-.13-.22-.27-.42-.4-.64,0-.14.08-.28.11-.42l.4.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5,75l-.33.65L34,75.25l.33-.66.15.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.77,118.9l-.45.42c0-.19.07-.38.11-.57s.31-.28.45-.43c0,.2-.07.39-.11.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.78,146.36l.16.22-.44-.2-.16-.22.44.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.14,140.92c-.2.08-.39.17-.59.27l.3-.34.58-.28c-.09.12-.19.23-.29.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.4,136.59c-.19.11-.38.22-.58.32l.28-.41.57-.32-.27.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.46,108.75l-.38.46c0-.21,0-.42,0-.63s.25-.3.37-.46c0,.21,0,.42,0,.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.94,32.86l-.41.21-.27-.19.41-.21.27.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.61,52.36l-.55.53c0-.12,0-.24,0-.36l.54-.53c0,.12,0,.24,0,.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.87,36.62l-.58.33c0-.08-.05-.16-.08-.23l.58-.32a2,2,0,0,0,.08.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.74,34.67l-.53.27-.14-.21.54-.27.13.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.6,138.43l-.58.29.28-.38.58-.3-.28.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.54,117.5l-.44.43c0-.19.07-.39.1-.58l.44-.43c0,.19-.06.39-.1.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4,61l-.48.6c0-.14,0-.27-.07-.4l.48-.6c0,.13,0,.27.07.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.9,110.25l-.39.45c0-.21,0-.41,0-.62l.4-.45,0,.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.28,116.08l-.43.44.09-.59.43-.44-.09.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.63,91.42l-.26.47c-.05-.22-.11-.45-.17-.67.09-.15.18-.31.26-.47.06.22.11.45.17.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.67,92.84l-.15.67L32.25,93l.15-.67.27.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.3,111.73l-.4.45c0-.21,0-.41,0-.62l.4-.45c0,.21,0,.42,0,.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,114.65l-.42.44c0-.2,0-.4.07-.6l.42-.44c0,.2,0,.4-.07.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.51,141.66l-.58.26.29-.33.58-.26-.29.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.66,113.2c-.13.15-.27.29-.41.44l.06-.61.41-.44-.06.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,129.12l-.53.37.21-.49.53-.37-.21.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.27,133.57l-.56.34c.09-.14.17-.29.25-.44l.56-.35c-.09.15-.17.3-.25.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,83.09c-.09.22-.18.44-.26.67l-.2-.47c.09-.22.17-.44.25-.66l.21.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.88,32.83l-.39.22-.29-.2.4-.21.28.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.81,48.45c0,.11,0,.22,0,.33l-.58-.49,0-.33.57.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.42,55.13l-.53.56c0-.13,0-.25,0-.37l.52-.56c0,.12,0,.25.05.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.34,58l-.5.58c0-.13,0-.26-.05-.39.16-.2.33-.39.5-.58,0,.13,0,.26.05.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.86,61.17c0,.13-.05.27-.07.4l-.48-.6a2.57,2.57,0,0,0,.07-.4l.48.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.13,70.22l-.38.64c0-.15-.08-.29-.12-.44l.38-.64.12.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.18,146.33l.14.22-.43-.2a1.76,1.76,0,0,1-.14-.23l.43.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.83,32.82a3.59,3.59,0,0,0-.38.21l-.3-.2.38-.21.3.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.54,32.83l-.3.19-.39-.21.3-.19.39.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.11,65.53c-.15.2-.29.41-.43.62,0-.14-.07-.28-.1-.42l.43-.62c0,.14.06.28.1.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.48,93c-.09.15-.17.31-.26.47-.05-.23-.11-.45-.16-.67l.27-.47.15.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.78,32.8l-.37.21a3.28,3.28,0,0,1-.31-.2l.37-.2.31.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,127.9c-.17.13-.34.26-.52.38.07-.16.13-.33.2-.5l.52-.38c-.06.17-.13.33-.2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.59,32.81l-.32.2-.37-.21.32-.2.37.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.26,76.57c-.1.22-.21.44-.32.66l-.16-.45.32-.66c0,.16.11.31.16.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.73,32.8l-.36.2-.32-.2.36-.2.32.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,139.25l-.58.29c.09-.13.19-.25.28-.37l.59-.3-.29.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.86,55.28c0,.12,0,.25-.05.37l-.53-.55c0-.13,0-.25.05-.37l.53.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.64,32.8l-.33.2L90,32.8l.33-.2.36.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.92,58.17c0,.13,0,.26-.06.39l-.5-.58.06-.38.5.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.69,32.79l-.35.21L89,32.8l.34-.2.35.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.2,47.1l0,.32-.58-.48,0-.32.58.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.57,135.57l-.57.32c.08-.14.17-.28.26-.42l.57-.33-.26.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3,35.55l-.55.29-.12-.22c.19-.09.37-.19.55-.29l.12.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.09,70.38l-.12.44-.39-.64c0-.15.09-.29.12-.43.14.21.26.42.39.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.38,132.46l-.55.35c.08-.15.16-.3.23-.46l.56-.35c-.08.15-.15.31-.24.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,84.66c-.08.22-.17.45-.24.67-.08-.15-.15-.31-.22-.47l.24-.66c.07.15.14.31.22.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.13,65.69c0,.14-.06.28-.09.42-.15-.2-.29-.41-.44-.62,0-.14.07-.28.1-.42l.43.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.16,50.89l-.56.53c0-.12,0-.24,0-.35l.56-.52c0,.11,0,.23,0,.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.58,146.3l.12.22-.41-.2a1.71,1.71,0,0,1-.13-.23l.42.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.8,137.46l-.58.31.27-.4.58-.31-.27.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.3,94.58,146,95c0-.22-.09-.44-.14-.66l.29-.47c0,.22.09.44.13.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,126.66l-.51.39.18-.52.51-.39c-.05.17-.12.35-.18.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.57,42.12a2.36,2.36,0,0,1,0,.28l-.6-.41c0-.09,0-.19,0-.28l.6.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.57,45.79c0,.1,0,.21,0,.31l-.59-.47,0-.31.6.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.36,140l-.59.29.28-.36.59-.29c-.09.13-.19.25-.28.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.25,43.3c0,.09,0,.19,0,.29l-.6-.43c0-.1,0-.2,0-.29l.6.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.91,44.52l0,.3-.6-.45c0-.1,0-.2,0-.3l.59.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.86,62.4l-.47.61c0-.14-.06-.27-.08-.41l.46-.6.09.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8,36.5l-.57.32a2.29,2.29,0,0,1-.1-.23l.57-.31.1.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.26,37.53l-.59.34c0-.08,0-.16-.08-.24l.59-.33c0,.07,0,.15.08.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.22,84.83l-.22.46-.24-.67.22-.46.24.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.79,71.72c-.13.21-.25.43-.37.64-.05-.14-.1-.29-.14-.44l.37-.64c.05.14.09.29.14.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.08,96.15c-.1.16-.19.32-.29.47,0-.22-.08-.44-.13-.66l.3-.47.12.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.87,33.6l-.46.25-.22-.21.46-.23.22.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,146.27l.11.22-.4-.2a1.63,1.63,0,0,1-.11-.23l.4.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,125.39l-.51.39c.06-.17.11-.35.17-.52l.51-.4c0,.18-.11.35-.17.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.06,78.12c-.1.22-.21.44-.3.66-.07-.15-.12-.3-.18-.45.1-.22.2-.44.31-.66,0,.15.11.3.17.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,86.24c-.08.22-.15.44-.22.67-.08-.16-.16-.31-.23-.47l.22-.67c.07.16.15.31.23.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.47,131.32l-.55.36c.08-.16.15-.31.22-.47l.55-.36c-.07.15-.14.31-.22.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.73,140.82l-.59.27c.09-.11.19-.22.28-.34l.59-.28-.28.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.91,53.6l-.54.55c0-.12,0-.24,0-.37l.54-.54c0,.12,0,.24,0,.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.66,67l-.42.63c0-.14-.07-.28-.11-.43l.42-.62c0,.14.07.28.11.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.71,134.51c-.18.12-.37.23-.56.34l.24-.44.57-.34c-.08.15-.16.3-.25.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.4,62.56c0,.14-.05.28-.08.41l-.47-.6.09-.41.46.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.75,59.37c-.17.19-.33.39-.5.59,0-.14,0-.27-.07-.4l.5-.58c0,.13,0,.26.07.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.74,49.47l-.57.51c0-.11,0-.23,0-.34l.57-.5c0,.11,0,.22,0,.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.82,97.72l-.31.47c0-.22-.07-.44-.1-.66l.3-.47c0,.22.08.44.11.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.77,56.43l-.52.57-.06-.38.52-.57.06.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.89,124.09l-.49.41.15-.54.5-.41c-.05.19-.1.36-.16.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.18,138.31l-.58.3.27-.38.58-.31a4.56,4.56,0,0,1-.27.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.44,71.88c-.05.15-.09.3-.14.44l-.37-.64c0-.15.09-.29.13-.44l.38.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.25,35.45l-.55.29c0-.08-.09-.15-.13-.22l.54-.29.14.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.38,53.75c0,.12,0,.24,0,.37l-.54-.55c0-.12,0-.24.05-.36l.54.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.54,145.79l.16.23-.46-.21-.16-.24.46.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,136.47l-.58.31c.09-.13.17-.27.26-.41l.57-.32-.25.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.84,33.56l-.46.23-.24-.2.46-.23.24.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.23,86.4l-.23.47c-.08-.22-.15-.45-.23-.67.08-.16.16-.31.23-.47.08.23.15.45.23.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.58,67.15c0,.14-.07.28-.11.42l-.42-.63c0-.14.08-.28.11-.42.14.21.29.42.42.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.57,49.61c0,.11,0,.23,0,.34l-.57-.51c0-.11,0-.22,0-.33l.57.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.52,59.52c0,.14,0,.27-.07.4l-.49-.59c0-.13,0-.26.07-.39.17.19.33.39.49.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,87.82l-.21.67c-.08-.16-.17-.31-.24-.47s.13-.45.21-.67c.07.16.16.31.24.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.52,99.29l-.32.46c0-.22-.06-.43-.09-.65l.32-.47.09.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.53,130.15l-.54.37c.07-.16.13-.32.21-.48l.54-.37-.21.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.79,122.78l-.49.4c0-.18.1-.36.14-.54l.49-.41c0,.18-.09.36-.14.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.51,56.58l-.06.38-.52-.56L135,56l.52.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9,79.67l-.3.67-.19-.46.3-.66c.06.15.12.3.19.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.48,73.23l-.36.65L35,73.44l.36-.65.15.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.19,100.85l-.33.46c0-.22-.06-.43-.08-.65l.33-.47c0,.22,0,.44.08.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.66,121.44l-.48.41.12-.56c.16-.14.33-.27.48-.42,0,.19-.08.38-.12.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.84,133.43l-.57.34.24-.44.56-.35-.23.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8,33.51l-.44.24-.25-.21.44-.23.25.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.56,139.14l-.59.29.27-.37.59-.3-.27.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.35,63.82c-.16.2-.31.41-.46.61,0-.14-.06-.27-.1-.41.15-.21.31-.41.46-.61,0,.13.06.27.1.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.75,36.39l-.57.31-.11-.23.56-.31.12.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,145.75l.15.24-.45-.21-.15-.25.45.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.2,88l-.24.47c-.07-.22-.14-.45-.22-.67l.25-.47.21.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.45,52.11l-.56.54c0-.12,0-.24,0-.36l.56-.53c0,.12,0,.23.05.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.05,89.4c-.07.22-.14.44-.2.67-.09-.16-.18-.31-.26-.47s.13-.45.2-.67c.08.16.17.31.26.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2,37.4l-.58.34a2.44,2.44,0,0,1-.1-.24l.58-.34.1.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.82,102.4l-.35.46c0-.21,0-.43-.07-.65l.35-.46c0,.21.05.43.07.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.25,68.45l-.41.63c0-.14-.09-.28-.12-.43l.4-.63.13.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.49,120.07l-.47.42c0-.18.07-.38.11-.56l.48-.43-.12.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.56,129l-.54.37c.07-.16.13-.33.2-.5l.54-.37c-.07.16-.13.33-.2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.31,79.84c-.06.16-.13.31-.19.46l-.3-.66.19-.46.3.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.78,33.47l-.44.24-.26-.21.43-.23.27.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.93,139.94l-.59.29.26-.36.59-.29-.26.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.4,103.94l-.35.46c0-.21,0-.43-.05-.64l.36-.46c0,.21,0,.42,0,.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.91,64c0,.14-.06.28-.1.41l-.45-.61c0-.14.07-.27.1-.41l.45.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.3,118.69l-.47.43c0-.2.07-.39.1-.58l.46-.43-.09.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.13,135.44l-.57.32.24-.42.58-.33c-.09.14-.17.29-.25.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.21,35.35l-.54.29-.15-.22.54-.29.15.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.37,137.34l-.59.31.26-.39.58-.32c-.08.14-.17.27-.25.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.77,81.24l-.28.66c-.07-.15-.14-.3-.2-.46.09-.22.18-.44.28-.66.06.15.14.3.2.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.18,60.74c-.16.2-.32.39-.48.6l-.09-.41.49-.59c0,.13,0,.27.08.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,105.47l-.36.47c0-.22,0-.43,0-.64l.37-.47c0,.22,0,.43,0,.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.3,140.72l-.59.28.26-.34.59-.28-.26.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.06,117.29l-.45.43c0-.2.06-.39.08-.59l.46-.43-.09.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,68.62c0,.14-.09.28-.13.43-.13-.22-.27-.43-.41-.64,0-.14.09-.28.13-.43l.41.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.25,54.88l-.54.55-.06-.37c.17-.19.35-.37.53-.56,0,.13,0,.25.07.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.14,89.56c-.09.16-.17.32-.26.47-.06-.22-.13-.44-.2-.67.09-.15.17-.31.26-.47.06.23.13.45.2.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.39,145.72l.13.23-.44-.21L80,145.5c.15.07.3.14.44.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.15,91c-.06.23-.13.45-.19.67l-.27-.47c.06-.22.12-.45.19-.67.08.16.18.31.27.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.47,107l-.38.46c0-.21,0-.43,0-.64l.38-.46c0,.22,0,.43,0,.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.94,132.31l-.56.35c.07-.15.15-.3.22-.46l.56-.35-.22.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.76,33.44l-.42.23-.29-.2.42-.23.29.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.8,115.86l-.45.44c0-.2.05-.39.07-.59l.45-.44c0,.2-.05.4-.07.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.57,127.73l-.53.38.18-.5.53-.39-.18.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.21,74.75l-.35.66c-.06-.15-.11-.3-.16-.45L35,74.3l.17.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.15,57.76c-.17.18-.34.38-.51.57,0-.13,0-.26-.07-.39.16-.19.34-.38.51-.57,0,.13.05.26.07.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.35,43.1c0,.1,0,.2,0,.3l-.61-.43c0-.1,0-.19.06-.29l.6.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.12,108.51l-.39.46c0-.21,0-.42,0-.63l.39-.46c0,.21,0,.42,0,.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.69,45.58c0,.1,0,.2,0,.31-.19-.16-.4-.31-.6-.46,0-.11,0-.21.06-.31l.59.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.5,114.43c-.15.14-.29.29-.44.44l.06-.6.43-.45c0,.21,0,.4-.05.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,44.32c0,.1,0,.2,0,.3-.2-.15-.4-.3-.61-.44,0-.11,0-.21.06-.31l.6.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.39,110l-.41.45c0-.2,0-.41,0-.62l.41-.45c0,.21,0,.41,0,.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.16,113l-.42.44c0-.2,0-.4,0-.6l.42-.45c0,.2,0,.41,0,.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.79,111.5l-.41.45c0-.21,0-.41,0-.62l.42-.45,0,.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.09,60.9c0,.13-.05.27-.08.4l-.49-.6.09-.4.48.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.05,55l-.06.38-.54-.56c0-.12.05-.24.07-.37.17.19.36.37.53.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,50.66l-.57.52-.06-.35.57-.52.06.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.74,33.42l-.41.22-.3-.21.41-.22.3.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,91.14l-.27.47-.18-.67.27-.47.18.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.29,92.56c-.06.23-.12.45-.17.67-.1-.15-.19-.31-.28-.47s.1-.44.16-.67c.1.16.19.32.29.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.14,57.91c0,.13,0,.26-.08.39l-.51-.58c0-.13,0-.26.07-.39.18.19.35.39.52.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.74,138.2l-.58.3.25-.38c.19-.11.39-.21.59-.31l-.26.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.87,65.25l-.44.62c0-.14-.08-.28-.11-.42.14-.21.29-.41.44-.62,0,.14.07.28.11.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,74.92l-.16.45-.36-.65c.06-.15.12-.3.17-.45.12.21.23.43.35.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.73,33.4l-.4.22L86,33.41l.39-.22.32.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.87,69.93l-.39.64c0-.14-.1-.29-.14-.43l.39-.64c.05.14.1.29.14.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.83,145.68a2.56,2.56,0,0,1,.11.24l-.42-.21c0-.08-.08-.16-.12-.24l.43.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.69,82.81q-.15.33-.27.66A4.81,4.81,0,0,1,33.2,83c.08-.22.18-.45.27-.67.07.16.14.31.22.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.55,126.48l-.53.39c.06-.17.12-.34.17-.52l.52-.39c-.05.18-.11.35-.16.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.24,145.18c.05.09.11.17.16.25l-.48-.22-.16-.25.48.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.26,134.38l-.57.33.23-.43.58-.34-.24.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.3,50.8c0,.11,0,.23-.06.35-.18-.18-.37-.35-.57-.52,0-.12,0-.23.06-.35l.57.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.58,38.35l-.6.35-.09-.25.59-.35a2.6,2.6,0,0,0,.1.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.72,33.38l-.39.23L87,33.39l.39-.22.33.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.68,33.39l-.33.21L91,33.38l.33-.21.39.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,131.16l-.55.37.2-.47.56-.37c-.06.16-.14.32-.21.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.71,33.38l-.38.22L88,33.38l.37-.21a3.24,3.24,0,0,1,.35.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.53,136.34l-.58.32.24-.41.58-.32-.24.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.69,33.38l-.35.22L90,33.38l.35-.22.37.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.17,37.27l-.59.34c0-.08-.07-.16-.11-.25l.58-.32a1,1,0,0,0,.12.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.2,35.31l-.17.22-.54-.28.17-.22.54.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7,33.38l-.36.21L89,33.38l.36-.22.36.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3,40.55l-.61.4c0-.1,0-.19-.07-.28l.6-.39a2.76,2.76,0,0,0,.08.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.47,94.15c-.06.22-.11.44-.16.66-.1-.16-.2-.31-.29-.47s.1-.44.15-.67c.09.16.2.32.3.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.39,65.41c0,.14-.07.29-.11.42l-.45-.62.12-.41.44.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.89,92.72l-.28.47c-.05-.22-.11-.44-.17-.66l.28-.47c.06.22.12.44.17.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,76.29l-.33.66a3.66,3.66,0,0,1-.18-.46l.33-.65.18.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.38,70.1c0,.15-.1.29-.14.44l-.4-.64c0-.15.09-.29.14-.44l.4.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.11,139l-.59.29.26-.37.58-.29c-.08.12-.16.25-.25.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.52,83c-.07.16-.14.31-.22.46q-.12-.33-.27-.66c.08-.16.15-.31.22-.47.09.23.19.45.27.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.49,125.2l-.51.4.15-.53.52-.4c-.05.18-.1.36-.16.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.77,53.36l-.55.54c0-.12,0-.24-.07-.37.18-.18.36-.36.55-.53,0,.12,0,.24.07.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.28,145.65l.09.24-.41-.22a2.44,2.44,0,0,1-.1-.24l.42.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.65,62.13l-.48.61c0-.14-.06-.28-.1-.41l.48-.6.1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.64,84.38c-.09.22-.18.44-.26.67-.08-.16-.16-.31-.23-.47s.17-.44.25-.67c.07.16.16.31.24.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.68,95.72c0,.23-.09.45-.14.67-.1-.16-.21-.31-.3-.47s.09-.45.13-.67l.31.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.48,139.84l-.59.29.25-.36.59-.29-.25.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.69,145.14l.15.25-.47-.22-.15-.26.47.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.71,94.3l-.3.47-.15-.66.3-.47.15.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.55,34.23l-.48.26-.24-.22.48-.25.24.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.06,130l-.55.37c.07-.16.13-.32.19-.48l.55-.38c-.06.17-.12.33-.19.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.55,53.5c0,.12,0,.24-.07.37l-.55-.55c0-.12,0-.24.07-.36l.55.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.41,123.91l-.51.4c0-.18.1-.36.14-.54l.51-.41c0,.18-.09.37-.14.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.61,56.18l-.53.56c0-.13,0-.25-.08-.38.18-.19.35-.38.53-.56,0,.12.06.25.08.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.57,59.1l-.51.59-.09-.4.51-.58a2.74,2.74,0,0,0,.09.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.37,133.28l-.56.35.21-.45.57-.35c-.07.15-.14.3-.22.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.53,71.43l-.39.65L36,71.64l.39-.65.15.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.63,62.29c0,.14-.06.27-.1.41l-.48-.6c0-.14.07-.28.11-.41l.47.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.69,36.17l-.55.31L72,36.25c.18-.11.37-.21.56-.31l.14.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.43,66.7l-.43.63c0-.14-.09-.28-.13-.43.14-.21.29-.41.44-.62,0,.14.08.28.12.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.94,97.3c0,.22-.09.44-.12.66l-.33-.47c0-.22.08-.44.13-.66.1.16.21.31.32.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.91,137.22l-.59.31c.09-.13.16-.26.24-.39l.59-.32-.24.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.57,84.54c-.07.16-.15.31-.23.47-.08-.22-.17-.45-.26-.67l.24-.47c.09.23.17.45.25.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.22,35.22l-.19.23-.53-.28.19-.22.53.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.49,95.88c-.1.16-.2.32-.31.47,0-.22-.09-.44-.14-.66l.31-.47c.05.22.1.44.14.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.77,77.84c-.1.22-.21.44-.32.66L34.26,78c.1-.22.21-.44.32-.66.07.15.13.3.19.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.67,135.31l-.58.32.23-.42.58-.33c-.08.14-.16.28-.23.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.09,48l-.06.33-.59-.49.06-.33.59.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.7,56.32c0,.13-.06.26-.08.39l-.53-.57c0-.13,0-.25.08-.38.17.19.35.38.53.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.3,122.58l-.5.41a4.88,4.88,0,0,0,.12-.55l.51-.41c0,.18-.09.37-.13.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.62,86l-.24.67c-.08-.16-.17-.31-.24-.47s.16-.45.24-.67l.24.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.73,59.26l-.09.39-.51-.58c0-.13.07-.26.09-.39l.51.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.55,34.18l-.47.25-.25-.21.46-.25.26.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.72,71.6c-.05.15-.1.29-.16.44-.12-.21-.25-.43-.39-.64.06-.15.11-.3.16-.44l.39.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.15,145.1a2,2,0,0,0,.13.25l-.46-.22a2.1,2.1,0,0,1-.13-.26l.46.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.32,51.88l-.56.52c0-.12,0-.24-.07-.35l.56-.53c0,.12,0,.24.07.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.84,66.87c-.05.14-.09.28-.13.42-.15-.21-.29-.42-.44-.62,0-.15.09-.29.13-.43l.44.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.08,128.79l-.54.38.18-.5.54-.38-.18.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.14,37.15l-.57.33c0-.08-.09-.16-.13-.24l.57-.32.13.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,97.45l-.33.47c0-.22-.08-.44-.12-.66l.32-.47c0,.22.09.44.13.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.55,38.21l-.59.35a2.72,2.72,0,0,1-.11-.25l.58-.35.12.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.45,46.66c0,.11,0,.22-.07.33l-.59-.48.06-.32.6.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.16,121.24l-.49.41c0-.18.07-.37.1-.55l.5-.42c0,.18-.07.37-.11.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.79,45.37a2.82,2.82,0,0,1-.07.31l-.6-.45c0-.11,0-.21.07-.31l.6.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.28,138.08l-.59.31.24-.39.59-.3-.24.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.59,86.12l-.25.47c-.08-.22-.16-.45-.25-.67.09-.16.18-.31.25-.47.09.22.17.45.25.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.46,132.16l-.56.36c.06-.16.13-.31.2-.46l.57-.36-.21.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.15,63.55l-.47.61c0-.14-.08-.28-.11-.42l.46-.61.12.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.94,99l-.33.47c0-.22-.07-.44-.12-.66.12-.15.23-.31.34-.47,0,.22.08.44.11.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.65,87.54c-.08.22-.15.45-.23.67l-.26-.47c.07-.23.15-.45.23-.67.08.16.17.31.26.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.55,34.14l-.46.25-.26-.22.45-.25.27.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,119.87l-.48.42c0-.19.07-.38.1-.57l.48-.42c0,.19-.06.38-.1.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.23,73l-.38.64c-.06-.14-.11-.29-.16-.44l.37-.65.17.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.23,35.14l-.21.23-.51-.28.2-.22.52.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.61,79.39c-.11.22-.21.44-.31.66l-.21-.46c.11-.22.21-.44.31-.66l.21.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.08,127.56l-.54.38c.06-.16.11-.33.16-.5l.54-.39c-.05.17-.11.34-.16.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.11,54.63l-.54.55-.09-.37.55-.55c0,.12,0,.24.08.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.62,145.06c0,.09.07.17.11.26l-.45-.23-.12-.26.46.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.61,100.58c-.12.16-.23.32-.35.47,0-.21-.06-.43-.1-.65.12-.16.24-.31.35-.47,0,.22.07.44.1.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.64,138.92c-.19.11-.39.2-.59.3l.24-.37.59-.3-.24.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,68.17l-.42.63-.15-.43.43-.63c0,.14.09.29.14.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.78,118.48l-.48.43c0-.19.06-.38.08-.58l.48-.43c0,.19-.05.39-.08.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.05,136.22l-.58.32.23-.41.58-.33c-.07.14-.15.28-.23.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.71,36.13a2,2,0,0,1-.18.23l-.54-.3.17-.23.55.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.79,134.24l-.58.34c.08-.14.15-.29.22-.44l.57-.34-.21.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.91,50.43l-.57.51c0-.11-.05-.23-.07-.35l.57-.51c0,.12,0,.23.07.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.14,63.7l-.12.42-.47-.61.12-.41.47.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,60.47l-.49.6c0-.14-.08-.27-.11-.41.16-.2.33-.39.5-.59,0,.14.07.27.1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.56,34.1l-.44.25-.28-.22c.14-.09.29-.17.44-.25l.28.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.56,87.7c-.08.16-.17.31-.26.47-.08-.22-.15-.44-.23-.67.09-.15.18-.31.26-.47.08.23.16.45.23.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.24,102.14l-.36.47c0-.22,0-.43-.08-.65l.36-.47c0,.22.06.43.08.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,57.5l-.52.57-.09-.39.52-.57.09.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,73.11l-.17.45c-.13-.22-.25-.44-.38-.65.06-.15.12-.3.17-.45l.38.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.54,117.07l-.47.44c0-.2.05-.39.07-.59l.47-.43c0,.19,0,.39-.07.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.71,89.12c-.07.23-.15.45-.21.67a4.39,4.39,0,0,1-.27-.47c.06-.22.14-.45.21-.67l.27.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.21,54.77c0,.13-.05.25-.08.38l-.55-.55.09-.38.54.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.83,103.69l-.37.46c0-.21-.05-.43-.07-.64l.37-.47c0,.22.05.43.07.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.52,131l-.56.37c.07-.16.13-.32.19-.48s.38-.24.56-.37a4.78,4.78,0,0,1-.19.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.36,144.5l.15.26-.49-.23-.15-.27.49.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.43,50.56c0,.12-.05.24-.08.35l-.58-.51c0-.12.06-.23.08-.35l.58.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.27,115.65l-.46.43c0-.19,0-.39.05-.59l.46-.44c0,.2,0,.4,0,.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.24,68.33c0,.15-.09.29-.14.44-.14-.21-.28-.43-.43-.64l.15-.43c.14.21.29.42.42.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.05,126.3l-.54.4c.05-.18.11-.35.15-.52l.54-.4-.15.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.58,41.49c-.21.13-.41.27-.61.41l-.09-.29.61-.4.09.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.58,34.06c-.14.09-.29.17-.44.25l-.29-.22.43-.24.3.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.29,60.63c0,.13-.07.27-.11.4l-.49-.59c0-.14.07-.27.1-.4.17.19.34.39.5.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.39,105.23l-.39.46c0-.21,0-.43-.05-.64.13-.15.26-.31.38-.47l.06.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.91,39.2l-.6.37-.11-.26.59-.37.12.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.22,35.07l-.22.22-.5-.27a2.28,2.28,0,0,1,.22-.22c.17.08.33.18.5.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,114.2l-.45.45c0-.2,0-.4,0-.6l.45-.45c0,.2,0,.4,0,.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.14,37l-.57.33-.15-.25L71,36.8l.15.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.09,145l.1.25-.44-.23a2.6,2.6,0,0,1-.1-.25l.44.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.49,81l-.3.67c-.08-.15-.15-.31-.22-.46.1-.22.19-.45.3-.67.07.16.14.31.22.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.31,57.65c0,.13-.06.26-.1.39-.17-.2-.34-.39-.52-.58,0-.13.07-.25.1-.38.17.19.35.37.52.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.91,106.76c-.13.15-.27.3-.4.46,0-.21,0-.43,0-.64.14-.15.27-.31.4-.46,0,.21,0,.42,0,.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.62,112.74l-.44.45c0-.2,0-.41,0-.61l.44-.45c0,.21,0,.41,0,.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.39,108.27l-.41.46,0-.63.41-.46c0,.21,0,.42,0,.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.25,111.27l-.43.45v-.62l.43-.45v.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,74.47l-.36.65c-.07-.15-.13-.3-.19-.45l.37-.65.18.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5,89.28l-.28.47-.21-.67.27-.46c.08.22.15.44.22.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.83,109.78l-.41.45c0-.21,0-.41,0-.62l.42-.46v.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.81,90.71c-.06.22-.14.44-.2.67l-.28-.48c.06-.22.13-.44.2-.66l.28.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.54,38.09l-.59.34c0-.08-.08-.17-.13-.25l.59-.35c0,.09.08.17.13.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.43,137.11l-.59.31c.07-.13.15-.26.22-.4l.59-.32-.22.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6,34l-.42.24-.32-.22.43-.24.31.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.69,65c-.16.2-.31.41-.46.62,0-.14-.09-.28-.13-.43l.45-.61c0,.14.09.28.14.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.66,53.12l-.57.54c0-.13-.05-.25-.08-.37l.56-.54c0,.12,0,.25.09.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.82,49.15c0,.12,0,.23-.08.34l-.59-.5c0-.11.06-.22.08-.33l.59.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.88,133.14l-.57.35.2-.45.57-.35c-.06.15-.13.3-.2.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,125l-.52.4c0-.17.09-.35.13-.53s.36-.26.53-.4c0,.18-.09.36-.14.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.71,36l-.19.24L104,36l.18-.23.55.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.62,34l-.41.24L85.89,34l.41-.23c.1.07.22.14.32.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.66,69.66l-.42.63-.15-.43.41-.64c0,.14.11.29.16.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.18,135.18l-.59.33c.08-.14.15-.28.22-.43l.58-.33-.21.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.56,129.83c-.18.13-.37.25-.56.37l.18-.48.56-.38-.18.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.3,74.64c-.06.15-.12.3-.19.45l-.36-.66c.06-.15.13-.3.18-.45.13.22.25.44.37.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.58,145a2.41,2.41,0,0,0,.08.25l-.43-.23-.09-.26.44.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.85,144.46l.13.26-.48-.23-.14-.28.49.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.65,34l-.4.23L86.91,34l.4-.23.34.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,92.29l-.18.67c-.11-.16-.2-.32-.3-.47l.18-.67.3.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.39,90.87l-.28.47-.21-.67c.1-.15.2-.31.29-.47.07.22.14.44.2.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.76,34l-.34.23L91,34l.35-.22.39.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.21,35l-.23.23-.5-.28.23-.22.5.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4,82.52l-.28.67-.24-.46c.09-.23.19-.45.28-.67.09.15.16.31.24.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.68,34l-.39.23L87.94,34l.38-.23.36.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.74,34l-.36.23L90,34l.35-.23.39.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.79,138l-.59.3.22-.38.59-.32c-.07.13-.14.27-.22.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.6,65.14c0,.14-.08.28-.13.42l-.46-.62c.05-.14.09-.28.13-.42l.46.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.68,53.26c0,.12-.05.24-.08.36l-.56-.54c0-.12.06-.24.08-.36l.56.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.71,34c-.13.07-.25.15-.37.23L89,34c.12-.08.24-.16.37-.23l.37.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.49,61.87c-.17.2-.33.39-.49.6l-.12-.41c.16-.21.32-.4.49-.6,0,.13.08.27.12.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.24,40.24l-.6.38-.11-.27.6-.38.11.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.89,123.72l-.52.41c0-.18.09-.36.13-.54s.34-.28.52-.41c-.05.18-.08.36-.13.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.49,55.92l-.54.57c0-.13-.06-.26-.1-.39l.54-.56c0,.13.06.26.1.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.62,69.82c-.05.14-.11.29-.16.44l-.42-.64c.06-.15.11-.29.16-.44.15.21.28.43.42.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.53,46.46l-.09.32-.6-.47.09-.32.6.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.73,76l-.36.65-.19-.45c.11-.22.23-.44.35-.66.07.15.13.31.2.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.13,93.88c-.06.22-.11.44-.17.66l-.31-.47c.05-.22.11-.44.17-.67.1.16.2.32.31.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.43,58.84l-.52.59c0-.14-.08-.27-.11-.4l.52-.58c0,.13.07.26.11.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.25,92.45c-.09.16-.2.32-.3.47l-.18-.66.3-.48.18.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.07,145l.06.26-.42-.23-.06-.26.42.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.84,82.69l-.24.46c-.09-.22-.19-.44-.29-.66l.24-.47c.09.22.19.44.29.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.23,34.9l-.49.27-.26-.23c.17-.08.33-.17.49-.26l.26.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.23,51.64l-.57.53-.09-.36.58-.52c0,.11.05.23.08.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.57,128.62,129,129c.06-.17.1-.34.16-.5l.55-.39c0,.17-.11.34-.16.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.82,62l-.12.41-.49-.6.12-.41.49.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.84,56.07c0,.13-.06.26-.1.38-.17-.19-.36-.37-.54-.56,0-.13.07-.25.1-.38l.54.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.19,34.94l-.25.23-.49-.27.25-.23.49.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,132c-.2.11-.38.23-.58.35.07-.15.13-.3.19-.46l.58-.36c-.07.16-.13.31-.19.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.34,144.41l.12.27-.48-.24c0-.09-.08-.18-.11-.27l.47.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.77,122.39l-.51.41c0-.18.07-.36.11-.55l.51-.41c0,.18-.07.37-.11.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.69,35.94l-.2.24-.54-.3.21-.23.53.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.35,84.1l-.27.67-.25-.47.27-.67.25.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.55,136.09l-.59.33.22-.41.59-.33-.22.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.91,39.06l-.6.37c0-.09-.09-.18-.13-.27l.6-.36a2.1,2.1,0,0,0,.13.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.35,95.46c-.06.22-.11.44-.16.66l-.33-.47c0-.22.11-.44.16-.66l.33.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.89,59c0,.13-.07.26-.11.39l-.51-.58c0-.13.07-.26.11-.4l.51.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.53,76.17c-.06.15-.13.3-.2.46-.11-.22-.23-.44-.35-.66.07-.15.14-.3.2-.45.12.21.24.43.35.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.25,66.43l-.45.62c0-.14-.1-.28-.14-.42L39.1,66l.15.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.55,38,69,38.3l-.15-.25.58-.34.15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.08,94l-.32.48c-.06-.22-.11-.45-.17-.67l.31-.47.18.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.32,71.15l-.4.65c-.06-.15-.11-.3-.17-.44l.4-.65c.06.15.11.3.17.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.28,134.1l-.58.35c.07-.15.14-.29.2-.44l.58-.35c-.06.15-.13.3-.2.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.57,41.33l-.61.4-.11-.29.61-.4.11.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.62,121l-.5.42.09-.56.5-.42a5.43,5.43,0,0,1-.09.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6,97c-.05.22-.1.44-.14.66l-.34-.48c0-.22.09-.44.14-.66l.34.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.26,34.85l-.48.27-.26-.23.47-.27.27.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.88,84.26l-.25.47-.27-.67.25-.46c.09.22.19.44.27.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.53,77.55l-.34.66L35,77.76l.34-.66.21.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.86,95.61l-.33.48c-.05-.22-.1-.45-.16-.67l.33-.47c.05.22.11.44.16.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,66.59c0,.14-.09.28-.14.43l-.45-.63.15-.42c.15.2.3.41.44.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.55,127.39l-.54.39.15-.51.54-.39a4.91,4.91,0,0,1-.15.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.84,50.2l-.58.52-.09-.35.58-.51.09.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,71.32l-.18.44c-.13-.22-.26-.43-.4-.64.06-.15.12-.3.17-.44l.41.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.34,85.68c-.09.22-.17.45-.26.67-.09-.16-.17-.32-.26-.47.08-.22.17-.45.26-.67.08.16.17.31.26.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.85,144.37l.09.27-.46-.24c0-.09-.07-.18-.1-.27.16.08.31.17.47.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,54.38l-.56.56c0-.13-.07-.26-.1-.38l.55-.55c0,.13.07.25.11.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.92,137l-.59.32c.07-.13.14-.27.2-.4l.6-.32-.21.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.44,119.67l-.5.42c0-.18.06-.38.08-.57l.5-.42-.08.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,63.28l-.48.61c-.05-.14-.1-.28-.14-.42l.48-.61c0,.14.09.28.14.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,130.86c-.19.12-.38.24-.56.37l.17-.48.57-.37-.18.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.67,35.86l-.22.24-.53-.3.22-.23.53.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.61,97.19l-.34.47-.15-.66.34-.47.15.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.88,42.46l-.61.42c0-.1-.07-.2-.1-.3.2-.14.4-.28.61-.41a2,2,0,0,0,.1.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.52,50.34c0,.11-.06.23-.1.35l-.58-.52.09-.34.59.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.49,143.78c0,.09.08.19.13.28l-.5-.25a2.39,2.39,0,0,1-.13-.28l.5.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3,34.8l-.47.27-.28-.24.47-.26.28.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.24,36.89c-.07.08-.12.16-.19.25l-.55-.32.18-.24.56.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.33,54.53c0,.12-.06.25-.1.37l-.56-.55c0-.12.08-.25.11-.37l.55.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.22,118.27l-.48.44.06-.58.49-.44c0,.2,0,.39-.07.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.89,57.25l-.53.57c0-.13-.08-.26-.11-.39l.53-.57c0,.13.07.26.11.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.9,85.84l-.27.47c-.08-.22-.17-.44-.26-.67l.27-.47c.09.23.17.45.26.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.88,60.21l-.51.59-.12-.4.51-.59.12.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,72.67l-.39.64-.18-.44.39-.65.18.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.31,98.76c-.11.16-.23.32-.35.47,0-.22-.08-.43-.13-.65l.35-.48c0,.22.09.44.13.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.51,126.13l-.54.4c.05-.18.09-.35.13-.52l.54-.4c0,.17-.09.35-.13.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.32,63.43l-.14.42-.48-.61c0-.14.09-.27.14-.41l.48.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.66,135.05l-.59.33c.07-.14.14-.28.2-.42l.59-.34c-.07.14-.13.29-.2.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.36,87.26l-.24.67-.28-.47.25-.67.27.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.36,133l-.58.36c.07-.15.13-.31.19-.46l.58-.35-.19.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.85,67.9l-.44.63c0-.15-.11-.29-.16-.44l.44-.63c.05.15.11.29.16.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.37,79.11c-.11.22-.22.44-.32.66-.08-.15-.16-.3-.23-.46.11-.22.21-.44.33-.66.07.15.14.31.22.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,116.86l-.48.44c0-.2,0-.39.05-.59l.48-.44c0,.2,0,.4-.05.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.36,144.33a2.13,2.13,0,0,0,.08.27l-.45-.24a2.76,2.76,0,0,1-.08-.27l.45.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.35,34.76c-.15.09-.3.18-.46.26l-.29-.23.45-.26.3.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.89,48.93l-.09.35-.6-.5c0-.12.07-.23.1-.34l.59.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,37.84l-.57.34-.17-.25.58-.34c0,.09.11.17.16.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,100.33l-.36.47c0-.22-.07-.44-.12-.65l.37-.48c0,.22.08.44.11.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.44,57.39c0,.13-.07.26-.11.39l-.53-.57c0-.13.08-.26.11-.39l.53.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.93,38.93l-.59.36c-.06-.09-.1-.18-.15-.26.2-.12.39-.25.59-.36l.15.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.44,60.36l-.12.41-.51-.59c0-.14.09-.27.13-.4l.5.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.7,115.43l-.47.44,0-.59.47-.44,0,.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.26,72.83l-.19.45-.39-.65.19-.45.39.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,129.67l-.57.38c.06-.16.11-.33.16-.49l.57-.38c-.05.17-.11.33-.16.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.62,101.89c-.12.16-.25.31-.38.47,0-.22-.06-.44-.1-.65.13-.16.25-.32.38-.47,0,.21.07.43.1.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.58,52.88l-.57.54c0-.13-.07-.25-.1-.37l.57-.54c0,.13.06.25.1.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.63,35.78l-.24.24-.51-.29.23-.24.52.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.45,68.06c-.06.14-.11.29-.17.43l-.44-.63c.06-.14.11-.29.17-.43l.44.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.87,87.43l-.28.47-.24-.67.28-.47.24.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.38,114l-.46.45c0-.2,0-.4,0-.6l.46-.45c0,.2,0,.4,0,.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4,34.73,84,35l-.31-.24.44-.25.31.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,143.73a2.36,2.36,0,0,0,.12.28l-.5-.24c0-.1-.08-.19-.11-.29l.49.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.44,124.84l-.54.41.12-.53.54-.41-.12.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.43,88.85c-.08.22-.16.45-.23.67l-.29-.47c.08-.23.15-.45.23-.67l.29.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.21,103.44c-.12.16-.25.31-.38.47l-.09-.65.39-.47c0,.22.06.43.08.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,112.52l-.46.45c0-.2,0-.41,0-.61l.45-.46v.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.77,105c-.12.16-.26.31-.39.47,0-.22,0-.43-.07-.64l.39-.47c0,.21.06.43.07.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,136l-.6.33c.07-.14.14-.27.2-.41l.59-.33c-.06.13-.13.27-.19.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.66,111l-.45.45c0-.2,0-.41,0-.62l.44-.45c0,.2,0,.41,0,.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.78,53c0,.12-.07.24-.11.37l-.56-.54.1-.37.57.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.88,144.3a2.68,2.68,0,0,0,.07.27l-.45-.24-.06-.28c.14.09.29.17.44.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.3,106.51l-.41.47-.06-.64.41-.46.06.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.58,41.17l-.61.4-.12-.29.6-.4c0,.1.08.19.13.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.2,36.79,105,37l-.55-.32.21-.24.54.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.24,109.54c-.15.15-.29.31-.43.46l0-.62.43-.46,0,.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.79,108l-.42.46c0-.21,0-.42-.05-.63.15-.15.29-.31.43-.46,0,.21,0,.42,0,.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.54,64.71c-.16.2-.32.41-.47.62a4.43,4.43,0,0,1-.15-.43l.47-.61.15.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.46,34.7,85,35l-.33-.24.44-.25.32.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.25,80.67l-.31.67c-.09-.16-.17-.31-.24-.46.1-.23.2-.45.31-.67l.24.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.76,74.19l-.38.65-.2-.45c.13-.21.25-.43.38-.65.06.15.13.3.2.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.42,131.87l-.58.36c.06-.15.12-.31.17-.46l.58-.37c-.06.16-.11.32-.17.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.81,89c-.1.16-.19.32-.29.47l-.24-.67.3-.47c.08.22.15.45.23.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.53,90.44c-.08.22-.15.44-.22.67l-.3-.48c.07-.22.14-.44.22-.67.1.16.19.32.3.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4,55.68l-.55.56c0-.13-.07-.26-.11-.38.18-.19.36-.38.55-.56,0,.12.07.25.11.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.52,34.68l-.42.25-.34-.24.42-.25.34.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.34,123.54l-.53.4c0-.18.07-.36.1-.54l.53-.41c0,.18-.07.36-.1.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.75,134l-.59.35c.06-.15.13-.29.18-.44l.59-.35-.18.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.49,69.38c-.15.21-.29.42-.43.64-.06-.15-.12-.3-.17-.44.14-.21.27-.43.42-.64l.18.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.58,35.71l-.25.24-.51-.29.25-.24.51.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,128.46l-.56.38c.05-.16.09-.33.14-.49l.56-.39c0,.17-.09.34-.14.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.18,51.41l-.58.53c0-.12-.07-.24-.11-.36l.58-.52c0,.11.07.23.11.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.78,64.86l-.15.43-.48-.62c.06-.14.11-.28.16-.42l.47.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.59,34.67c-.14.08-.28.16-.41.25l-.36-.24.41-.25.36.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.37,61.6l-.5.6c0-.13-.1-.27-.14-.41l.5-.6c0,.14.09.28.14.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.38,136.88l-.59.32.2-.4.59-.33c-.06.14-.13.27-.2.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.53,74.35l-.21.46c-.12-.22-.25-.44-.38-.66.07-.15.14-.29.21-.45.12.22.25.44.38.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.54,143.69c0,.09.06.19.1.28l-.48-.25c0-.09-.07-.19-.11-.29l.49.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.32,58.59c-.17.19-.34.39-.52.58,0-.13-.09-.27-.12-.4l.52-.58.12.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.65,34.66l-.4.25-.36-.25.39-.24.37.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.78,34.66l-.37.25L90,34.66l.37-.24.39.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.41,144.26a2.56,2.56,0,0,0,0,.27l-.43-.24a2.56,2.56,0,0,1,0-.27l.43.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.72,34.66l-.39.24L89,34.66l.39-.25c.12.09.25.16.38.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,55.82l-.12.39c-.18-.19-.36-.38-.55-.56.05-.13.08-.26.12-.38l.55.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.89,42.29l-.61.42-.12-.3.61-.41.12.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.19,51.55c0,.11-.07.23-.11.36l-.58-.53c0-.12.08-.24.11-.36l.58.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.67,92c-.08.22-.14.44-.21.66l-.31-.47c.06-.23.13-.45.2-.67l.32.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.71,90.6l-.31.47c-.07-.22-.14-.45-.22-.67l.31-.47c.07.22.15.44.22.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.16,82.25l-.3.66-.25-.46c.09-.23.2-.45.3-.67l.25.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.81,69.54c-.05.15-.11.29-.17.44-.14-.21-.29-.42-.43-.64l.18-.43.42.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.21,122.2l-.52.42c0-.19.06-.37.08-.55l.53-.42-.09.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,38.81l-.58.35c-.06-.09-.11-.18-.16-.27l.58-.35c.06.09.11.18.16.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,61.76c0,.13-.09.27-.13.41l-.51-.6c.05-.14.1-.27.14-.41l.5.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,58.74c0,.13-.08.26-.13.4l-.53-.58c0-.14.09-.27.13-.4l.53.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.16,36.7c-.07.08-.15.16-.22.25l-.54-.31a2.62,2.62,0,0,1,.22-.25l.54.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.53,75.73l-.37.65L36,75.93l.36-.66c.07.16.14.31.22.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,127.22l-.56.39c.05-.16.09-.33.13-.51l.56-.39c0,.17-.09.34-.13.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.45,130.71l-.57.37.16-.48.57-.37c0,.16-.1.32-.16.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.84,93.61c-.06.22-.12.45-.19.67-.11-.16-.21-.32-.33-.48.07-.22.12-.44.19-.66l.33.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2,43.46l-.61.44-.12-.31.61-.43.12.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.11,134.92l-.58.34.18-.43.59-.34c-.06.15-.12.29-.19.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.57,92.18c-.1.16-.21.32-.32.48-.06-.23-.14-.45-.2-.67l.31-.48.21.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.1,82.41l-.25.47c-.1-.23-.2-.45-.31-.67l.26-.47.3.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.11,66.16l-.46.62c0-.14-.11-.28-.16-.43l.46-.62.16.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,120.85l-.51.42c0-.19.05-.38.08-.56l.51-.43c0,.19-.05.38-.08.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.57,50.11a3.58,3.58,0,0,1-.11.35l-.59-.51c0-.11.08-.23.11-.34l.59.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.08,143.64l.08.29-.47-.26c0-.09-.06-.19-.08-.28l.47.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,54.15l-.56.54c0-.12-.07-.25-.12-.37l.56-.55.12.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.62,143l.12.3-.51-.26-.12-.3.51.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.81,132.87l-.58.35.17-.45.58-.36c0,.15-.11.3-.17.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.16,70.88c-.14.21-.29.42-.42.64-.07-.15-.13-.3-.19-.44l.42-.64c.06.14.12.29.19.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.76,75.89c-.07.15-.14.31-.22.46-.12-.22-.24-.44-.37-.66.08-.15.15-.3.22-.45l.37.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.11,83.82c-.09.23-.19.45-.28.67L34.56,84c.09-.22.19-.45.29-.67.09.16.17.32.26.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5,44.68l-.61.45c0-.11-.08-.21-.11-.32l.61-.44c0,.1.07.21.11.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.05,95.2c-.06.22-.11.44-.17.66l-.34-.48c.06-.21.11-.44.17-.66l.34.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,35.55l-.49.29-.28-.25.49-.28c.09.09.19.16.28.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.39,93.77l-.33.47c-.06-.22-.12-.44-.19-.66l.33-.48c.07.22.13.44.19.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.61,41c-.2.12-.4.26-.6.39-.05-.09-.1-.19-.14-.28l.6-.4c0,.1.09.19.14.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.85,119.47l-.51.43c0-.19,0-.38.07-.57l.5-.43c0,.19,0,.38-.06.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.21,66.32c-.05.14-.11.28-.17.42l-.46-.62.17-.42.46.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.41,54.28c0,.13-.07.26-.12.38l-.56-.55.12-.37.56.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.94,126l-.55.4.12-.53.55-.4-.12.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.88,63c-.16.21-.33.41-.49.61l-.15-.42.49-.6.15.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.15,71c-.06.15-.13.3-.19.44l-.42-.64c.06-.15.13-.29.19-.44l.42.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.1,36.61l-.23.25-.54-.31.24-.24.53.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3,96.78c0,.22-.1.44-.16.66L34.79,97c.06-.21.11-.44.16-.66l.35.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.48,135.85l-.6.33c.06-.13.13-.27.18-.41.2-.11.4-.22.59-.34-.05.15-.11.28-.17.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.82,57l-.54.57c-.05-.13-.09-.27-.13-.4l.54-.56c0,.13.08.26.13.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.34,77.28c-.13.22-.24.43-.36.66-.08-.16-.15-.31-.23-.46l.36-.66c.07.15.15.3.23.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.15,84l-.27.47c-.09-.22-.19-.44-.29-.66l.27-.47c.1.22.2.44.29.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.18,95.35l-.34.48-.18-.67.34-.47.18.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.46,129.52l-.57.38.15-.49.57-.38-.15.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.79,60c-.18.19-.34.39-.52.59,0-.14-.09-.28-.14-.41l.52-.59c0,.14.09.27.14.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.63,118.07l-.5.43c0-.19,0-.38.05-.57l.5-.44c0,.19,0,.39-.05.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.63,143.6c0,.1,0,.19.07.29l-.47-.26-.06-.29.46.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.06,35.51l-.48.28-.3-.25c.16-.09.32-.19.48-.27l.3.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1,85.41l-.27.66c-.1-.15-.19-.31-.28-.47l.27-.67.28.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.33,39.81l-.6.38c0-.1-.11-.19-.16-.28l.59-.37.17.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.59,98.35l-.15.66-.36-.47c.05-.22.09-.44.14-.66l.37.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,38.68l-.58.36-.18-.27.58-.35.18.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.54,52.65l-.58.53c0-.12-.08-.24-.12-.36l.58-.54.12.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.45,63.17l-.15.42c-.16-.21-.33-.41-.49-.61l.15-.42c.16.2.33.4.49.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.54,57.14c0,.13-.08.26-.13.39l-.54-.57c0-.13.08-.26.13-.38l.54.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.18,143c0,.1.06.2.1.3l-.5-.26-.11-.3.51.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.93,96.93l-.36.47-.16-.66.36-.47c0,.22.1.44.16.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.37,116.65c-.16.15-.32.3-.49.44,0-.19,0-.39,0-.59.17-.14.33-.29.49-.44a5.68,5.68,0,0,1,0,.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.19,133.84l-.59.35.16-.44.59-.35c0,.15-.11.3-.16.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.56,60.11c-.05.13-.1.27-.14.4l-.52-.59c0-.13.09-.27.14-.4l.52.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.72,67.63l-.45.62-.18-.43.45-.63.18.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.86,72.39l-.4.65c-.08-.15-.14-.3-.21-.45l.41-.65c.06.15.13.3.2.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.85,131.73l-.58.36c.06-.15.11-.31.16-.46l.58-.37c-.05.16-.1.31-.16.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.93,42.13l-.61.41-.14-.29.61-.41.14.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.86,124.67l-.55.4c0-.17.07-.35.11-.53l.54-.41c0,.18-.07.36-.1.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.84,52.78l-.12.37c-.19-.18-.38-.36-.58-.53.05-.12.08-.25.12-.37l.58.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.14,35.46l-.47.28-.31-.25.47-.27.31.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.16,85.57l-.28.47c-.09-.23-.18-.45-.28-.67l.29-.47.27.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.64,98.5l-.37.48-.15-.66.37-.47.15.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.08,115.22l-.48.44c0-.2,0-.4,0-.59l.48-.45c0,.2,0,.4,0,.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,36.53l-.25.25-.53-.3c.09-.08.17-.17.25-.25l.53.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.13,87c-.09.22-.17.45-.26.67l-.3-.47c.09-.23.18-.45.26-.67l.3.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.18,78.83c-.12.22-.23.44-.34.67L35.59,79c.12-.22.23-.44.34-.66l.25.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.19,143.56a2.93,2.93,0,0,0,0,.29l-.45-.26-.06-.29.46.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.31,100.07l-.38.48c0-.22-.09-.44-.13-.66.13-.16.26-.31.38-.47,0,.22.09.44.13.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.76,113.77l-.47.44v-.6l.48-.45c0,.2,0,.4,0,.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.6,67.78c0,.15-.11.29-.17.44l-.46-.63.18-.43c.16.2.31.41.45.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.45,128.3l-.57.39c.05-.17.08-.34.13-.5l.57-.39c-.05.17-.09.33-.13.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.16,51.19c-.2.17-.4.34-.59.52l-.12-.36.58-.52.13.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.23,35.43l-.46.27-.32-.25.45-.27.33.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.35,55.44c-.19.18-.37.37-.55.55l-.14-.38c.19-.19.38-.37.56-.56,0,.13.09.26.13.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,101.64l-.39.47-.12-.65c.14-.16.26-.32.39-.48l.12.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.41,112.3l-.46.45c0-.21,0-.41,0-.61l.47-.46c0,.21,0,.41,0,.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.74,123.35l-.53.41c0-.18.06-.36.08-.54l.54-.41c0,.18-.05.36-.09.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.24,43.29l-.62.43c0-.1-.09-.2-.13-.31L61.1,43c0,.1.09.2.14.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.43,64.44l-.48.62c-.06-.14-.11-.28-.17-.43l.49-.61c0,.14.1.28.16.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.74,142.92l.09.3-.5-.26c0-.1,0-.2-.08-.3l.49.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.14,87.15l-.3.47c-.08-.22-.17-.44-.26-.66.1-.16.2-.32.29-.48l.27.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.55,103.19c-.13.16-.26.32-.4.47,0-.21-.07-.43-.1-.64l.4-.48c0,.22.07.44.1.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.54,134.8l-.59.34c.06-.14.11-.28.17-.43l.59-.34c0,.14-.11.29-.17.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,110.81l-.45.46,0-.62.45-.46,0,.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.19,88.58c-.09.22-.17.45-.25.67l-.3-.48.24-.67c.11.16.21.32.31.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.33,35.4l-.45.27-.34-.25.45-.27.34.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.12,104.74l-.42.47c0-.22,0-.43-.08-.65l.41-.47.09.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.6,109.31l-.45.46c0-.21,0-.42,0-.62l.44-.46c0,.2,0,.41,0,.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.65,106.27l-.43.47c0-.21,0-.42-.07-.64l.42-.46c0,.21.05.42.08.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.14,107.8l-.43.46q0-.32-.06-.63l.43-.46.06.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,55.58c0,.13-.09.26-.13.38l-.56-.55c0-.13.09-.26.13-.39l.56.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.76,143.53c0,.09,0,.18,0,.28l-.44-.26a2.7,2.7,0,0,1,0-.28l.45.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.26,58.34c-.18.19-.36.38-.53.58l-.15-.4.54-.58c0,.14.1.27.14.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6,73.92c-.13.21-.27.43-.39.65-.08-.15-.15-.3-.22-.46l.39-.65c.07.16.15.31.22.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,36.46l-.27.25-.52-.3.27-.25.52.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.87,130.56l-.58.37c0-.15.1-.31.14-.47.2-.12.39-.25.58-.38,0,.16-.09.32-.14.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.29,61.35c-.18.19-.35.39-.52.59l-.15-.41c.17-.2.33-.4.51-.6,0,.14.1.28.16.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.54,44.5l-.61.45-.14-.32.61-.44c0,.1.09.21.14.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.06,80.4l-.33.66-.26-.46.33-.67c.08.16.17.31.26.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.91,64.6c0,.14-.11.28-.17.42l-.48-.61.17-.42.48.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.42,35.38l-.43.27-.36-.25.44-.27c.12.08.24.16.35.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.39,39.68l-.59.38-.18-.28.6-.37c0,.09.11.18.17.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.23,132.73l-.59.36c.06-.15.11-.3.16-.46l.59-.36c-.06.16-.1.31-.16.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.36,69.11l-.44.63c-.07-.14-.13-.29-.19-.44l.44-.63c.06.15.12.29.19.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.6,122l-.53.42c0-.18.05-.37.07-.55l.53-.42a5.17,5.17,0,0,1-.07.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.4,127.06l-.56.39c0-.17.08-.34.12-.51l.56-.4a4.37,4.37,0,0,1-.12.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.52,35.37l-.42.26-.37-.26.43-.26.36.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.07,88.74l-.3.47c-.08-.22-.17-.44-.25-.67l.31-.47.24.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.29,90.17l-.24.67-.31-.48c.07-.22.15-.44.23-.67l.32.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.1,58.48c0,.14-.09.27-.14.4l-.54-.57.15-.4.53.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.63,35.36l-.41.26-.39-.26.41-.26.39.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.77,142.23c0,.1.06.2.1.31l-.52-.27c0-.11-.07-.21-.1-.32l.52.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.07,61.5c0,.13-.1.27-.16.41l-.51-.6c0-.14.11-.27.16-.41l.51.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.62,37.49l-.24.26c-.18-.11-.36-.22-.55-.32l.23-.26.56.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.93,53.91l-.57.55-.14-.38.57-.54c0,.12.09.25.14.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.32,142.88c0,.1.05.2.07.29l-.49-.26c0-.1,0-.2-.07-.3l.49.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.33,143.49a2.46,2.46,0,0,0,0,.28l-.43-.25c0-.1,0-.2,0-.29l.43.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.43,120.65c-.17.15-.35.29-.53.43,0-.19,0-.38.06-.56l.53-.43-.06.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,42c-.21.13-.41.27-.61.41-.06-.1-.1-.2-.16-.3l.61-.41c.05.1.1.2.16.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.43,91.76c-.08.22-.16.44-.23.67L34.87,92c.07-.22.15-.44.22-.67l.34.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,90.33c-.1.16-.21.31-.32.47-.07-.22-.15-.44-.23-.67.11-.15.21-.31.32-.47.08.22.16.44.23.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,82c-.11.22-.21.45-.32.67-.09-.16-.18-.31-.26-.47.1-.22.21-.44.31-.67L36,82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.46,54.05c-.05.12-.09.25-.14.38l-.57-.55c.05-.12.1-.25.14-.37l.57.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.37,75.45l-.38.66c-.08-.15-.16-.3-.23-.46.12-.22.25-.43.38-.65.07.15.16.3.23.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,65.89c-.15.21-.31.42-.47.62l-.18-.43c.16-.2.31-.41.47-.62l.18.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.86,129.37l-.57.38c0-.16.08-.33.13-.49l.57-.38c0,.16-.08.32-.13.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.33,125.79l-.55.4c0-.18.07-.35.1-.52l.55-.41c0,.18-.06.35-.1.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.6,133.71l-.6.35c0-.14.11-.29.16-.44l.59-.35-.15.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.23,119.27l-.52.43c0-.19,0-.38,0-.57l.52-.43c0,.19,0,.38,0,.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6,93.35l-.21.67-.34-.48c.06-.22.13-.45.2-.67l.35.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.78,56.75l-.55.57c0-.13-.09-.26-.15-.39l.56-.57c0,.13.09.27.14.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.71,36.3l-.51.3-.29-.26.5-.29.3.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,70.61c-.14.21-.28.43-.43.64-.06-.15-.14-.3-.2-.45.14-.21.28-.43.43-.64.06.15.13.3.2.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.26,131.59l-.59.36c0-.15.1-.3.14-.46l.59-.37-.14.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.84,91.91c-.11.17-.22.32-.34.48-.07-.22-.14-.44-.22-.66l.34-.48c.07.22.14.44.22.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.32,82.13l-.27.47-.32-.66.27-.47.32.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.53,52.42,50,53c-.05-.12-.09-.24-.14-.37l.59-.52.13.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.91,142.83c0,.1,0,.2,0,.3l-.48-.27c0-.1,0-.2,0-.3l.48.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.35,142.17l.09.31-.51-.27-.09-.31.51.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.34,66.05c-.06.14-.12.29-.19.43-.15-.21-.31-.41-.47-.62l.18-.43.48.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.52,37.4l-.25.27-.54-.33a3.07,3.07,0,0,0,.25-.26l.54.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3,43.13l-.61.42c-.06-.1-.11-.2-.16-.3l.61-.43c0,.1.1.21.16.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.92,83.55l-.3.67-.28-.47.3-.67.28.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.74,59.7c-.18.2-.35.4-.53.59-.05-.13-.11-.27-.16-.41l.53-.58c.05.14.11.27.16.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.81,94.94c-.07.22-.13.44-.19.66-.12-.16-.25-.32-.36-.48.06-.22.13-.44.19-.66l.36.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.6,56.9l-.15.39-.55-.57.15-.39.55.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,117.87l-.51.44a5.78,5.78,0,0,0,0-.58l.51-.44c0,.19,0,.39,0,.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.66,93.5l-.34.48-.21-.66.35-.48c.07.22.14.44.2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,134.68l-.6.34.15-.43.6-.34-.15.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.24,124.49l-.55.41c0-.18.05-.36.08-.53l.55-.41c0,.18,0,.35-.08.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.82,36.25c-.17.09-.33.19-.49.29L81,36.28l.5-.29.31.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.55,62.91l-.17.42-.51-.61.18-.42.5.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.18,77l-.37.66-.24-.46c.12-.22.24-.44.37-.66l.24.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.17,51l-.59.52c0-.12-.1-.24-.14-.36l.59-.52c0,.12.09.24.14.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.05,96.52c-.06.22-.12.44-.17.66l-.37-.47.18-.67.36.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.63,59.85c0,.14-.1.27-.16.41-.17-.2-.35-.39-.53-.59.06-.13.11-.27.16-.4l.53.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.83,128.14l-.57.39.12-.5.57-.39-.12.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.37,83.71c-.09.16-.19.32-.29.47l-.3-.67.28-.47.31.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.73,116.45l-.5.44c0-.2,0-.39,0-.59l.5-.44c0,.19,0,.39,0,.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6,44.33l-.62.44-.15-.32.61-.44c.05.11.1.21.16.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.45,95.09c-.11.16-.24.32-.36.48-.06-.23-.12-.45-.19-.67l.36-.48c.06.23.13.45.19.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5,142.79c0,.1,0,.2,0,.3l-.47-.27,0-.3.46.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.91,85.13c-.1.23-.19.45-.29.67l-.3-.47.3-.67c.09.16.19.32.29.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.34,98.1c-.06.22-.11.44-.17.66l-.38-.48c.05-.22.11-.44.17-.65.12.16.25.31.38.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.63,67.36l-.47.63c-.06-.15-.13-.29-.19-.44l.46-.63c.06.15.13.29.2.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.34,55.2c-.19.18-.38.37-.56.56a3.12,3.12,0,0,1-.15-.39l.56-.55.15.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.62,132.6,122,133c0-.15.1-.31.14-.46l.59-.36c0,.15-.09.3-.14.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,142.12a1.55,1.55,0,0,0,.07.31l-.51-.27a3,3,0,0,1-.07-.32l.51.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.94,36.21l-.48.29-.33-.26.48-.29.33.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.42,37.32l-.27.27-.53-.32.27-.27.53.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.24,115l-.49.44v-.59l.49-.45v.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.74,72.12l-.42.65-.22-.45.42-.65.22.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9,45.57l-.62.46-.15-.33.62-.45a3,3,0,0,0,.15.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26,130.42l-.59.37c0-.16.09-.32.13-.48l.58-.37-.12.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.2,96.67l-.37.48c-.05-.22-.12-.44-.18-.66L143,96c.07.22.12.44.18.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.07,41.83l-.61.4a2.14,2.14,0,0,1-.17-.3l.6-.4.18.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.11,123.17l-.54.42c0-.18,0-.36.07-.54l.54-.42c0,.18,0,.36-.07.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.1,113.55l-.48.45c0-.2,0-.4,0-.6l.49-.46c0,.21,0,.41,0,.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.38,85.29l-.3.48c-.1-.22-.19-.45-.29-.67l.3-.47.29.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.92,98.25l-.38.48c-.06-.22-.11-.44-.17-.66l.38-.48c.06.22.11.44.17.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.05,55.34c0,.13-.1.26-.15.39l-.57-.56c.06-.13.11-.25.16-.38.19.18.38.36.56.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,78.56l-.36.66-.26-.46.36-.66.26.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.06,36.17l-.47.29-.34-.26.47-.29.34.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.59,72.28l-.22.45-.42-.65.22-.44.42.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.94,86.72c-.1.22-.19.45-.28.67l-.31-.47c.09-.23.18-.45.28-.67.1.16.2.32.31.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.37,64.18l-.5.62-.18-.43.49-.61c.06.14.12.28.19.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.78,126.9l-.57.39c0-.17.07-.34.1-.51l.57-.4c0,.17-.07.35-.1.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.74,112.08l-.48.45c0-.2,0-.41,0-.61l.48-.46,0,.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.11,142.75c0,.1,0,.2,0,.3l-.46-.27c0-.1,0-.2,0-.3l.46.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.24,58.09c-.19.19-.36.39-.55.58l-.16-.4.55-.57c.05.13.1.26.16.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.6,99.82l-.4.48-.15-.66.4-.47.15.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.34,110.59l-.46.46c0-.21,0-.42,0-.62l.47-.46c0,.2,0,.41,0,.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.24,101.39l-.41.47c0-.21-.09-.43-.13-.65l.4-.47c.05.21.1.43.14.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,121.83l-.54.42.06-.55.54-.43-.06.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.19,36.14l-.46.29-.35-.27.46-.28.35.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,133.59l-.6.35c.05-.15.1-.29.14-.44l.59-.36c0,.15-.08.3-.13.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.91,109.08l-.45.47c0-.21-.05-.42-.07-.63.16-.15.31-.31.46-.46l.06.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.94,53.68l-.58.55c-.06-.13-.1-.26-.15-.38l.57-.54.16.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.84,103c-.13.16-.27.31-.41.47l-.12-.65.41-.47c0,.22.09.43.12.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.57,142.07a2.87,2.87,0,0,0,.05.31l-.5-.27c0-.11,0-.21-.05-.32l.5.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.45,107.57,140,108c0-.21-.05-.42-.07-.63.15-.15.29-.31.44-.47,0,.21,0,.43.08.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.42,104.5c-.15.15-.29.31-.43.47,0-.21-.07-.43-.11-.64l.43-.48c0,.22.07.43.11.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.15,58.24c-.05.13-.11.26-.16.4-.19-.19-.37-.38-.55-.58.06-.13.11-.26.16-.39.19.19.37.37.55.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,64.33c-.06.15-.12.29-.19.43-.16-.21-.33-.41-.49-.61l.18-.43.5.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,106c-.15.15-.29.31-.44.47l-.09-.64.44-.47.09.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.35,86.88c-.1.16-.2.32-.31.48-.09-.23-.18-.45-.28-.67.11-.16.21-.32.31-.48.1.22.19.45.28.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.38,43l-.61.42a3.07,3.07,0,0,1-.17-.31l.61-.42.17.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,88.31l-.27.67c-.11-.16-.21-.32-.32-.47.09-.23.18-.45.26-.67l.33.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.33,36.12l-.45.28-.37-.26.45-.28.37.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.49,73.65c-.14.21-.28.43-.41.65l-.24-.46c.14-.21.27-.43.41-.65l.24.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.28,68.84c-.16.21-.31.42-.46.64L39.61,69l.46-.63c.06.15.14.29.21.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.24,129.22c-.2.12-.39.25-.58.38,0-.16.07-.33.11-.49l.58-.39c0,.17-.07.33-.11.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.13,61.24c0,.14-.11.28-.17.41l-.52-.59.17-.41c.18.19.35.39.52.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.47,53.82l-.15.38-.58-.55c0-.12.11-.25.15-.37.2.17.39.36.58.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.63,131.45l-.59.37.12-.47c.2-.12.4-.24.59-.37,0,.16-.08.31-.12.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.72,142.71v.3l-.44-.27v-.3l.44.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.91,80.13c-.12.22-.24.44-.35.66l-.27-.47.35-.66c.08.16.18.31.27.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.46,36.1l-.43.28-.39-.27.44-.27.38.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.78,120.46l-.54.43a5.27,5.27,0,0,0,0-.56l.54-.43c0,.19,0,.38,0,.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.69,125.62c-.18.14-.37.27-.56.4,0-.17.06-.34.08-.52l.57-.41c0,.18-.06.36-.09.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.29,88.47c-.1.16-.21.32-.32.48l-.27-.67.33-.48c.09.22.18.45.26.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.56,52.2l-.59.53-.15-.37.59-.53c0,.13.1.25.15.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1,89.91l-.26.66-.33-.47c.08-.22.16-.45.25-.67l.34.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.54,141.34c0,.11,0,.21.07.32l-.52-.28c0-.11,0-.22-.07-.33l.52.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.68,44.16l-.61.44c-.06-.11-.12-.21-.17-.32l.61-.44.17.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.78,56.52l-.56.56c-.06-.13-.11-.26-.16-.39l.56-.57c.05.14.11.26.16.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.19,142c0,.1,0,.2,0,.31l-.49-.28c0-.11,0-.21,0-.32l.49.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,65.63l-.49.62c-.07-.14-.13-.29-.2-.43l.49-.62c.06.15.13.29.2.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.56,119.08l-.52.43c0-.19,0-.38,0-.57l.53-.44c0,.2,0,.39,0,.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.34,142.68c0,.1,0,.2,0,.29-.14-.09-.29-.17-.43-.27s0-.2,0-.3l.43.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.83,81.7c-.12.22-.23.44-.34.67l-.28-.47.33-.67c.1.16.19.32.29.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.23,91.5l-.24.67-.34-.48c.07-.23.15-.45.23-.67l.35.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.19,90.06l-.33.48c-.08-.22-.17-.45-.26-.67l.34-.48c.09.23.17.45.25.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.26,75.18l-.39.66c-.09-.15-.17-.31-.25-.46l.39-.65c.09.15.17.3.25.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.62,56.65c-.05.14-.11.27-.17.4l-.56-.57c.06-.13.12-.26.17-.39l.56.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,45.39l-.62.46-.16-.33.61-.45c0,.11.11.21.17.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.19,128l-.58.39c0-.17.06-.34.1-.5l.58-.39c0,.16-.06.33-.1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.43,37.08l-.51.31-.31-.27c.17-.1.34-.21.51-.3a3.88,3.88,0,0,1,.31.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,132.47l-.6.36c0-.15.08-.31.12-.46l.6-.36-.12.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.72,59.46l-.53.58-.18-.4.54-.59c.05.14.12.27.17.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.59,124.32l-.57.41c0-.18,0-.35.07-.53l.56-.42-.06.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.78,62.5q-.27.3-.51.6c-.07-.14-.13-.28-.19-.42l.51-.6c.06.14.12.28.19.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,70.34l-.44.64c-.08-.15-.15-.3-.22-.45l.44-.63c.07.15.15.29.22.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.27,46.67l-.61.47a3.54,3.54,0,0,1-.16-.34l.61-.46.16.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.32,117.67l-.52.44c0-.19,0-.39,0-.58l.52-.44c0,.19,0,.39,0,.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.62,130.27l-.59.38c0-.16.07-.32.11-.48l.59-.38c0,.16-.07.32-.11.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4,93.09c-.07.22-.15.44-.22.67l-.36-.48c.07-.23.15-.45.22-.67l.36.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,142.65l0,.29-.42-.27,0-.3.42.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.06,91.65l-.35.48-.24-.67c.12-.15.23-.32.35-.47l.24.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.67,59.6l-.18.41-.54-.59.18-.4.54.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.6,62.65c-.06.14-.12.28-.19.42-.17-.2-.33-.4-.51-.6.07-.14.13-.28.19-.42l.51.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.82,142c0,.1,0,.21,0,.31l-.47-.28c0-.1,0-.21,0-.31.16.09.32.18.47.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.18,141.28c0,.11,0,.22,0,.33l-.51-.29c0-.11,0-.22-.06-.33.17.1.34.2.52.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.36,55l-.57.55-.17-.38.58-.55c0,.13.11.25.16.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.49,42.82l-.61.42-.19-.31.61-.42c.06.1.12.21.19.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.4,70.5c-.07.15-.15.29-.23.44l-.44-.63.23-.45c.15.21.3.42.44.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.58,37l-.5.31-.33-.27.51-.31.32.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.78,83.28c-.11.22-.22.45-.32.67l-.3-.48.32-.66c.09.16.2.32.3.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,116.24l-.51.45v-.59l.51-.45v.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.61,94.68c-.08.22-.14.44-.21.66-.13-.15-.25-.31-.37-.47l.21-.67.37.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.45,123l-.56.41.06-.54.55-.42c0,.18,0,.36-.05.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.89,93.24l-.36.48-.23-.66.36-.48.23.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.08,76.73l-.39.66-.26-.46.38-.66.27.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.05,55.11c-.05.13-.11.25-.17.38l-.57-.55c.05-.13.11-.26.17-.38l.57.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.12,126.73l-.58.4c0-.17.06-.34.08-.51l.58-.4c0,.17,0,.34-.08.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.58,67.1l-.48.62-.21-.43.48-.63.21.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.85,96.27c-.07.22-.13.44-.19.66l-.39-.48c.07-.22.13-.44.2-.66l.38.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.74,114.8l-.5.45c0-.2,0-.4,0-.6l.5-.45c0,.2,0,.4,0,.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.54,83.44l-.3.47-.33-.66c.11-.16.21-.32.31-.48.11.23.21.45.32.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.74,37l-.5.3L81.91,37c.16-.1.32-.21.49-.3l.34.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.68,94.83l-.38.48c-.06-.22-.14-.44-.21-.66l.38-.48.21.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.67,71.86c-.15.21-.29.42-.43.64-.09-.15-.16-.3-.24-.45l.43-.65.24.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.47,141.94c0,.1,0,.21,0,.31L78,142v-.32l.47.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.13,97.85l-.18.66-.4-.48.18-.66.4.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.25,57.86l-.55.57a3.52,3.52,0,0,1-.18-.4l.55-.57.18.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.77,84.87c-.11.22-.21.44-.31.67l-.31-.48.3-.67c.1.16.21.32.32.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,131.31l-.59.37c0-.15.07-.31.1-.46l.59-.38c0,.16-.06.32-.1.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,53.46,50.4,54c-.07-.13-.12-.25-.18-.38l.59-.54c0,.13.11.26.17.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.79,44l-.61.43a3.37,3.37,0,0,1-.19-.32l.61-.43.19.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.4,113.34l-.5.45,0-.6.5-.46,0,.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.58,129.07l-.59.38a3.86,3.86,0,0,0,.09-.49l.59-.38-.09.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.82,141.23c0,.11,0,.22,0,.33l-.5-.29c0-.11,0-.22,0-.33l.5.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.44,99.43c0,.22-.11.44-.16.65-.14-.15-.27-.31-.41-.47.06-.22.11-.44.17-.66l.4.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.28,121.65l-.55.42c0-.18,0-.37,0-.55l.55-.43c0,.19,0,.37,0,.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.43,96.42l-.38.48c-.06-.23-.14-.44-.2-.67l.39-.47c.06.22.13.44.19.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.35,63.93c-.18.2-.34.41-.51.61-.07-.14-.14-.29-.2-.43l.5-.61c.07.15.13.29.21.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9,37l-.48.3L83.06,37c.16-.11.32-.2.48-.3l.36.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,111.86l-.49.46c0-.21,0-.41,0-.62l.49-.45c0,.2,0,.4.05.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.16,58l-.18.4-.56-.58c.06-.13.13-.26.18-.4l.56.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.45,53.59c-.06.13-.12.25-.17.38l-.59-.54c.06-.12.12-.25.17-.37l.59.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.69,72l-.24.45-.43-.64.24-.45.43.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.15,98l-.39.48c-.06-.22-.12-.44-.19-.66l.4-.48.18.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.55,85l-.31.48c-.1-.22-.21-.44-.31-.67l.31-.47c.11.22.21.44.31.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.92,78.29l-.37.66c-.09-.15-.19-.31-.27-.46.11-.23.24-.44.37-.66l.27.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.63,110.37l-.48.46c0-.21,0-.42-.07-.62l.48-.46c0,.2.05.41.07.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,125.46l-.57.4c0-.17.05-.35.07-.52l.57-.41c0,.17,0,.35-.07.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,64.08c-.06.14-.13.28-.2.43l-.51-.61.21-.43c.17.2.34.4.5.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.06,36.92l-.47.3-.37-.28.47-.3.37.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.83,99.57l-.4.48c-.06-.22-.12-.43-.17-.65l.41-.48c.06.22.11.44.16.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.09,45.22c-.21.15-.42.3-.62.46-.06-.12-.13-.22-.19-.34l.62-.44.19.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.16,61c-.06.14-.13.28-.19.41l-.54-.59c.07-.14.14-.27.2-.41.18.19.36.39.53.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.73,140.47l.06.33-.53-.29-.06-.35.53.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.12,141.9c0,.1,0,.21,0,.31l-.45-.28c0-.11,0-.22,0-.32l.46.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.19,108.86l-.47.46c0-.21-.06-.41-.08-.62l.47-.47c0,.21,0,.42.08.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.48,101.15l-.42.47-.15-.65.42-.48.15.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.09,120.28l-.54.43c0-.19,0-.38,0-.56l.54-.44c0,.19,0,.38,0,.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.72,107.34c-.16.15-.31.31-.46.46,0-.21-.07-.42-.1-.63l.46-.47c0,.22.07.43.1.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.09,102.71l-.43.47c0-.21-.09-.43-.14-.65.15-.15.29-.31.43-.47.05.21.1.43.14.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.38,45.32l-.19.33-.61-.45.18-.33.62.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.23,36.9l-.46.29c-.13-.09-.26-.18-.38-.28l.46-.29.38.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.21,105.8l-.45.47c0-.21-.07-.42-.11-.63l.45-.47c0,.21.08.42.11.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.67,104.26l-.44.47c0-.21-.08-.42-.13-.64l.44-.47c.05.21.09.43.13.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.23,68.58l-.46.63c-.08-.15-.16-.29-.23-.44l.47-.63c.07.15.15.29.22.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.38,46.49l-.62.47-.18-.34.61-.46c.06.11.12.22.19.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.42,73.38,39,74c-.09-.15-.17-.31-.25-.46l.42-.64c.08.15.17.3.26.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.82,56.28l-.57.57-.18-.4.57-.56c0,.13.12.26.18.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.48,141.18c0,.11,0,.22,0,.33l-.49-.29c0-.11,0-.22,0-.33l.5.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.53,86.61l-.33.48-.3-.67.33-.47.3.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,36.88l-.45.29-.39-.28L87,36.6l.39.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.67,47.8l-.61.49a2.91,2.91,0,0,1-.18-.35l.61-.48.18.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.52,127.84l-.59.39c0-.17,0-.34.08-.5l.58-.4c0,.17,0,.34-.07.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,130.13l-.6.38c0-.16.07-.32.09-.48l.6-.38-.09.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.81,79.86c-.13.22-.25.44-.37.66l-.28-.47.36-.66c.09.16.19.31.29.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.15,68.73c-.08.15-.16.3-.23.45l-.47-.63c.07-.15.15-.3.23-.45l.47.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.78,141.86c0,.1,0,.21,0,.31l-.45-.28,0-.32.45.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.6,56.42l-.18.4-.57-.57.19-.39.56.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.86,118.89c-.17.14-.36.28-.53.43v-.57l.54-.44c0,.19,0,.39,0,.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.9,124.15l-.57.41c0-.17,0-.35,0-.53l.57-.42c0,.18,0,.36,0,.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,73.54l-.26.45-.42-.64c.08-.16.17-.31.25-.46l.43.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.94,65.38l-.5.61-.21-.43c.16-.21.33-.41.5-.61.06.14.14.28.21.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.75,59.22l-.55.58c-.06-.14-.13-.27-.19-.41.18-.19.36-.39.55-.58.06.14.12.27.19.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.47,88.21c-.12.15-.23.32-.34.48-.1-.23-.19-.45-.29-.67l.34-.48c.1.22.19.44.29.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4,140.41c0,.11,0,.22,0,.34l-.52-.3c0-.12,0-.23,0-.35l.52.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.79,62.25l-.53.6c-.07-.14-.14-.28-.2-.42l.52-.6c.07.14.13.28.21.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.92,43.84l-.61.44L63.1,44l.62-.42.2.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.17,37.9l-.52.33-.32-.29.52-.32.32.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.42,54.75l-.58.55-.18-.39.58-.55.18.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.15,141.13c0,.11,0,.22,0,.33l-.49-.29c0-.11,0-.22,0-.33l.49.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.61,117.47l-.53.45c0-.2,0-.39,0-.59l.53-.44c0,.2,0,.39,0,.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.67,59.36c-.07.13-.13.27-.2.41l-.55-.59c.07-.13.13-.27.2-.4l.55.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2,74.92c-.14.22-.28.43-.41.65l-.27-.46.41-.65.27.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.45,141.82c0,.11,0,.21,0,.32l-.43-.29c0-.11,0-.21,0-.32l.44.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.73,81.44l-.36.66-.3-.47.35-.67c.1.16.2.32.31.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.92,70.08c-.16.21-.31.42-.46.64l-.24-.45c.15-.22.3-.43.46-.64l.24.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.37,89.8l-.35.48-.27-.67.35-.48.27.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.62,62.4c-.06.14-.14.28-.21.42l-.52-.6c.07-.14.14-.28.2-.42.18.2.36.39.53.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.43,126.58l-.58.4.06-.51.58-.41-.06.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.29,131.18l-.59.37.09-.46.6-.38c0,.16-.06.31-.1.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.75,122.82l-.56.42,0-.54c.19-.14.38-.28.56-.43l0,.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,54.88l-.18.39-.58-.55.18-.39.58.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.32,116l-.52.45c0-.2,0-.39,0-.59l.52-.45c0,.2,0,.4,0,.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.89,128.92l-.59.39c0-.16,0-.33.07-.49l.59-.39c0,.16,0,.33-.07.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.35,37.85l-.51.32-.34-.28.51-.32.34.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.22,45.06l-.62.45c-.07-.11-.13-.23-.2-.33l.61-.45.21.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.46,70.23l-.24.45-.46-.63c.08-.16.16-.3.25-.45l.45.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.23,91.39a5.46,5.46,0,0,1-.36.48c-.08-.22-.17-.44-.26-.66l.37-.48c.09.22.17.44.25.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.13,141.79c0,.11,0,.21-.07.31l-.42-.29.06-.31.43.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.08,140.35l0,.34-.52-.3c0-.11,0-.23,0-.34l.51.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3,57.62l-.56.57c-.07-.13-.14-.27-.2-.4l.56-.57c.06.14.14.27.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.83,141.09c0,.11,0,.22,0,.32l-.48-.29c0-.11,0-.22,0-.33l.48.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.26,45.15l-.2.34-.62-.45.21-.33.61.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.68,83c-.12.22-.23.44-.34.67-.11-.16-.21-.32-.31-.48l.33-.67.32.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,114.59l-.52.46c0-.2,0-.4,0-.6L136,114c0,.2,0,.4,0,.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.57,66.84l-.49.62L41.85,67l.49-.63c.07.15.15.3.23.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.39,53.37c-.06.13-.12.26-.19.38l-.59-.53.19-.38.59.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,76.47l-.4.65-.27-.46.39-.65c.09.15.19.3.28.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.57,121.47l-.56.42c0-.18,0-.37,0-.55l.56-.43c0,.19,0,.37,0,.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.07,93l-.38.48-.24-.67.37-.48c.09.22.17.44.25.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.51,46.32l-.62.46-.2-.34.62-.46.2.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.54,37.8l-.5.32-.36-.28.51-.32.35.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.13,57.76l-.2.4-.56-.57.2-.4.56.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.94,139.56c0,.12,0,.23,0,.35l-.54-.31c0-.12,0-.24,0-.36l.54.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.32,125.29l-.58.41c0-.17,0-.35.05-.52l.57-.41c0,.17,0,.35,0,.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.69,96c-.07.22-.15.44-.21.66l-.4-.48.21-.66.4.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.66,113.13l-.51.45c0-.2,0-.4-.05-.6l.51-.46c0,.2,0,.41,0,.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.36,63.68c-.17.2-.35.4-.52.61l-.21-.43.51-.61c.07.14.14.29.22.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.64,71.59l-.45.64-.25-.45.44-.64.26.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.67,83.17l-.32.48L141,83c.11-.15.21-.31.32-.47l.34.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,46.42l-.2.34-.62-.46.21-.34.61.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.83,67c-.08.15-.15.3-.23.44l-.5-.62.24-.44.49.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.79,47.62l-.61.48c-.07-.11-.13-.23-.2-.35l.62-.47.19.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.39,50.35l-.6.51-.2-.36L55.2,50l.19.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.86,94.58l-.39.48c-.07-.22-.15-.44-.23-.66l.39-.49c.08.22.16.45.23.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.09,49l-.61.49c-.07-.12-.14-.24-.2-.36l.61-.49.2.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,97.61c-.07.22-.14.44-.2.65-.14-.15-.28-.32-.41-.48.06-.22.13-.44.2-.65l.41.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.67,84.61l-.33.66L37,84.8l.33-.67c.1.16.22.32.33.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.73,37.77l-.49.31-.37-.29.5-.31.36.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.24,130l-.59.39c0-.16,0-.32.07-.48l.6-.39c0,.16,0,.32-.08.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.28,111.65l-.5.45c0-.2,0-.4-.07-.61.17-.15.34-.3.5-.46,0,.2,0,.41.07.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.52,141l0,.33-.47-.3c0-.1,0-.22,0-.33l.47.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.15,60.74l-.21.42-.55-.59c.07-.14.15-.28.21-.41.19.19.37.39.55.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.81,127.69l-.59.39.06-.5.59-.4-.06.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.27,99.19c-.05.22-.12.43-.18.65l-.42-.48.18-.65c.14.16.29.32.42.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.05,63.82c-.07.15-.14.29-.22.43l-.52-.6.22-.43.52.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.62,96.17l-.4.48c-.07-.22-.14-.44-.22-.66l.4-.48c.08.22.15.44.22.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.36,120.09l-.55.44c0-.19,0-.38,0-.57l.56-.43c0,.19,0,.38,0,.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.89,56.06l-.58.56c-.06-.14-.13-.27-.19-.4.18-.19.38-.37.57-.56l.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.78,140.3c0,.11,0,.23,0,.34l-.51-.3c0-.12,0-.23,0-.35l.51.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.86,110.15l-.48.46-.09-.62.49-.46c0,.2.06.41.08.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.93,37.74l-.48.31-.38-.29.48-.31.38.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.86,78l-.39.66-.29-.47.39-.66c.1.16.2.31.29.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.34,97.75l-.41.48c-.07-.22-.13-.44-.2-.66.14-.15.28-.32.41-.48.07.22.14.44.2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.68,84.76l-.33.48-.33-.67.33-.48.33.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.42,108.64l-.48.46c0-.21-.07-.41-.1-.62l.48-.47c0,.21.07.42.1.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.55,56.19c-.06.13-.13.26-.2.4-.19-.19-.38-.38-.58-.56l.21-.4.57.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,99.33l-.42.48c-.07-.22-.13-.44-.19-.65q.21-.25.42-.48c.07.21.13.43.19.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.18,124l-.58.42,0-.54c.19-.14.38-.27.57-.42l0,.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.23,68.32l-.48.63-.24-.44c.16-.21.31-.42.48-.63l.24.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.14,37.71l-.47.31c-.14-.09-.27-.19-.4-.29l.47-.31.4.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.94,107.11l-.47.47c0-.21-.08-.42-.11-.63.15-.16.31-.31.47-.47,0,.21.07.42.11.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.68,100.9l-.43.48c-.06-.21-.12-.43-.17-.65l.43-.48c.06.22.11.44.17.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.43,105.57l-.47.48-.12-.64.46-.47c0,.21.09.42.13.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.64,139.49c0,.12,0,.24,0,.36l-.53-.31c0-.12,0-.24,0-.36.17.11.35.21.53.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.3,102.47l-.45.48-.15-.65.44-.48c.05.22.1.43.16.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.22,141c0,.11,0,.22,0,.33l-.45-.3c0-.11,0-.22,0-.33l.46.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.88,104l-.45.47c-.05-.21-.09-.43-.15-.64l.46-.48c0,.22.09.43.14.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.12,118.7l-.54.44c0-.19,0-.39,0-.58l.54-.44c0,.19,0,.39,0,.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.39,73.12l-.44.65-.27-.46.44-.65.27.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.34,37.69l-.46.31-.4-.29.45-.31.41.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.37,44.9l-.61.45a4,4,0,0,1-.22-.34l.61-.44.22.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.81,59l-.56.58L47,59.15l.56-.58.21.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.51,54.53l-.58.54-.21-.39.59-.54.2.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.17,68.47l-.24.45-.49-.63.25-.44.48.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.65,86.35l-.34.48c-.1-.22-.21-.44-.31-.67.11-.16.23-.31.34-.48l.31.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,65.13c-.17.2-.35.4-.51.61l-.23-.43.5-.62.24.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.49,140.25c0,.11,0,.23,0,.34l-.49-.31c0-.11,0-.23,0-.34l.5.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.7,126.42l-.58.41c0-.17,0-.35,0-.52l.59-.4c0,.17,0,.34,0,.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.75,79.6l-.38.66-.3-.47.37-.66.31.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.17,128.78l-.6.39c0-.16,0-.32.06-.49l.6-.39-.06.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.63,59.12l-.21.41-.56-.58.21-.41.56.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.94,54.65c-.07.14-.13.27-.2.4l-.59-.55c.07-.13.14-.26.2-.39l.59.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.86,117.28l-.54.45,0-.59.54-.44,0,.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,122.65l-.57.42c0-.18,0-.36,0-.54l.57-.43,0,.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.66,46.15l-.62.46-.21-.34.61-.46c.07.12.15.23.22.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.93,141c0,.11-.05.22-.07.32l-.44-.3c0-.11,0-.22.06-.33l.45.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.45,65.27a4.77,4.77,0,0,1-.24.44c-.16-.21-.33-.41-.51-.62l.24-.43.51.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.59,88l-.35.48-.3-.67.35-.48c.11.22.21.44.3.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.6,62.15c-.07.14-.15.28-.23.42-.18-.2-.35-.4-.53-.59l.22-.43.54.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.83,46.25c-.07.11-.14.23-.22.34l-.62-.46a4,4,0,0,0,.22-.34l.62.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.36,139.44v.35l-.52-.31c0-.12,0-.24,0-.36l.53.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.92,69.82l-.47.64c-.09-.15-.17-.3-.25-.45l.46-.64c.09.15.18.3.26.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,47.45l-.62.47a4.05,4.05,0,0,1-.21-.35l.61-.47.22.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.18,74.66c-.15.21-.29.43-.43.65-.1-.15-.19-.31-.28-.46l.42-.65.29.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.84,51.58l-.61.52c-.07-.13-.14-.25-.2-.38l.6-.51.21.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.56,115.85l-.53.45c0-.2,0-.4,0-.59.18-.15.36-.3.53-.46,0,.2,0,.4,0,.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.39,57.39q-.3.28-.57.57c-.08-.13-.15-.27-.22-.4l.57-.57c.07.13.14.27.22.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.12,42.28l-.6.41-.25-.32c.19-.14.39-.27.59-.4l.26.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.67,81.18c-.13.22-.25.44-.37.66L38,81.36l.37-.66.32.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2,140.2l0,.34-.48-.31c0-.11,0-.23,0-.34l.49.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.23,48.78l-.61.49-.21-.35.61-.49.21.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.53,50.16l-.61.51-.21-.37c.2-.17.4-.34.61-.5.06.12.14.24.21.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.15,138.61c0,.13,0,.25,0,.37l-.54-.32,0-.37.55.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.54,47.55l-.21.35-.62-.48.22-.34.61.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.64,140.93c0,.11,0,.22-.08.33l-.43-.3c0-.11.05-.22.08-.33l.43.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.5,89.54l-.37.48c-.09-.22-.19-.44-.29-.66.13-.16.25-.32.37-.49.1.22.19.45.29.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.13,38.7,80.6,39l-.35-.3.52-.33.36.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.58,125.13l-.59.42c0-.18,0-.35,0-.53l.59-.41,0,.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.82,121.29l-.57.43c0-.18,0-.37,0-.55l.56-.44c0,.19,0,.38,0,.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.22,74.81l-.29.46-.43-.65c.1-.15.2-.3.29-.46l.43.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.07,57.53l-.22.4-.57-.57.21-.4.58.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.23,114.39l-.52.46-.06-.6c.18-.15.36-.3.53-.46,0,.2,0,.4,0,.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.7,81.33c-.1.16-.21.32-.32.47-.12-.22-.24-.44-.37-.66.11-.16.22-.31.32-.47.13.22.25.43.37.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6,66.59l-.5.62-.24-.44.49-.62.25.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.07,127.54l-.59.4c0-.17,0-.34,0-.51l.6-.4c0,.17,0,.34-.05.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.35,60.36,46.8,61c-.08-.13-.15-.28-.23-.42.19-.19.37-.39.55-.58.07.14.15.28.23.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.37,91.14l-.38.48-.28-.67.38-.48c.1.22.19.44.28.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.55,44.75l-.61.44c-.09-.11-.16-.22-.24-.33l.61-.44.24.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.35,38.66l-.51.33-.37-.3.51-.33.37.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.42,63.43l-.53.61-.24-.43.53-.6a4.49,4.49,0,0,0,.24.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.62,82.76l-.35.66c-.11-.15-.23-.31-.33-.47.11-.23.23-.45.35-.67l.33.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,76.21c-.15.22-.29.44-.42.65l-.3-.46.42-.66c.1.16.19.32.3.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.88,112.92l-.52.46c0-.2-.05-.4-.07-.6l.52-.47c0,.21,0,.41.07.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,55.84l-.59.55L50.2,56l.58-.55c.07.13.14.27.22.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.09,139.38c0,.12,0,.24,0,.35l-.52-.31c0-.12,0-.24,0-.36l.52.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.93,140.15c0,.12,0,.23-.05.35-.15-.11-.32-.21-.47-.31,0-.12,0-.23,0-.35l.48.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.82,66.74l-.25.44c-.16-.21-.33-.42-.5-.62l.25-.44c.16.21.33.41.5.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.1,60.5l-.23.42c-.18-.2-.37-.39-.55-.58.07-.15.15-.28.22-.42l.56.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.2,92.73l-.39.49c-.09-.22-.18-.44-.26-.67l.39-.48.26.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.65,71.34c-.16.21-.31.42-.46.64-.09-.16-.19-.31-.27-.46l.45-.64c.09.15.19.3.28.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.6,119.91l-.56.44c0-.19,0-.38,0-.56l.56-.44c0,.19,0,.37,0,.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,63.58l-.24.43-.53-.61.24-.43c.17.21.35.41.53.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.58,95.78c-.08.22-.16.43-.23.65L37.93,96l.23-.66.42.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.58,38.62l-.51.33-.38-.3.5-.33.39.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.47,56l-.22.4-.59-.55c.08-.13.15-.27.22-.4l.59.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.48,111.43l-.5.47-.09-.62.51-.46c0,.21.06.41.08.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.42,123.82l-.58.42c0-.18,0-.36,0-.54l.58-.42c0,.18,0,.36,0,.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.75,82.91l-.33.48-.36-.66c.11-.17.23-.32.33-.48.13.22.24.44.36.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.89,138.55c0,.12,0,.24,0,.37l-.53-.32a2.41,2.41,0,0,1,0-.38l.54.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.44,43.42l-.6.42c-.09-.1-.17-.21-.26-.32l.61-.42.25.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,94.33l-.41.48-.24-.66c.13-.16.27-.32.4-.49l.25.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.84,46l-.62.46L62,46.11l.61-.46.24.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.85,97.37c-.08.22-.15.43-.22.65l-.42-.48.21-.66.43.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.61,84.35l-.34.66c-.12-.15-.23-.32-.34-.47.11-.23.22-.45.34-.67l.34.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.06,109.93l-.5.47c0-.21-.06-.41-.1-.62l.5-.47c0,.21.07.42.1.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.15,99c-.07.22-.14.44-.2.65l-.43-.48c.06-.22.13-.44.2-.65l.43.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.81,38.59l-.49.32-.4-.3.49-.32.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.42,128.64l-.6.39c0-.16,0-.32,0-.49l.6-.39c0,.16,0,.33,0,.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.67,46.09l-.24.34-.62-.46.24-.34.62.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.76,95.92l-.41.48-.24-.66.42-.48.23.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,126.27l-.59.41,0-.52.59-.41,0,.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.67,140.11c0,.12,0,.23-.07.34l-.47-.31c0-.11.05-.23.07-.34l.47.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.35,118.51l-.56.44c0-.19,0-.38,0-.57l.55-.44,0,.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.91,58.75l-.57.58c-.08-.14-.15-.28-.23-.41l.57-.58c.07.14.15.28.23.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.61,108.42l-.49.47-.12-.63.49-.47.12.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.85,77.77l-.41.66-.3-.47c.12-.22.26-.44.4-.66l.31.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.27,68.07l-.49.63c-.09-.15-.18-.3-.26-.45l.49-.62c.08.15.17.3.26.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.49,97.51l-.43.48c-.07-.22-.14-.44-.22-.66l.43-.48c.07.22.15.44.22.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.83,139.33l0,.35-.51-.32,0-.35.51.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.12,47.28l-.62.47c-.07-.12-.15-.23-.23-.35l.62-.47.23.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.05,38.56l-.49.33c-.13-.11-.27-.21-.41-.31l.49-.32.41.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.76,84.5l-.35.48-.34-.67c.12-.15.23-.32.35-.47l.34.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.12,106.89l-.48.47c0-.21-.09-.42-.13-.63l.48-.48c0,.21.09.43.13.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3,52.83l-.6.53L53.48,53l.6-.53.22.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.18,99.09l-.44.48-.2-.65.44-.49c.07.22.13.44.2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.6,105.35c-.16.16-.31.32-.47.47l-.15-.63.48-.48c0,.21.1.42.14.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.55,58.89l-.23.41-.57-.58c.08-.14.16-.27.23-.41.19.19.39.38.57.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.84,100.67l-.45.48c-.06-.22-.13-.44-.19-.65l.45-.49c.06.22.12.44.19.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.38,47.38l-.23.35-.62-.47.23-.35.62.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4,72.86l-.45.65-.28-.46.45-.65c.09.16.19.31.28.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.24,122.48l-.57.42v-.54l.57-.43c0,.18,0,.37,0,.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.05,103.79l-.47.48c-.05-.21-.1-.42-.16-.64l.47-.48c.05.22.11.43.16.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.46,102.24l-.46.48c-.05-.22-.11-.44-.17-.65l.45-.48.18.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.91,61.77l-.54.6-.24-.43.54-.59.24.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.41,48.6l-.62.49c-.08-.12-.16-.24-.23-.36l.62-.48c.07.12.15.24.23.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,51.38l-.61.52-.22-.38.61-.51c.07.13.14.25.22.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.69,50l-.61.51-.23-.37.62-.5.22.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.75,44.61l-.61.44c-.09-.11-.17-.23-.25-.34l.61-.43.25.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.07,117.09l-.55.45c0-.2,0-.39,0-.58l.55-.45c0,.19,0,.39,0,.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.64,138.49c0,.12,0,.24,0,.36l-.53-.32v-.37l.54.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.41,140.07c0,.12,0,.23-.08.34l-.45-.31c0-.11.05-.23.08-.34l.45.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.1,48.71l-.24.36-.61-.49.23-.36.62.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.37,137.63c0,.13,0,.26,0,.39l-.55-.33c0-.13,0-.26,0-.39l.55.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.5,51.5l-.23.37-.61-.51c.08-.13.16-.25.23-.38l.61.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.74,86.09l-.36.48-.33-.66.36-.48.33.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.54,61.91l-.25.43-.54-.6.24-.42.55.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.8,50.08l-.23.37L121,50l.23-.37.61.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.41,65l-.25.44c-.18-.2-.35-.41-.52-.61l.25-.44c.17.21.35.41.52.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.73,79.34l-.39.66c-.1-.16-.21-.32-.32-.47l.39-.66c.11.15.22.31.32.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.51,57.17l-.58.57-.23-.41.57-.56.24.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.8,125l-.58.41c0-.17,0-.35,0-.52l.59-.42c0,.18,0,.35,0,.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.66,43.3l-.61.41-.27-.32.61-.42c.09.11.17.22.27.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.58,139.28c0,.11,0,.23,0,.35l-.5-.32c0-.12,0-.24,0-.36l.5.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.3,127.4l-.59.4c0-.17,0-.34,0-.51l.6-.4,0,.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.76,115.65l-.54.45-.06-.59.54-.45.06.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,121.12l-.57.43c0-.18,0-.37,0-.55l.57-.44c0,.19,0,.37,0,.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,57.3l-.24.41-.58-.57.24-.4.58.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,69.57c-.16.21-.33.42-.48.63-.1-.15-.19-.3-.28-.45l.48-.63c.09.15.18.3.28.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.68,87.69l-.37.48c-.11-.22-.22-.44-.32-.66.12-.17.25-.33.37-.49.11.22.21.45.32.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,45.84l-.62.46c-.08-.12-.16-.24-.25-.35l.62-.45.25.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2,74.4l-.45.65-.29-.46c.14-.22.29-.44.44-.65.09.15.19.31.3.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.46,60.13c-.19.2-.38.39-.56.59a4.49,4.49,0,0,1-.24-.42c.18-.2.37-.39.55-.58l.25.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.14,55.62l-.59.56-.24-.4.59-.56.24.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.65,80.92l-.38.66-.33-.48c.12-.22.25-.44.38-.66l.33.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4,138.43l0,.36-.52-.32c0-.12,0-.25,0-.37l.52.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.42,114.19c-.17.16-.35.31-.53.46,0-.2,0-.4-.08-.6l.54-.46c0,.2.05.4.07.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.58,89.29l-.38.48-.3-.66.38-.49.3.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.22,74.55l-.3.47c-.15-.22-.29-.44-.44-.65l.3-.46.44.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.35,139.23c0,.12,0,.24-.07.35l-.49-.32.06-.36.5.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.14,137.57c0,.12,0,.25,0,.38l-.54-.34v-.38l.55.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.51,63.2l-.54.6c-.09-.14-.17-.29-.25-.43.18-.2.35-.41.54-.61a4.91,4.91,0,0,0,.25.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.93,140c0,.12-.08.23-.11.34l-.44-.31.11-.35.44.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.35,55.75l-.24.4-.59-.56.24-.39.59.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,60.27c-.08.14-.16.28-.25.42-.18-.2-.37-.39-.56-.59l.25-.41.56.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.32,47.12l-.62.47c-.08-.12-.17-.24-.24-.36.2-.16.41-.31.62-.46l.24.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.63,123.66l-.58.42v-.54l.58-.42v.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.8,119.74l-.57.43,0-.56.57-.44,0,.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.16,39.55l-.52.35-.38-.32.52-.34.38.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.74,81.07l-.34.48c-.12-.23-.25-.45-.38-.66l.34-.48c.13.22.26.44.38.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,44.47l-.61.44-.27-.34.61-.43.27.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.05,112.72l-.52.46-.09-.61.53-.46c0,.2.06.41.08.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.79,54.11l-.6.54c-.07-.13-.15-.26-.23-.39l.6-.54c.07.13.15.26.23.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.19,47.21c-.08.12-.16.24-.25.35l-.62-.47c.09-.11.17-.23.25-.35l.62.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.45,90.88l-.39.49c-.09-.22-.19-.44-.29-.66l.39-.49c.1.22.2.44.29.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,63.33c-.08.15-.17.29-.26.44-.17-.21-.36-.41-.54-.61.09-.14.18-.28.26-.43l.54.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,76c-.15.22-.29.44-.43.66l-.31-.47c.14-.22.28-.44.43-.65.1.15.2.31.31.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.61,82.5l-.37.67-.35-.48c.12-.23.25-.45.37-.67.12.17.23.33.35.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6,48.43l-.62.49-.24-.36c.21-.16.41-.33.62-.48l.24.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7,71.09l-.47.63c-.1-.15-.2-.3-.29-.46l.47-.63.29.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7,140c0,.11-.09.23-.13.34l-.43-.32.13-.34.43.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.7,54.23l-.24.39-.6-.54.24-.39.6.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.48,52.63l-.61.53c-.09-.13-.16-.26-.24-.39l.61-.52c.07.13.16.25.24.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.42,39.51l-.51.34-.4-.31L83,39.2l.39.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.65,111.23l-.52.46c0-.2-.07-.41-.1-.61l.52-.47c0,.21.07.41.1.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.89,49.79l-.62.5L58,49.92l.62-.49.25.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.29,92.48c-.13.17-.27.33-.41.49l-.27-.66.4-.49c.1.22.19.44.28.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,58.53l-.57.57-.25-.41.57-.57c.09.13.17.27.25.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.17,51.19l-.61.52-.24-.38.61-.51.24.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.91,48.53l-.25.37-.61-.49.25-.36.61.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.12,139.18c0,.12-.06.24-.08.36l-.48-.32c0-.12,0-.24.08-.36l.48.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.18,138.37c0,.12,0,.25-.05.37l-.51-.33c0-.12,0-.25,0-.37l.52.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.54,118.33l-.57.44c0-.19,0-.38,0-.57l.56-.45c0,.2,0,.39,0,.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5,95.54l-.24.65-.43-.48c.08-.22.16-.44.25-.66l.42.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,52.75l-.25.38-.6-.52.24-.39.61.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.79,82.65l-.35.48c-.13-.22-.25-.44-.37-.66l.35-.48.37.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.22,109.72l-.51.47-.12-.62.51-.47.12.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.63,49.9c-.08.12-.16.25-.25.37l-.62-.5c.09-.12.17-.24.25-.37l.62.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.69,39.48l-.51.34-.41-.32.51-.34.41.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.33,51.3l-.24.38-.61-.51.24-.38.61.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.09,94.08l-.42.49c-.08-.22-.17-.44-.26-.66l.42-.49.26.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.44,122.31l-.59.43c0-.18,0-.36,0-.54l.58-.43c0,.18,0,.36,0,.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.77,97.13c-.08.22-.16.43-.23.65-.15-.15-.3-.32-.44-.48.07-.22.15-.44.23-.66l.44.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.44,58.66l-.25.41-.57-.57.24-.41.58.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6,84.1l-.36.66-.36-.48.36-.67.36.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.93,137.5l0,.38-.54-.33,0-.39.54.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.27,45.69c-.21.16-.42.3-.62.46l-.27-.35.62-.45.27.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.35,67.83c-.17.2-.34.41-.5.62-.1-.15-.19-.3-.28-.45.17-.2.33-.41.5-.62.09.15.18.3.28.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.07,98.71c-.07.22-.15.44-.22.66l-.45-.49c.08-.22.15-.43.22-.65l.45.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.76,108.2l-.51.47c0-.2-.08-.41-.13-.62l.51-.48c0,.21.08.42.13.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,61.54l-.55.59-.26-.43c.18-.2.37-.39.56-.59.08.14.16.29.25.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.86,95.67c-.14.17-.29.33-.43.49l-.25-.66c.14-.16.29-.32.43-.49.08.23.16.44.25.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,39.45l-.5.34L85,39.47l.49-.33.43.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.87,77.52l-.42.65c-.11-.15-.22-.31-.32-.47l.42-.66.32.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.13,64.64l-.53.61c-.09-.14-.18-.29-.26-.44.17-.2.35-.4.52-.61.09.15.19.29.27.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.26,106.67l-.49.47-.15-.63.5-.47c0,.21.09.42.14.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.59,97.27l-.44.48c-.08-.22-.15-.44-.24-.65l.44-.49.24.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9,139.14l-.09.36-.47-.33.09-.36.47.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.25,116.9l-.56.45-.06-.58.55-.45c0,.2,0,.39.07.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.66,57l-.59.57-.24-.41c.19-.19.38-.38.58-.56.08.14.17.27.25.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.8,84.24c-.12.17-.24.32-.37.49l-.35-.67.36-.48.36.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.73,105.13l-.48.47c-.06-.21-.11-.42-.17-.63l.49-.48c.06.21.11.42.16.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.46,72.61c-.16.21-.31.43-.46.65l-.3-.47c.15-.21.3-.43.46-.64l.3.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.28,98.85l-.44.49c-.07-.22-.15-.44-.23-.66l.46-.48.21.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.44,61.67l-.26.43c-.18-.2-.37-.4-.56-.59l.26-.43.56.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.21,44.34l-.61.43-.28-.33.61-.43.28.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.17,103.57l-.48.48c-.05-.21-.11-.43-.17-.64l.47-.48c.06.21.13.42.18.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,100.43c-.15.16-.31.32-.46.49l-.21-.65.46-.49.21.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,138.32c0,.12,0,.24-.06.37l-.51-.33c0-.13,0-.25.06-.38l.51.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.58,102l-.47.48c-.06-.22-.13-.43-.19-.65l.47-.48c.06.21.13.43.19.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.33,64.78l-.27.44-.53-.61.27-.44.53.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.83,57.08l-.25.41-.58-.56.25-.41.58.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.55,47l-.62.47-.26-.36.61-.46.27.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.21,121l-.57.43c0-.18,0-.37,0-.55l.58-.44c0,.19,0,.37,0,.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.92,115.46l-.55.45c0-.19-.05-.39-.07-.59l.55-.45c0,.2.05.39.07.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.31,55.42l-.6.54c-.08-.13-.17-.26-.25-.4l.6-.54.25.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.77,85.84l-.37.48c-.11-.22-.23-.44-.35-.66.13-.16.26-.32.38-.49.11.23.23.45.34.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.76,79.09c-.13.22-.27.43-.41.66L40,79.27c.13-.22.26-.44.4-.66l.34.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7,139.1c0,.12-.08.24-.12.36l-.46-.33.12-.36.46.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.73,137.44c0,.13,0,.25,0,.38l-.53-.34c0-.12,0-.25,0-.38l.54.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.41,136.55c0,.13,0,.26,0,.39-.19-.11-.38-.22-.56-.34,0-.13,0-.26,0-.4l.56.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6,59.91l-.57.58c-.08-.14-.17-.28-.26-.42l.57-.58.26.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.06,69.32c-.17.22-.34.42-.5.64l-.29-.46.49-.63.3.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.83,48.27l-.62.48c-.1-.12-.18-.24-.27-.36l.62-.48.27.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,53.91l-.6.54-.26-.4.61-.53.25.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.77,138.27c0,.12-.06.24-.08.37l-.5-.34c0-.12,0-.24.08-.37l.5.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.26,74.15l-.46.65-.31-.47.45-.64.32.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.57,114l-.54.46-.09-.6.54-.46.09.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1,49.62l-.62.5c-.08-.13-.17-.25-.26-.38l.62-.49.26.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.72,87.44l-.39.48-.33-.66.38-.49c.12.22.23.44.34.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.88,60c-.08.14-.17.28-.26.42-.18-.2-.38-.39-.57-.58.09-.14.18-.28.26-.42.2.19.38.39.57.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.51,45.56,65.9,46l-.29-.34.62-.45.28.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,119.56l-.57.44c0-.19,0-.38,0-.56l.58-.45c0,.19,0,.38,0,.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.79,66.1c-.18.21-.36.41-.53.62-.1-.14-.19-.29-.28-.44l.52-.62c.09.15.19.3.29.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,52.44l-.62.53-.25-.39.61-.52.26.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.39,51l-.62.51c-.09-.13-.18-.25-.26-.38l.62-.51c.08.13.17.26.26.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5,139.07c0,.12-.09.23-.13.35l-.45-.33a3.62,3.62,0,0,1,.13-.35l.45.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.53,54l-.25.39-.61-.54c.09-.13.17-.26.25-.39.21.18.41.35.61.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.68,80.67l-.39.66-.35-.48.39-.66.35.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.84,52.55c-.08.13-.17.26-.26.39l-.61-.52.26-.39.61.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.47,44.22l-.61.43-.3-.34.61-.43.3.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.14,51.12l-.26.38-.62-.51c.09-.13.18-.25.26-.38l.62.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,40.48l-.54.36-.39-.33.53-.35.4.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.84,63.1l-.27.43-.55-.6.27-.43.55.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.19,112.52l-.53.46c0-.2-.07-.4-.11-.6l.54-.47c0,.2.07.41.1.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.62,89l-.39.48c-.11-.22-.22-.44-.32-.66l.39-.49c.11.22.22.44.32.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.54,137.38l-.06.38-.53-.34L74,137l.53.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.21,58.31l-.58.57-.27-.41.58-.57.27.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.74,80.81l-.36.49-.39-.67c.12-.15.23-.31.35-.47l.4.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.31,139a3.68,3.68,0,0,0-.15.35l-.44-.33.15-.36c.14.12.29.23.44.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.58,138.22c0,.12-.07.25-.1.37l-.49-.34c0-.12.06-.24.1-.37l.49.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.23,136.48c0,.13,0,.27,0,.4l-.55-.35c0-.13,0-.26,0-.4l.55.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.79,70.84l-.48.63L43,71c.16-.22.32-.43.49-.64l.3.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69,118.15l-.57.45c0-.19-.05-.38-.07-.58.19-.15.38-.29.57-.45,0,.2,0,.39.07.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.06,92.1l-.3.66-.41-.49c.09-.22.19-.44.29-.66l.42.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8,46.81l-.62.47-.28-.36.61-.46.29.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.78,111l-.53.47-.12-.61.53-.47.12.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.08,75.71l-.44.64-.33-.47c.15-.21.29-.43.44-.65l.33.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.29,58.44l-.26.41-.58-.57c.08-.14.17-.27.26-.41l.58.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.27,40.44l-.52.35c-.14-.1-.28-.22-.41-.33l.52-.35.41.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.5,90.64l-.41.49c-.1-.23-.2-.45-.31-.67.14-.16.28-.32.41-.49.11.22.21.45.31.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.64,82.25c-.12.23-.26.44-.38.67-.13-.16-.25-.33-.37-.49.13-.22.25-.44.39-.66.11.17.24.32.36.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.25,93.7c-.1.22-.19.44-.28.66l-.43-.49.28-.66c.14.16.29.32.43.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.19,61.31c-.19.2-.38.39-.56.59-.1-.14-.19-.28-.28-.43l.57-.59.27.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.34,109.51l-.52.48c0-.21-.09-.42-.14-.62l.52-.48c.05.21.09.42.14.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.85,56.75l-.6.56c-.09-.14-.17-.28-.26-.41l.59-.56.27.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.34,92.24l-.43.49c-.09-.22-.19-.44-.29-.67l.42-.48.3.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.57,40.4l-.52.36-.42-.33.52-.35c.13.11.28.22.42.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.47,67.59l-.52.62c-.1-.15-.2-.3-.29-.45l.51-.62.3.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.48,95.3l-.27.66c-.14-.17-.29-.33-.44-.49l.27-.66.44.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.78,82.4l-.36.48-.39-.66.37-.48.38.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.07,48.11l-.62.48-.28-.37.62-.47.28.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4,138.18c0,.12-.08.24-.11.36l-.48-.33c0-.13.07-.25.11-.37l.48.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.78,45.43l-.62.44-.3-.35.62-.44.3.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.36,137.32c0,.13,0,.26-.07.39l-.52-.35c0-.12,0-.25.07-.38l.52.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.38,116.72l-.56.45c0-.19,0-.38-.08-.58l.56-.45c0,.19.06.39.08.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.87,108c-.17.16-.34.32-.52.47l-.15-.62.52-.48.15.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.74,96.89c-.09.22-.17.44-.25.66L40,97.06l.24-.66c.15.17.3.33.46.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.14,93.84l-.43.49-.28-.66c.14-.17.29-.33.43-.49.1.22.19.44.28.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.67,56.87l-.27.41-.6-.56c.1-.14.18-.27.27-.41l.6.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.3,61.44l-.27.43-.57-.59.28-.42.56.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.87,40.38l-.51.35-.43-.33.51-.35.43.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.63,83.85c-.13.22-.25.44-.37.66L39.88,84c.12-.23.25-.45.37-.67l.38.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,98.48c-.08.22-.16.44-.23.66l-.46-.49c.07-.22.15-.44.23-.65l.46.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,67.73l-.29.45-.52-.63.3-.44.51.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.36,100.07c-.08.21-.15.43-.22.65l-.47-.49c.07-.22.14-.43.22-.65l.47.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.51,55.21l-.6.55-.27-.4.6-.55.27.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.94,77.27c-.15.21-.29.43-.43.65l-.34-.47.43-.66.34.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.36,106.45l-.5.48c-.06-.21-.12-.42-.17-.63l.51-.48c.05.21.11.42.16.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.91,95.44l-.44.49-.27-.66c.15-.17.3-.33.44-.5.1.22.18.45.27.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.69,135.5c0,.14,0,.27,0,.41l-.56-.35c0-.14,0-.28,0-.42l.57.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.21,64.54c-.09.15-.19.3-.29.44-.17-.2-.36-.4-.54-.6l.29-.44.54.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.06,136.42l-.06.39-.54-.35.06-.4.54.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.35,49.45l-.62.5-.28-.38.62-.49c.09.13.18.25.28.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.56,72.37l-.48.64-.32-.47.48-.64.32.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.83,104.91c-.17.15-.34.32-.5.48-.07-.21-.13-.43-.18-.64l.49-.48c.07.21.13.42.19.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.65,97c-.15.16-.31.32-.46.49-.08-.22-.16-.44-.25-.66.15-.16.31-.32.45-.49l.26.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,55.33l-.27.4-.6-.54.27-.4.6.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2,53.72l-.61.53-.27-.39.61-.54.27.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.79,84c-.12.16-.25.32-.37.49l-.38-.67.38-.48.37.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.26,103.35l-.5.48c-.06-.21-.12-.43-.19-.64.17-.16.33-.33.49-.49l.2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.35,98.62c-.16.16-.31.33-.46.49l-.24-.66c.15-.16.31-.32.46-.49l.24.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.62,50.84l-.62.5L58.73,51l.62-.5.27.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.2,49.55c-.1.12-.19.25-.28.38l-.62-.5.28-.37.62.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.65,101.78l-.48.48-.21-.64.48-.49.21.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,100.2l-.47.49-.23-.65.48-.49c.07.22.14.44.22.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.91,52.26c-.21.17-.42.34-.62.52L57,52.39l.61-.52.28.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.05,115.27c-.18.16-.37.31-.56.46,0-.2-.06-.39-.1-.59l.57-.46.09.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.78,59.69l-.58.58-.27-.42.57-.58.28.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.23,138.14l-.13.36-.47-.34c0-.12.09-.24.13-.37l.47.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.33,53.83l-.27.4-.61-.54.27-.39.61.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.63,52.36l-.27.39c-.21-.17-.42-.34-.62-.52l.28-.38.61.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2,137.27c0,.13-.06.26-.1.38-.17-.11-.34-.22-.5-.34,0-.13.06-.26.09-.39l.51.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.07,46.67l-.62.46-.3-.36.62-.45.3.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.73,59.82l-.28.42-.58-.58.28-.42.58.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.18,69.09l-.51.62-.3-.45.5-.63c.1.15.21.3.31.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.83,78.84l-.42.66L41.06,79l.42-.66.35.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.77,85.59l-.39.49-.36-.67.39-.48c.12.21.24.44.36.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.69,113.8l-.56.47c0-.2-.07-.4-.11-.6l.56-.46c0,.2.07.4.11.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.93,65.87c-.18.2-.35.41-.53.62L46.1,66l.54-.61c.1.14.19.29.29.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.07,138.1c0,.12-.1.24-.14.37l-.47-.34.15-.38.46.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.06,45.3c-.2.14-.4.3-.61.44-.11-.11-.21-.23-.32-.35l.62-.44.31.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.36,73.91l-.47.64-.33-.47.47-.64c.1.16.22.31.33.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9,136.35c0,.14-.05.27-.07.4l-.53-.35c0-.13,0-.27.07-.4l.53.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.3,69.23l-.31.45-.51-.63.31-.45.51.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.41,58.1l-.59.57-.28-.42.59-.56.28.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.54,135.43l-.06.41-.56-.36.06-.41.56.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69,62.87l-.29.43-.55-.59c.09-.15.19-.29.29-.44l.55.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.35,48l-.63.48-.29-.37.62-.47.3.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.71,87.19l-.4.49c-.11-.23-.23-.45-.35-.67.14-.16.27-.32.4-.49l.35.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.55,66c-.09.15-.19.3-.29.45l-.54-.62.3-.45c.18.21.36.41.53.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.29,112.32l-.54.47c0-.2-.08-.4-.13-.61.19-.15.37-.31.55-.47l.12.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,137.22c0,.13-.07.26-.1.38l-.51-.34.12-.39.49.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.11,58.22c-.09.14-.18.28-.28.42l-.59-.57.28-.41.59.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.1,74.05l-.33.47c-.15-.22-.31-.43-.47-.65l.34-.46c.16.21.31.42.46.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.76,80.42c-.14.22-.28.44-.41.66L41,80.6l.41-.66.37.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.92,138.06c-.06.13-.11.25-.17.37l-.44-.34c0-.13.1-.25.16-.37l.45.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.06,56.54l-.6.56-.28-.41.6-.56.28.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.62,88.79c-.13.17-.27.33-.41.49-.11-.22-.22-.44-.34-.66l.42-.49.33.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.62,49.3l-.63.48-.29-.37.62-.49.3.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.87,110.82l-.54.47c0-.2-.09-.4-.14-.61l.54-.47c.05.2.1.41.14.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.92,70.6l-.49.63-.32-.46.49-.63c.11.15.22.3.32.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.38,61.09l-.57.59-.29-.43.57-.59.29.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,80.56c-.12.17-.24.33-.37.49-.13-.22-.27-.44-.41-.66l.37-.48c.13.22.27.43.41.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.19,75.46l-.46.65-.34-.47.45-.65c.12.15.23.31.35.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.36,46.54l-.62.46c-.11-.13-.21-.24-.31-.37l.61-.45.32.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.94,49.39l-.29.37-.63-.49.3-.37.62.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,134.42c0,.14,0,.28-.06.42l-.57-.37.06-.42.57.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.77,136.3c0,.13-.07.26-.1.39l-.53-.35.1-.4.53.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.75,55l-.61.54-.29-.4.61-.54.29.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.08,91.86c-.11.22-.21.44-.31.66-.15-.16-.29-.33-.43-.49l.3-.66.44.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.77,138l-.18.37-.43-.35c0-.12.11-.24.17-.37l.44.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.89,50.67l-.62.5-.3-.38.63-.5.29.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.5,90.4l-.43.49c-.1-.23-.21-.45-.32-.67.14-.16.29-.32.42-.49l.33.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9,137.18l-.12.38-.5-.35c0-.13.09-.26.13-.39l.49.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.71,82l-.4.66-.37-.48.39-.67.38.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.13,61.22c-.09.15-.19.29-.29.43l-.57-.59.29-.43.57.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.42,109.31l-.53.48c0-.21-.11-.42-.16-.63l.54-.47.15.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.63,67.35c-.18.21-.36.41-.53.62l-.31-.45.52-.62.32.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.45,53.53l-.62.53c-.1-.13-.19-.26-.28-.4l.61-.52.29.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.48,116.54l-.57.46c0-.2-.06-.39-.1-.59l.58-.45c0,.19.07.39.09.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,41.37l-.52.36-.44-.34L84,41l.43.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.16,52.08l-.62.52-.29-.39.62-.52.29.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4,135.36c0,.14-.05.27-.07.41l-.55-.36c0-.14,0-.27.07-.41l.55.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.79,55.13l-.28.41L122.9,55l.29-.4.6.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.27,93.46l-.3.66-.44-.49.29-.66.45.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.67,50.77l-.3.38-.62-.5.3-.39.62.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.28,75.6l-.35.48c-.15-.22-.3-.44-.46-.65l.35-.48c.15.22.3.44.46.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.34,92l-.44.49c-.1-.22-.2-.44-.31-.66.15-.17.3-.33.44-.5.1.23.21.45.31.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.1,53.64l-.29.4-.61-.53c.09-.14.19-.27.29-.4l.61.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.94,107.78l-.53.48c-.06-.21-.11-.42-.17-.63l.53-.48c0,.21.11.42.17.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.78,41.34l-.51.36-.45-.34.52-.36.44.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.49,95.07c-.1.22-.19.43-.28.65-.15-.16-.31-.32-.46-.49l.29-.66c.14.17.3.33.45.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.73,82.15l-.38.49c-.13-.22-.26-.44-.4-.66l.38-.49c.14.22.27.44.4.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.06,64.31l-.31.45c-.18-.21-.36-.41-.55-.61.11-.15.21-.29.3-.44l.56.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,59.48l-.58.58-.29-.43.58-.58.29.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.75,96.66q-.15.33-.27.66L41,96.83l.27-.66.47.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.15,93.6l-.45.49-.29-.66.44-.49.3.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.42,106.24l-.52.48-.18-.63.52-.48c.06.21.13.42.18.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,98.26c-.08.22-.17.43-.25.65l-.47-.49c.08-.22.16-.44.25-.65l.47.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.71,101.43c-.08.21-.16.43-.23.64l-.49-.48c.07-.22.15-.44.23-.65l.49.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.64,47.82l-.62.47-.32-.37.63-.47c.1.13.2.25.31.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.05,77l-.45.66-.35-.48c.14-.22.29-.44.44-.65l.36.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.36,99.85c-.08.21-.17.43-.24.65l-.49-.49.24-.65.49.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7,72.13c-.16.21-.33.42-.49.64l-.34-.47c.17-.21.33-.43.49-.64l.34.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.77,137.13c0,.13-.1.26-.14.38l-.48-.35c0-.12.09-.25.14-.38l.48.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.14,115.09l-.57.46c0-.2-.07-.39-.11-.59l.57-.46c0,.19.07.39.11.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.64,136.24c0,.13-.08.26-.11.4l-.52-.36c0-.13.07-.26.11-.4l.52.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.92,95.2l-.45.49c-.09-.22-.19-.44-.29-.66.15-.16.31-.32.46-.49l.28.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.88,104.69l-.51.48c-.07-.21-.13-.42-.2-.63l.51-.49c.07.21.13.43.2.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.53,59.6l-.29.43-.59-.58L127,59l.58.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.66,96.8l-.46.49-.27-.66c.15-.16.31-.32.46-.49.1.22.18.44.27.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3,103.13l-.51.48c-.06-.21-.13-.43-.21-.64l.51-.49.21.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.74,83.75c-.12.16-.26.32-.39.48l-.39-.66c.13-.16.27-.32.39-.49.14.22.27.44.39.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.37,98.39c-.16.16-.31.33-.48.49-.08-.22-.17-.43-.25-.65l.48-.49c.08.21.16.43.25.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.69,101.56l-.5.48-.22-.64.49-.49c.08.21.15.43.23.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.42,77.17l-.36.47-.45-.65.36-.48.45.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,100l-.48.49-.24-.65.49-.5c.08.22.16.44.23.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.86,134.34c0,.14,0,.28-.07.43l-.57-.37c0-.15,0-.29.08-.43.18.13.37.25.56.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.28,135.3l-.09.4-.54-.36c0-.13.06-.27.09-.41l.54.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,62.52l-.57.59-.3-.44.57-.59c.09.15.19.29.3.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.64,57.9l-.59.56c-.11-.14-.2-.28-.3-.42l.6-.56.29.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.67,46.42c-.21.14-.41.3-.62.45l-.33-.37.62-.45.33.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.35,68.85l-.52.63L45.5,69l.52-.63c.11.16.21.31.33.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.91,49.14l-.62.49L63,49.25l.62-.48c.1.12.2.25.31.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.76,113.62l-.56.46c0-.2-.09-.4-.13-.6l.56-.46c.05.2.09.4.13.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.65,137.09c-.06.13-.11.26-.16.38l-.47-.35c0-.13.1-.25.16-.38l.47.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.12,65.64l-.54.62c-.11-.15-.21-.31-.32-.45.18-.21.37-.41.55-.61.1.14.2.3.31.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.9,58l-.3.42-.6-.56.3-.42.6.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,78.6c-.15.21-.3.43-.44.65l-.37-.48.43-.65.38.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.51,62.64l-.3.44-.57-.59.31-.44c.18.2.38.39.56.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.72,85.34c-.13.17-.27.33-.4.49l-.38-.66.41-.49.37.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.52,136.19c0,.13-.09.26-.13.39l-.51-.35c0-.14.09-.27.13-.4l.51.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.31,56.35l-.6.55-.3-.41.6-.55.3.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5,73.67l-.48.64-.35-.47.48-.64c.11.16.23.31.35.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.18,50.51l-.63.5-.3-.39.62-.5.31.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.39,65.78c-.1.15-.21.29-.32.44l-.54-.61c.11-.15.21-.3.32-.44l.54.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.36,112.13l-.56.47c-.05-.2-.09-.4-.14-.6l.56-.48c.05.21.09.41.14.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.28,133.3c0,.15,0,.29-.07.44l-.58-.38c0-.14.05-.29.07-.44l.58.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.52,78.74l-.37.48-.43-.65c.12-.17.24-.33.37-.49l.43.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,54.83l-.61.54c-.11-.13-.21-.27-.3-.4.2-.19.4-.36.61-.54l.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.39,50.6l-.31.39-.62-.5.31-.39.62.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.45,51.91l-.63.52-.3-.4.62-.51.31.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.53,137.06c-.06.12-.11.25-.17.38l-.46-.36.17-.38.46.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.72,53.35l-.62.53-.3-.4.62-.53.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.61,60.88c-.2.19-.39.39-.58.59L50.72,61c.2-.19.39-.39.58-.58l.31.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.66,87l-.41.49-.36-.67.41-.49.36.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,47.68l-.62.47L66,47.78l.62-.46.33.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.18,135.24c0,.13-.08.27-.11.4l-.54-.36c0-.14.07-.28.11-.41l.54.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.55,54.94l-.31.41-.61-.54c.1-.14.21-.27.3-.41l.62.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.12,52l-.31.39-.62-.51.31-.39.62.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.76,134.27l-.09.42-.56-.37.09-.42.56.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.87,80.18c-.14.22-.29.44-.42.66l-.39-.49.43-.65.38.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.84,53.46l-.3.4-.62-.53.3-.4.62.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.92,110.63l-.55.47-.15-.61.55-.48.15.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.09,70.36l-.51.64-.33-.47q.24-.32.51-.63c.1.16.22.31.33.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.93,61l-.31.44-.58-.59c.1-.14.2-.29.31-.43l.58.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.41,136.14l-.14.39-.5-.36c0-.13.09-.26.14-.39l.5.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.43,137c-.07.13-.13.26-.2.38l-.45-.35c.07-.13.13-.26.2-.38l.45.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.58,88.55l-.43.49c-.11-.22-.23-.44-.35-.66.14-.16.28-.33.43-.49.11.22.23.44.35.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.66,64l-.56.6c-.11-.14-.21-.29-.31-.44l.55-.6c.11.14.21.29.32.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.6,80.32l-.38.48-.43-.65.38-.49.43.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.33,75.22l-.46.65q-.19-.24-.36-.48c.15-.21.3-.43.46-.64l.36.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.46,109.11l-.54.48-.18-.62.55-.48c.06.2.11.41.17.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.24,59.27c-.2.19-.4.38-.59.58-.11-.14-.21-.29-.31-.43l.59-.57.31.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.14,91.63c-.11.22-.22.44-.32.66l-.45-.5c.11-.22.22-.44.32-.66l.45.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.22,49l-.62.48c-.11-.12-.22-.25-.32-.38l.62-.48c.1.13.22.25.32.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.86,64.09l-.31.44-.57-.6c.11-.15.22-.29.32-.44l.56.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.83,81.77l-.42.66L42,81.94l.41-.66c.13.17.26.33.4.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.45,90.16l-.43.49-.34-.66.44-.5c.11.22.23.44.33.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.15,75.36l-.36.48c-.15-.22-.31-.43-.47-.65l.36-.48c.16.22.32.43.47.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.33,137l-.21.37-.44-.35.21-.39c.14.13.29.24.44.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,107.58l-.54.48c-.06-.21-.13-.42-.19-.63l.54-.48c.06.21.12.42.19.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.08,135.18l-.12.4-.53-.36.12-.41.53.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.3,59.39c-.1.15-.2.29-.31.43l-.59-.57.31-.43.59.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.19,133.23c0,.14-.06.28-.08.43l-.58-.38.09-.44.57.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.33,93.23c-.11.22-.21.44-.31.66-.16-.16-.31-.33-.46-.49l.31-.66c.15.16.3.33.46.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.32,136.1c-.06.13-.11.26-.16.39l-.49-.36c0-.13.1-.27.16-.4l.49.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.19,114.91l-.57.46c-.05-.19-.09-.39-.13-.59l.57-.46c0,.19.09.39.13.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.3,91.76l-.45.5c-.11-.22-.21-.44-.33-.66.16-.17.31-.33.45-.5.12.22.22.44.33.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.64,81.91l-.39.49-.42-.66c.13-.17.27-.33.4-.49.14.22.28.44.41.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.55,94.84c-.1.22-.21.43-.3.65L41.78,95l.3-.66c.15.17.31.33.47.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.67,134.2c0,.15-.07.29-.11.42l-.55-.37c0-.14.07-.28.11-.42l.55.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9,57.7l-.6.56L54,57.84l.6-.56.31.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.44,106l-.53.49c-.06-.21-.13-.42-.2-.63l.53-.49c.07.21.13.42.2.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.49,50.35l-.63.5-.32-.39.63-.49c.1.13.21.26.32.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.87,71.89l-.5.64L45,72.06l.5-.64c.12.16.23.32.35.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8,96.44l-.29.65L42,96.6l.29-.66c.16.17.31.34.48.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.11,93.37c-.15.16-.3.33-.46.49-.1-.22-.2-.44-.31-.66.16-.16.31-.33.46-.49l.31.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2,76.79l-.46.65L43.37,77c.15-.22.3-.44.46-.65l.37.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.29,47.56l-.63.46c-.11-.12-.22-.25-.34-.37l.62-.46.35.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.74,101.21c-.09.22-.17.43-.24.65l-.51-.49.24-.65.51.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.08,98l-.27.65c-.16-.17-.33-.33-.49-.49l.27-.66.49.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.39,99.63c-.08.21-.17.43-.25.65l-.5-.5c.09-.21.17-.43.26-.65l.49.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.25,62.3l-.58.6c-.11-.15-.21-.3-.32-.44l.57-.6.33.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.09,50.44l-.32.39-.63-.5.33-.38.62.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.89,104.48l-.53.49c-.07-.22-.13-.43-.21-.64l.52-.49c.07.21.15.42.22.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.65,57.81c-.1.14-.21.28-.31.43l-.61-.57.32-.42.6.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.89,95c-.15.17-.31.33-.47.49l-.3-.65c.16-.17.32-.33.47-.5l.3.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.59,56.16l-.61.55-.31-.42.61-.55.31.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.75,51.75l-.62.51-.32-.4.62-.5c.11.13.22.25.32.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.3,102.91l-.51.49c-.08-.21-.15-.43-.23-.64l.51-.49c.08.21.16.43.23.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6,132.16a3.12,3.12,0,0,0-.09.44l-.58-.38c0-.15,0-.3.08-.45l.59.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.64,96.57l-.48.5-.29-.66.48-.5c.1.22.2.44.29.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.8,113.43l-.57.47c0-.2-.09-.39-.14-.59l.57-.48c.05.2.09.41.14.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.23,136.05c-.06.14-.12.27-.17.4l-.48-.37c0-.13.11-.26.17-.39l.48.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.55,68.62l-.53.63-.34-.46.53-.63c.11.16.22.31.34.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3,54.65l-.62.54-.31-.41.61-.54.32.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.3,62.43l-.33.44-.57-.6.32-.43.58.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.29,76.92c-.12.16-.25.32-.37.49l-.47-.66c.13-.15.26-.32.38-.47l.46.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,53.18l-.62.53-.32-.41.62-.52.32.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.68,101.34l-.5.49c-.08-.22-.16-.43-.25-.65l.51-.49.24.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.34,65.42c-.18.21-.37.4-.55.61l-.33-.45L49,65l.33.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.35,98.16l-.49.5c-.08-.22-.18-.43-.27-.65l.49-.5.27.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65,83.5c-.13.17-.27.33-.41.49-.13-.22-.26-.44-.4-.66.14-.16.28-.32.41-.49.14.22.27.44.4.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,99.75c-.16.17-.33.33-.5.5-.08-.22-.16-.44-.25-.65l.49-.5.26.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.83,51.84l-.33.4-.62-.51.32-.4.63.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,135.12l-.14.41-.52-.37c0-.14.09-.27.14-.41l.52.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.27,54.76l-.32.41c-.2-.19-.41-.36-.61-.54.1-.14.21-.27.32-.41l.61.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.19,65.55l-.33.45-.56-.61.34-.45c.18.21.36.41.55.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.12,133.15c0,.15-.07.29-.1.43l-.57-.38c0-.14.07-.29.11-.43l.56.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1,78.36c-.15.22-.31.43-.45.65l-.39-.48.45-.65.39.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.56,48.86l-.62.48L65.6,49l.62-.48c.11.13.22.26.34.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6,134.14c0,.14-.08.28-.13.42-.17-.13-.36-.25-.54-.37l.12-.43.55.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.87,60.67l-.59.59c-.11-.15-.22-.29-.32-.44l.58-.58.33.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.38,111.94l-.56.48c0-.21-.11-.41-.16-.61l.56-.47c.06.2.11.4.16.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.68,73.44c-.16.21-.33.42-.49.64l-.36-.48c.16-.21.32-.43.49-.64l.36.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.63,85.11l-.42.49-.39-.67.42-.49.39.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.16,136l-.2.39-.47-.37.19-.39.48.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.69,60.79l-.33.44c-.19-.2-.39-.39-.59-.58.12-.15.22-.29.33-.44.19.2.39.39.59.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.39,78.5,135,79l-.45-.65.39-.48c.15.21.3.43.44.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.93,135.07c-.05.14-.1.27-.16.41l-.51-.37c0-.14.11-.27.16-.41l.51.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.94,110.44l-.56.47-.18-.61.56-.48.18.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.83,50.21l-.63.49-.34-.39.63-.49.34.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.91,63.75l-.57.59L50,63.9l.57-.6.33.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.58,86.71l-.43.49c-.13-.22-.26-.44-.38-.66l.43-.5.38.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.52,59.08l-.6.57-.32-.43.59-.57.33.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3,70.14l-.52.63c-.12-.16-.23-.32-.35-.47l.52-.63.35.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.09,136c-.08.13-.14.26-.21.39l-.46-.36c.06-.13.14-.27.21-.4l.46.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,79.94l-.43.66c-.14-.16-.27-.32-.4-.49.14-.22.29-.44.44-.65l.39.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.54,132.08c0,.14-.07.29-.1.44l-.58-.39c0-.15.07-.3.1-.45l.58.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.05,59.19l-.33.43-.6-.57.33-.43.6.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.64,63.87l-.34.45c-.19-.21-.38-.4-.57-.6l.34-.45.57.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.54,134.08c-.05.14-.1.28-.14.42l-.54-.38c0-.14.09-.28.14-.42l.54.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.52,75l-.48.64-.38-.47c.16-.22.32-.44.49-.65l.37.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.46,108.91l-.55.48c-.06-.2-.12-.41-.19-.61l.55-.49c.07.21.13.42.19.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.49,88.32l-.44.49-.37-.66c.15-.17.3-.33.44-.5.13.22.25.44.37.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.09,51.59l-.63.51-.33-.4.62-.5.34.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.07,133.08c0,.15-.09.29-.12.43l-.56-.38.12-.44.56.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.47,80.08l-.4.49c-.14-.22-.29-.44-.44-.66l.4-.48c.14.22.29.43.44.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2,57.51l-.61.56-.33-.43.61-.55.33.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.49,67l-.35.46-.55-.62.35-.45.55.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,136c-.08.13-.16.26-.23.39l-.45-.37.22-.39L82,136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.87,135l-.17.41-.5-.37c0-.14.11-.27.17-.41l.5.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.51,51.68l-.34.4-.63-.51.34-.39.63.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.92,131c0,.15-.07.3-.1.46l-.59-.4c0-.15.07-.31.11-.46l.58.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.35,53c-.21.17-.42.34-.62.52l-.34-.41c.21-.17.42-.34.62-.52l.34.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9,56l-.61.54L57,56.11l.61-.55.33.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,75.12c-.12.17-.25.32-.38.48l-.48-.64.38-.48.48.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.92,48.73l-.63.48-.35-.39.62-.47.36.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.62,54.48,59,55c-.11-.13-.23-.27-.33-.41l.62-.53.33.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,81.53l-.43.66c-.13-.16-.27-.32-.4-.49l.42-.65.41.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,107.38l-.55.48c-.07-.21-.14-.41-.2-.62l.54-.49.21.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.37,89.92l-.45.5-.36-.66.46-.5.35.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.52,62.09c-.2.2-.39.4-.59.59l-.33-.44.58-.59c.11.15.22.3.34.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.24,53.11l-.34.41c-.2-.18-.41-.35-.62-.52l.34-.41c.2.18.42.35.62.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,135.93l-.24.38-.44-.37.24-.39.44.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.09,71.66c-.18.22-.34.43-.52.64l-.36-.47.51-.64c.12.16.24.32.37.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.42,105.83l-.54.49-.21-.63c.17-.17.36-.33.54-.49l.21.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.22,91.53l-.46.5c-.11-.22-.23-.44-.35-.66l.47-.5.34.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.51,81.67l-.41.49-.43-.66c.14-.16.28-.32.41-.49.15.22.29.44.43.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.18,102.58c-.09.21-.17.43-.25.64l-.52-.49.24-.64.53.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,62.22l-.33.44-.59-.59.34-.44c.2.19.39.39.58.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.39,76.55c-.16.22-.32.43-.47.65-.14-.16-.26-.32-.39-.48.15-.22.31-.43.47-.65l.39.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.49,134l-.15.42-.53-.38c0-.14.1-.28.15-.42l.53.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.82,135c-.06.14-.12.27-.19.41l-.49-.38c.06-.13.12-.27.19-.41l.49.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.81,101c-.09.22-.18.43-.26.65l-.52-.5c.09-.21.17-.43.26-.64l.52.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5,132l-.12.44-.57-.39c0-.15.08-.3.12-.45l.57.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.86,104.27l-.53.49-.24-.63.53-.5.24.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.47,99.41c-.1.22-.19.43-.27.65l-.51-.49.27-.65.51.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.16,97.82l-.29.65-.49-.5c.09-.21.18-.43.28-.65l.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,93.14c-.15.17-.31.33-.47.5l-.33-.66.48-.5c.11.22.22.44.32.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.79,68.4l-.54.62c-.13-.15-.24-.31-.36-.46l.54-.62.36.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.18,50.07l-.62.49-.36-.39.63-.49.35.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,133l-.14.44-.55-.39c0-.15.09-.29.14-.44L73,133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.26,102.7l-.52.49c-.08-.21-.16-.42-.25-.64l.53-.49.24.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.82,94.75l-.48.49c-.11-.22-.21-.44-.32-.65l.48-.5.32.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.16,60.47l-.6.58c-.11-.14-.22-.29-.34-.43l.6-.58c.11.14.22.29.34.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.12,76.69q-.18.24-.39.48c-.15-.22-.31-.43-.47-.65l.39-.48c.16.22.32.43.47.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,65.33l-.35.45-.56-.6.35-.45.56.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.64,101.12l-.52.5-.26-.65.51-.49.27.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.57,96.35l-.49.5-.3-.66.49-.5.3.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,99.54l-.51.49-.27-.64.5-.5c.1.21.19.43.28.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.29,98l-.5.49-.29-.65.5-.5.29.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.52,83.27l-.42.49-.42-.66.42-.49.42.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.41,60.59l-.34.44-.59-.58.34-.44.59.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.78,134.94c-.07.14-.14.27-.2.41-.17-.13-.32-.26-.49-.38l.21-.41.48.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9,130.9l-.12.45L68.2,131a4.05,4.05,0,0,1,.12-.47l.58.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.44,51.44l-.62.51-.35-.4.62-.5.35.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.29,48.61l-.62.48-.37-.39.62-.47.37.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.29,78.13c-.16.21-.31.43-.47.65l-.39-.48.46-.66c.13.17.26.33.4.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9,73.21l-.5.64L46,73.37l.5-.64.38.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.83,58.88l-.61.57L54.88,59l.61-.57c.11.15.22.29.34.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.46,134l-.18.42-.52-.38.18-.43.52.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.5,84.87l-.43.5c-.13-.23-.27-.44-.41-.66l.43-.5c.14.22.28.44.41.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.19,63.54c-.19.2-.39.39-.58.6l-.34-.45.57-.6.35.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.75,59l-.34.43-.6-.57c.11-.15.23-.29.34-.43l.6.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7,52.86l-.62.52c-.12-.14-.24-.27-.35-.41.21-.17.42-.34.62-.52.12.14.24.27.35.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.23,78.26l-.4.49-.47-.65c.13-.16.27-.32.4-.49.16.22.31.44.47.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.52,57.32l-.61.56-.34-.42.61-.56.34.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.27,129.77c0,.16-.08.32-.12.47l-.59-.4c0-.16.07-.32.11-.48l.6.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.48,131.92c0,.15-.1.3-.14.45l-.57-.39c0-.15.09-.3.14-.45l.57.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,133l-.15.43c-.18-.13-.36-.26-.55-.38,0-.15.1-.29.16-.44L74,133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.75,134.91l-.22.4-.48-.38.23-.41.47.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.55,69.91l-.53.63c-.13-.15-.25-.31-.37-.47.17-.21.35-.42.53-.62.12.15.24.31.37.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,54.31l-.63.53L60,54.43l.62-.53c.11.14.23.28.35.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.24,55.8c-.21.18-.42.36-.62.55l-.35-.42.62-.55.35.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.38,63.66l-.36.45-.57-.6.35-.45.58.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.9,53c-.11.14-.23.27-.35.41l-.62-.52c.11-.14.23-.27.35-.41l.62.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.32,66.69l-.56.61-.36-.46.56-.61.36.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.45,86.48,135,87l-.39-.66c.15-.16.3-.33.44-.5.14.22.27.45.4.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.22,79.71q-.24.33-.45.66l-.42-.49.45-.66.42.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.43,133.92l-.19.42-.51-.38c.06-.15.12-.29.19-.43l.51.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.56,49.94l-.62.49-.37-.4.62-.48.37.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.43,108.72c-.19.16-.38.32-.56.49l-.21-.62c.19-.16.38-.32.56-.49l.21.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.24,66.81l-.36.46-.56-.61.36-.46.56.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.74,74.76l-.49.64-.39-.48c.17-.21.33-.42.49-.64l.39.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.73,134.87l-.24.41L81,134.9a4.36,4.36,0,0,1,.24-.41l.46.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.82,61.89c-.2.2-.39.4-.59.59-.12-.15-.24-.29-.35-.44l.59-.59c.11.15.23.3.35.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.3,79.85c-.14.16-.28.32-.41.49l-.46-.66.42-.48.45.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.36,88.08l-.45.5-.39-.66c.16-.16.31-.33.46-.5l.38.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.89,130.81c0,.16-.09.31-.14.46l-.57-.4c0-.15.08-.31.13-.46l.58.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.69,48.5l-.62.47-.39-.39.62-.47.39.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.91,107.18l-.55.49c-.08-.21-.15-.42-.23-.62l.56-.49c.07.21.15.42.22.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.79,74.89l-.39.49-.5-.65.39-.48.5.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.76,62l-.35.45-.59-.59.35-.45c.2.2.39.4.59.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,132.89c-.06.15-.12.29-.17.43l-.54-.39c0-.14.11-.29.17-.43l.54.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.18,81.31l-.45.65-.42-.49.44-.66.43.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.71,134.85l-.26.4-.45-.39.26-.4.45.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.39,91.18c-.12.22-.24.43-.36.66l-.47-.51c.12-.22.23-.44.36-.65.15.17.31.33.47.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.82,51.31l-.62.5-.37-.41.63-.49.36.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.47,131.86l-.15.44-.56-.39c0-.16.1-.3.15-.45.19.13.38.26.56.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.25,89.7c-.16.16-.31.33-.47.5-.12-.23-.25-.45-.37-.67l.46-.49.38.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.66,104l-.24.64-.54-.49.24-.64.54.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.34,71.44c-.18.21-.35.42-.52.64l-.39-.48L48,71c.12.16.25.32.38.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.42,133.88l-.21.41-.5-.38.21-.43c.16.14.33.27.5.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.36,105.63l-.54.49-.24-.63.55-.49c.08.21.16.42.23.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.48,60.28l-.6.58c-.12-.15-.24-.29-.35-.44l.59-.58.36.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.27,129.68c0,.16-.09.32-.13.48l-.59-.41c0-.16.09-.32.13-.48l.59.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.27,102.38c-.08.21-.17.42-.26.64l-.53-.49c.08-.22.17-.43.26-.65l.53.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.87,123.78c0,.17-.08.35-.13.52l-.61-.43c0-.18.08-.36.13-.53l.61.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.06,68.19l-.55.61c-.13-.15-.25-.31-.37-.46l.55-.62.37.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.34,81.44l-.42.49-.45-.65.43-.5.44.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.1,91.31l-.48.5-.36-.66.48-.5.36.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.62,76.33c-.17.21-.33.43-.49.64l-.4-.48.48-.65.41.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.79,104.07l-.54.49-.25-.63.54-.5.25.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.68,65.12l-.36.46c-.19-.21-.38-.41-.58-.61l.37-.45.57.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.91,100.8l-.27.64-.53-.5c.09-.21.18-.43.28-.64l.52.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.08,52.71l-.63.52-.36-.41.62-.52.37.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.58,99.21c-.09.21-.19.43-.29.64l-.51-.49c.09-.22.19-.44.29-.66l.51.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.28,97.61l-.3.65-.51-.5.3-.65.51.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.17,82.91c-.15.21-.29.43-.43.65l-.44-.49.43-.66c.14.17.29.33.44.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.17,58.7l-.61.57-.36-.44.61-.56.36.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.92,92.92l-.49.5c-.11-.22-.22-.44-.34-.66l.48-.5.35.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.19,102.5l-.54.49c-.08-.21-.17-.42-.26-.64l.53-.49.27.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.62,128.54c0,.16-.09.32-.13.48l-.6-.42c0-.16.09-.32.14-.48l.59.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.57,125l-.12.51-.62-.43c0-.17.09-.34.13-.51l.61.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,49.82l-.62.48L68,49.9l.63-.48.38.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.92,76.46l-.41.49L132,76.3c.13-.16.27-.32.4-.49l.49.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.71,94.52l-.5.5c-.1-.22-.22-.43-.33-.65l.49-.5.34.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.34,54.16l-.63.52-.36-.41.62-.53c.12.14.25.27.37.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.42,133.83l-.23.42-.49-.39.22-.42.5.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.55,100.92l-.53.49-.27-.64.52-.5c.1.22.19.43.28.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,132.84c-.06.14-.13.28-.19.43l-.53-.39c.06-.15.13-.29.19-.44.18.13.36.26.53.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.88,57.15l-.62.55c-.13-.14-.24-.28-.36-.43l.62-.55a4.82,4.82,0,0,0,.36.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.43,58.81c-.11.14-.23.29-.36.43-.2-.19-.4-.38-.61-.56.12-.15.25-.29.36-.44l.61.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,127.37c0,.17-.09.33-.14.49l-.6-.42c0-.16.08-.33.13-.49l.61.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.27,126.19c0,.17-.09.33-.13.5l-.61-.42c0-.17.09-.34.13-.51l.61.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6,55.64c-.21.17-.41.35-.62.54l-.36-.43.62-.53.36.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.46,96.13c-.16.17-.33.33-.5.5-.1-.22-.21-.44-.32-.65l.5-.51c.11.22.22.44.32.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.89,99.33l-.52.49-.3-.64.52-.5.3.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.19,97.73l-.51.5c-.1-.22-.21-.43-.31-.65l.52-.5.3.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.51,121.18c0,.18-.1.36-.14.54l-.61-.45c0-.18.09-.36.14-.54l.61.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9,130.74c-.05.15-.11.3-.15.46l-.58-.41c0-.15.1-.3.16-.46l.57.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.35,83l-.44.49-.43-.65.44-.5.43.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.51,63.34c-.2.19-.4.39-.59.59l-.36-.45.58-.59.37.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.17,118.5l-.15.57c-.2-.15-.41-.3-.6-.46q.06-.28.15-.57l.6.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.48,131.79c-.06.15-.12.3-.17.44l-.56-.39c.06-.15.12-.3.17-.45l.56.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.16,73l-.52.63-.39-.48.51-.63.4.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.52,77.9l-.48.65-.41-.49.47-.64.42.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.08,63.45l-.37.45-.58-.59.36-.45c.2.2.4.39.59.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.42,133.8l-.24.41-.48-.39.24-.42.48.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.62,66.48l-.57.61c-.13-.15-.25-.31-.37-.46l.56-.61.38.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.22,51.17l-.62.5-.39-.4.63-.5.38.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.83,69.7l-.54.62-.39-.47.55-.62.38.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.33,84.64l-.45.5-.42-.66.45-.5.42.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,78l-.42.49-.47-.66.41-.48L133,78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.29,129.6l-.15.47-.58-.41c0-.16.1-.31.15-.47l.58.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.21,122.42c-.05.18-.09.36-.14.54l-.61-.45c0-.18.09-.35.14-.54l.61.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,132.79c-.07.14-.13.28-.2.43l-.53-.4.21-.43.52.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.15,61.7l-.59.59-.37-.45.6-.58.36.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,66.6l-.37.46-.57-.61.38-.46.56.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.35,108.54l-.56.48c-.08-.2-.15-.41-.23-.62l.57-.48c.08.2.15.41.22.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.44,133.76c-.09.14-.18.28-.26.42l-.47-.39c.08-.14.16-.28.25-.42l.48.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.45,79.49l-.47.65-.42-.49L46,79c.15.16.29.33.43.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.38,49.7l-.63.48-.39-.4.62-.47.4.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.28,86.25l-.46.5-.41-.66.46-.5.41.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.56,117.07c-.06.19-.12.38-.17.57l-.6-.46.16-.58.61.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.48,52.57l-.63.51c-.13-.14-.26-.27-.38-.41l.63-.51c.12.14.25.27.38.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.87,119.78c-.06.18-.11.37-.16.55l-.61-.45c0-.19.1-.37.16-.56l.61.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.92,130.67c0,.15-.11.3-.17.45-.18-.13-.38-.26-.56-.4,0-.16.11-.31.17-.46l.56.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5,131.73c-.07.15-.13.29-.19.44l-.55-.4c.06-.15.13-.29.19-.45l.55.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,74.54l-.51.64-.41-.48.51-.64.41.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.66,128.45c0,.16-.11.32-.15.48l-.6-.42.15-.49.6.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.92,123.66c-.05.17-.1.35-.14.52l-.62-.44.15-.53.61.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.83,60.1l-.61.57-.36-.44.6-.57.37.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.09,79.62c-.14.17-.28.33-.43.49l-.47-.65c.15-.16.29-.33.43-.49.16.22.32.43.47.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.83,107l-.57.49c-.08-.2-.15-.41-.24-.62l.57-.49.24.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,127.27a4.74,4.74,0,0,0-.15.5c-.2-.15-.41-.28-.6-.43,0-.16.09-.33.14-.49l.61.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.62,124.88c0,.17-.1.34-.14.51l-.61-.43c0-.18.09-.35.14-.52l.61.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2,105.33c-.09.21-.17.42-.25.63l-.56-.5.25-.63.56.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,132.74l-.23.43-.51-.4c.07-.14.14-.29.22-.43l.52.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.22,64.8l-.58.6-.38-.46.58-.6.38.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.55,74.67l-.41.48-.51-.64L131,74l.51.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.19,87.86l-.46.5c-.14-.22-.27-.44-.4-.66.15-.17.31-.33.47-.5l.39.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.46,133.73l-.28.42-.46-.4.27-.41.47.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.32,126.08l-.15.5-.61-.42.15-.51.61.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.73,54l-.63.53-.37-.42c.2-.18.41-.35.62-.52.13.14.26.27.38.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.53,58.52l-.61.57-.37-.44c.2-.19.4-.38.61-.56l.37.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.63,71.23l-.54.63-.39-.48.53-.63.4.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,55.47c-.21.18-.42.37-.63.54L61,55.59l.62-.54.38.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.41,81.08l-.45.66-.44-.5.45-.65.44.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.26,57l-.63.55c-.12-.14-.25-.28-.37-.43l.62-.55c.12.15.25.29.38.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.79,103.76c-.09.21-.18.42-.26.63L47,103.9c.08-.21.17-.43.26-.64l.55.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.37,68l-.56.61-.39-.47.56-.61.39.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.38,64.91l-.38.46-.58-.6c.12-.15.25-.3.37-.46l.59.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.27,105.44l-.56.49-.25-.63.56-.49.25.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.58,91c-.13.22-.26.44-.38.66l-.48-.51.37-.65.49.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.08,89.47l-.48.5-.38-.66c.16-.16.32-.33.47-.5.14.22.26.44.39.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.64,51.05l-.62.49-.4-.4.63-.49.39.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.33,129.52c-.06.16-.11.32-.17.47l-.58-.41c.06-.16.11-.32.17-.47l.58.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.57,121l-.15.55-.62-.45c.05-.18.1-.37.16-.55l.61.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,115.61c-.07.2-.13.39-.18.58l-.6-.47c.05-.19.11-.38.18-.58l.6.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.88,76.11l-.5.64L47,76.27c.16-.22.33-.43.5-.65l.41.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.53,131.67l-.2.44-.54-.4c.06-.15.14-.3.2-.45.19.14.37.27.54.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.13,81.21c-.15.17-.29.34-.44.5l-.46-.66c.15-.16.3-.32.44-.49l.46.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.21,68.1c-.13.15-.25.31-.38.47l-.56-.62.39-.47.55.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.68,103.87l-.55.5c-.08-.21-.17-.43-.26-.64l.55-.49c.09.21.18.42.26.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.94,91.09c-.17.16-.33.33-.49.5l-.38-.66.49-.5.38.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.06,132.69l-.24.43-.5-.39c.07-.15.15-.29.23-.44l.51.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.25,118.36c-.06.19-.12.38-.17.56l-.61-.46c.06-.18.11-.37.17-.56l.61.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.81,49.6l-.62.47c-.14-.13-.28-.26-.41-.4l.62-.47.41.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,130.6l-.18.46-.57-.41.19-.46.56.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.85,63.14c-.2.2-.39.4-.59.59l-.38-.45.59-.59.38.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.74,99c-.11.22-.21.43-.31.65l-.53-.5c.1-.22.21-.43.31-.65l.53.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.07,102.3l-.54.49c-.1-.21-.19-.42-.28-.63l.54-.5c.09.21.19.42.28.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4,82.68l-.44.66-.45-.5c.15-.22.29-.44.44-.65l.45.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.76,92.7c-.16.17-.33.33-.5.5-.12-.22-.23-.44-.36-.65l.5-.51.36.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.68,76.24l-.42.48-.5-.64.42-.49.5.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.71,128.36l-.17.48-.59-.42c0-.16.11-.32.17-.48l.59.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.43,100.71l-.54.5c-.1-.21-.2-.43-.29-.64l.53-.5.3.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.28,122.3c-.05.18-.11.35-.16.53l-.61-.44c.05-.18.1-.36.16-.54l.61.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.55,94.31l-.5.5-.35-.65.51-.51.34.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9,52.44c-.21.16-.42.34-.63.51l-.4-.42.63-.5c.14.13.26.27.4.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.75,99.12l-.53.5-.3-.65.53-.5.3.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.32,95.92l-.52.5-.33-.65.51-.51.34.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.05,97.52l-.52.5c-.11-.21-.22-.43-.32-.65l.52-.5c.11.22.22.43.32.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.45,72.77c-.17.21-.35.42-.52.64l-.41-.49.52-.63.41.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.14,82.81l-.45.5-.45-.65.45-.5.45.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,66.28l-.57.61L52,66.42l.57-.61.39.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1,132.66c-.09.14-.17.28-.25.42l-.5-.4.25-.43.5.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4,114.14c-.06.19-.13.39-.19.59l-.6-.48c.06-.2.13-.39.19-.59l.6.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.52,61.52l-.61.58-.38-.45.61-.58.38.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.79,77.69c-.17.21-.33.43-.49.64-.15-.16-.29-.33-.43-.49.16-.21.32-.43.49-.64l.43.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.06,127.18c-.06.16-.12.33-.17.49l-.6-.42c0-.17.11-.34.17-.5l.6.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,123.54l-.16.52-.61-.44c.05-.17.1-.35.16-.53l.61.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.42,84.29,46,85l-.46-.5.43-.66c.16.16.31.33.46.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.58,131.62c-.08.14-.15.29-.22.44l-.53-.41.22-.44.53.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.15,69.49l-.56.62-.39-.47c.18-.21.36-.42.55-.62l.4.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.38,126c0,.17-.11.34-.16.5l-.61-.43c.06-.17.11-.34.17-.5l.6.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.69,124.77c0,.17-.11.34-.16.51l-.61-.43c0-.18.11-.35.16-.52.21.14.41.29.61.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.15,53.86l-.63.52L64.13,54l.63-.52.39.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,119.64c-.05.19-.11.37-.17.56l-.61-.46c.06-.18.11-.37.17-.56l.61.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.39,129.45c-.07.15-.13.31-.19.47l-.57-.42c.05-.16.12-.31.18-.47l.58.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.64,66.39c-.12.16-.26.31-.39.47l-.57-.61.39-.46.57.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.08,50.93c-.21.17-.41.33-.63.49L69,51l.63-.49.41.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.66,116.92c-.07.19-.13.38-.19.57l-.61-.46c.06-.19.12-.39.19-.58l.61.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.77,77.81l-.43.5c-.16-.22-.32-.44-.49-.65.14-.17.29-.33.43-.49l.49.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,130.53l-.21.46-.55-.41c.07-.15.13-.31.2-.46l.56.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.21,59.92l-.61.57c-.13-.15-.26-.29-.38-.44.2-.2.4-.39.61-.57l.38.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.12,84.42l-.46.5-.44-.66c.16-.16.31-.33.46-.5l.44.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.44,69.61l-.4.48-.55-.63.4-.47.55.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.15,132.62l-.27.43-.49-.4.27-.44.49.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.47,85.9l-.42.66c-.16-.17-.31-.34-.47-.5L46,85.4c.16.17.31.34.47.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.93,58.35l-.62.56-.39-.43.62-.56.39.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.66,56.82l-.63.55c-.13-.15-.25-.29-.39-.43l.63-.55.39.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.86,112.65l-.21.59-.6-.48c.07-.2.14-.4.22-.6l.59.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3,74.33l-.51.64-.42-.49.51-.64.42.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.57,64.6l-.58.6c-.14-.15-.27-.3-.4-.46l.59-.6.39.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.64,131.57l-.24.44-.52-.41c.07-.15.15-.29.23-.44l.53.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.07,86c-.16.17-.32.33-.47.5-.14-.22-.28-.44-.43-.66.16-.17.32-.33.47-.5.15.22.29.44.43.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.78,128.28l-.19.48-.58-.42.18-.49.59.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.67,120.92l-.18.54-.61-.45c0-.19.11-.37.17-.55l.62.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.71,106.81l-.57.49c-.09-.21-.18-.41-.26-.62l.57-.5.26.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.21,132.59c-.1.14-.2.28-.29.43l-.48-.41.29-.43.48.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,64.71l-.4.47-.59-.6.4-.46.59.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.35,105.14l-.27.63-.56-.5c.09-.21.18-.42.26-.63l.57.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.84,79.4c-.14.17-.29.33-.44.49l-.48-.65c.15-.16.3-.32.44-.49l.48.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.34,52.31l-.63.51-.41-.42.63-.5c.13.14.27.27.41.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.27,74.45l-.42.49c-.17-.22-.34-.43-.52-.64l.42-.49.52.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,71l-.55.63L50,71.17l.55-.63L51,71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.71,67.77l-.57.62-.4-.47.57-.61.4.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.08,115.46c-.07.19-.13.39-.19.58l-.61-.47c.06-.2.13-.39.2-.58l.6.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,87.64c-.16.17-.32.33-.48.51-.14-.23-.28-.44-.42-.66l.49-.51c.13.22.27.44.41.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.08,130.47l-.21.46-.55-.41c.07-.15.14-.31.22-.46l.54.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.36,118.22c-.06.19-.13.38-.19.56l-.61-.46.18-.57.62.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.46,129.38c-.07.15-.13.31-.2.47l-.57-.42c.06-.16.13-.32.2-.47l.57.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.14,127.09l-.19.49-.59-.43.18-.49.6.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.38,122.18l-.18.53-.61-.45c0-.18.11-.36.17-.54l.62.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.35,111.14c-.08.2-.16.4-.23.6l-.59-.48.22-.61.6.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.14,105.25l-.57.5c-.08-.21-.18-.42-.27-.63l.57-.5.27.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,103.57c-.1.21-.2.42-.29.63l-.56-.49.28-.64.57.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.27,132.56,83,133l-.47-.41.3-.43.47.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.23,63l-.6.59c-.13-.16-.27-.31-.4-.46l.6-.59c.13.15.27.3.4.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.54,50.83l-.63.48-.42-.41.62-.48.43.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.89,67.89l-.4.47-.57-.61.4-.47.57.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.64,71.14l-.41.48-.55-.63.41-.48.55.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7,131.52l-.25.44-.51-.4.25-.45.51.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8,90.75l-.39.65-.5-.5.39-.66.5.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.88,89.26c-.17.16-.33.33-.49.5-.14-.22-.27-.44-.4-.66.16-.17.32-.34.49-.5.13.22.26.44.4.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.47,125.88l-.18.51-.6-.44a5,5,0,0,1,.18-.5l.6.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.09,123.43l-.18.52-.61-.44c.05-.18.11-.36.17-.53l.62.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.18,75.89l-.51.65c-.14-.17-.28-.33-.43-.49l.51-.64.43.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.59,53.73l-.63.52-.41-.43.63-.51c.14.13.27.28.41.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.79,124.66a4.56,4.56,0,0,0-.18.52l-.61-.44a4.56,4.56,0,0,1,.18-.52c.2.15.4.3.61.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.54,103.68l-.56.5c-.09-.21-.18-.42-.28-.63l.56-.5.28.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.88,81l-.45.5c-.16-.22-.32-.43-.47-.65l.45-.5c.16.22.31.44.47.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.74,90.87l-.5.51-.39-.66.5-.51.39.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.91,61.34l-.61.58c-.13-.15-.27-.3-.39-.46l.61-.57.39.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.92,102.1l-.55.5-.3-.64.55-.5c.1.21.21.43.3.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.39,76l-.43.49-.51-.64.43-.49c.18.21.35.42.51.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.87,128.2c-.08.16-.14.32-.21.48l-.58-.42c.06-.17.13-.33.2-.49l.59.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.54,114c-.07.2-.15.39-.22.59l-.6-.47.21-.6c.2.17.4.32.61.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.07,119.51c-.06.19-.13.37-.19.55l-.62-.45c.07-.19.13-.38.19-.56l.62.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.32,66.08l-.59.61-.4-.47.58-.6.41.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.56,92.49c-.17.16-.33.33-.5.5-.13-.22-.25-.44-.38-.65l.51-.51c.13.22.25.44.37.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.17,130.42c-.08.15-.17.3-.24.45l-.54-.41c.07-.15.15-.31.23-.46l.55.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.27,100.51l-.55.51c-.1-.22-.21-.43-.31-.65l.55-.5c.1.21.2.43.31.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.78,131.48l-.27.44-.5-.41c.08-.15.18-.29.27-.44l.5.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.78,72.56l-.54.64-.42-.49.54-.63c.13.16.28.32.42.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.62,59.75l-.62.57-.4-.45.62-.57.4.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.36,94.1l-.51.51c-.12-.22-.24-.44-.37-.66l.52-.51c.12.22.25.44.36.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.09,56.67l-.63.54c-.14-.14-.27-.29-.4-.43l.62-.54.41.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.58,98.92l-.54.5c-.1-.21-.21-.43-.32-.64l.54-.51c.11.22.22.43.32.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.35,58.19l-.62.56c-.14-.15-.28-.29-.41-.44l.62-.56.41.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.78,116.78c-.07.19-.14.38-.2.57l-.61-.47c.06-.19.13-.38.2-.58l.61.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.13,95.71l-.52.51-.35-.66.52-.5c.12.22.24.43.35.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.55,129.31c-.08.16-.15.31-.22.47l-.57-.42c.07-.16.15-.31.22-.47l.57.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.87,97.32l-.53.5-.34-.65.54-.5.33.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5,69.29c-.19.21-.38.41-.56.62-.15-.16-.28-.32-.42-.48.18-.21.38-.41.56-.62l.42.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8,52.19l-.63.51c-.14-.15-.28-.28-.42-.42l.62-.5.43.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.89,82.59l-.46.51-.46-.66.46-.5.46.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.3,66.2l-.41.46-.58-.6c.13-.16.27-.31.41-.47.19.2.39.4.58.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,50.73l-.62.48L72,50.8c.21-.16.41-.33.62-.48l.44.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.11,69.41l-.42.47-.56-.62.42-.47c.19.2.37.41.56.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.24,127c-.07.17-.14.33-.2.5l-.6-.43c.07-.17.13-.34.2-.5l.6.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.79,120.79c-.07.18-.13.36-.2.55l-.61-.46c.06-.18.12-.36.19-.55.2.16.41.31.62.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.87,131.45c-.1.14-.2.29-.29.44l-.5-.42c.1-.15.2-.29.29-.44l.5.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.49,77.6c-.15.16-.3.32-.44.49l-.51-.65L130,77l.5.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,64.42l-.6.59-.4-.46.59-.6.41.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,112.49c-.08.2-.16.39-.23.59l-.6-.48.23-.6.6.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.87,84.2l-.47.51-.45-.66c.15-.17.32-.33.47-.5l.45.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.26,130.37l-.26.45-.53-.42.25-.45.54.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.58,125.79c-.07.17-.14.34-.2.5l-.6-.43.2-.51.6.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5,122.06c-.07.18-.13.36-.19.54l-.62-.46c.06-.18.13-.35.19-.53l.62.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.05,53.6l-.63.52L67,53.69l.63-.51.42.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.67,64.52l-.41.47-.6-.6.41-.46.6.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.64,74.12l-.53.64-.44-.49.53-.64.44.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9,124.56c-.07.17-.13.34-.2.52l-.6-.45c.06-.17.12-.34.19-.51l.61.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.21,123.32c-.07.17-.14.35-.2.52l-.61-.44c.06-.18.12-.36.19-.53l.62.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,128.13c-.08.16-.15.32-.22.48l-.58-.43.22-.48.58.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.49,118.09c-.06.18-.13.37-.2.56l-.62-.47c.07-.19.14-.37.21-.57l.61.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,131.41l-.3.44c-.16-.14-.32-.28-.49-.41l.3-.45.49.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.23,115.31c-.07.2-.15.39-.22.59l-.61-.48c.07-.2.14-.39.22-.58l.61.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.65,129.25l-.24.47c-.18-.15-.37-.29-.56-.43l.24-.47.56.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.55,106.63l-.58.49c-.08-.2-.18-.41-.27-.62l.58-.5.27.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.09,67.58c-.2.2-.39.41-.58.61l-.42-.47c.19-.21.39-.41.58-.61l.42.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.82,85.81l-.48.51c-.15-.22-.3-.44-.44-.66l.48-.5c.15.21.3.43.44.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.63,62.78l-.6.58-.41-.45.6-.59.41.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.54,105l-.29.63-.57-.5c.09-.21.18-.42.28-.63l.58.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.31,70.82c-.19.21-.37.42-.56.62L51.33,71l.55-.62.43.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,74.24l-.44.49-.53-.64.44-.48.53.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.82,87.31c-.15.21-.29.43-.43.65l-.49-.5c.14-.23.28-.44.43-.66l.49.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.27,52.09l-.62.49c-.15-.13-.3-.28-.44-.42l.63-.49.43.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.55,79.18c-.14.17-.3.34-.45.5l-.49-.65.45-.49c.17.21.33.43.49.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.51,111l-.24.6-.6-.49.24-.6.6.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.53,67.69l-.41.48-.58-.62.42-.47.57.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.36,130.32l-.27.45-.53-.41.27-.46.53.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.06,131.39l-.32.43-.47-.42c.1-.14.2-.29.31-.43l.48.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.3,70.94l-.42.48-.56-.63.43-.48.55.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,105.07l-.57.5c-.09-.22-.19-.42-.29-.63l.58-.5.28.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.34,61.17l-.62.57-.41-.45.61-.58.42.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.74,87.43l-.49.5-.43-.65.5-.51.42.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.35,126.93l-.21.48c-.2-.14-.4-.28-.59-.43.06-.17.14-.33.21-.49l.59.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.21,119.38l-.21.56-.61-.47c.06-.18.13-.37.2-.55l.62.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.06,59.59l-.63.56L60,59.7l.62-.56.42.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.79,58l-.62.55-.42-.44.63-.55.41.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.52,75.69c-.17.21-.35.42-.52.64l-.45-.49c.17-.22.35-.43.52-.64l.45.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.06,90.54c-.14.22-.27.44-.4.66l-.51-.51c.13-.22.26-.44.4-.66l.51.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.16,131.36l-.33.44-.46-.42c.1-.15.22-.29.33-.44l.46.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.37,103.49l-.57.5-.3-.63.57-.5.3.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.63,89l-.5.51c-.13-.22-.27-.44-.41-.66l.5-.5c.14.21.28.43.41.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7,113.83c-.08.2-.16.39-.23.59l-.61-.48.23-.59.61.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.72,65.9l-.59.6L54.71,66l.59-.6.42.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.76,129.19l-.25.47-.55-.43.25-.47.55.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.59,80.78l-.46.5-.49-.65c.16-.17.32-.33.47-.5l.48.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.09,128.06c-.09.16-.16.32-.24.48l-.57-.43c.08-.16.15-.32.23-.49l.58.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.94,116.64l-.22.57-.62-.47.22-.58.62.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.53,53.48,68.9,54l-.44-.43.63-.51.44.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.71,125.7l-.22.51-.6-.44c.07-.17.14-.34.22-.51l.6.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.47,130.28c-.1.15-.19.3-.28.45l-.52-.42c.09-.15.19-.3.28-.46l.52.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.08,75.81l-.45.49c-.17-.21-.35-.42-.52-.64l.45-.49c.17.21.35.42.52.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.93,120.67l-.21.55-.62-.46.21-.55.62.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.73,101.91l-.56.51c-.1-.22-.21-.43-.32-.64l.57-.51c.1.22.21.43.31.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.5,90.66l-.51.51c-.14-.22-.27-.44-.41-.65l.51-.52.41.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.92,66l-.42.47-.59-.6.42-.47.59.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.07,100.32l-.56.51c-.1-.22-.22-.43-.33-.65l.56-.5.33.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.77,52l-.63.49-.45-.42.63-.5c.14.15.3.29.45.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,124.47c-.08.17-.15.34-.22.51l-.6-.44.21-.52.61.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.33,92.28l-.52.51-.39-.66.52-.51.39.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.64,122l-.21.53-.61-.45q.09-.27.21-.54l.61.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.35,123.22c-.07.17-.15.35-.21.52l-.62-.45.21-.53.62.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.38,98.72l-.55.51-.34-.65.55-.5.34.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.14,93.89l-.53.51c-.13-.21-.26-.43-.38-.65l.53-.51c.12.22.25.44.38.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.47,72.48,127,73l-.55-.63.44-.49.55.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.38,64.24c-.21.19-.41.39-.6.59a6.14,6.14,0,0,1-.42-.47l.6-.59c.13.16.27.31.42.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.66,97.12l-.54.51-.36-.65.55-.51c.11.22.23.43.35.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.74,69.21l-.42.48c-.19-.21-.38-.42-.58-.62l.44-.48c.19.21.38.41.56.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.91,95.51l-.53.51-.37-.65.53-.51c.13.21.25.43.37.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.6,82.38l-.47.51-.48-.66.48-.5c.16.22.32.43.47.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.59,130.24l-.3.45-.51-.42.3-.46.51.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.19,112.33c-.08.2-.17.4-.24.6l-.61-.49.24-.6.61.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.88,129.14l-.26.46-.55-.42.27-.47.54.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.49,126.85l-.24.49-.58-.44c.07-.16.15-.33.23-.49l.59.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.66,118c-.08.18-.15.37-.23.56l-.61-.47c.07-.19.14-.38.22-.57l.62.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.27,64.34l-.43.47-.6-.6.43-.46.6.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.17,77.39l-.46.5-.51-.65.46-.5.51.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4,115.17c-.08.19-.15.39-.23.58-.2-.16-.41-.31-.61-.48.07-.19.15-.38.23-.58l.61.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.22,128c-.09.16-.17.32-.25.48L73.4,128l.25-.48.57.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.07,62.61l-.61.58L58,62.73l.61-.58c.14.15.29.3.43.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.58,84l-.48.51-.47-.66.49-.5c.16.21.31.43.46.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.72,130.21l-.32.45-.5-.43.32-.45.5.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.78,61l-.62.58-.42-.46.62-.57.42.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.85,125.62c-.08.17-.15.34-.23.5l-.59-.44c.07-.17.15-.34.23-.51l.59.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.38,119.26l-.23.56-.61-.47c.07-.18.14-.37.22-.56l.62.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.36,106.45l-.58.5-.29-.62.59-.5c.09.21.19.41.28.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.52,59.43l-.63.56-.43-.45.63-.56.43.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.15,67.5l-.44.48c-.19-.21-.38-.41-.58-.61l.43-.48.59.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.71,110.82c-.09.2-.18.4-.26.6l-.61-.49.26-.6.61.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.76,104.78l-.3.63-.58-.5q.13-.31.3-.63c.19.17.38.34.58.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,129.09l-.29.46-.53-.43.28-.46.54.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.53,85.6l-.49.51-.45-.65.49-.51c.16.22.3.44.45.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.85,130.18l-.33.45L82,130.2l.34-.45.48.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.23,79l-.46.5-.51-.65.47-.5c.17.22.34.43.5.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.93,70.74l-.44.48-.57-.62c.16-.16.3-.32.45-.48l.56.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.19,124.38c-.08.17-.16.34-.23.51l-.6-.45c.07-.17.15-.34.23-.51l.6.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1,120.56c-.08.18-.16.36-.23.54l-.62-.46c.07-.18.15-.36.23-.55l.62.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.77,104.89l-.58.5-.3-.63.58-.5.3.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.63,126.78c-.08.16-.17.32-.25.49l-.57-.44.24-.49c.2.14.39.29.58.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.12,116.5c-.08.2-.16.39-.23.58l-.62-.48c.07-.19.15-.38.23-.57l.62.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.39,103.21c-.11.21-.22.42-.32.63l-.58-.5c.11-.21.21-.43.32-.64l.58.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.51,123.12c-.08.17-.15.35-.23.52l-.61-.45c.07-.18.15-.35.23-.53l.61.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.81,121.84c-.08.18-.16.36-.23.54l-.61-.46c.07-.18.14-.36.22-.54l.62.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.89,113.69c-.08.19-.16.39-.25.58l-.61-.48c.08-.2.17-.39.25-.59l.61.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.36,127.93l-.27.48-.55-.43c.08-.16.17-.32.26-.48l.56.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.14,65.72c-.2.19-.4.4-.59.6l-.44-.47q.3-.31.6-.6l.43.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.46,87.22l-.51.51c-.14-.22-.29-.44-.44-.65l.51-.52.44.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,130.16l-.34.44-.48-.43.35-.45.47.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.25,109.29c-.09.2-.19.4-.28.61l-.6-.5.27-.61.61.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.51,65.82c-.14.16-.29.31-.44.47l-.59-.6.43-.47.6.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.15,103.31l-.57.51c-.11-.21-.21-.42-.32-.64l.58-.5.31.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.17,129.05c-.11.15-.21.3-.31.46l-.52-.43.3-.47.53.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.36,90.34c-.14.22-.29.44-.42.66l-.52-.51c.13-.22.27-.44.41-.66l.53.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.35,88.84l-.51.51c-.14-.22-.28-.44-.43-.66.17-.17.35-.33.52-.51l.42.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.27,80.57l-.48.51-.49-.65.47-.51.5.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.54,53.27l-.63.51c-.16-.14-.31-.29-.46-.44l.63-.5.46.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.14,130.14l-.36.44-.47-.43.36-.45.47.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.73,75.6l-.46.5-.54-.64c.16-.16.31-.33.46-.49l.54.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.51,101.73l-.57.5-.33-.63.57-.51.33.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,125.54l-.24.5-.59-.44.24-.51.59.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.84,117.83c-.08.19-.16.37-.23.56l-.62-.47c.07-.19.15-.38.23-.57l.62.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.22,90.46l-.52.51-.42-.65c.18-.17.35-.35.52-.52.14.22.29.44.42.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.29,130.12l-.38.44-.45-.43.37-.45.46.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.35,69l-.44.49-.58-.62.44-.48.58.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.84,64.17l-.44.46-.61-.59.44-.46.61.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.84,100.13l-.57.51-.34-.64.56-.51.35.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.09,72.28l-.45.49-.56-.63c.15-.16.31-.32.46-.49l.55.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.81,107.74l-.29.62-.6-.5.29-.62.6.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4,112.18c-.08.21-.17.4-.26.6l-.61-.49c.08-.2.17-.4.26-.6l.61.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.52,127.88c-.1.16-.19.32-.28.48l-.56-.44.29-.48.55.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.06,92.08l-.53.51c-.13-.22-.27-.44-.41-.65l.53-.51c.14.21.28.43.41.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.53,62.44l-.62.58-.43-.46.61-.58.44.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.32,129l-.32.46-.51-.44.31-.46.52.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.44,130.11l-.39.44-.44-.43.39-.45.44.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8,126.71l-.27.49-.57-.44c.08-.17.18-.33.26-.49l.58.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.14,98.53l-.56.51-.36-.64.56-.51.36.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.61,115c-.09.19-.17.38-.25.57-.21-.15-.42-.32-.62-.48.08-.19.16-.39.25-.58l.62.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.87,93.7l-.54.51-.39-.65.54-.52.39.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.41,96.92l-.55.52-.37-.65.55-.51c.12.21.24.43.37.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.26,60.85l-.63.57L61.19,61l.63-.57c.14.16.29.31.44.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.28,82.18l-.49.5L128.3,82l.49-.51.49.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.65,95.31l-.54.51-.38-.64.54-.52c.13.22.26.43.38.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.37,124.29c-.09.17-.17.34-.25.51l-.6-.45c.08-.17.16-.34.25-.51l.6.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.57,119.14c-.09.19-.17.37-.24.56l-.62-.47c.07-.19.15-.37.24-.56l.62.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.79,54.69l-.63.52-.47-.44.64-.52.46.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.81,77.18c-.15.17-.31.34-.47.5-.17-.21-.35-.42-.52-.64.15-.17.31-.33.47-.5l.52.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.69,123c-.08.18-.16.35-.25.53l-.6-.46.24-.52.61.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4,106.19c-.1.2-.21.41-.3.62l-.6-.51c.1-.2.2-.41.31-.62l.59.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.29,120.45,64,121l-.61-.46.24-.55.62.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,121.74l-.25.54-.61-.46.24-.54.62.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.48,129l-.33.46c-.17-.14-.33-.29-.51-.43l.33-.47.51.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.73,67.32l-.45.48-.59-.61.44-.48.6.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.93,110.67l-.27.6-.61-.49.27-.61.61.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.26,83.79c-.17.16-.33.33-.5.51l-.47-.66.5-.51.47.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.69,127.83l-.3.47-.54-.43c.09-.16.19-.32.29-.48.19.14.37.29.55.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.14,106.28l-.59.5-.31-.62.6-.5.3.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.19,125.47c-.09.17-.18.33-.26.5l-.59-.45.27-.5.58.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.33,116.38l-.25.57-.62-.48c.08-.19.16-.39.25-.58.21.16.42.32.62.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,104.61c-.1.22-.21.42-.31.63l-.59-.5c.1-.21.2-.42.31-.63l.59.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.53,70.55l-.46.48-.57-.62c.15-.16.31-.32.45-.48.2.2.39.41.58.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,126.65c-.09.16-.19.32-.28.49l-.57-.45.29-.49.56.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,56.14l-.64.53-.45-.44.63-.53.46.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.11,113.55c-.09.19-.17.39-.26.58l-.62-.48.27-.59.61.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.65,128.94c-.12.15-.23.31-.34.46l-.5-.44c.11-.15.23-.3.34-.46l.5.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.88,78.77l-.48.51-.52-.65.48-.5c.17.22.35.43.52.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.21,85.4l-.5.51-.47-.65.51-.51.46.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.54,104.71l-.59.51-.32-.63.59-.5c.11.21.21.42.32.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.07,65.64l-.45.48-.6-.6c.14-.16.3-.31.45-.47l.6.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.56,124.21c-.1.17-.18.34-.27.51l-.59-.45c.08-.17.17-.34.26-.52l.6.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.49,109.13c-.1.21-.19.41-.29.61l-.61-.5c.1-.2.2-.4.29-.61l.61.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.83,128.92c-.12.15-.25.3-.36.46l-.49-.45.36-.46.49.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.87,127.78l-.32.48-.53-.44.31-.48.54.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.06,117.71c-.09.19-.18.37-.26.56l-.62-.47c.08-.19.17-.38.26-.57l.62.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.32,54.59l-.63.51-.47-.44.63-.51.47.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.14,87l-.52.51c-.14-.22-.3-.43-.45-.65l.52-.51.45.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.91,103.14l-.59.5L126,103l.58-.51c.12.21.23.43.34.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,62.29l-.63.58-.45-.47.63-.58c.14.16.3.31.45.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,128.9l-.38.45-.47-.44.37-.46.48.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.76,60.7l-.63.57-.46-.46.63-.57.46.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.89,122.94c-.09.17-.17.34-.26.52L68,123c.08-.18.17-.35.26-.53l.6.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.78,119c-.08.19-.17.37-.26.55l-.61-.47c.08-.18.16-.37.25-.55l.62.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.34,75.41c-.16.16-.31.33-.47.5-.18-.22-.36-.43-.55-.64l.48-.5.54.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.92,68.83l-.46.49-.58-.62.45-.48.59.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.91,80.37l-.49.51-.51-.65.49-.5.51.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.39,125.4l-.28.5-.58-.45.28-.5.58.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.16,126.59l-.3.49-.56-.45.3-.49.56.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.64,112c-.09.2-.18.4-.28.6l-.61-.5.27-.59.62.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.84,114.9c-.1.2-.18.39-.27.58L59,115a6.11,6.11,0,0,1,.27-.58l.62.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,88.64l-.53.51-.44-.65.53-.51c.15.21.29.43.44.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.25,101.55l-.58.51c-.11-.22-.23-.43-.35-.64l.58-.51c.12.21.24.42.35.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.21,121.65c-.09.18-.18.35-.26.53l-.62-.46.26-.54.62.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5,120.35l-.26.54-.61-.47.25-.54.62.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.19,128.88l-.39.46-.46-.45c.12-.15.26-.3.38-.46l.47.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.68,72.09l-.46.49-.57-.62.47-.49c.19.2.38.41.56.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.07,107.58c-.1.21-.2.41-.31.62l-.6-.5c.1-.21.2-.41.31-.62l.6.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.84,91.77l-.42.65-.54-.51.42-.65.54.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.05,127.74l-.33.48-.52-.45.33-.47.52.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.91,90.26c-.18.17-.36.34-.53.52l-.44-.66.54-.51.43.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.57,100l-.58.51c-.11-.21-.23-.42-.36-.64l.58-.51.36.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.38,128.87l-.41.45-.45-.44c.13-.16.27-.31.4-.46l.46.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.56,56l-.63.53-.47-.45.63-.53.47.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.48,107.68l-.6.5c-.1-.21-.2-.41-.31-.62l.61-.5.3.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.75,91.88l-.54.52-.42-.65.54-.52.42.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.86,98.35l-.57.51-.37-.64.57-.52.37.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.57,93.5,128,94c-.13-.22-.27-.43-.41-.65l.55-.52.41.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.12,96.74l-.56.51c-.13-.21-.26-.43-.38-.65l.56-.51c.13.22.26.43.38.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.92,82l-.5.51c-.17-.22-.33-.44-.5-.65l.5-.51.5.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.36,95.12l-.56.52-.39-.65.55-.52.4.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.77,124.14a4.91,4.91,0,0,0-.28.5l-.6-.45c.1-.17.19-.35.28-.52l.6.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.28,67.14l-.46.48-.6-.6.46-.48.6.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.57,116.25q-.15.28-.27.57l-.63-.48.27-.57.63.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.67,106c-.11.21-.21.42-.32.62l-.6-.5c.11-.21.21-.42.32-.62l.6.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.25,127.71l-.34.47-.52-.45c.11-.16.22-.32.34-.47l.52.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.43,77l-.49.5c-.17-.21-.36-.42-.53-.64l.48-.5.54.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.36,126.54c-.1.16-.21.32-.31.49l-.55-.45c.1-.17.21-.33.31-.49l.55.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.19,110.52l-.29.6c-.21-.16-.41-.33-.61-.5.09-.2.19-.4.29-.6l.61.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8,57.51l-.63.54-.47-.46.63-.53.47.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.59,125.34l-.29.49-.58-.45.3-.5.57.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.36,113.41c-.09.2-.19.39-.28.59l-.62-.49c.1-.2.19-.39.28-.59l.62.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.89,106.12l-.6.5c-.11-.2-.22-.41-.32-.62l.6-.5c.11.2.21.41.32.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.1,70.36l-.47.49-.59-.61.47-.49.59.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.11,122.85c-.09.17-.18.35-.28.52l-.6-.46c.09-.17.18-.35.28-.52l.6.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.9,83.59l-.51.51-.49-.65c.17-.17.35-.34.51-.51.17.21.33.43.49.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.29,117.59l-.27.56-.62-.47.27-.57.62.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3,104.45l-.33.63-.6-.51.33-.63.6.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.45,127.68l-.36.47-.5-.45c.12-.16.23-.32.36-.47.17.14.33.3.5.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.79,63.75l-.61.58-.47-.47.62-.59.46.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.43,121.56l-.27.53-.61-.47.27-.53c.21.15.41.31.61.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,118.93c-.09.18-.19.36-.27.55l-.62-.48.27-.55.62.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.28,60.56l-.63.57c-.16-.16-.32-.31-.47-.47l.63-.56.47.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.53,62.14l-.63.58-.46-.48c.21-.19.42-.37.62-.57.16.16.31.32.47.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.73,120.25l-.27.54-.62-.47c.09-.18.19-.36.28-.55l.61.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.12,55.93l-.64.52L71,56l.63-.52.49.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.27,104.55l-.6.5-.33-.62.6-.51.33.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.58,126.49l-.33.49-.55-.45L78,126l.55.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.49,78.58l-.5.51c-.17-.22-.35-.43-.53-.65.17-.16.33-.33.5-.5l.53.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.76,109l-.3.61-.62-.5c.11-.2.21-.41.31-.61l.61.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.86,85.2l-.52.52-.48-.65.52-.52.48.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,102.87c-.12.21-.24.42-.35.63L53,103c.11-.21.23-.42.35-.63l.59.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.66,127.65l-.37.47-.5-.45c.13-.16.25-.32.38-.47l.49.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,124.06l-.3.51-.59-.46.3-.51.59.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.09,114.78c-.1.19-.19.38-.28.58l-.62-.49a6.19,6.19,0,0,1,.28-.58l.62.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.81,125.28l-.31.49-.56-.45c.1-.17.2-.34.31-.5l.56.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.46,68.66l-.47.48-.59-.61.47-.48c.2.2.4.4.59.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.91,111.9l-.3.6L58,112l.3-.59.62.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.63,103l-.6.51c-.11-.21-.23-.43-.35-.63l.6-.52.35.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.88,127.63l-.39.47-.49-.46.39-.47.49.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.79,86.83l-.53.51-.47-.65.53-.52.47.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.92,75.22l-.48.5-.56-.63.49-.5.55.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.35,57.4l-.63.53-.49-.46.64-.53.48.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8,126.45l-.35.48-.53-.45.34-.49.54.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.24,71.91l-.47.49-.58-.62.48-.49.57.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.36,107.43c-.11.21-.22.41-.32.62l-.61-.51.32-.62.61.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.52,80.18l-.5.51L125.5,80l.5-.51.52.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1,127.61l-.4.47-.48-.46.4-.47.48.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,101.37l-.59.52-.36-.64.59-.51.36.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.35,122.78l-.3.52-.59-.47.29-.52.6.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.69,88.45l-.54.51-.46-.65.54-.51c.16.21.31.43.46.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.82,116.13c-.09.2-.19.38-.28.57l-.63-.48.29-.57.62.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.32,127.6l-.42.47-.46-.46c.13-.16.27-.31.41-.47l.47.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2,91.59c-.15.21-.29.43-.43.65l-.55-.52.43-.65.55.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.21,107.52l-.61.51c-.1-.21-.21-.41-.32-.62.2-.17.41-.33.61-.51l.32.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.27,99.77l-.59.52c-.12-.21-.24-.43-.37-.64l.58-.51.38.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.68,55.84l-.63.52-.5-.46.63-.52.5.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.54,127.6c-.14.15-.29.3-.43.46l-.45-.46.43-.47.45.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.56,90.07l-.54.52-.45-.65.55-.52c.15.22.3.43.44.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.05,125.22l-.33.5-.56-.46.33-.5c.18.16.37.31.56.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.68,121.47l-.29.53-.61-.47c.1-.18.19-.36.29-.53l.61.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.56,117.49l-.29.55-.63-.48c.1-.18.2-.37.29-.56l.63.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.23,124c-.11.17-.22.33-.32.51l-.58-.47.31-.51.59.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.55,98.17l-.58.51-.39-.64.58-.52.39.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.48,110.38c-.11.2-.21.4-.31.6l-.62-.5c.1-.2.2-.4.31-.6l.62.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,126.41c-.12.17-.24.32-.35.49l-.53-.46c.12-.16.24-.33.36-.48l.52.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.41,91.7l-.55.51-.43-.65L127,91l.43.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.64,113.28l-.3.59-.62-.49a6.54,6.54,0,0,1,.3-.59l.62.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,105.87c-.12.2-.23.41-.34.62L55,106l.34-.62.61.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.53,81.78l-.51.52-.51-.65.51-.51.51.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.8,96.56l-.57.51c-.13-.21-.26-.43-.4-.64l.57-.52.4.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,120.15c-.1.18-.2.36-.29.55l-.62-.48c.09-.18.2-.36.29-.54l.62.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.24,93.32c-.19.17-.38.34-.56.52l-.43-.65.56-.52.43.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.28,118.82l-.29.55-.62-.47c.09-.19.19-.37.29-.56.2.17.41.32.62.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.82,60.43l-.63.57-.48-.47.63-.56.48.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,94.94l-.56.52-.42-.65.57-.52c.14.22.28.43.41.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,76.8l-.49.51c-.18-.22-.37-.43-.55-.64l.5-.51.54.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.63,70.19l-.48.49c-.2-.21-.4-.41-.59-.62l.48-.49.59.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.6,106l-.6.51-.34-.62.61-.51.33.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.37,73.46l-.49.51-.57-.63.49-.5.57.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.26,126.38l-.37.48-.52-.45c.12-.17.25-.33.37-.49l.52.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.92,57.29l-.64.54-.49-.46.63-.53.5.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.62,104.29c-.12.21-.24.42-.35.63l-.61-.51.35-.63.61.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.51,83.4l-.52.51c-.17-.21-.34-.43-.5-.65l.52-.51c.17.21.33.43.5.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6,122.7l-.31.52-.59-.47.31-.52.59.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.29,125.17l-.34.5-.56-.46c.12-.16.23-.33.35-.5l.55.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.37,114.66l-.3.57c-.21-.16-.42-.32-.62-.49.09-.19.2-.39.3-.58l.62.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.06,108.84l-.32.61-.61-.51.32-.61.61.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,104.39c-.2.16-.4.34-.6.51l-.35-.63.6-.51c.12.21.24.42.35.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.48,123.94c-.12.17-.22.34-.33.5l-.58-.46.33-.51.58.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.06,78.39l-.5.51-.54-.64.5-.51.54.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5,126.36c-.12.16-.26.31-.38.47l-.51-.46c.12-.16.26-.32.39-.48l.5.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2,111.77l-.31.59-.62-.49c.1-.2.2-.4.31-.6l.62.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,68.49l-.48.49c-.2-.21-.41-.41-.61-.61.16-.16.33-.32.49-.49l.6.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.28,102.71c-.13.21-.24.42-.36.63l-.6-.52.36-.63.6.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.47,85l-.53.51c-.16-.22-.33-.43-.5-.65l.54-.52.49.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.94,121.39l-.31.53-.6-.47c.1-.18.2-.36.31-.54l.6.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.11,116c-.11.19-.21.38-.31.57l-.62-.49.3-.57.63.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.32,102.8l-.6.52c-.12-.22-.24-.42-.37-.63l.6-.52.37.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.75,126.34l-.4.47-.5-.46.4-.48.5.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.54,125.13l-.35.49-.55-.46.36-.49.54.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,101.11l-.37.63-.59-.51c.12-.21.25-.42.37-.64l.59.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.47,75l-.5.5-.56-.63c.17-.17.33-.34.5-.5.19.2.38.41.56.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.77,71.73l-.49.5-.58-.62.49-.5.58.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.26,120.06c-.11.18-.21.37-.31.54l-.61-.47.31-.54.61.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.68,107.28l-.34.62-.62-.51.34-.62.62.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.84,117.38l-.31.56-.62-.48.3-.57.63.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.56,118.73c-.11.18-.21.36-.31.55l-.62-.48.31-.56c.2.17.41.33.62.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.4,86.64l-.54.52-.48-.65.54-.52.48.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,126.32c-.13.16-.28.31-.41.47l-.49-.46.42-.48.48.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5,57.2l-.63.53-.51-.46.64-.53.5.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.09,80l-.51.51-.53-.64.51-.51.53.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.64,101.21l-.6.51c-.12-.21-.25-.42-.38-.63l.6-.52.38.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.87,122.63l-.33.52-.59-.47.33-.52.59.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.91,107.37l-.61.51c-.11-.21-.23-.41-.34-.61l.61-.51c.12.2.23.4.34.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.74,123.88l-.34.51-.57-.47c.11-.17.22-.34.34-.51l.57.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.94,113.16l-.32.58-.62-.49.31-.59.63.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.26,126.31l-.43.47-.47-.47.42-.47.48.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.3,88.26l-.54.52c-.16-.22-.32-.43-.47-.65l.54-.52c.16.22.32.43.47.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.79,110.24l-.33.6-.62-.5c.11-.2.21-.4.33-.6l.62.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.52,126.3c-.15.16-.3.31-.44.47-.16-.15-.31-.31-.47-.47.14-.16.29-.31.44-.47.15.16.32.31.47.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.93,99.6c-.19.18-.39.35-.59.52l-.39-.63.59-.52.39.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.59,91.41l-.44.65-.56-.52c.14-.22.29-.44.44-.65l.56.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8,125.09l-.37.5-.54-.47.38-.49.53.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.76,93c-.15.21-.29.43-.43.64l-.57-.52.43-.65.57.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.31,105.72c-.12.21-.24.41-.35.62l-.61-.51c.11-.21.23-.42.35-.62l.61.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.18,89.89l-.55.52-.46-.65.55-.52c.16.21.31.43.46.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.2,98l-.58.52c-.13-.22-.27-.43-.4-.64l.58-.53.4.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.14,70l-.5.49-.6-.61.5-.49.6.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.55,76.62l-.51.51c-.18-.22-.37-.43-.56-.64q.27-.26.51-.51l.56.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,91.51l-.56.52-.45-.64.56-.53.45.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.1,81.6l-.52.51c-.18-.21-.35-.43-.52-.64l.52-.52.52.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.22,121.31l-.32.53-.6-.47.32-.53.6.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.45,96.38l-.58.52-.41-.64.57-.52c.15.21.28.43.42.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.29,105.81l-.61.51-.36-.62.62-.51.35.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.68,114.54l-.32.58-.63-.5.32-.58.63.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.87,93.14l-.57.52-.44-.65.57-.52.44.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.67,94.76l-.57.52c-.14-.21-.28-.43-.43-.64l.58-.53.42.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.07,125.06l-.38.49-.53-.47.39-.49.52.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,123.83l-.35.51-.57-.47.36-.51.56.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1,57.11l-.63.53c-.18-.15-.35-.31-.52-.47l.63-.52.52.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,104.14l-.36.62-.61-.51.36-.63.61.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.39,108.7c-.11.2-.22.41-.34.61l-.61-.51c.1-.2.22-.41.33-.61l.62.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.15,122.57c-.12.17-.23.35-.34.52l-.59-.47c.11-.18.22-.35.34-.52l.59.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.55,120c-.11.18-.22.36-.32.54l-.61-.48c.1-.18.21-.36.32-.54l.61.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.41,115.92l-.32.56-.62-.49c.1-.19.21-.38.32-.57l.62.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.52,111.65c-.11.19-.22.39-.32.59l-.63-.51.33-.59.62.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.08,83.21c-.17.18-.35.35-.53.52l-.51-.64.53-.52c.18.21.35.43.51.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.85,118.64l-.32.55-.61-.49.32-.55.61.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.14,117.28c-.11.19-.22.37-.32.56-.21-.16-.42-.32-.62-.49.1-.19.21-.37.32-.56l.62.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.64,104.23l-.61.51-.36-.62.61-.52.36.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.35,125c-.13.17-.27.33-.4.49l-.52-.47.4-.49.52.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.61,78.21l-.52.51c-.18-.21-.37-.42-.55-.64l.52-.51c.18.22.37.43.55.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.64,102.55c-.13.21-.26.42-.38.63l-.6-.52L56,102l.61.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3,123.79c-.13.16-.25.33-.38.5l-.55-.47.37-.51.56.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.27,71.56c-.16.17-.33.34-.5.5l-.6-.61.51-.5.59.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,84.83l-.54.52-.5-.64.54-.52.5.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.63,125c-.14.16-.28.32-.41.49l-.51-.47c.13-.17.27-.33.41-.49l.51.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,102.64l-.6.52-.38-.63.61-.52.37.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.52,121.24l-.34.53-.6-.48.34-.53q.3.26.6.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,107.14c-.12.21-.24.41-.35.62l-.62-.51c.11-.21.23-.42.35-.62l.62.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.34,58.59l-.64.54c-.17-.16-.34-.32-.52-.47l.64-.54.52.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.26,113l-.33.59-.62-.5c.1-.2.22-.39.33-.59l.62.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.34,101c-.13.21-.27.42-.39.64l-.6-.52.39-.64.6.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.44,122.51l-.36.52-.57-.48.35-.51.58.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.91,125l-.42.49L85,125l.43-.48.49.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.58,107.23l-.62.51c-.11-.21-.23-.41-.35-.61.2-.18.41-.35.62-.52.12.21.24.41.35.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.13,110.12c-.12.19-.23.39-.34.59l-.63-.5.34-.6c.21.17.42.33.63.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,86.46l-.55.52c-.16-.22-.33-.43-.5-.65l.55-.52c.17.21.34.43.5.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.28,101.05l-.6.52-.39-.64.6-.52.39.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.64,79.81l-.53.52-.54-.64.53-.52.54.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2,125c-.14.17-.29.32-.44.48l-.48-.47.43-.49.49.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.86,119.91c-.12.17-.23.35-.34.53l-.61-.48.34-.54.61.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.59,123.75l-.39.5-.54-.47.38-.51.55.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,114.43l-.33.58-.63-.5c.11-.19.22-.39.34-.58l.62.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.49,125l-.45.48-.48-.48.46-.49c.16.17.32.32.47.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.67,105.57l-.37.62-.61-.51c.11-.21.24-.42.36-.62l.62.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.89,88.08l-.56.53-.48-.65.55-.53.49.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.57,99.44l-.6.52c-.13-.21-.27-.42-.41-.63l.6-.53.41.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.17,118.55c-.12.18-.23.37-.34.55l-.61-.49.34-.55.61.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,91.24l-.46.64L54,91.36l.46-.65.57.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.74,115.81c-.12.19-.23.38-.34.57-.2-.17-.41-.33-.62-.49l.33-.57.63.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.46,117.19l-.33.55-.62-.48.33-.56.62.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.18,92.87l-.45.64L54.16,93c.15-.22.29-.43.45-.65l.57.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.07,76.45c-.18.16-.35.33-.52.51l-.57-.64.52-.51.57.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.77,89.71l-.56.52-.48-.64.57-.53c.16.22.32.43.47.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.94,105.66l-.61.51-.37-.61.62-.52.36.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.83,97.83l-.6.52-.41-.64.59-.52.42.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.83,121.18l-.36.53-.59-.48c.12-.18.23-.36.36-.53l.59.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.74,122.46l-.37.52-.57-.48c.13-.17.25-.35.37-.52l.57.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.64,81.42c-.17.18-.35.35-.53.52l-.53-.64.53-.52.53.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.89,123.71l-.4.5-.54-.47.4-.51c.18.16.36.33.54.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.63,91.34l-.57.52-.46-.64.57-.53.46.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.87,111.52c-.12.2-.23.4-.35.59l-.62-.5.34-.59.63.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.07,96.21l-.59.53-.43-.65.59-.52c.14.21.28.43.43.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.75,108.57c-.12.2-.24.4-.35.6-.21-.17-.42-.33-.63-.51l.36-.6.62.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.47,93l-.58.52-.45-.65.58-.52.45.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.28,94.59l-.58.53c-.15-.22-.3-.43-.44-.65l.58-.52.44.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.34,104c-.13.21-.26.42-.38.63l-.61-.52c.12-.21.24-.42.37-.63l.62.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.28,104.08l-.61.52-.38-.63.61-.51c.13.2.26.41.38.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2,123.69l-.42.49-.52-.47.41-.51c.17.17.35.32.53.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.63,83l-.54.52-.53-.65.54-.52c.18.22.36.43.53.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.18,119.83c-.12.18-.24.36-.35.54l-.61-.49c.12-.17.24-.36.36-.54l.6.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.61,112.93l-.35.58-.62-.5.34-.59.63.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.12,78l-.53.51-.56-.63.53-.52c.18.22.38.43.56.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.06,122.42l-.39.51-.56-.48.38-.52.57.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,102.4c-.14.21-.27.42-.4.63l-.61-.52c.13-.21.26-.42.4-.63l.61.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.39,107c-.12.2-.24.41-.37.61l-.62-.51.37-.62c.21.18.42.34.62.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.15,121.12l-.37.53-.59-.49c.13-.17.25-.35.37-.52l.59.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.51,123.66l-.43.5-.51-.48c.13-.17.28-.34.42-.5l.52.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.6,102.49,121,103c-.13-.21-.26-.42-.4-.63l.62-.52.39.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5,118.47l-.35.55-.61-.49.35-.55.61.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.49,110l-.36.6-.62-.51c.11-.2.23-.4.35-.6l.63.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.35,114.33l-.35.57-.62-.5.34-.57c.22.16.42.33.63.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.59,84.66l-.55.52c-.17-.22-.35-.43-.52-.64l.55-.53.52.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.22,107.09l-.62.51-.37-.61.62-.51c.13.2.25.4.37.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.74,100.8c-.14.21-.28.42-.41.63l-.6-.52c.13-.21.26-.42.4-.63l.61.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8,117.1l-.35.56-.61-.5.35-.55.61.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.08,115.72c-.12.19-.23.38-.35.56l-.62-.49.35-.57.62.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.83,123.64c-.15.17-.3.33-.44.5l-.51-.48c.14-.17.29-.34.44-.5l.51.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.38,122.38l-.4.51-.55-.49.4-.51.55.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.9,100.89l-.61.52c-.13-.21-.27-.42-.41-.63l.61-.52.41.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.15,123.63c-.15.17-.31.33-.45.5l-.5-.49.45-.5.5.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.15,79.64l-.54.52-.55-.64.54-.52c.18.22.37.43.55.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.52,86.28l-.55.53-.51-.65.56-.52.5.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.47,123.62l-.46.5-.49-.49.46-.49.49.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.06,105.44l-.39.61-.62-.51c.13-.21.26-.41.38-.62l.63.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.51,119.77l-.36.53-.6-.49.37-.53c.2.16.4.32.59.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.24,111.41c-.12.2-.25.39-.36.59l-.63-.51.36-.59.63.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.48,121.07l-.38.52-.58-.48.38-.53.58.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.17,99.28l-.6.53-.42-.64.6-.52.42.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.44,87.91l-.57.53-.49-.65.56-.53c.17.22.34.43.5.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.57,105.52,119,106c-.13-.21-.26-.41-.38-.62l.62-.52c.12.21.26.41.38.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.13,108.44l-.37.61-.63-.52.38-.6.62.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.71,122.34l-.41.51-.55-.49c.14-.16.27-.34.41-.51l.55.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.63,92.7l-.46.65-.59-.53.47-.65c.19.18.38.36.58.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.42,97.67l-.6.53c-.14-.22-.28-.43-.43-.64L122,97l.43.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.33,89.54l-.58.53-.48-.65.57-.53.49.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.16,81.25l-.55.52-.54-.64.54-.52c.19.21.37.43.55.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.85,118.4l-.37.54-.6-.49.36-.55.61.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.74,103.85l-.39.63-.62-.53.39-.62.62.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.65,96.05l-.6.53c-.14-.22-.29-.43-.44-.64l.6-.53.44.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.19,91.17l-.58.53c-.15-.22-.31-.43-.47-.65l.58-.53.47.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,112.82l-.36.58-.63-.5.36-.58.63.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.85,94.43l-.59.52-.45-.64.59-.53.45.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,92.8l-.58.53c-.15-.22-.31-.43-.47-.65l.59-.53.46.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.9,103.94c-.21.17-.42.34-.62.52l-.4-.62.62-.53c.13.21.26.42.4.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.05,122.31l-.43.51c-.17-.17-.35-.32-.53-.49l.42-.51.54.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.16,117c-.12.18-.25.37-.36.55l-.62-.49.37-.56.61.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.72,114.23l-.36.57-.63-.5.36-.58.63.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.82,121l-.39.52-.57-.49.39-.52.57.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.45,115.63l-.37.56-.62-.5c.12-.19.24-.38.37-.56l.62.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.86,119.71l-.38.53-.59-.49.38-.54.59.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.14,82.87l-.55.52-.54-.64.56-.53c.17.22.35.43.53.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.6,77.87l-.54.52-.56-.63.54-.52.56.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.44,102.26l-.4.63-.62-.53c.14-.21.27-.42.41-.62l.61.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.79,106.88l-.38.61-.63-.52.39-.61.62.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.88,109.87l-.38.6-.62-.51c.12-.2.24-.4.37-.6l.63.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4,122.29c-.15.17-.3.33-.44.5-.18-.16-.36-.32-.53-.49l.44-.51.53.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.2,102.34l-.62.53c-.13-.21-.27-.42-.41-.63l.62-.52.41.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.17,100.66l-.42.63-.61-.53q.2-.32.42-.63l.61.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.74,122.27l-.45.5-.52-.49.45-.51.52.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.1,84.49l-.56.53-.52-.65.56-.53.52.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.18,121l-.42.52L79.2,121c.14-.17.27-.35.41-.53l.57.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.21,118.33l-.38.54-.6-.49.38-.55.6.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.63,111.3l-.38.59-.63-.51.38-.59.63.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.09,122.26l-.46.5-.51-.5c.16-.16.31-.33.46-.5.18.16.35.33.51.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.48,100.74l-.61.53-.42-.63.61-.53c.14.21.29.42.42.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.47,105.31c-.13.2-.26.41-.4.61l-.62-.52.4-.62.62.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.63,79.47l-.55.53-.56-.64.55-.52.56.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.23,119.65l-.4.53-.58-.49.39-.53.59.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.45,122.25l-.48.5c-.16-.17-.33-.33-.5-.5l.48-.5.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8,122.25l-.49.5c-.15-.17-.32-.34-.48-.5l.48-.5c.17.16.33.33.49.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,86.12l-.57.52L121,86l.56-.53.52.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.54,108.32l-.39.61-.63-.52.39-.61.63.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.54,116.94l-.39.56-.61-.5.38-.56.62.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.17,105.38c-.2.18-.41.35-.62.52-.13-.2-.27-.4-.4-.61l.62-.52c.14.2.27.41.4.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.37,112.72c-.13.19-.25.39-.37.58l-.63-.51c.12-.19.25-.38.37-.58l.63.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.75,99.13l-.61.53L119.7,99l.61-.53.44.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.54,120.94c-.15.17-.29.35-.43.52l-.55-.49.42-.52.56.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.83,115.55c-.13.18-.26.37-.38.56l-.62-.51c.13-.18.26-.37.38-.56l.62.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.11,114.14c-.13.19-.26.38-.38.57l-.62-.51.37-.57.63.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,87.75l-.58.52-.51-.64.58-.53.51.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,97.52c-.21.17-.41.35-.61.53l-.45-.64.61-.53.45.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.17,103.72l-.41.62-.62-.52c.13-.21.27-.42.41-.62l.62.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.11,92.55l-.48.64L57,92.66l.48-.64.59.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.64,81.09l-.56.52-.55-.63.56-.53c.18.21.37.42.55.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.85,89.38l-.58.53c-.16-.22-.33-.43-.5-.65l.58-.53c.17.22.34.43.5.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.59,118.27l-.39.54-.6-.5.39-.54.6.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.2,95.89l-.6.54c-.15-.22-.3-.43-.46-.64l.61-.53.45.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6,119.6l-.41.53-.58-.49.41-.54.58.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.91,120.91l-.44.52-.55-.5.44-.52.55.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.72,91l-.58.53c-.16-.22-.33-.43-.49-.64l.59-.54.48.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.48,103.8l-.62.52c-.14-.2-.27-.41-.41-.62l.62-.52c.14.2.28.41.41.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.29,109.76l-.39.6-.63-.52.39-.59.63.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.4,94.27l-.6.53-.47-.64.6-.53.47.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.57,92.64l-.59.53-.48-.64.59-.53c.16.21.33.42.48.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.21,106.76l-.39.61-.63-.52c.13-.21.26-.41.4-.61.2.17.42.34.62.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.89,102.13l-.42.62-.62-.53c.13-.21.28-.41.42-.62l.62.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62,82.7l-.56.53-.54-.64.56-.53.54.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.28,120.89l-.45.51-.54-.5.45-.51.54.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.92,116.87l-.39.56-.61-.51c.13-.18.26-.37.4-.55l.6.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,111.2c-.14.19-.26.39-.39.58l-.63-.51.39-.59.63.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.77,102.2l-.62.53-.42-.62.62-.53.42.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,119.56c-.14.18-.29.35-.42.53l-.58-.5.43-.53.57.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.66,120.87l-.46.51-.53-.5.46-.51.53.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.23,115.47c-.13.18-.27.37-.39.56l-.62-.51.39-.56.62.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.78,112.63l-.39.58-.63-.52.39-.58.63.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,118.21l-.41.54-.59-.5.41-.54.59.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.51,114.05l-.39.57-.62-.51.39-.57.62.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.59,84.33l-.57.53-.54-.64.57-.53.54.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.91,105.18l-.41.61-.63-.52.41-.61.63.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,120.86l-.47.51-.52-.5c.15-.18.31-.35.47-.52l.52.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,108.21l-.4.6c-.21-.17-.43-.34-.63-.52.12-.2.26-.4.4-.6.21.17.41.35.63.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,100.6l-.62.53-.43-.63.62-.53.43.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.43,120.85l-.49.51-.51-.51.49-.51.51.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.75,105.26l-.63.52-.41-.61.62-.53.42.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.81,120.85l-.5.5-.49-.5.49-.51.5.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.37,119.52c-.14.18-.29.35-.44.53l-.56-.5c.15-.18.29-.36.44-.53l.56.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.53,86l-.58.53c-.17-.22-.35-.43-.53-.64l.58-.54.53.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.29,99l-.61.53-.45-.63.62-.54.44.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.33,116.81l-.41.55-.6-.51.41-.55.6.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.62,103.59l-.42.62-.63-.52c.14-.21.28-.42.43-.62l.62.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.72,109.66c-.14.19-.27.39-.4.59l-.63-.52.4-.59.63.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.38,118.16l-.42.54-.59-.5.43-.54.58.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.45,87.59l-.58.53-.52-.64.58-.54.52.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.52,97.37l-.61.53-.46-.63.61-.53.46.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.77,119.49c-.15.18-.31.35-.45.53l-.56-.51.45-.52.56.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,103.67l-.62.52c-.15-.2-.29-.41-.43-.61l.63-.53.42.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.66,106.64l-.41.61-.63-.52c.13-.21.27-.41.41-.61l.63.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.35,89.22l-.59.53-.51-.64.59-.53.51.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.64,115.4l-.4.55-.62-.5.41-.57.61.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.73,95.75l-.61.53-.47-.64.61-.53.47.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.47,111.1l-.41.59-.62-.52.4-.59.63.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.23,90.85l-.6.54c-.16-.22-.33-.43-.5-.64l.6-.54c.16.22.33.43.5.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.92,94.12l-.61.53-.48-.64.61-.53.48.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.08,92.49l-.6.53-.49-.64.6-.53c.17.21.33.42.49.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.94,114l-.41.57-.62-.51.41-.57.62.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.21,112.54l-.41.58-.62-.52c.13-.19.27-.38.4-.58l.63.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.36,102c-.15.2-.3.41-.44.62l-.62-.53c.14-.21.28-.42.43-.62l.63.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.17,119.47c-.15.17-.31.34-.46.52l-.55-.51.46-.52.55.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.08,82.55l-.57.53-.56-.64.57-.53.56.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.79,118.12c-.15.18-.29.36-.44.53l-.58-.5.44-.54.58.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.74,116.75l-.42.55-.6-.51.42-.55.6.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.32,102.07l-.63.53-.43-.62.62-.53.44.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.58,119.45l-.48.52-.53-.51.47-.52c.18.17.36.33.54.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.42,108.1c-.15.2-.28.4-.42.6l-.63-.52.42-.6c.21.17.41.35.63.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.37,105.06l-.42.62-.63-.53c.13-.21.28-.41.42-.61l.63.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,119.43l-.48.52-.53-.51.48-.52.53.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.65,119.44l-.53.51c-.16-.17-.33-.34-.49-.52l.53-.51.49.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.05,84.17l-.59.54-.54-.64c.19-.18.38-.36.58-.53l.55.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.58,100.47,117,101l-.45-.63.63-.53.45.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.07,115.33l-.42.56-.61-.51c.14-.19.28-.38.43-.56l.6.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.41,119.43l-.5.51-.52-.51.5-.52.52.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.23,119.43l-.52.51-.49-.51.51-.52.5.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.21,118.08l-.45.54-.57-.51.45-.54.57.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.82,119.43l-.51.51c-.16-.17-.34-.34-.51-.51l.51-.52.51.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.17,109.56l-.42.59-.63-.52.42-.59.63.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.17,116.7l-.44.55-.59-.51c.14-.19.29-.37.44-.55l.59.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,85.8l-.59.54-.54-.64.59-.54.54.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.38,113.9l-.43.57-.61-.52.42-.57.62.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.81,98.85l-.62.54-.46-.63.62-.54.46.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1,103.47l-.43.62-.63-.53.43-.62.63.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.92,111l-.42.59-.63-.52.42-.59.63.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.66,112.46q-.22.29-.42.57l-.63-.51.42-.58.63.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.13,106.53c-.15.2-.29.41-.43.61l-.63-.53.43-.61.63.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.63,118.05l-.46.53-.56-.51.46-.54.56.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.58,103.54l-.63.53-.44-.61.63-.53.44.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.91,87.44l-.59.53-.53-.64.59-.53c.18.21.36.42.53.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,97.23l-.62.54-.47-.64.62-.53.47.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3,93.89c-.16.22-.33.43-.49.64L60.2,94l.49-.63.61.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.82,89.07l-.6.54L117.7,89l.6-.54c.17.21.34.43.52.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.23,95.6l-.62.54-.48-.63.62-.54.48.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.51,115.27l-.43.56-.6-.52.43-.56.6.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.85,101.87l-.45.62-.63-.53.45-.62.63.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.7,90.71l-.6.53-.51-.63.6-.54.51.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.41,94c-.21.17-.41.35-.61.53l-.5-.63.61-.54.5.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.07,118l-.48.53L83,118l.48-.53.56.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.61,116.65l-.45.55-.59-.51.45-.55.59.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.56,92.34l-.6.54-.51-.64.61-.54.5.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.89,108l-.43.6-.63-.53.43-.6.63.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.84,101.94l-.63.54-.45-.62.63-.54.45.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.51,82.4l-.58.54-.57-.64c.2-.17.39-.35.58-.53l.57.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.86,105l-.44.61-.63-.53.44-.61.63.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5,118l-.48.53-.55-.51.49-.54.54.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.83,113.83l-.44.57-.61-.52.43-.57.62.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.64,109.47l-.43.59-.63-.53.43-.59.63.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.12,112.38l-.44.58-.62-.52.44-.58c.2.18.41.35.62.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.94,118l-.49.52-.54-.51.49-.53.54.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.39,110.93l-.44.58-.62-.52.43-.59.63.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.71,118l-.54.51-.49-.52c.17-.18.35-.35.53-.53l.5.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.05,116.62l-.46.54-.58-.52.46-.54.58.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.08,100.34l-.62.53-.47-.62.63-.54.46.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.47,84l-.58.54-.56-.64.59-.54c.18.22.37.43.55.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.39,118c-.17.18-.35.35-.51.53l-.53-.53.5-.52.54.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.27,118l-.53.52-.51-.52.53-.52.51.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,115.22l-.45.55-.6-.51.45-.56.6.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.83,118l-.52.52-.52-.52.52-.53.52.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6,103.36l-.45.61-.63-.53.45-.61.63.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.62,106.43l-.44.6-.63-.52c.14-.21.29-.41.44-.61l.63.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.31,98.72l-.63.54-.47-.63.63-.54.47.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.42,85.66l-.59.54-.55-.64.59-.54c.19.21.37.43.55.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.51,116.58l-.48.54-.57-.51c.15-.19.31-.37.47-.55l.58.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.29,113.77l-.44.56-.61-.52c.15-.18.3-.37.44-.56l.61.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.51,97.1l-.62.54-.48-.63.62-.54c.16.21.33.42.48.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.35,87.29l-.6.54-.54-.63.6-.54.54.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.38,107.91l-.45.59L68.3,108c.15-.21.3-.4.45-.6l.63.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.43,115.17l-.46.55c-.2-.17-.4-.34-.59-.52.15-.18.3-.37.46-.55l.59.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.37,101.76c-.16.2-.31.41-.47.62l-.63-.54.46-.62.64.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,116.56l-.48.53-.57-.52.49-.54.56.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.59,112.32l-.44.57-.62-.53.44-.57.62.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.7,95.47l-.62.54-.49-.63.62-.54.49.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.26,88.93l-.6.54-.54-.64.61-.54.53.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.13,109.38c-.15.2-.3.39-.44.59l-.63-.53.44-.59.63.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.87,110.85l-.45.58-.62-.52.44-.59.63.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.36,104.85l-.45.61-.63-.54.45-.61.63.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.87,93.84l-.62.54-.5-.64.62-.54c.16.22.33.43.5.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.15,90.57l-.61.54-.52-.64.61-.54c.17.21.35.42.52.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.34,101.83l-.63.53c-.16-.2-.31-.41-.47-.62l.63-.53c.16.2.31.41.47.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,92.2l-.61.54-.52-.63.61-.54.52.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.43,116.54c-.17.18-.34.35-.5.53l-.56-.52.5-.54.56.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9,115.13l-.47.55-.59-.52.47-.55.59.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.77,113.72l-.46.56-.6-.53.46-.56.6.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9,116.52c-.17.18-.35.36-.51.54l-.55-.53.51-.54c.18.18.36.36.55.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.78,116.53l-.55.52-.51-.53.55-.53.51.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.57,100.21l-.63.54-.48-.62.63-.54.48.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.13,106.34l-.46.6L68,106.4l.45-.6.64.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.37,116.51l-.52.54-.54-.53.52-.54.54.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.31,116.52l-.54.52-.52-.53.54-.53.52.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.84,116.51l-.53.53c-.18-.17-.35-.35-.53-.53l.53-.53.53.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.88,83.89l-.59.54-.57-.63.59-.54.57.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.13,103.25c-.16.21-.32.41-.47.62l-.63-.54c.15-.2.3-.41.46-.61.21.18.42.36.64.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.08,112.25l-.46.57L75,112.3c.15-.19.31-.38.46-.58l.61.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.38,115.1l-.49.54-.58-.52.49-.55.58.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.89,107.82l-.46.6-.63-.54.45-.59.64.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.78,98.6l-.63.54-.49-.63.63-.54.49.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.37,110.78c-.16.19-.31.39-.46.58l-.62-.53c.15-.19.3-.39.46-.58l.62.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.83,85.53l-.6.54-.56-.64.6-.54c.19.21.38.42.56.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.63,109.31l-.45.58-.63-.53.46-.59.62.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.26,113.67c-.16.18-.32.37-.47.56l-.6-.53c.15-.19.31-.37.47-.56l.6.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,97l-.62.54c-.17-.2-.33-.41-.5-.62l.63-.55L115,97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.76,87.16l-.6.54-.55-.63.6-.55.55.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.87,115.07c-.17.18-.34.36-.5.55l-.57-.53c.16-.19.33-.37.49-.55l.58.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.89,104.75l-.47.61-.63-.54.47-.61.63.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.15,95.34l-.62.55-.51-.63.62-.55.51.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.68,88.8l-.61.54-.55-.63.61-.55c.19.21.37.42.55.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.31,93.71l-.62.54-.52-.63.62-.54.52.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.58,112.2l-.47.57-.61-.53.47-.57c.21.17.41.35.61.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.57,90.44,115,91l-.54-.63.62-.55.53.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.36,115.05c-.17.18-.35.36-.51.54l-.57-.53.51-.54.57.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.45,92.07l-.62.55c-.17-.21-.35-.42-.52-.64l.61-.54.53.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.76,113.63c-.17.18-.33.37-.49.56l-.59-.53.48-.56.6.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.65,106.25l-.46.6-.64-.54.47-.6.63.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.85,115c-.17.17-.35.35-.52.54l-.56-.54.52-.54c.19.18.38.35.56.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.88,110.72l-.47.57-.62-.53.47-.58.62.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.41,107.74c-.16.2-.31.4-.47.59l-.63-.53.47-.6.63.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.67,103.15l-.48.62-.63-.55.47-.61.64.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.35,115l-.53.54-.55-.54.53-.54.55.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.15,109.23l-.46.59-.63-.54.47-.58.62.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.84,115c-.18.17-.36.35-.53.53l-.54-.53.53-.54a6.88,6.88,0,0,1,.54.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.26,113.59l-.5.56-.58-.53.49-.56.59.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1,112.15l-.49.57-.6-.54.48-.57.61.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.23,98.48l-.64.55-.49-.63.63-.54c.17.2.33.41.5.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.44,104.66l-.48.6c-.22-.17-.43-.35-.64-.53l.48-.61.64.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.77,113.56l-.51.56-.58-.54.51-.55.58.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.41,96.85l-.63.55-.51-.63.63-.54.51.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4,110.66l-.48.57-.61-.53.48-.58.61.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.15,87l-.61.55-.56-.64.61-.54.56.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2,106.17c-.17.19-.32.39-.48.59l-.63-.54.47-.6.64.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.58,95.22l-.63.55-.52-.63.63-.55.52.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.62,112.11l-.5.56-.6-.53.5-.57.6.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.69,109.17l-.49.58-.62-.54.48-.58.63.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.29,113.54l-.52.56-.58-.54.52-.56.58.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,107.67l-.48.59-.63-.54.48-.59.63.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.07,88.67l-.62.55-.55-.63.62-.55.55.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.73,93.59l-.63.54c-.18-.2-.35-.41-.53-.62l.63-.55.53.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,90.31l-.62.55-.54-.64.62-.54.54.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.86,92c-.21.18-.42.36-.62.55l-.54-.63.62-.55.54.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.81,113.53c-.18.18-.36.36-.53.55l-.57-.54.53-.55.57.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.33,113.52l-.54.55-.56-.54.54-.55.56.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.15,112.07c-.17.19-.35.37-.51.56l-.6-.53.51-.57.6.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.23,109.11l-.49.58-.62-.54.49-.58.62.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.76,106.09l-.5.6c-.21-.18-.41-.37-.63-.55l.49-.59.64.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.68,112l-.52.56-.58-.54.51-.56.59.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5,107.6l-.49.59-.63-.54.5-.59.62.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.82,96.74l-.63.55-.52-.62.63-.55.52.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.07,107.54c-.17.2-.34.39-.5.59l-.63-.55.51-.58.62.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.33,106l-.5.6-.63-.55.5-.6.63.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,76.18a59.19,59.19,0,0,0-54.81,26.11.74.74,0,0,1-1.29-.12h0l-19.22-44.5-2.92-6.76a89.78,89.78,0,1,0-6.78,89.45,2.38,2.38,0,0,0,.23-2.28l-13.23-30.61a1.58,1.58,0,0,0-3,.16A61,61,0,0,1,76.1,149.14a59.91,59.91,0,0,1-45.81-46.2A60.9,60.9,0,0,1,144.45,63q1.28,2.59,2.3,5.32l25,58,2.73,6.32a11.84,11.84,0,0,1-.11,9.63l-32.33,70.21a2.42,2.42,0,0,0,3,3.29l30.77-10.69a4.31,4.31,0,0,0,2.52-2.29L192,173.1l.83-1.81a2,2,0,0,1,3.35-.37,59.22,59.22,0,0,0,36.05,22.43,60.46,60.46,0,0,0,11.18,1.05A59.24,59.24,0,0,0,249,76.18Zm1.47,88.53a30.41,30.41,0,0,1-36.55-36.53,29.82,29.82,0,0,1,22.54-22.56A30.4,30.4,0,0,1,273,142.16,29.8,29.8,0,0,1,250.42,164.71Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 331.09,
    y1: 19.09,
    x2: 331.09,
    y2: 196.89
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogohorizontal);
export default __webpack_public_path__ + "static/media/logo horizontal.5fee2384883b687bb4d0d99c8e809e6f.svg";
export { ForwardRef as ReactComponent };